/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./javascripts/site.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./javascripts/modules/_closest.js":
/*!*****************************************!*\
  !*** ./javascripts/modules/_closest.js ***!
  \*****************************************/
/*! exports provided: closest */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closest", function() { return closest; });
function closest(el, targetClass) {
  for (var item = el; item; item = item.parentElement) {
    if (item.classList.contains(targetClass)) {
      return item;
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/_easings.js":
/*!*****************************************!*\
  !*** ./javascripts/modules/_easings.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

window.easings = {
  def: 'easeOutQuad',
  linear: function linear(t, b, c, d) {
    return c * t / d + b;
  },
  swing: function swing(t, b, c, d) {
    return window.fp_easings[window.fp_easings.def](t, b, c, d);
  },
  easeInQuad: function easeInQuad(t, b, c, d) {
    return c * (t /= d) * t + b;
  },
  easeOutQuad: function easeOutQuad(t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
  },
  easeInOutQuad: function easeInOutQuad(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
    return -c / 2 * (--t * (t - 2) - 1) + b;
  },
  easeInCubic: function easeInCubic(t, b, c, d) {
    return c * (t /= d) * t * t + b;
  },
  easeOutCubic: function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  },
  easeInOutCubic: function easeInOutCubic(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t + 2) + b;
  },
  easeInQuart: function easeInQuart(t, b, c, d) {
    return c * (t /= d) * t * t * t + b;
  },
  easeOutQuart: function easeOutQuart(t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b;
  },
  easeInOutQuart: function easeInOutQuart(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
    return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
  },
  easeInQuint: function easeInQuint(t, b, c, d) {
    return c * (t /= d) * t * t * t * t + b;
  },
  easeOutQuint: function easeOutQuint(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
  },
  easeInOutQuint: function easeInOutQuint(t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t * t * t * t + b;
    return c / 2 * ((t -= 2) * t * t * t * t + 2) + b;
  },
  easeInSine: function easeInSine(t, b, c, d) {
    return -c * Math.cos(t / d * (Math.PI / 2)) + c + b;
  },
  easeOutSine: function easeOutSine(t, b, c, d) {
    return c * Math.sin(t / d * (Math.PI / 2)) + b;
  },
  easeInOutSine: function easeInOutSine(t, b, c, d) {
    return -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
  },
  easeInExpo: function easeInExpo(t, b, c, d) {
    return t == 0 ? b : c * Math.pow(2, 10 * (t / d - 1)) + b;
  },
  easeOutExpo: function easeOutExpo(t, b, c, d) {
    return t == d ? b + c : c * (-Math.pow(2, -10 * t / d) + 1) + b;
  },
  easeInOutExpo: function easeInOutExpo(t, b, c, d) {
    if (t == 0) return b;
    if (t == d) return b + c;
    if ((t /= d / 2) < 1) return c / 2 * Math.pow(2, 10 * (t - 1)) + b;
    return c / 2 * (-Math.pow(2, -10 * --t) + 2) + b;
  },
  easeInCirc: function easeInCirc(t, b, c, d) {
    return -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
  },
  easeOutCirc: function easeOutCirc(t, b, c, d) {
    return c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
  },
  easeInOutCirc: function easeInOutCirc(t, b, c, d) {
    if ((t /= d / 2) < 1) return -c / 2 * (Math.sqrt(1 - t * t) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  },
  easeInElastic: function easeInElastic(t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;
    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);
    return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
  },
  easeOutElastic: function easeOutElastic(t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d) == 1) return b + c;
    if (!p) p = d * .3;
    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);
    return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b;
  },
  easeInOutElastic: function easeInOutElastic(t, b, c, d) {
    var s = 1.70158;
    var p = 0;
    var a = c;
    if (t == 0) return b;
    if ((t /= d / 2) == 2) return b + c;
    if (!p) p = d * (.3 * 1.5);
    if (a < Math.abs(c)) {
      a = c;
      var s = p / 4;
    } else var s = p / (2 * Math.PI) * Math.asin(c / a);
    if (t < 1) return -.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p)) + b;
    return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - s) * (2 * Math.PI) / p) * .5 + c + b;
  },
  easeInBack: function easeInBack(t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  },
  easeOutBack: function easeOutBack(t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  },
  easeInOutBack: function easeInOutBack(t, b, c, d, s) {
    if (s == undefined) s = 1.70158;
    if ((t /= d / 2) < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  },
  easeInBounce: function easeInBounce(t, b, c, d) {
    return c - window.fp_easings.easeOutBounce(d - t, 0, c, d) + b;
  },
  easeOutBounce: function easeOutBounce(t, b, c, d) {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + b;
    }
  },
  easeInOutBounce: function easeInOutBounce(t, b, c, d) {
    if (t < d / 2) return window.fp_easings.easeInBounce(t * 2, 0, c, d) * .5 + b;
    return window.fp_easings.easeOutBounce(t * 2 - d, 0, c, d) * .5 + c * .5 + b;
  }
};

/***/ }),

/***/ "./javascripts/modules/_getHeight.js":
/*!*******************************************!*\
  !*** ./javascripts/modules/_getHeight.js ***!
  \*******************************************/
/*! exports provided: getHeight */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHeight", function() { return getHeight; });
function getHeight(el) {
  var height = el.offsetHeight;
  return height;
}

/***/ }),

/***/ "./javascripts/modules/_getOffset.js":
/*!*******************************************!*\
  !*** ./javascripts/modules/_getOffset.js ***!
  \*******************************************/
/*! exports provided: getOffset */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOffset", function() { return getOffset; });
function getOffset(el) {
  var box = el.getBoundingClientRect();
  return {
    top: box.top + window.pageYOffset - document.documentElement.clientTop,
    left: box.left + window.pageXOffset - document.documentElement.clientLeft
  };
}

/***/ }),

/***/ "./javascripts/modules/_randNum.js":
/*!*****************************************!*\
  !*** ./javascripts/modules/_randNum.js ***!
  \*****************************************/
/*! exports provided: intRandom, customRandom */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intRandom", function() { return intRandom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customRandom", function() { return customRandom; });
// この関数は、指定された最小値(min)と最大値(max)の範囲で整数のランダムな数を生成し、その数を返します。
// Math.random()は0以上1未満のランダムな数を生成するので、この数を(max - min + 1)で乗算し、Math.floorで整数に変換し、最後に最小値(min)を加えて範囲を調整しています。
function intRandom(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// この関数は、最小値と最大値（0以下および小数点付きの数値も含む）の間でランダムな数を生成し、指定された小数点以下の桁数でその数を切り捨てます。
// 使用例:
// 最小値 -5.5、最大値 10.2、小数点以下3桁でランダムな数を生成
// const randomNumber = customRandom(-5.5, 10.2, 3);

function customRandom(min, max, decimalPlaces) {
  if (min > max) {
    throw new Error("最小値は最大値より小さくなければなりません。");
  }
  var rand = Math.random() * (max - min) + min;
  return parseFloat(rand.toFixed(decimalPlaces));
}

/***/ }),

/***/ "./javascripts/modules/draggable.js":
/*!******************************************!*\
  !*** ./javascripts/modules/draggable.js ***!
  \******************************************/
/*! exports provided: draggable */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "draggable", function() { return draggable; });
/* harmony import */ var interactjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! interactjs */ "./node_modules/interactjs/dist/interact.min.js");
/* harmony import */ var interactjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(interactjs__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _easings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./_easings */ "./javascripts/modules/_easings.js");
/* harmony import */ var _easings__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_easings__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _closest__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./_closest */ "./javascripts/modules/_closest.js");



function draggable() {
  var grab = document.querySelectorAll('.draggable');
  var grabLength = grab.length + 1;
  if (grab.length) {
    var _loop = function _loop(i) {
      var _grab = grab[i];
      _grab.addEventListener('click', function (e) {
        if (_grab.classList.contains('is-dragging')) {
          e.preventDefault();
        }
      });
      var restrict = [];
      if (!_grab.classList.contains('is-no-restrict')) {
        restrict = [interactjs__WEBPACK_IMPORTED_MODULE_0___default.a.modifiers.restrictRect({
          restriction: 'parent',
          endOnly: true
        })];
      }
      var dragStartListner = function dragStartListner(event) {
        var target = event.target;
        var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_2__["closest"])(target, 'draggable-parent');
        target.classList.add('is-dragging');
        if (parent) parent.classList.add('is-dragging-parent');
        target.style.zIndex = grabLength;
        grabLength = grabLength + 1;
      };
      var dragMoveListner = function dragMoveListner(event) {
        var target = event.target;
        var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx;
        var y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        target.style.transform = "translate(".concat(x, "px,").concat(y, "px)");
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
      };
      var dragEndListner = function dragEndListner(event) {
        event.preventDefault();
        event.stopPropagation();
        console.log('awdawd');
        var target = event.target;
        var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_2__["closest"])(target, 'draggable-parent');
        setTimeout(function () {
          target.classList.remove('is-dragging');
          if (parent) parent.classList.remove('is-dragging-parent');
        }, 50);
      };
      var initInteract = function initInteract() {
        interactjs__WEBPACK_IMPORTED_MODULE_0___default()(_grab).draggable({
          autoScroll: false,
          inertia: false,
          modifiers: restrict,
          listeners: {
            start: function start(event) {
              dragStartListner(event);
            },
            move: function move(event) {
              dragMoveListner(event);
            },
            end: function end(event) {
              dragEndListner(event);
            }
          }
        });
      };
      initInteract();
    };
    for (var i = 0; i < grab.length; i++) {
      _loop(i);
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/exhibitionImages.js":
/*!*************************************************!*\
  !*** ./javascripts/modules/exhibitionImages.js ***!
  \*************************************************/
/*! exports provided: exhibitionImages */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exhibitionImages", function() { return exhibitionImages; });
/* harmony import */ var _randNum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_randNum */ "./javascripts/modules/_randNum.js");

function exhibitionImages() {
  var img = document.querySelectorAll('.exhibition-element-img');
  var ww = window.innerWidth;

  // 配列の長さを指定
  var length = img.length; // 例えば10とする
  var numbers = [];
  // 0からlength-1までの数を生成
  for (var i = 0; i < length; i++) {
    numbers.push(i);
  }
  // 配列をシャッフルしてランダム性を確保
  var shuffledNumbers = numbers.sort(function () {
    return 0.5 - Math.random();
  });
  var numL = 80;
  var maxL = 80;
  var minL = 10;
  var count = 5;
  if (ww < 768) {
    numL = 90;
    maxL = 90;
    minL = 10;
    count = 10;
  }

  // 増加フラグ
  var increasingL = true;
  if (numL >= maxL) increasingL = false;
  for (var _i = 0; _i < img.length; _i++) {
    var el = img[_i];
    var im = el.querySelector('img');

    // 数値を増減
    if (increasingL) {
      numL = numL + count;
    } else {
      numL = numL - count;
    }
    // 増加していて最大値に達したら減少に切り替え
    if (numL === maxL && increasingL) {
      increasingL = false;
    }
    // 減少していて最小値に達したら増加に切り替え
    else if (numL === minL && !increasingL) {
      increasingL = true;
    }
    var d = Object(_randNum__WEBPACK_IMPORTED_MODULE_0__["intRandom"])(100, 3000);
    var w = Object(_randNum__WEBPACK_IMPORTED_MODULE_0__["intRandom"])(8, 16);
    if (ww < 768) {
      w = Object(_randNum__WEBPACK_IMPORTED_MODULE_0__["intRandom"])(6, 12);
    }
    el.style.zIndex = shuffledNumbers[_i];
    el.style.left = "".concat(numL, "%");
    el.style.width = "".concat(w, "rem");
    im.style.transitionDelay = "".concat(d, "ms");
    el.classList.add('is-active');
  }
}

/***/ }),

/***/ "./javascripts/modules/externalLink.js":
/*!*********************************************!*\
  !*** ./javascripts/modules/externalLink.js ***!
  \*********************************************/
/*! exports provided: externalLink */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "externalLink", function() { return externalLink; });
function externalLink() {
  var anchors = document.querySelectorAll("a");
  if (anchors.length) {
    for (var i = 0, l = anchors.length; i < l; i++) {
      if (location.host !== anchors[i].host) {
        var href = anchors[i].getAttribute("href");
        if (href && href !== "#" && href !== "javascript:void(0)") {
          anchors[i].setAttribute("target", "_blank");
        }
      }
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/fluidvideo.js":
/*!*******************************************!*\
  !*** ./javascripts/modules/fluidvideo.js ***!
  \*******************************************/
/*! exports provided: fluidvideo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fluidvideo", function() { return fluidvideo; });
function fluidvideo() {
  // List of Video Vendors embeds you want to support
  var players = ['iframe'];

  // Select videos
  var fitVids = document.querySelectorAll(players.join(","));

  // If there are videos on the page...
  if (fitVids.length) {
    // Loop through videos
    for (var i = 0; i < fitVids.length; i++) {
      // Get Video Information
      var el = fitVids[i];
      if (el.matches('[src*="embed.music.apple.com"]') || el.matches('[src*="embed.podcasts.apple.com"]')) {
        el.outerHTML = "<div class=\"embed-apple-music\">".concat(el.outerHTML, "</div>");
      } else if (el.matches('[src*="docs.google.com/forms"]')) {
        el.outerHTML = "<div class=\"embed-google-forms\">".concat(el.outerHTML, "</div>");
      } else {
        var width = el.getAttribute("width");
        var height = el.getAttribute("height");
        if (width && height && !width.includes('%') && !height.includes('%')) {
          var aspectRatio = height / width;
          var parentDiv = el.parentNode;

          // Wrap it in a DIV
          var div = document.createElement("div");
          div.className = "fitVids-wrapper";
          div.style.paddingBottom = aspectRatio * 100 + "%";
          parentDiv.insertBefore(div, el);
          el.remove();
          div.appendChild(el);

          // Clear height/width from fitVid
          el.removeAttribute("height");
          el.removeAttribute("width");
        }
      }
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/headerLogo.js":
/*!*******************************************!*\
  !*** ./javascripts/modules/headerLogo.js ***!
  \*******************************************/
/*! exports provided: headerLogo */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "headerLogo", function() { return headerLogo; });
/* harmony import */ var _getOffset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_getOffset */ "./javascripts/modules/_getOffset.js");

function headerLogo() {
  var logo = document.querySelector('.identity');
  if (logo) {
    if (document.body.classList.contains('template-index')) {
      var offsetTop = '';
      var getPos = function getPos() {
        document.body.classList.remove('is-logo-fixed');
        var offset = Object(_getOffset__WEBPACK_IMPORTED_MODULE_0__["getOffset"])(logo);
        offsetTop = offset.top;
      };
      var scroller = function scroller() {
        var scTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
        if (offsetTop < scTop) {
          document.body.classList.add('is-logo-fixed');
        } else {
          document.body.classList.remove('is-logo-fixed');
        }
      };
      window.addEventListener('resize', function () {
        getPos();
        scroller();
      });
      window.addEventListener('scroll', scroller, {
        passive: true
      });
      setInterval(function () {
        scroller();
      }, 1000);
      getPos();
      scroller();
    } else {
      var _scroller = function _scroller() {
        var scTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
        if (scTop > 30) {
          document.body.classList.add('is-logo-bg');
        } else {
          document.body.classList.remove('is-logo-bg');
        }
      };
      window.addEventListener('resize', function () {
        _scroller();
      });
      window.addEventListener('scroll', _scroller, {
        passive: true
      });
      setInterval(function () {
        _scroller();
      }, 1000);
      _scroller();
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/homeLayout.js":
/*!*******************************************!*\
  !*** ./javascripts/modules/homeLayout.js ***!
  \*******************************************/
/*! exports provided: homeLayout */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "homeLayout", function() { return homeLayout; });
/* harmony import */ var masonry_layout__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! masonry-layout */ "./node_modules/masonry-layout/masonry.js");
/* harmony import */ var masonry_layout__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(masonry_layout__WEBPACK_IMPORTED_MODULE_0__);

function homeLayout() {
  // const homeGrid = document.querySelectorAll('.home-grid');

  // homeGrid.forEach(element => {
  //   const msnry = new Masonry( element, {
  //     columnWidth: '.grid-sizer',
  //     itemSelector: '.home-element',
  //     percentPosition: true
  //   });
  // })
}

/***/ }),

/***/ "./javascripts/modules/hover.js":
/*!**************************************!*\
  !*** ./javascripts/modules/hover.js ***!
  \**************************************/
/*! exports provided: hover, hoverDynamic */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hover", function() { return hover; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoverDynamic", function() { return hoverDynamic; });
/* harmony import */ var _closest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_closest */ "./javascripts/modules/_closest.js");

function hover() {
  var hov = document.querySelectorAll('a, button, .hov');
  if (hasTouchScreen()) {
    var _loop = function _loop(i) {
      var el = hov[i];
      var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'hover-parent-touch');
      el.addEventListener('touchstart', function (e) {
        this.classList.add('hover-touch');
        if (parent) {
          parent.classList.add('hover-parent-touch');
        }
      });
      el.addEventListener('touchend', function (e) {
        this.classList.remove('hover-touch');
        if (parent) {
          parent.classList.remove('hover-parent-touch');
        }
      });
    };
    for (var i = 0; i < hov.length; i++) {
      _loop(i);
    }
    ;
  } else {
    var _loop2 = function _loop2(_i) {
      var el = hov[_i];
      var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'hover-parent-no-touch');
      el.addEventListener('mouseenter', function (e) {
        this.classList.add('hover');
        if (parent) {
          parent.classList.add('hover-parent-no-touch');
        }
      });
      el.addEventListener('mouseleave', function (e) {
        this.classList.remove('hover');
        if (parent) {
          parent.classList.remove('hover-parent-no-touch');
        }
      });
    };
    for (var _i = 0; _i < hov.length; _i++) {
      _loop2(_i);
    }
    ;
  }
}
function hoverDynamic(el) {
  if (el) {
    if (!hasTouchScreen()) {
      el.addEventListener('mouseenter', function (e) {
        this.classList.add('hover');
        var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'js-hover-parent');
        if (parent) {
          parent.classList.add('hover-parent');
        }
      });
      el.addEventListener('mouseleave', function (e) {
        this.classList.remove('hover');
        var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'js-hover-parent');
        if (parent) {
          parent.classList.remove('hover-parent');
        }
      });
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/marquee.js":
/*!****************************************!*\
  !*** ./javascripts/modules/marquee.js ***!
  \****************************************/
/*! exports provided: marquee */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "marquee", function() { return marquee; });
function marquee() {
  var marquees = document.querySelectorAll('.js-marquee');
  marquees.forEach(function (marquee) {
    var marqueeContainer = marquee.querySelector('.marquee-container');
    if (marqueeContainer) {
      var marqueeContent = marquee.querySelector('.marquee-content');
      if (marqueeContent) {
        var marqueeElements = marqueeContent.querySelectorAll('.marquee-element');
        if (marqueeElements.length) {
          var updatePosition = function updatePosition() {
            currentPosition += speed * direction;

            // コンテンツが左端または右端に到達した場合のリセット
            if (direction == -1 && -currentPosition >= w) {
              currentPosition = 0;
            } else if (direction == 1 && currentPosition >= w) {
              currentPosition = 0;
            }
            marqueeContainer.style.transform = "translateX(".concat(currentPosition, "px)");
          };
          var animate = function animate() {
            if (!pause) updatePosition();
            requestAnimationFrame(animate);
          };
          var ensureFilled = function ensureFilled() {
            // コンテンツ幅が画面幅より短い場合に複製が1つだと右端に空白ができるため、
            // 画面幅を覆いきるまで複製を追加する
            var required = marquee.offsetWidth + w;
            while (marqueeContainer.offsetWidth < required) {
              marqueeContainer.appendChild(marqueeContent.cloneNode(true));
            }
          };
          var speed = 1;
          var direction = -1;
          var pause = false;
          var isPause = false;
          if (marquee.dataset.speed) speed = Number(marquee.dataset.speed);
          if (marquee.dataset.direction == 'left') direction = -1;
          if (marquee.dataset.direction == 'right') direction = 1;
          if (marquee.dataset.pause == 'true') isPause = true;
          if (marquee.dataset.pause == 'false') isPause = false;
          var currentPosition = 0;
          var w = marqueeContent.offsetWidth;
          ensureFilled();
          if (isPause) {
            // ホバー時にアニメーションを一時停止
            marquee.addEventListener('mouseover', function () {
              return pause = true;
            });
            marquee.addEventListener('mouseout', function () {
              return pause = false;
            });
          }
          var lastInnerWidth = window.innerWidth;
          window.addEventListener("resize", function () {
            if (lastInnerWidth != window.innerWidth) {
              lastInnerWidth = window.innerWidth;
              setTimeout(function () {
                w = marqueeContent.offsetWidth;
                ensureFilled();
              }, 0);
            }
          });
          setInterval(function () {
            w = marqueeContent.offsetWidth;
            ensureFilled();
          }, 1000);
          animate(); // アニメーションの開始

          marquee.classList.add('is-active');
        }
      }
    }
  });
}

/***/ }),

/***/ "./javascripts/modules/navNested.js":
/*!******************************************!*\
  !*** ./javascripts/modules/navNested.js ***!
  \******************************************/
/*! exports provided: navNested */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "navNested", function() { return navNested; });
/* harmony import */ var _closest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_closest */ "./javascripts/modules/_closest.js");

function navNested() {
  var navNested = document.querySelectorAll('.nav-nested');
  if (navNested.length) {
    if (hasTouchScreen()) {
      var _loop = function _loop(i) {
        var el = navNested[i];
        var trigger = el.querySelector('.nav-nested-trigger');
        if (trigger) {
          trigger.addEventListener('click', function (e) {
            document.body.classList.remove('is-cart-active', 'is-search-active');
            if (el.classList.contains('is-active')) {
              el.classList.remove('is-active');
              var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'js-nav-container');
              if (parent) {
                parent.classList.remove('is-active');
              }
            } else {
              for (var _i = 0; _i < navNested.length; _i++) {
                var _el = navNested[_i];
                _el.classList.remove('is-active');
              }
              el.classList.add('is-active');
              var _parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'js-nav-container');
              if (_parent) {
                _parent.classList.add('is-active');
              }
            }
            e.preventDefault();
          });
        }
      };
      for (var i = 0; i < navNested.length; i++) {
        _loop(i);
      }
      ;
    } else {
      var _loop2 = function _loop2(_i2) {
        var el = navNested[_i2];
        el.addEventListener('mouseenter', function (e) {
          document.body.classList.remove('is-cart-active', 'is-search-active');
          el.classList.add('is-active');
        });
        el.addEventListener('mouseleave', function (e) {
          el.classList.remove('is-active');
        });
      };
      for (var _i2 = 0; _i2 < navNested.length; _i2++) {
        _loop2(_i2);
      }
      ;
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/openClose.js":
/*!******************************************!*\
  !*** ./javascripts/modules/openClose.js ***!
  \******************************************/
/*! exports provided: openClose */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "openClose", function() { return openClose; });
function openClose() {
  var target = '';
  var openTargetElements = document.querySelectorAll('[data-open-target]');
  openTargetElements.forEach(function (element) {
    element.addEventListener('click', function () {
      target = element.getAttribute('data-open-target');
      var isContainerKeep = element.getAttribute('data-is-container-keep');
      document.querySelectorAll("[data-container=\"".concat(target, "\"]")).forEach(function (container) {
        container.classList.remove('display-none');
      });
      if (!isContainerKeep) {
        var closestContainer = element.closest('[data-container]');
        if (closestContainer) {
          closestContainer.classList.add('display-none');
        }
      }
    });
  });
  if (window.location.hash) {
    target = window.location.hash.replace("#", "");
    if (!/gid|pid/.test(target)) {
      var targetElement = document.querySelector("[data-open-target=\"".concat(target, "\"]"));
      if (targetElement) {
        targetElement.click();
      }
    }
  }
}
;

/***/ }),

/***/ "./javascripts/modules/photoswipe-init.js":
/*!************************************************!*\
  !*** ./javascripts/modules/photoswipe-init.js ***!
  \************************************************/
/*! exports provided: initPhotoSwipeFromDOM */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initPhotoSwipeFromDOM", function() { return initPhotoSwipeFromDOM; });
/* harmony import */ var _photoswipe__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./photoswipe */ "./javascripts/modules/photoswipe.js");
/* harmony import */ var _photoswipe__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_photoswipe__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _photoswipe_ui_default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./photoswipe-ui-default */ "./javascripts/modules/photoswipe-ui-default.js");
/* harmony import */ var _photoswipe_ui_default__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_photoswipe_ui_default__WEBPACK_IMPORTED_MODULE_1__);


function initPhotoSwipeFromDOM(gallerySelector) {
  // parse slide data (url, title, size ...) from DOM elements
  // (children of gallerySelector)
  var parseThumbnailElements = function parseThumbnailElements(el) {
    var thumbElements = el.querySelectorAll('.js-pswp-element');
    var items = [];
    for (var i = 0; i < thumbElements.length; i++) {
      var figureEl = thumbElements[i];

      // include only element nodes
      if (figureEl.nodeType !== 1) continue;
      var size = figureEl.getAttribute('data-size').split('x');

      // create slide object
      var item = {
        src: figureEl.getAttribute('href'),
        w: parseInt(size[0], 10),
        h: parseInt(size[1], 10)
      };
      if (figureEl.querySelector('.js-pswp-caption')) {
        item.title = figureEl.querySelector('.js-pswp-caption').innerHTML;
      }
      item.el = figureEl;
      items.push(item);
    }
    return items;
  };

  // find nearest parent element
  var closest = function closest(el, fn) {
    return el && (fn(el) ? el : closest(el.parentNode, fn));
  };

  // triggers when user clicks on thumbnail
  var onThumbnailsClick = function onThumbnailsClick(e) {
    e = e || window.event;
    e.preventDefault ? e.preventDefault() : e.returnValue = false;
    var eTarget = e.target || e.srcElement;

    // find root element of slide
    var clickedListItem = closest(eTarget, function (el) {
      return el.classList.contains('js-pswp-element');
    });
    if (!clickedListItem) {
      return;
    }

    // find index of clicked item by looping through all child nodes
    // alternatively, you may define index via data- attribute
    var clickedGallery = clickedListItem.closest(gallerySelector);
    var childNodes = clickedGallery.querySelectorAll('.js-pswp-element');
    var nodeIndex = 0;
    var index = '';
    for (var i = 0; i < childNodes.length; i++) {
      if (childNodes[i].nodeType !== 1) {
        continue;
      }
      if (childNodes[i] === clickedListItem) {
        index = nodeIndex;
        break;
      }
      nodeIndex++;
    }
    if (index >= 0) {
      // open PhotoSwipe if valid index found
      openPhotoSwipe(index, clickedGallery);
    }
    return false;
  };

  // parse picture index and gallery index from URL (#&pid=1&gid=2)
  var photoswipeParseHash = function photoswipeParseHash() {
    var hash = window.location.hash.substring(1);
    var params = {};
    if (hash.length < 5) {
      return params;
    }
    var consts = hash.split('&');
    for (var i = 0; i < consts.length; i++) {
      if (!consts[i]) {
        continue;
      }
      var pair = consts[i].split('=');
      if (pair.length < 2) {
        continue;
      }
      params[pair[0]] = pair[1];
    }
    if (params.gid) {
      params.gid = parseInt(params.gid, 10);
    }
    return params;
  };
  var openPhotoSwipe = function openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
    var pswpElement = document.querySelector('.pswp');
    var items = parseThumbnailElements(galleryElement);
    // define options (if needed)
    var options = {
      allowPanToNext: true,
      preload: [2, 2],
      spacing: 0.12,
      bgOpacity: 1,
      mouseUsed: false,
      loop: true,
      pinchToClose: true,
      closeOnScroll: true,
      closeOnVerticalDrag: true,
      verticalDragRange: 0.75,
      hideAnimationDuration: 0,
      showAnimationDuration: 0,
      showHideOpacity: false,
      focus: true,
      escKey: true,
      arrowKeys: true,
      mainScrollEndFriction: 0.35,
      panEndFriction: 0.35,
      // define gallery index (for URL)
      galleryUID: galleryElement.getAttribute('data-pswp-uid'),
      getThumbBoundsFn: function getThumbBoundsFn(index) {
        // See Options -> getThumbBoundsFn section of documentation for more info
        var thumbnail = items[index].el.querySelector('.js-pswp-img'); // find thumbnail
        var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
        var rect = thumbnail.getBoundingClientRect();
        return {
          x: rect.left,
          y: rect.top + pageYScroll,
          w: rect.width
        };
      }
    };

    // PhotoSwipe opened from URL
    if (fromURL) {
      if (options.galleryPIDs) {
        // parse real index when custom PIDs are used
        // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
        for (var j = 0; j < items.length; j++) {
          if (items[j].pid == index) {
            options.index = j;
            break;
          }
        }
      } else {
        // in URL indexes start from 1
        options.index = parseInt(index, 10) - 1;
      }
    } else {
      options.index = parseInt(index, 10);
    }

    // exit if index not found
    if (isNaN(options.index)) {
      return;
    }
    if (disableAnimation) {
      options.showAnimationDuration = 0;
    }

    // Pass data to PhotoSwipe and initialize it
    var pswp_gallery = new _photoswipe__WEBPACK_IMPORTED_MODULE_0__(pswpElement, _photoswipe_ui_default__WEBPACK_IMPORTED_MODULE_1__, items, options);
    pswp_gallery.init();
  };

  // loop through all gallery elements and bind events
  var galleryElements = document.querySelectorAll(gallerySelector);
  for (var i = 0, l = galleryElements.length; i < l; i++) {
    galleryElements[i].setAttribute('data-pswp-uid', i + 1);
    var t = galleryElements[i].querySelectorAll('.js-pswp-open');
    for (var ii = 0; ii < t.length; ii++) {
      t[ii].onclick = onThumbnailsClick;
    }
  }

  // Parse URL and open gallery if it contains #&pid=3&gid=1
  var hashData = photoswipeParseHash();
  if (hashData.pid && hashData.gid) {
    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
  }
}
;

/***/ }),

/***/ "./javascripts/modules/photoswipe-ui-default.js":
/*!******************************************************!*\
  !*** ./javascripts/modules/photoswipe-ui-default.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*! PhotoSwipe Default UI - 4.1.2 - 2017-04-05
* http://photoswipe.com
* Copyright (c) 2017 Dmitry Semenov; */
/**
*
* UI on top of main sliding area (caption, arrows, close button, etc.).
* Built just using public methods/properties of PhotoSwipe.
*
*/
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  'use strict';

  var PhotoSwipeUI_Default = function PhotoSwipeUI_Default(pswp, framework) {
    var ui = this;
    var _overlayUIUpdated = false,
      _controlsVisible = true,
      _fullscrenAPI,
      _controls,
      _captionContainer,
      _fakeCaptionContainer,
      _indexIndicator,
      _shareButton,
      _shareModal,
      _shareModalHidden = true,
      _initalCloseOnScrollValue,
      _isIdle,
      _listen,
      _loadingIndicator,
      _loadingIndicatorHidden,
      _loadingIndicatorTimeout,
      _galleryHasOneSlide,
      _options,
      _defaultUIOptions = {
        barsSize: {
          top: 50,
          bottom: 'auto'
        },
        closeElClasses: ['item', 'img', 'caption', 'zoom-wrap', 'ui', 'top-bar'],
        timeToIdle: 4000,
        timeToIdleOutside: 1000,
        loadingIndicatorDelay: 1000,
        // 2s

        addCaptionHTMLFn: function addCaptionHTMLFn(item, captionEl /*, isFake */) {
          if (!item.title) {
            captionEl.children[0].innerHTML = '';
            return false;
          }
          captionEl.children[0].innerHTML = item.title;
          return true;
        },
        closeEl: true,
        captionEl: true,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        tapToClose: false,
        tapToToggleControls: true,
        clickToCloseNonZoomable: true,
        shareButtons: [{
          id: 'facebook',
          label: 'Share on Facebook',
          url: 'https://www.facebook.com/sharer/sharer.php?u={{url}}'
        }, {
          id: 'twitter',
          label: 'Tweet',
          url: 'https://twitter.com/intent/tweet?text={{text}}&url={{url}}'
        }, {
          id: 'pinterest',
          label: 'Pin it',
          url: 'http://www.pinterest.com/pin/create/button/' + '?url={{url}}&media={{image_url}}&description={{text}}'
        }, {
          id: 'download',
          label: 'Download image',
          url: '{{raw_image_url}}',
          download: true
        }],
        getImageURLForShare: function getImageURLForShare( /* shareButtonData */
        ) {
          return pswp.currItem.src || '';
        },
        getPageURLForShare: function getPageURLForShare( /* shareButtonData */
        ) {
          return window.location.href;
        },
        getTextForShare: function getTextForShare( /* shareButtonData */
        ) {
          return pswp.currItem.title || '';
        },
        indexIndicatorSep: ' / ',
        fitControlsWidth: 1200
      },
      _blockControlsTap,
      _blockControlsTapTimeout;
    var _onControlsTap = function _onControlsTap(e) {
        if (_blockControlsTap) {
          return true;
        }
        e = e || window.event;
        if (_options.timeToIdle && _options.mouseUsed && !_isIdle) {
          // reset idle timer
          _onIdleMouseMove();
        }
        var target = e.target || e.srcElement,
          uiElement,
          clickedClass = target.getAttribute('class') || '',
          found;
        for (var i = 0; i < _uiElements.length; i++) {
          uiElement = _uiElements[i];
          if (uiElement.onTap && clickedClass.indexOf('pswp__' + uiElement.name) > -1) {
            uiElement.onTap();
            found = true;
          }
        }
        if (found) {
          if (e.stopPropagation) {
            e.stopPropagation();
          }
          _blockControlsTap = true;

          // Some versions of Android don't prevent ghost click event
          // when preventDefault() was called on touchstart and/or touchend.
          //
          // This happens on v4.3, 4.2, 4.1,
          // older versions strangely work correctly,
          // but just in case we add delay on all of them)
          var tapDelay = framework.features.isOldAndroid ? 600 : 30;
          _blockControlsTapTimeout = setTimeout(function () {
            _blockControlsTap = false;
          }, tapDelay);
        }
      },
      _fitControlsInViewport = function _fitControlsInViewport() {
        return !pswp.likelyTouchDevice || _options.mouseUsed || screen.width > _options.fitControlsWidth;
      },
      _togglePswpClass = function _togglePswpClass(el, cName, add) {
        framework[(add ? 'add' : 'remove') + 'Class'](el, 'pswp__' + cName);
      },
      // add class when there is just one item in the gallery
      // (by default it hides left/right arrows and 1ofX counter)
      _countNumItems = function _countNumItems() {
        var hasOneSlide = _options.getNumItemsFn() === 1;
        if (hasOneSlide !== _galleryHasOneSlide) {
          _togglePswpClass(_controls, 'ui--one-slide', hasOneSlide);
          _galleryHasOneSlide = hasOneSlide;
        }
      },
      _toggleShareModalClass = function _toggleShareModalClass() {
        _togglePswpClass(_shareModal, 'share-modal--hidden', _shareModalHidden);
      },
      _toggleShareModal = function _toggleShareModal() {
        _shareModalHidden = !_shareModalHidden;
        if (!_shareModalHidden) {
          _toggleShareModalClass();
          setTimeout(function () {
            if (!_shareModalHidden) {
              framework.addClass(_shareModal, 'pswp__share-modal--fade-in');
            }
          }, 30);
        } else {
          framework.removeClass(_shareModal, 'pswp__share-modal--fade-in');
          setTimeout(function () {
            if (_shareModalHidden) {
              _toggleShareModalClass();
            }
          }, 300);
        }
        if (!_shareModalHidden) {
          _updateShareURLs();
        }
        return false;
      },
      _openWindowPopup = function _openWindowPopup(e) {
        e = e || window.event;
        var target = e.target || e.srcElement;
        pswp.shout('shareLinkClick', e, target);
        if (!target.href) {
          return false;
        }
        if (target.hasAttribute('download')) {
          return true;
        }
        window.open(target.href, 'pswp_share', 'scrollbars=yes,resizable=yes,toolbar=no,' + 'location=yes,width=550,height=420,top=100,left=' + (window.screen ? Math.round(screen.width / 2 - 275) : 100));
        if (!_shareModalHidden) {
          _toggleShareModal();
        }
        return false;
      },
      _updateShareURLs = function _updateShareURLs() {
        var shareButtonOut = '',
          shareButtonData,
          shareURL,
          image_url,
          page_url,
          share_text;
        for (var i = 0; i < _options.shareButtons.length; i++) {
          shareButtonData = _options.shareButtons[i];
          image_url = _options.getImageURLForShare(shareButtonData);
          page_url = _options.getPageURLForShare(shareButtonData);
          share_text = _options.getTextForShare(shareButtonData);
          shareURL = shareButtonData.url.replace('{{url}}', encodeURIComponent(page_url)).replace('{{image_url}}', encodeURIComponent(image_url)).replace('{{raw_image_url}}', image_url).replace('{{text}}', encodeURIComponent(share_text));
          shareButtonOut += '<a href="' + shareURL + '" target="_blank" ' + 'class="pswp__share--' + shareButtonData.id + '"' + (shareButtonData.download ? 'download' : '') + '>' + shareButtonData.label + '</a>';
          if (_options.parseShareButtonOut) {
            shareButtonOut = _options.parseShareButtonOut(shareButtonData, shareButtonOut);
          }
        }
        _shareModal.children[0].innerHTML = shareButtonOut;
        _shareModal.children[0].onclick = _openWindowPopup;
      },
      _hasCloseClass = function _hasCloseClass(target) {
        for (var i = 0; i < _options.closeElClasses.length; i++) {
          if (framework.hasClass(target, 'pswp__' + _options.closeElClasses[i])) {
            return true;
          }
        }
      },
      _idleInterval,
      _idleTimer,
      _idleIncrement = 0,
      _onIdleMouseMove = function _onIdleMouseMove() {
        clearTimeout(_idleTimer);
        _idleIncrement = 0;
        if (_isIdle) {
          ui.setIdle(false);
        }
      },
      _onMouseLeaveWindow = function _onMouseLeaveWindow(e) {
        e = e ? e : window.event;
        var from = e.relatedTarget || e.toElement;
        if (!from || from.nodeName === 'HTML') {
          clearTimeout(_idleTimer);
          _idleTimer = setTimeout(function () {
            ui.setIdle(true);
          }, _options.timeToIdleOutside);
        }
      },
      _setupFullscreenAPI = function _setupFullscreenAPI() {
        if (_options.fullscreenEl && !framework.features.isOldAndroid) {
          if (!_fullscrenAPI) {
            _fullscrenAPI = ui.getFullscreenAPI();
          }
          if (_fullscrenAPI) {
            framework.bind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
            ui.updateFullscreen();
            framework.addClass(pswp.template, 'pswp--supports-fs');
          } else {
            framework.removeClass(pswp.template, 'pswp--supports-fs');
          }
        }
      },
      _setupLoadingIndicator = function _setupLoadingIndicator() {
        // Setup loading indicator
        if (_options.preloaderEl) {
          _toggleLoadingIndicator(true);
          _listen('beforeChange', function () {
            clearTimeout(_loadingIndicatorTimeout);

            // display loading indicator with delay
            _loadingIndicatorTimeout = setTimeout(function () {
              if (pswp.currItem && pswp.currItem.loading) {
                if (!pswp.allowProgressiveImg() || pswp.currItem.img && !pswp.currItem.img.naturalWidth) {
                  // show preloader if progressive loading is not enabled,
                  // or image width is not defined yet (because of slow connection)
                  _toggleLoadingIndicator(false);
                  // items-controller.js function allowProgressiveImg
                }
              } else {
                _toggleLoadingIndicator(true); // hide preloader
              }
            }, _options.loadingIndicatorDelay);
          });
          _listen('imageLoadComplete', function (index, item) {
            if (pswp.currItem === item) {
              _toggleLoadingIndicator(true);
            }
          });
        }
      },
      _toggleLoadingIndicator = function _toggleLoadingIndicator(hide) {
        if (_loadingIndicatorHidden !== hide) {
          _togglePswpClass(_loadingIndicator, 'preloader--active', !hide);
          _loadingIndicatorHidden = hide;
        }
      },
      _applyNavBarGaps = function _applyNavBarGaps(item) {
        var gap = item.vGap;
        if (_fitControlsInViewport()) {
          var bars = _options.barsSize;
          if (_options.captionEl && bars.bottom === 'auto') {
            if (!_fakeCaptionContainer) {
              _fakeCaptionContainer = framework.createEl('pswp__caption pswp__caption--fake');
              _fakeCaptionContainer.appendChild(framework.createEl('pswp__caption__center'));
              _controls.insertBefore(_fakeCaptionContainer, _captionContainer);
              framework.addClass(_controls, 'pswp__ui--fit');
            }
            if (_options.addCaptionHTMLFn(item, _fakeCaptionContainer, true)) {
              var captionSize = _fakeCaptionContainer.clientHeight;
              gap.bottom = parseInt(captionSize, 10) || 44;
            } else {
              gap.bottom = bars.top; // if no caption, set size of bottom gap to size of top
            }
          } else {
            gap.bottom = bars.bottom === 'auto' ? 0 : bars.bottom;
          }

          // height of top bar is static, no need to calculate it
          gap.top = bars.top;
        } else {
          gap.top = gap.bottom = 0;
        }
      },
      _setupIdle = function _setupIdle() {
        // Hide controls when mouse is used
        if (_options.timeToIdle) {
          _listen('mouseUsed', function () {
            framework.bind(document, 'mousemove', _onIdleMouseMove);
            framework.bind(document, 'mouseout', _onMouseLeaveWindow);
            _idleInterval = setInterval(function () {
              _idleIncrement++;
              if (_idleIncrement === 2) {
                ui.setIdle(true);
              }
            }, _options.timeToIdle / 2);
          });
        }
      },
      _setupHidingControlsDuringGestures = function _setupHidingControlsDuringGestures() {
        // Hide controls on vertical drag
        _listen('onVerticalDrag', function (now) {
          if (_controlsVisible && now < 0.95) {
            ui.hideControls();
          } else if (!_controlsVisible && now >= 0.95) {
            ui.showControls();
          }
        });

        // Hide controls when pinching to close
        var pinchControlsHidden;
        _listen('onPinchClose', function (now) {
          if (_controlsVisible && now < 0.9) {
            ui.hideControls();
            pinchControlsHidden = true;
          } else if (pinchControlsHidden && !_controlsVisible && now > 0.9) {
            ui.showControls();
          }
        });
        _listen('zoomGestureEnded', function () {
          pinchControlsHidden = false;
          if (pinchControlsHidden && !_controlsVisible) {
            ui.showControls();
          }
        });
      };
    var _uiElements = [{
      name: 'caption',
      option: 'captionEl',
      onInit: function onInit(el) {
        _captionContainer = el;
      }
    }, {
      name: 'share-modal',
      option: 'shareEl',
      onInit: function onInit(el) {
        _shareModal = el;
      },
      onTap: function onTap() {
        _toggleShareModal();
      }
    }, {
      name: 'button--share',
      option: 'shareEl',
      onInit: function onInit(el) {
        _shareButton = el;
      },
      onTap: function onTap() {
        _toggleShareModal();
      }
    }, {
      name: 'button--zoom',
      option: 'zoomEl',
      onTap: pswp.toggleDesktopZoom
    }, {
      name: 'counter',
      option: 'counterEl',
      onInit: function onInit(el) {
        _indexIndicator = el;
      }
    }, {
      name: 'button--close',
      option: 'closeEl',
      onTap: pswp.close
    }, {
      name: 'button--arrow--left',
      option: 'arrowEl',
      onTap: pswp.prev
    }, {
      name: 'button--arrow--right',
      option: 'arrowEl',
      onTap: pswp.next
    }, {
      name: 'button--fs',
      option: 'fullscreenEl',
      onTap: function onTap() {
        if (_fullscrenAPI.isFullscreen()) {
          _fullscrenAPI.exit();
        } else {
          _fullscrenAPI.enter();
        }
      }
    }, {
      name: 'preloader',
      option: 'preloaderEl',
      onInit: function onInit(el) {
        _loadingIndicator = el;
      }
    }];
    var _setupUIElements = function _setupUIElements() {
      var item, classAttr, uiElement;
      var loopThroughChildElements = function loopThroughChildElements(sChildren) {
        if (!sChildren) {
          return;
        }
        var l = sChildren.length;
        for (var i = 0; i < l; i++) {
          item = sChildren[i];
          classAttr = item.className;
          for (var a = 0; a < _uiElements.length; a++) {
            uiElement = _uiElements[a];
            if (classAttr.indexOf('pswp__' + uiElement.name) > -1) {
              if (_options[uiElement.option]) {
                // if element is not disabled from options

                framework.removeClass(item, 'pswp__element--disabled');
                if (uiElement.onInit) {
                  uiElement.onInit(item);
                }

                //item.style.display = 'block';
              } else {
                framework.addClass(item, 'pswp__element--disabled');
                //item.style.display = 'none';
              }
            }
          }
        }
      };
      loopThroughChildElements(_controls.children);
      var topBar = framework.getChildByClass(_controls, 'pswp__top-bar');
      if (topBar) {
        loopThroughChildElements(topBar.children);
      }
    };
    ui.init = function () {
      // extend options
      framework.extend(pswp.options, _defaultUIOptions, true);

      // create local link for fast access
      _options = pswp.options;

      // find pswp__ui element
      _controls = framework.getChildByClass(pswp.scrollWrap, 'pswp__ui');

      // create local link
      _listen = pswp.listen;
      _setupHidingControlsDuringGestures();

      // update controls when slides change
      _listen('beforeChange', ui.update);

      // toggle zoom on double-tap
      _listen('doubleTap', function (point) {
        var initialZoomLevel = pswp.currItem.initialZoomLevel;
        if (pswp.getZoomLevel() !== initialZoomLevel) {
          pswp.zoomTo(initialZoomLevel, point, 333);
        } else {
          pswp.zoomTo(_options.getDoubleTapZoom(false, pswp.currItem), point, 333);
        }
      });

      // Allow text selection in caption
      _listen('preventDragEvent', function (e, isDown, preventObj) {
        var t = e.target || e.srcElement;
        if (t && t.getAttribute('class') && e.type.indexOf('mouse') > -1 && (t.getAttribute('class').indexOf('__caption') > 0 || /(SMALL|STRONG|EM)/i.test(t.tagName))) {
          preventObj.prevent = false;
        }
      });

      // bind events for UI
      _listen('bindEvents', function () {
        framework.bind(_controls, 'pswpTap click', _onControlsTap);
        framework.bind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
        if (!pswp.likelyTouchDevice) {
          framework.bind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
        }
      });

      // unbind events for UI
      _listen('unbindEvents', function () {
        if (!_shareModalHidden) {
          _toggleShareModal();
        }
        if (_idleInterval) {
          clearInterval(_idleInterval);
        }
        framework.unbind(document, 'mouseout', _onMouseLeaveWindow);
        framework.unbind(document, 'mousemove', _onIdleMouseMove);
        framework.unbind(_controls, 'pswpTap click', _onControlsTap);
        framework.unbind(pswp.scrollWrap, 'pswpTap', ui.onGlobalTap);
        framework.unbind(pswp.scrollWrap, 'mouseover', ui.onMouseOver);
        if (_fullscrenAPI) {
          framework.unbind(document, _fullscrenAPI.eventK, ui.updateFullscreen);
          if (_fullscrenAPI.isFullscreen()) {
            _options.hideAnimationDuration = 0;
            _fullscrenAPI.exit();
          }
          _fullscrenAPI = null;
        }
      });

      // clean up things when gallery is destroyed
      _listen('destroy', function () {
        if (_options.captionEl) {
          if (_fakeCaptionContainer) {
            _controls.removeChild(_fakeCaptionContainer);
          }
          framework.removeClass(_captionContainer, 'pswp__caption--empty');
        }
        if (_shareModal) {
          _shareModal.children[0].onclick = null;
        }
        framework.removeClass(_controls, 'pswp__ui--over-close');
        framework.addClass(_controls, 'pswp__ui--hidden');
        ui.setIdle(false);
      });
      if (!_options.showAnimationDuration) {
        framework.removeClass(_controls, 'pswp__ui--hidden');
      }
      _listen('initialZoomIn', function () {
        if (_options.showAnimationDuration) {
          framework.removeClass(_controls, 'pswp__ui--hidden');
        }
      });
      _listen('initialZoomOut', function () {
        framework.addClass(_controls, 'pswp__ui--hidden');
      });
      _listen('parseVerticalMargin', _applyNavBarGaps);
      _setupUIElements();
      if (_options.shareEl && _shareButton && _shareModal) {
        _shareModalHidden = true;
      }
      _countNumItems();
      _setupIdle();
      _setupFullscreenAPI();
      _setupLoadingIndicator();
    };
    ui.setIdle = function (isIdle) {
      _isIdle = isIdle;
      _togglePswpClass(_controls, 'ui--idle', isIdle);
    };
    ui.update = function () {
      // Don't update UI if it's hidden
      if (_controlsVisible && pswp.currItem) {
        ui.updateIndexIndicator();
        if (_options.captionEl) {
          _options.addCaptionHTMLFn(pswp.currItem, _captionContainer);
          _togglePswpClass(_captionContainer, 'caption--empty', !pswp.currItem.title);
        }
        _overlayUIUpdated = true;
      } else {
        _overlayUIUpdated = false;
      }
      if (!_shareModalHidden) {
        _toggleShareModal();
      }
      _countNumItems();
    };
    ui.updateFullscreen = function (e) {
      if (e) {
        // some browsers change window scroll position during the fullscreen
        // so PhotoSwipe updates it just in case
        setTimeout(function () {
          pswp.setScrollOffset(0, framework.getScrollY());
        }, 50);
      }

      // toogle pswp--fs class on root element
      framework[(_fullscrenAPI.isFullscreen() ? 'add' : 'remove') + 'Class'](pswp.template, 'pswp--fs');
    };
    ui.updateIndexIndicator = function () {
      if (_options.counterEl) {
        _indexIndicator.innerHTML = pswp.getCurrentIndex() + 1 + _options.indexIndicatorSep + _options.getNumItemsFn();
      }
    };
    ui.onGlobalTap = function (e) {
      e = e || window.event;
      var target = e.target || e.srcElement;
      if (_blockControlsTap) {
        return;
      }
      if (e.detail && e.detail.pointerType === 'mouse') {
        // close gallery if clicked outside of the image
        if (_hasCloseClass(target)) {
          pswp.close();
          return;
        }
        if (framework.hasClass(target, 'pswp__img')) {
          if (pswp.getZoomLevel() === 1 && pswp.getZoomLevel() <= pswp.currItem.fitRatio) {
            if (_options.clickToCloseNonZoomable) {
              pswp.close();
            }
          } else {
            pswp.toggleDesktopZoom(e.detail.releasePoint);
          }
        }
      } else {
        // tap anywhere (except buttons) to toggle visibility of controls
        if (_options.tapToToggleControls) {
          if (_controlsVisible) {
            ui.hideControls();
          } else {
            ui.showControls();
          }
        }

        // tap to close gallery
        if (_options.tapToClose && (framework.hasClass(target, 'pswp__img') || _hasCloseClass(target))) {
          pswp.close();
          return;
        }
      }
    };
    ui.onMouseOver = function (e) {
      e = e || window.event;
      var target = e.target || e.srcElement;

      // add class when mouse is over an element that should close the gallery
      _togglePswpClass(_controls, 'ui--over-close', _hasCloseClass(target));
    };
    ui.hideControls = function () {
      framework.addClass(_controls, 'pswp__ui--hidden');
      _controlsVisible = false;
    };
    ui.showControls = function () {
      _controlsVisible = true;
      if (!_overlayUIUpdated) {
        ui.update();
      }
      framework.removeClass(_controls, 'pswp__ui--hidden');
    };
    ui.supportsFullscreen = function () {
      var d = document;
      return !!(d.exitFullscreen || d.mozCancelFullScreen || d.webkitExitFullscreen || d.msExitFullscreen);
    };
    ui.getFullscreenAPI = function () {
      var dE = document.documentElement,
        api,
        tF = 'fullscreenchange';
      if (dE.requestFullscreen) {
        api = {
          enterK: 'requestFullscreen',
          exitK: 'exitFullscreen',
          elementK: 'fullscreenElement',
          eventK: tF
        };
      } else if (dE.mozRequestFullScreen) {
        api = {
          enterK: 'mozRequestFullScreen',
          exitK: 'mozCancelFullScreen',
          elementK: 'mozFullScreenElement',
          eventK: 'moz' + tF
        };
      } else if (dE.webkitRequestFullscreen) {
        api = {
          enterK: 'webkitRequestFullscreen',
          exitK: 'webkitExitFullscreen',
          elementK: 'webkitFullscreenElement',
          eventK: 'webkit' + tF
        };
      } else if (dE.msRequestFullscreen) {
        api = {
          enterK: 'msRequestFullscreen',
          exitK: 'msExitFullscreen',
          elementK: 'msFullscreenElement',
          eventK: 'MSFullscreenChange'
        };
      }
      if (api) {
        api.enter = function () {
          // disable close-on-scroll in fullscreen
          _initalCloseOnScrollValue = _options.closeOnScroll;
          _options.closeOnScroll = false;
          if (this.enterK === 'webkitRequestFullscreen') {
            pswp.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT);
          } else {
            return pswp.template[this.enterK]();
          }
        };
        api.exit = function () {
          _options.closeOnScroll = _initalCloseOnScrollValue;
          return document[this.exitK]();
        };
        api.isFullscreen = function () {
          return document[this.elementK];
        };
      }
      return api;
    };
  };
  return PhotoSwipeUI_Default;
});

/***/ }),

/***/ "./javascripts/modules/photoswipe.js":
/*!*******************************************!*\
  !*** ./javascripts/modules/photoswipe.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*! PhotoSwipe - v4.1.2 - 2017-04-05
* http://photoswipe.com
* Copyright (c) 2017 Dmitry Semenov; */
(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(this, function () {
  'use strict';

  var PhotoSwipe = function PhotoSwipe(template, UiClass, items, options) {
    /*>>framework-bridge*/
    /**
     *
     * Set of generic functions used by gallery.
     * 
     * You're free to modify anything here as long as functionality is kept.
     * 
     */
    var framework = {
      features: null,
      bind: function bind(target, type, listener, unbind) {
        var methodName = (unbind ? 'remove' : 'add') + 'EventListener';
        type = type.split(' ');
        for (var i = 0; i < type.length; i++) {
          if (type[i]) {
            target[methodName](type[i], listener, false);
          }
        }
      },
      isArray: function isArray(obj) {
        return obj instanceof Array;
      },
      createEl: function createEl(classes, tag) {
        var el = document.createElement(tag || 'div');
        if (classes) {
          el.className = classes;
        }
        return el;
      },
      getScrollY: function getScrollY() {
        var yOffset = window.pageYOffset;
        return yOffset !== undefined ? yOffset : document.documentElement.scrollTop;
      },
      unbind: function unbind(target, type, listener) {
        framework.bind(target, type, listener, true);
      },
      removeClass: function removeClass(el, className) {
        var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
        el.className = el.className.replace(reg, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
      },
      addClass: function addClass(el, className) {
        if (!framework.hasClass(el, className)) {
          el.className += (el.className ? ' ' : '') + className;
        }
      },
      hasClass: function hasClass(el, className) {
        return el.className && new RegExp('(^|\\s)' + className + '(\\s|$)').test(el.className);
      },
      getChildByClass: function getChildByClass(parentEl, childClassName) {
        var node = parentEl.firstChild;
        while (node) {
          if (framework.hasClass(node, childClassName)) {
            return node;
          }
          node = node.nextSibling;
        }
      },
      arraySearch: function arraySearch(array, value, key) {
        var i = array.length;
        while (i--) {
          if (array[i][key] === value) {
            return i;
          }
        }
        return -1;
      },
      extend: function extend(o1, o2, preventOverwrite) {
        for (var prop in o2) {
          if (o2.hasOwnProperty(prop)) {
            if (preventOverwrite && o1.hasOwnProperty(prop)) {
              continue;
            }
            o1[prop] = o2[prop];
          }
        }
      },
      easing: {
        sine: {
          out: function out(k) {
            return Math.sin(k * (Math.PI / 2));
          },
          inOut: function inOut(k) {
            return -(Math.cos(Math.PI * k) - 1) / 2;
          }
        },
        cubic: {
          out: function out(k) {
            return --k * k * k + 1;
          }
        }
        /*
        	elastic: {
        		out: function ( k ) {
        				var s, a = 0.1, p = 0.4;
        			if ( k === 0 ) return 0;
        			if ( k === 1 ) return 1;
        			if ( !a || a < 1 ) { a = 1; s = p / 4; }
        			else s = p * Math.asin( 1 / a ) / ( 2 * Math.PI );
        			return ( a * Math.pow( 2, - 10 * k) * Math.sin( ( k - s ) * ( 2 * Math.PI ) / p ) + 1 );
        			},
        	},
        	back: {
        		out: function ( k ) {
        			var s = 1.70158;
        			return --k * k * ( ( s + 1 ) * k + s ) + 1;
        		}
        	}
        */
      },
      /**
       * 
       * @return {object}
       * 
       * {
       *  raf : request animation frame function
       *  caf : cancel animation frame function
       *  transfrom : transform property key (with vendor), or null if not supported
       *  oldIE : IE8 or below
       * }
       * 
       */
      detectFeatures: function detectFeatures() {
        if (framework.features) {
          return framework.features;
        }
        var helperEl = framework.createEl(),
          helperStyle = helperEl.style,
          vendor = '',
          features = {};

        // IE8 and below
        features.oldIE = document.all && !document.addEventListener;
        features.touch = 'ontouchstart' in window;
        if (window.requestAnimationFrame) {
          features.raf = window.requestAnimationFrame;
          features.caf = window.cancelAnimationFrame;
        }
        features.pointerEvent = navigator.pointerEnabled || navigator.msPointerEnabled;

        // fix false-positive detection of old Android in new IE
        // (IE11 ua string contains "Android 4.0")

        if (!features.pointerEvent) {
          var ua = navigator.userAgent;

          // Detect if device is iPhone or iPod and if it's older than iOS 8
          // http://stackoverflow.com/a/14223920
          // 
          // This detection is made because of buggy top/bottom toolbars
          // that don't trigger window.resize event.
          // For more info refer to _isFixedPosition variable in core.js

          if (/iP(hone|od)/.test(navigator.platform)) {
            var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (v && v.length > 0) {
              v = parseInt(v[1], 10);
              if (v >= 1 && v < 8) {
                features.isOldIOSPhone = true;
              }
            }
          }

          // Detect old Android (before KitKat)
          // due to bugs related to position:fixed
          // http://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript

          var match = ua.match(/Android\s([0-9\.]*)/);
          var androidversion = match ? match[1] : 0;
          androidversion = parseFloat(androidversion);
          if (androidversion >= 1) {
            if (androidversion < 4.4) {
              features.isOldAndroid = true; // for fixed position bug & performance
            }
            features.androidVersion = androidversion; // for touchend bug
          }
          features.isMobileOpera = /opera mini|opera mobi/i.test(ua);

          // p.s. yes, yes, UA sniffing is bad, propose your solution for above bugs.
        }
        var styleChecks = ['transform', 'perspective', 'animationName'],
          vendors = ['', 'webkit', 'Moz', 'ms', 'O'],
          styleCheckItem,
          styleName;
        for (var i = 0; i < 4; i++) {
          vendor = vendors[i];
          for (var a = 0; a < 3; a++) {
            styleCheckItem = styleChecks[a];

            // uppercase first letter of property name, if vendor is present
            styleName = vendor + (vendor ? styleCheckItem.charAt(0).toUpperCase() + styleCheckItem.slice(1) : styleCheckItem);
            if (!features[styleCheckItem] && styleName in helperStyle) {
              features[styleCheckItem] = styleName;
            }
          }
          if (vendor && !features.raf) {
            vendor = vendor.toLowerCase();
            features.raf = window[vendor + 'RequestAnimationFrame'];
            if (features.raf) {
              features.caf = window[vendor + 'CancelAnimationFrame'] || window[vendor + 'CancelRequestAnimationFrame'];
            }
          }
        }
        if (!features.raf) {
          var lastTime = 0;
          features.raf = function (fn) {
            var currTime = new Date().getTime();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function () {
              fn(currTime + timeToCall);
            }, timeToCall);
            lastTime = currTime + timeToCall;
            return id;
          };
          features.caf = function (id) {
            clearTimeout(id);
          };
        }

        // Detect SVG support
        features.svg = !!document.createElementNS && !!document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect;
        framework.features = features;
        return features;
      }
    };
    framework.detectFeatures();

    // Override addEventListener for old versions of IE
    if (framework.features.oldIE) {
      framework.bind = function (target, type, listener, unbind) {
        type = type.split(' ');
        var methodName = (unbind ? 'detach' : 'attach') + 'Event',
          evName,
          _handleEv = function _handleEv() {
            listener.handleEvent.call(listener);
          };
        for (var i = 0; i < type.length; i++) {
          evName = type[i];
          if (evName) {
            if (_typeof(listener) === 'object' && listener.handleEvent) {
              if (!unbind) {
                listener['oldIE' + evName] = _handleEv;
              } else {
                if (!listener['oldIE' + evName]) {
                  return false;
                }
              }
              target[methodName]('on' + evName, listener['oldIE' + evName]);
            } else {
              target[methodName]('on' + evName, listener);
            }
          }
        }
      };
    }

    /*>>framework-bridge*/

    /*>>core*/
    //function(template, UiClass, items, options)

    var self = this;

    /**
     * Static vars, don't change unless you know what you're doing.
     */
    var DOUBLE_TAP_RADIUS = 25,
      NUM_HOLDERS = 3;

    /**
     * Options
     */
    var _options = {
      allowPanToNext: true,
      spacing: 0.12,
      bgOpacity: 1,
      mouseUsed: false,
      loop: true,
      pinchToClose: true,
      closeOnScroll: true,
      closeOnVerticalDrag: true,
      verticalDragRange: 0.75,
      hideAnimationDuration: 333,
      showAnimationDuration: 333,
      showHideOpacity: false,
      focus: true,
      escKey: true,
      arrowKeys: true,
      mainScrollEndFriction: 0.35,
      panEndFriction: 0.35,
      isClickableElement: function isClickableElement(el) {
        return el.tagName === 'A';
      },
      getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
        if (isMouseClick) {
          return 1;
        } else {
          return item.initialZoomLevel < 0.7 ? 1 : 1.33;
        }
      },
      maxSpreadZoom: 1.33,
      modal: true,
      // not fully implemented yet
      scaleMode: 'fit' // TODO
    };
    framework.extend(_options, options);

    /**
     * Private helper variables & functions
     */

    var _getEmptyPoint = function _getEmptyPoint() {
      return {
        x: 0,
        y: 0
      };
    };
    var _isOpen,
      _isDestroying,
      _closedByScroll,
      _currentItemIndex,
      _containerStyle,
      _containerShiftIndex,
      _currPanDist = _getEmptyPoint(),
      _startPanOffset = _getEmptyPoint(),
      _panOffset = _getEmptyPoint(),
      _upMoveEvents,
      // drag move, drag end & drag cancel events array
      _downEvents,
      // drag start events array
      _globalEventHandlers,
      _viewportSize = {},
      _currZoomLevel,
      _startZoomLevel,
      _translatePrefix,
      _translateSufix,
      _updateSizeInterval,
      _itemsNeedUpdate,
      _currPositionIndex = 0,
      _offset = {},
      _slideSize = _getEmptyPoint(),
      // size of slide area, including spacing
      _itemHolders,
      _prevItemIndex,
      _indexDiff = 0,
      // difference of indexes since last content update
      _dragStartEvent,
      _dragMoveEvent,
      _dragEndEvent,
      _dragCancelEvent,
      _transformKey,
      _pointerEventEnabled,
      _isFixedPosition = true,
      _likelyTouchDevice,
      _modules = [],
      _requestAF,
      _cancelAF,
      _initalClassName,
      _initalWindowScrollY,
      _oldIE,
      _currentWindowScrollY,
      _features,
      _windowVisibleSize = {},
      _renderMaxResolution = false,
      _orientationChangeTimeout,
      // Registers PhotoSWipe module (History, Controller ...)
      _registerModule = function _registerModule(name, module) {
        framework.extend(self, module.publicMethods);
        _modules.push(name);
      },
      _getLoopedId = function _getLoopedId(index) {
        var numSlides = _getNumItems();
        if (index > numSlides - 1) {
          return index - numSlides;
        } else if (index < 0) {
          return numSlides + index;
        }
        return index;
      },
      // Micro bind/trigger
      _listeners = {},
      _listen = function _listen(name, fn) {
        if (!_listeners[name]) {
          _listeners[name] = [];
        }
        return _listeners[name].push(fn);
      },
      _shout = function _shout(name) {
        var listeners = _listeners[name];
        if (listeners) {
          var args = Array.prototype.slice.call(arguments);
          args.shift();
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].apply(self, args);
          }
        }
      },
      _getCurrentTime = function _getCurrentTime() {
        return new Date().getTime();
      },
      _applyBgOpacity = function _applyBgOpacity(opacity) {
        _bgOpacity = opacity;
        self.bg.style.opacity = opacity * _options.bgOpacity;
      },
      _applyZoomTransform = function _applyZoomTransform(styleObj, x, y, zoom, item) {
        if (!_renderMaxResolution || item && item !== self.currItem) {
          zoom = zoom / (item ? item.fitRatio : self.currItem.fitRatio);
        }
        styleObj[_transformKey] = _translatePrefix + x + 'px, ' + y + 'px' + _translateSufix + ' scale(' + zoom + ')';
      },
      _applyCurrentZoomPan = function _applyCurrentZoomPan(allowRenderResolution) {
        if (_currZoomElementStyle) {
          if (allowRenderResolution) {
            if (_currZoomLevel > self.currItem.fitRatio) {
              if (!_renderMaxResolution) {
                _setImageSize(self.currItem, false, true);
                _renderMaxResolution = true;
              }
            } else {
              if (_renderMaxResolution) {
                _setImageSize(self.currItem);
                _renderMaxResolution = false;
              }
            }
          }
          _applyZoomTransform(_currZoomElementStyle, _panOffset.x, _panOffset.y, _currZoomLevel);
        }
      },
      _applyZoomPanToItem = function _applyZoomPanToItem(item) {
        if (item.container) {
          _applyZoomTransform(item.container.style, item.initialPosition.x, item.initialPosition.y, item.initialZoomLevel, item);
        }
      },
      _setTranslateX = function _setTranslateX(x, elStyle) {
        elStyle[_transformKey] = _translatePrefix + x + 'px, 0px' + _translateSufix;
      },
      _moveMainScroll = function _moveMainScroll(x, dragging) {
        if (!_options.loop && dragging) {
          var newSlideIndexOffset = _currentItemIndex + (_slideSize.x * _currPositionIndex - x) / _slideSize.x,
            delta = Math.round(x - _mainScrollPos.x);
          if (newSlideIndexOffset < 0 && delta > 0 || newSlideIndexOffset >= _getNumItems() - 1 && delta < 0) {
            x = _mainScrollPos.x + delta * _options.mainScrollEndFriction;
          }
        }
        _mainScrollPos.x = x;
        _setTranslateX(x, _containerStyle);
      },
      _calculatePanOffset = function _calculatePanOffset(axis, zoomLevel) {
        var m = _midZoomPoint[axis] - _offset[axis];
        return _startPanOffset[axis] + _currPanDist[axis] + m - m * (zoomLevel / _startZoomLevel);
      },
      _equalizePoints = function _equalizePoints(p1, p2) {
        p1.x = p2.x;
        p1.y = p2.y;
        if (p2.id) {
          p1.id = p2.id;
        }
      },
      _roundPoint = function _roundPoint(p) {
        p.x = Math.round(p.x);
        p.y = Math.round(p.y);
      },
      _mouseMoveTimeout = null,
      _onFirstMouseMove = function _onFirstMouseMove() {
        // Wait until mouse move event is fired at least twice during 100ms
        // We do this, because some mobile browsers trigger it on touchstart
        if (_mouseMoveTimeout) {
          framework.unbind(document, 'mousemove', _onFirstMouseMove);
          framework.addClass(template, 'pswp--has_mouse');
          _options.mouseUsed = true;
          _shout('mouseUsed');
        }
        _mouseMoveTimeout = setTimeout(function () {
          _mouseMoveTimeout = null;
        }, 100);
      },
      _bindEvents = function _bindEvents() {
        framework.bind(document, 'keydown', self);
        if (_features.transform) {
          // don't bind click event in browsers that don't support transform (mostly IE8)
          framework.bind(self.scrollWrap, 'click', self);
        }
        if (!_options.mouseUsed) {
          framework.bind(document, 'mousemove', _onFirstMouseMove);
        }
        framework.bind(window, 'resize scroll orientationchange', self);
        _shout('bindEvents');
      },
      _unbindEvents = function _unbindEvents() {
        framework.unbind(window, 'resize scroll orientationchange', self);
        framework.unbind(window, 'scroll', _globalEventHandlers.scroll);
        framework.unbind(document, 'keydown', self);
        framework.unbind(document, 'mousemove', _onFirstMouseMove);
        if (_features.transform) {
          framework.unbind(self.scrollWrap, 'click', self);
        }
        if (_isDragging) {
          framework.unbind(window, _upMoveEvents, self);
        }
        clearTimeout(_orientationChangeTimeout);
        _shout('unbindEvents');
      },
      _calculatePanBounds = function _calculatePanBounds(zoomLevel, update) {
        var bounds = _calculateItemSize(self.currItem, _viewportSize, zoomLevel);
        if (update) {
          _currPanBounds = bounds;
        }
        return bounds;
      },
      _getMinZoomLevel = function _getMinZoomLevel(item) {
        if (!item) {
          item = self.currItem;
        }
        return item.initialZoomLevel;
      },
      _getMaxZoomLevel = function _getMaxZoomLevel(item) {
        if (!item) {
          item = self.currItem;
        }
        return item.w > 0 ? _options.maxSpreadZoom : 1;
      },
      // Return true if offset is out of the bounds
      _modifyDestPanOffset = function _modifyDestPanOffset(axis, destPanBounds, destPanOffset, destZoomLevel) {
        if (destZoomLevel === self.currItem.initialZoomLevel) {
          destPanOffset[axis] = self.currItem.initialPosition[axis];
          return true;
        } else {
          destPanOffset[axis] = _calculatePanOffset(axis, destZoomLevel);
          if (destPanOffset[axis] > destPanBounds.min[axis]) {
            destPanOffset[axis] = destPanBounds.min[axis];
            return true;
          } else if (destPanOffset[axis] < destPanBounds.max[axis]) {
            destPanOffset[axis] = destPanBounds.max[axis];
            return true;
          }
        }
        return false;
      },
      _setupTransforms = function _setupTransforms() {
        if (_transformKey) {
          // setup 3d transforms
          var allow3dTransform = _features.perspective && !_likelyTouchDevice;
          _translatePrefix = 'translate' + (allow3dTransform ? '3d(' : '(');
          _translateSufix = _features.perspective ? ', 0px)' : ')';
          return;
        }

        // Override zoom/pan/move functions in case old browser is used (most likely IE)
        // (so they use left/top/width/height, instead of CSS transform)

        _transformKey = 'left';
        framework.addClass(template, 'pswp--ie');
        _setTranslateX = function _setTranslateX(x, elStyle) {
          elStyle.left = x + 'px';
        };
        _applyZoomPanToItem = function _applyZoomPanToItem(item) {
          var zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
            s = item.container.style,
            w = zoomRatio * item.w,
            h = zoomRatio * item.h;
          s.width = w + 'px';
          s.height = h + 'px';
          s.left = item.initialPosition.x + 'px';
          s.top = item.initialPosition.y + 'px';
        };
        _applyCurrentZoomPan = function _applyCurrentZoomPan() {
          if (_currZoomElementStyle) {
            var s = _currZoomElementStyle,
              item = self.currItem,
              zoomRatio = item.fitRatio > 1 ? 1 : item.fitRatio,
              w = zoomRatio * item.w,
              h = zoomRatio * item.h;
            s.width = w + 'px';
            s.height = h + 'px';
            s.left = _panOffset.x + 'px';
            s.top = _panOffset.y + 'px';
          }
        };
      },
      _onKeyDown = function _onKeyDown(e) {
        var keydownAction = '';
        if (_options.escKey && e.keyCode === 27) {
          keydownAction = 'close';
        } else if (_options.arrowKeys) {
          if (e.keyCode === 37) {
            keydownAction = 'prev';
          } else if (e.keyCode === 39) {
            keydownAction = 'next';
          }
        }
        if (keydownAction) {
          // don't do anything if special key pressed to prevent from overriding default browser actions
          // e.g. in Chrome on Mac cmd+arrow-left returns to previous page
          if (!e.ctrlKey && !e.altKey && !e.shiftKey && !e.metaKey) {
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              e.returnValue = false;
            }
            self[keydownAction]();
          }
        }
      },
      _onGlobalClick = function _onGlobalClick(e) {
        if (!e) {
          return;
        }

        // don't allow click event to pass through when triggering after drag or some other gesture
        if (_moved || _zoomStarted || _mainScrollAnimating || _verticalDragInitiated) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      _updatePageScrollOffset = function _updatePageScrollOffset() {
        self.setScrollOffset(0, framework.getScrollY());
      };

    // Micro animation engine
    var _animations = {},
      _numAnimations = 0,
      _stopAnimation = function _stopAnimation(name) {
        if (_animations[name]) {
          if (_animations[name].raf) {
            _cancelAF(_animations[name].raf);
          }
          _numAnimations--;
          delete _animations[name];
        }
      },
      _registerStartAnimation = function _registerStartAnimation(name) {
        if (_animations[name]) {
          _stopAnimation(name);
        }
        if (!_animations[name]) {
          _numAnimations++;
          _animations[name] = {};
        }
      },
      _stopAllAnimations = function _stopAllAnimations() {
        for (var prop in _animations) {
          if (_animations.hasOwnProperty(prop)) {
            _stopAnimation(prop);
          }
        }
      },
      _animateProp = function _animateProp(name, b, endProp, d, easingFn, onUpdate, onComplete) {
        var startAnimTime = _getCurrentTime(),
          t;
        _registerStartAnimation(name);
        var animloop = function animloop() {
          if (_animations[name]) {
            t = _getCurrentTime() - startAnimTime; // time diff
            //b - beginning (start prop)
            //d - anim duration

            if (t >= d) {
              _stopAnimation(name);
              onUpdate(endProp);
              if (onComplete) {
                onComplete();
              }
              return;
            }
            onUpdate((endProp - b) * easingFn(t / d) + b);
            _animations[name].raf = _requestAF(animloop);
          }
        };
        animloop();
      };
    var publicMethods = {
      // make a few local variables and functions public
      shout: _shout,
      listen: _listen,
      viewportSize: _viewportSize,
      options: _options,
      isMainScrollAnimating: function isMainScrollAnimating() {
        return _mainScrollAnimating;
      },
      getZoomLevel: function getZoomLevel() {
        return _currZoomLevel;
      },
      getCurrentIndex: function getCurrentIndex() {
        return _currentItemIndex;
      },
      isDragging: function isDragging() {
        return _isDragging;
      },
      isZooming: function isZooming() {
        return _isZooming;
      },
      setScrollOffset: function setScrollOffset(x, y) {
        _offset.x = x;
        _currentWindowScrollY = _offset.y = y;
        _shout('updateScrollOffset', _offset);
      },
      applyZoomPan: function applyZoomPan(zoomLevel, panX, panY, allowRenderResolution) {
        _panOffset.x = panX;
        _panOffset.y = panY;
        _currZoomLevel = zoomLevel;
        _applyCurrentZoomPan(allowRenderResolution);
      },
      init: function init() {
        if (_isOpen || _isDestroying) {
          return;
        }
        var i;
        self.framework = framework; // basic functionality
        self.template = template; // root DOM element of PhotoSwipe
        self.bg = framework.getChildByClass(template, 'pswp__bg');
        _initalClassName = template.className;
        _isOpen = true;
        _features = framework.detectFeatures();
        _requestAF = _features.raf;
        _cancelAF = _features.caf;
        _transformKey = _features.transform;
        _oldIE = _features.oldIE;
        self.scrollWrap = framework.getChildByClass(template, 'pswp__scroll-wrap');
        self.container = framework.getChildByClass(self.scrollWrap, 'pswp__container');
        _containerStyle = self.container.style; // for fast access

        // Objects that hold slides (there are only 3 in DOM)
        self.itemHolders = _itemHolders = [{
          el: self.container.children[0],
          wrap: 0,
          index: -1
        }, {
          el: self.container.children[1],
          wrap: 0,
          index: -1
        }, {
          el: self.container.children[2],
          wrap: 0,
          index: -1
        }];

        // hide nearby item holders until initial zoom animation finishes (to avoid extra Paints)
        _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'none';
        _setupTransforms();

        // Setup global events
        _globalEventHandlers = {
          resize: self.updateSize,
          // Fixes: iOS 10.3 resize event
          // does not update scrollWrap.clientWidth instantly after resize
          // https://github.com/dimsemenov/PhotoSwipe/issues/1315
          orientationchange: function orientationchange() {
            clearTimeout(_orientationChangeTimeout);
            _orientationChangeTimeout = setTimeout(function () {
              if (_viewportSize.x !== self.scrollWrap.clientWidth) {
                self.updateSize();
              }
            }, 500);
          },
          scroll: _updatePageScrollOffset,
          keydown: _onKeyDown,
          click: _onGlobalClick
        };

        // disable show/hide effects on old browsers that don't support CSS animations or transforms, 
        // old IOS, Android and Opera mobile. Blackberry seems to work fine, even older models.
        var oldPhone = _features.isOldIOSPhone || _features.isOldAndroid || _features.isMobileOpera;
        if (!_features.animationName || !_features.transform || oldPhone) {
          _options.showAnimationDuration = _options.hideAnimationDuration = 0;
        }

        // init modules
        for (i = 0; i < _modules.length; i++) {
          self['init' + _modules[i]]();
        }

        // init
        if (UiClass) {
          var ui = self.ui = new UiClass(self, framework);
          ui.init();
        }
        _shout('firstUpdate');
        _currentItemIndex = _currentItemIndex || _options.index || 0;
        // validate index
        if (isNaN(_currentItemIndex) || _currentItemIndex < 0 || _currentItemIndex >= _getNumItems()) {
          _currentItemIndex = 0;
        }
        self.currItem = _getItemAt(_currentItemIndex);
        if (_features.isOldIOSPhone || _features.isOldAndroid) {
          _isFixedPosition = false;
        }
        template.setAttribute('aria-hidden', 'false');
        if (_options.modal) {
          if (!_isFixedPosition) {
            template.style.position = 'absolute';
            template.style.top = framework.getScrollY() + 'px';
          } else {
            template.style.position = 'fixed';
          }
        }
        if (_currentWindowScrollY === undefined) {
          _shout('initialLayout');
          _currentWindowScrollY = _initalWindowScrollY = framework.getScrollY();
        }

        // add classes to root element of PhotoSwipe
        var rootClasses = 'pswp--open ';
        if (_options.mainClass) {
          rootClasses += _options.mainClass + ' ';
        }
        if (_options.showHideOpacity) {
          rootClasses += 'pswp--animate_opacity ';
        }
        rootClasses += _likelyTouchDevice ? 'pswp--touch' : 'pswp--notouch';
        rootClasses += _features.animationName ? ' pswp--css_animation' : '';
        rootClasses += _features.svg ? ' pswp--svg' : '';
        framework.addClass(template, rootClasses);
        self.updateSize();

        // initial update
        _containerShiftIndex = -1;
        _indexDiff = null;
        for (i = 0; i < NUM_HOLDERS; i++) {
          _setTranslateX((i + _containerShiftIndex) * _slideSize.x, _itemHolders[i].el.style);
        }
        if (!_oldIE) {
          framework.bind(self.scrollWrap, _downEvents, self); // no dragging for old IE
        }
        _listen('initialZoomInEnd', function () {
          self.setContent(_itemHolders[0], _currentItemIndex - 1);
          self.setContent(_itemHolders[2], _currentItemIndex + 1);
          _itemHolders[0].el.style.display = _itemHolders[2].el.style.display = 'block';
          if (_options.focus) {
            // focus causes layout, 
            // which causes lag during the animation, 
            // that's why we delay it untill the initial zoom transition ends
            template.focus();
          }
          _bindEvents();
        });

        // set content for center slide (first time)
        self.setContent(_itemHolders[1], _currentItemIndex);
        self.updateCurrItem();
        _shout('afterInit');
        if (!_isFixedPosition) {
          // On all versions of iOS lower than 8.0, we check size of viewport every second.
          // 
          // This is done to detect when Safari top & bottom bars appear, 
          // as this action doesn't trigger any events (like resize). 
          // 
          // On iOS8 they fixed this.
          // 
          // 10 Nov 2014: iOS 7 usage ~40%. iOS 8 usage 56%.

          _updateSizeInterval = setInterval(function () {
            if (!_numAnimations && !_isDragging && !_isZooming && _currZoomLevel === self.currItem.initialZoomLevel) {
              self.updateSize();
            }
          }, 1000);
        }
        framework.addClass(template, 'pswp--visible');
      },
      // Close the gallery, then destroy it
      close: function close() {
        if (!_isOpen) {
          return;
        }
        _isOpen = false;
        _isDestroying = true;
        _shout('close');
        _unbindEvents();
        _showOrHide(self.currItem, null, true, self.destroy);
      },
      // destroys the gallery (unbinds events, cleans up intervals and timeouts to avoid memory leaks)
      destroy: function destroy() {
        _shout('destroy');
        if (_showOrHideTimeout) {
          clearTimeout(_showOrHideTimeout);
        }
        template.setAttribute('aria-hidden', 'true');
        template.className = _initalClassName;
        if (_updateSizeInterval) {
          clearInterval(_updateSizeInterval);
        }
        framework.unbind(self.scrollWrap, _downEvents, self);

        // we unbind scroll event at the end, as closing animation may depend on it
        framework.unbind(window, 'scroll', self);
        _stopDragUpdateLoop();
        _stopAllAnimations();
        _listeners = null;
      },
      /**
       * Pan image to position
       * @param {Number} x     
       * @param {Number} y     
       * @param {Boolean} force Will ignore bounds if set to true.
       */
      panTo: function panTo(x, y, force) {
        if (!force) {
          if (x > _currPanBounds.min.x) {
            x = _currPanBounds.min.x;
          } else if (x < _currPanBounds.max.x) {
            x = _currPanBounds.max.x;
          }
          if (y > _currPanBounds.min.y) {
            y = _currPanBounds.min.y;
          } else if (y < _currPanBounds.max.y) {
            y = _currPanBounds.max.y;
          }
        }
        _panOffset.x = x;
        _panOffset.y = y;
        _applyCurrentZoomPan();
      },
      handleEvent: function handleEvent(e) {
        e = e || window.event;
        if (_globalEventHandlers[e.type]) {
          _globalEventHandlers[e.type](e);
        }
      },
      goTo: function goTo(index) {
        index = _getLoopedId(index);
        var diff = index - _currentItemIndex;
        _indexDiff = diff;
        _currentItemIndex = index;
        self.currItem = _getItemAt(_currentItemIndex);
        _currPositionIndex -= diff;
        _moveMainScroll(_slideSize.x * _currPositionIndex);
        _stopAllAnimations();
        _mainScrollAnimating = false;
        self.updateCurrItem();
      },
      next: function next() {
        self.goTo(_currentItemIndex + 1);
      },
      prev: function prev() {
        self.goTo(_currentItemIndex - 1);
      },
      // update current zoom/pan objects
      updateCurrZoomItem: function updateCurrZoomItem(emulateSetContent) {
        if (emulateSetContent) {
          _shout('beforeChange', 0);
        }

        // itemHolder[1] is middle (current) item
        if (_itemHolders[1].el.children.length) {
          var zoomElement = _itemHolders[1].el.children[0];
          if (framework.hasClass(zoomElement, 'pswp__zoom-wrap')) {
            _currZoomElementStyle = zoomElement.style;
          } else {
            _currZoomElementStyle = null;
          }
        } else {
          _currZoomElementStyle = null;
        }
        _currPanBounds = self.currItem.bounds;
        _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
        _panOffset.x = _currPanBounds.center.x;
        _panOffset.y = _currPanBounds.center.y;
        if (emulateSetContent) {
          _shout('afterChange');
        }
      },
      invalidateCurrItems: function invalidateCurrItems() {
        _itemsNeedUpdate = true;
        for (var i = 0; i < NUM_HOLDERS; i++) {
          if (_itemHolders[i].item) {
            _itemHolders[i].item.needsUpdate = true;
          }
        }
      },
      updateCurrItem: function updateCurrItem(beforeAnimation) {
        if (_indexDiff === 0) {
          return;
        }
        var diffAbs = Math.abs(_indexDiff),
          tempHolder;
        if (beforeAnimation && diffAbs < 2) {
          return;
        }
        self.currItem = _getItemAt(_currentItemIndex);
        _renderMaxResolution = false;
        _shout('beforeChange', _indexDiff);
        if (diffAbs >= NUM_HOLDERS) {
          _containerShiftIndex += _indexDiff + (_indexDiff > 0 ? -NUM_HOLDERS : NUM_HOLDERS);
          diffAbs = NUM_HOLDERS;
        }
        for (var i = 0; i < diffAbs; i++) {
          if (_indexDiff > 0) {
            tempHolder = _itemHolders.shift();
            _itemHolders[NUM_HOLDERS - 1] = tempHolder; // move first to last

            _containerShiftIndex++;
            _setTranslateX((_containerShiftIndex + 2) * _slideSize.x, tempHolder.el.style);
            self.setContent(tempHolder, _currentItemIndex - diffAbs + i + 1 + 1);
          } else {
            tempHolder = _itemHolders.pop();
            _itemHolders.unshift(tempHolder); // move last to first

            _containerShiftIndex--;
            _setTranslateX(_containerShiftIndex * _slideSize.x, tempHolder.el.style);
            self.setContent(tempHolder, _currentItemIndex + diffAbs - i - 1 - 1);
          }
        }

        // reset zoom/pan on previous item
        if (_currZoomElementStyle && Math.abs(_indexDiff) === 1) {
          var prevItem = _getItemAt(_prevItemIndex);
          if (prevItem.initialZoomLevel !== _currZoomLevel) {
            _calculateItemSize(prevItem, _viewportSize);
            _setImageSize(prevItem);
            _applyZoomPanToItem(prevItem);
          }
        }

        // reset diff after update
        _indexDiff = 0;
        self.updateCurrZoomItem();
        _prevItemIndex = _currentItemIndex;
        _shout('afterChange');
      },
      updateSize: function updateSize(force) {
        if (!_isFixedPosition && _options.modal) {
          var windowScrollY = framework.getScrollY();
          if (_currentWindowScrollY !== windowScrollY) {
            template.style.top = windowScrollY + 'px';
            _currentWindowScrollY = windowScrollY;
          }
          if (!force && _windowVisibleSize.x === window.innerWidth && _windowVisibleSize.y === window.innerHeight) {
            return;
          }
          _windowVisibleSize.x = window.innerWidth;
          _windowVisibleSize.y = window.innerHeight;

          //template.style.width = _windowVisibleSize.x + 'px';
          template.style.height = _windowVisibleSize.y + 'px';
        }
        _viewportSize.x = self.scrollWrap.clientWidth;
        _viewportSize.y = self.scrollWrap.clientHeight;
        _updatePageScrollOffset();
        _slideSize.x = _viewportSize.x + Math.round(_viewportSize.x * _options.spacing);
        _slideSize.y = _viewportSize.y;
        _moveMainScroll(_slideSize.x * _currPositionIndex);
        _shout('beforeResize'); // even may be used for example to switch image sources

        // don't re-calculate size on inital size update
        if (_containerShiftIndex !== undefined) {
          var holder, item, hIndex;
          for (var i = 0; i < NUM_HOLDERS; i++) {
            holder = _itemHolders[i];
            _setTranslateX((i + _containerShiftIndex) * _slideSize.x, holder.el.style);
            hIndex = _currentItemIndex + i - 1;
            if (_options.loop && _getNumItems() > 2) {
              hIndex = _getLoopedId(hIndex);
            }

            // update zoom level on items and refresh source (if needsUpdate)
            item = _getItemAt(hIndex);

            // re-render gallery item if `needsUpdate`,
            // or doesn't have `bounds` (entirely new slide object)
            if (item && (_itemsNeedUpdate || item.needsUpdate || !item.bounds)) {
              self.cleanSlide(item);
              self.setContent(holder, hIndex);

              // if "center" slide
              if (i === 1) {
                self.currItem = item;
                self.updateCurrZoomItem(true);
              }
              item.needsUpdate = false;
            } else if (holder.index === -1 && hIndex >= 0) {
              // add content first time
              self.setContent(holder, hIndex);
            }
            if (item && item.container) {
              _calculateItemSize(item, _viewportSize);
              _setImageSize(item);
              _applyZoomPanToItem(item);
            }
          }
          _itemsNeedUpdate = false;
        }
        _startZoomLevel = _currZoomLevel = self.currItem.initialZoomLevel;
        _currPanBounds = self.currItem.bounds;
        if (_currPanBounds) {
          _panOffset.x = _currPanBounds.center.x;
          _panOffset.y = _currPanBounds.center.y;
          _applyCurrentZoomPan(true);
        }
        _shout('resize');
      },
      // Zoom current item to
      zoomTo: function zoomTo(destZoomLevel, centerPoint, speed, easingFn, updateFn) {
        /*
        	if(destZoomLevel === 'fit') {
        		destZoomLevel = self.currItem.fitRatio;
        	} else if(destZoomLevel === 'fill') {
        		destZoomLevel = self.currItem.fillRatio;
        	}
        */

        if (centerPoint) {
          _startZoomLevel = _currZoomLevel;
          _midZoomPoint.x = Math.abs(centerPoint.x) - _panOffset.x;
          _midZoomPoint.y = Math.abs(centerPoint.y) - _panOffset.y;
          _equalizePoints(_startPanOffset, _panOffset);
        }
        var destPanBounds = _calculatePanBounds(destZoomLevel, false),
          destPanOffset = {};
        _modifyDestPanOffset('x', destPanBounds, destPanOffset, destZoomLevel);
        _modifyDestPanOffset('y', destPanBounds, destPanOffset, destZoomLevel);
        var initialZoomLevel = _currZoomLevel;
        var initialPanOffset = {
          x: _panOffset.x,
          y: _panOffset.y
        };
        _roundPoint(destPanOffset);
        var onUpdate = function onUpdate(now) {
          if (now === 1) {
            _currZoomLevel = destZoomLevel;
            _panOffset.x = destPanOffset.x;
            _panOffset.y = destPanOffset.y;
          } else {
            _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
            _panOffset.x = (destPanOffset.x - initialPanOffset.x) * now + initialPanOffset.x;
            _panOffset.y = (destPanOffset.y - initialPanOffset.y) * now + initialPanOffset.y;
          }
          if (updateFn) {
            updateFn(now);
          }
          _applyCurrentZoomPan(now === 1);
        };
        if (speed) {
          _animateProp('customZoomTo', 0, 1, speed, easingFn || framework.easing.sine.inOut, onUpdate);
        } else {
          onUpdate(1);
        }
      }
    };

    /*>>core*/

    /*>>gestures*/
    /**
     * Mouse/touch/pointer event handlers.
     * 
     * separated from @core.js for readability
     */

    var MIN_SWIPE_DISTANCE = 30,
      DIRECTION_CHECK_OFFSET = 10; // amount of pixels to drag to determine direction of swipe

    var _gestureStartTime,
      _gestureCheckSpeedTime,
      // pool of objects that are used during dragging of zooming
      p = {},
      // first point
      p2 = {},
      // second point (for zoom gesture)
      delta = {},
      _currPoint = {},
      _startPoint = {},
      _currPointers = [],
      _startMainScrollPos = {},
      _releaseAnimData,
      _posPoints = [],
      // array of points during dragging, used to determine type of gesture
      _tempPoint = {},
      _isZoomingIn,
      _verticalDragInitiated,
      _oldAndroidTouchEndTimeout,
      _currZoomedItemIndex = 0,
      _centerPoint = _getEmptyPoint(),
      _lastReleaseTime = 0,
      _isDragging,
      // at least one pointer is down
      _isMultitouch,
      // at least two _pointers are down
      _zoomStarted,
      // zoom level changed during zoom gesture
      _moved,
      _dragAnimFrame,
      _mainScrollShifted,
      _currentPoints,
      // array of current touch points
      _isZooming,
      _currPointsDistance,
      _startPointsDistance,
      _currPanBounds,
      _mainScrollPos = _getEmptyPoint(),
      _currZoomElementStyle,
      _mainScrollAnimating,
      // true, if animation after swipe gesture is running
      _midZoomPoint = _getEmptyPoint(),
      _currCenterPoint = _getEmptyPoint(),
      _direction,
      _isFirstMove,
      _opacityChanged,
      _bgOpacity,
      _wasOverInitialZoom,
      _isEqualPoints = function _isEqualPoints(p1, p2) {
        return p1.x === p2.x && p1.y === p2.y;
      },
      _isNearbyPoints = function _isNearbyPoints(touch0, touch1) {
        return Math.abs(touch0.x - touch1.x) < DOUBLE_TAP_RADIUS && Math.abs(touch0.y - touch1.y) < DOUBLE_TAP_RADIUS;
      },
      _calculatePointsDistance = function _calculatePointsDistance(p1, p2) {
        _tempPoint.x = Math.abs(p1.x - p2.x);
        _tempPoint.y = Math.abs(p1.y - p2.y);
        return Math.sqrt(_tempPoint.x * _tempPoint.x + _tempPoint.y * _tempPoint.y);
      },
      _stopDragUpdateLoop = function _stopDragUpdateLoop() {
        if (_dragAnimFrame) {
          _cancelAF(_dragAnimFrame);
          _dragAnimFrame = null;
        }
      },
      _dragUpdateLoop = function _dragUpdateLoop() {
        if (_isDragging) {
          _dragAnimFrame = _requestAF(_dragUpdateLoop);
          _renderMovement();
        }
      },
      _canPan = function _canPan() {
        return !(_options.scaleMode === 'fit' && _currZoomLevel === self.currItem.initialZoomLevel);
      },
      // find the closest parent DOM element
      _closestElement = function _closestElement(el, fn) {
        if (!el || el === document) {
          return false;
        }

        // don't search elements above pswp__scroll-wrap
        if (el.getAttribute('class') && el.getAttribute('class').indexOf('pswp__scroll-wrap') > -1) {
          return false;
        }
        if (fn(el)) {
          return el;
        }
        return _closestElement(el.parentNode, fn);
      },
      _preventObj = {},
      _preventDefaultEventBehaviour = function _preventDefaultEventBehaviour(e, isDown) {
        _preventObj.prevent = !_closestElement(e.target, _options.isClickableElement);
        _shout('preventDragEvent', e, isDown, _preventObj);
        return _preventObj.prevent;
      },
      _convertTouchToPoint = function _convertTouchToPoint(touch, p) {
        p.x = touch.pageX;
        p.y = touch.pageY;
        p.id = touch.identifier;
        return p;
      },
      _findCenterOfPoints = function _findCenterOfPoints(p1, p2, pCenter) {
        pCenter.x = (p1.x + p2.x) * 0.5;
        pCenter.y = (p1.y + p2.y) * 0.5;
      },
      _pushPosPoint = function _pushPosPoint(time, x, y) {
        if (time - _gestureCheckSpeedTime > 50) {
          var o = _posPoints.length > 2 ? _posPoints.shift() : {};
          o.x = x;
          o.y = y;
          _posPoints.push(o);
          _gestureCheckSpeedTime = time;
        }
      },
      _calculateVerticalDragOpacityRatio = function _calculateVerticalDragOpacityRatio() {
        var yOffset = _panOffset.y - self.currItem.initialPosition.y; // difference between initial and current position
        return 1 - Math.abs(yOffset / (_viewportSize.y / 2));
      },
      // points pool, reused during touch events
      _ePoint1 = {},
      _ePoint2 = {},
      _tempPointsArr = [],
      _tempCounter,
      _getTouchPoints = function _getTouchPoints(e) {
        // clean up previous points, without recreating array
        while (_tempPointsArr.length > 0) {
          _tempPointsArr.pop();
        }
        if (!_pointerEventEnabled) {
          if (e.type.indexOf('touch') > -1) {
            if (e.touches && e.touches.length > 0) {
              _tempPointsArr[0] = _convertTouchToPoint(e.touches[0], _ePoint1);
              if (e.touches.length > 1) {
                _tempPointsArr[1] = _convertTouchToPoint(e.touches[1], _ePoint2);
              }
            }
          } else {
            _ePoint1.x = e.pageX;
            _ePoint1.y = e.pageY;
            _ePoint1.id = '';
            _tempPointsArr[0] = _ePoint1; //_ePoint1;
          }
        } else {
          _tempCounter = 0;
          // we can use forEach, as pointer events are supported only in modern browsers
          _currPointers.forEach(function (p) {
            if (_tempCounter === 0) {
              _tempPointsArr[0] = p;
            } else if (_tempCounter === 1) {
              _tempPointsArr[1] = p;
            }
            _tempCounter++;
          });
        }
        return _tempPointsArr;
      },
      _panOrMoveMainScroll = function _panOrMoveMainScroll(axis, delta) {
        var panFriction,
          overDiff = 0,
          newOffset = _panOffset[axis] + delta[axis],
          startOverDiff,
          dir = delta[axis] > 0,
          newMainScrollPosition = _mainScrollPos.x + delta.x,
          mainScrollDiff = _mainScrollPos.x - _startMainScrollPos.x,
          newPanPos,
          newMainScrollPos;

        // calculate fdistance over the bounds and friction
        if (newOffset > _currPanBounds.min[axis] || newOffset < _currPanBounds.max[axis]) {
          panFriction = _options.panEndFriction;
          // Linear increasing of friction, so at 1/4 of viewport it's at max value. 
          // Looks not as nice as was expected. Left for history.
          // panFriction = (1 - (_panOffset[axis] + delta[axis] + panBounds.min[axis]) / (_viewportSize[axis] / 4) );
        } else {
          panFriction = 1;
        }
        newOffset = _panOffset[axis] + delta[axis] * panFriction;

        // move main scroll or start panning
        if (_options.allowPanToNext || _currZoomLevel === self.currItem.initialZoomLevel) {
          if (!_currZoomElementStyle) {
            newMainScrollPos = newMainScrollPosition;
          } else if (_direction === 'h' && axis === 'x' && !_zoomStarted) {
            if (dir) {
              if (newOffset > _currPanBounds.min[axis]) {
                panFriction = _options.panEndFriction;
                overDiff = _currPanBounds.min[axis] - newOffset;
                startOverDiff = _currPanBounds.min[axis] - _startPanOffset[axis];
              }

              // drag right
              if ((startOverDiff <= 0 || mainScrollDiff < 0) && _getNumItems() > 1) {
                newMainScrollPos = newMainScrollPosition;
                if (mainScrollDiff < 0 && newMainScrollPosition > _startMainScrollPos.x) {
                  newMainScrollPos = _startMainScrollPos.x;
                }
              } else {
                if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                  newPanPos = newOffset;
                }
              }
            } else {
              if (newOffset < _currPanBounds.max[axis]) {
                panFriction = _options.panEndFriction;
                overDiff = newOffset - _currPanBounds.max[axis];
                startOverDiff = _startPanOffset[axis] - _currPanBounds.max[axis];
              }
              if ((startOverDiff <= 0 || mainScrollDiff > 0) && _getNumItems() > 1) {
                newMainScrollPos = newMainScrollPosition;
                if (mainScrollDiff > 0 && newMainScrollPosition < _startMainScrollPos.x) {
                  newMainScrollPos = _startMainScrollPos.x;
                }
              } else {
                if (_currPanBounds.min.x !== _currPanBounds.max.x) {
                  newPanPos = newOffset;
                }
              }
            }

            //
          }
          if (axis === 'x') {
            if (newMainScrollPos !== undefined) {
              _moveMainScroll(newMainScrollPos, true);
              if (newMainScrollPos === _startMainScrollPos.x) {
                _mainScrollShifted = false;
              } else {
                _mainScrollShifted = true;
              }
            }
            if (_currPanBounds.min.x !== _currPanBounds.max.x) {
              if (newPanPos !== undefined) {
                _panOffset.x = newPanPos;
              } else if (!_mainScrollShifted) {
                _panOffset.x += delta.x * panFriction;
              }
            }
            return newMainScrollPos !== undefined;
          }
        }
        if (!_mainScrollAnimating) {
          if (!_mainScrollShifted) {
            if (_currZoomLevel > self.currItem.fitRatio) {
              _panOffset[axis] += delta[axis] * panFriction;
            }
          }
        }
      },
      // Pointerdown/touchstart/mousedown handler
      _onDragStart = function _onDragStart(e) {
        // Allow dragging only via left mouse button.
        // As this handler is not added in IE8 - we ignore e.which
        // 
        // http://www.quirksmode.org/js/events_properties.html
        // https://developer.mozilla.org/en-US/docs/Web/API/event.button
        if (e.type === 'mousedown' && e.button > 0) {
          return;
        }
        if (_initialZoomRunning) {
          e.preventDefault();
          return;
        }
        if (_oldAndroidTouchEndTimeout && e.type === 'mousedown') {
          return;
        }
        if (_preventDefaultEventBehaviour(e, true)) {
          e.preventDefault();
        }
        _shout('pointerDown');
        if (_pointerEventEnabled) {
          var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
          if (pointerIndex < 0) {
            pointerIndex = _currPointers.length;
          }
          _currPointers[pointerIndex] = {
            x: e.pageX,
            y: e.pageY,
            id: e.pointerId
          };
        }
        var startPointsList = _getTouchPoints(e),
          numPoints = startPointsList.length;
        _currentPoints = null;
        _stopAllAnimations();

        // init drag
        if (!_isDragging || numPoints === 1) {
          _isDragging = _isFirstMove = true;
          framework.bind(window, _upMoveEvents, self);
          _isZoomingIn = _wasOverInitialZoom = _opacityChanged = _verticalDragInitiated = _mainScrollShifted = _moved = _isMultitouch = _zoomStarted = false;
          _direction = null;
          _shout('firstTouchStart', startPointsList);
          _equalizePoints(_startPanOffset, _panOffset);
          _currPanDist.x = _currPanDist.y = 0;
          _equalizePoints(_currPoint, startPointsList[0]);
          _equalizePoints(_startPoint, _currPoint);

          //_equalizePoints(_startMainScrollPos, _mainScrollPos);
          _startMainScrollPos.x = _slideSize.x * _currPositionIndex;
          _posPoints = [{
            x: _currPoint.x,
            y: _currPoint.y
          }];
          _gestureCheckSpeedTime = _gestureStartTime = _getCurrentTime();

          //_mainScrollAnimationEnd(true);
          _calculatePanBounds(_currZoomLevel, true);

          // Start rendering
          _stopDragUpdateLoop();
          _dragUpdateLoop();
        }

        // init zoom
        if (!_isZooming && numPoints > 1 && !_mainScrollAnimating && !_mainScrollShifted) {
          _startZoomLevel = _currZoomLevel;
          _zoomStarted = false; // true if zoom changed at least once

          _isZooming = _isMultitouch = true;
          _currPanDist.y = _currPanDist.x = 0;
          _equalizePoints(_startPanOffset, _panOffset);
          _equalizePoints(p, startPointsList[0]);
          _equalizePoints(p2, startPointsList[1]);
          _findCenterOfPoints(p, p2, _currCenterPoint);
          _midZoomPoint.x = Math.abs(_currCenterPoint.x) - _panOffset.x;
          _midZoomPoint.y = Math.abs(_currCenterPoint.y) - _panOffset.y;
          _currPointsDistance = _startPointsDistance = _calculatePointsDistance(p, p2);
        }
      },
      // Pointermove/touchmove/mousemove handler
      _onDragMove = function _onDragMove(e) {
        e.preventDefault();
        if (_pointerEventEnabled) {
          var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
          if (pointerIndex > -1) {
            var p = _currPointers[pointerIndex];
            p.x = e.pageX;
            p.y = e.pageY;
          }
        }
        if (_isDragging) {
          var touchesList = _getTouchPoints(e);
          if (!_direction && !_moved && !_isZooming) {
            if (_mainScrollPos.x !== _slideSize.x * _currPositionIndex) {
              // if main scroll position is shifted – direction is always horizontal
              _direction = 'h';
            } else {
              var diff = Math.abs(touchesList[0].x - _currPoint.x) - Math.abs(touchesList[0].y - _currPoint.y);
              // check the direction of movement
              if (Math.abs(diff) >= DIRECTION_CHECK_OFFSET) {
                _direction = diff > 0 ? 'h' : 'v';
                _currentPoints = touchesList;
              }
            }
          } else {
            _currentPoints = touchesList;
          }
        }
      },
      // 
      _renderMovement = function _renderMovement() {
        if (!_currentPoints) {
          return;
        }
        var numPoints = _currentPoints.length;
        if (numPoints === 0) {
          return;
        }
        _equalizePoints(p, _currentPoints[0]);
        delta.x = p.x - _currPoint.x;
        delta.y = p.y - _currPoint.y;
        if (_isZooming && numPoints > 1) {
          // Handle behaviour for more than 1 point

          _currPoint.x = p.x;
          _currPoint.y = p.y;

          // check if one of two points changed
          if (!delta.x && !delta.y && _isEqualPoints(_currentPoints[1], p2)) {
            return;
          }
          _equalizePoints(p2, _currentPoints[1]);
          if (!_zoomStarted) {
            _zoomStarted = true;
            _shout('zoomGestureStarted');
          }

          // Distance between two points
          var pointsDistance = _calculatePointsDistance(p, p2);
          var zoomLevel = _calculateZoomLevel(pointsDistance);

          // slightly over the of initial zoom level
          if (zoomLevel > self.currItem.initialZoomLevel + self.currItem.initialZoomLevel / 15) {
            _wasOverInitialZoom = true;
          }

          // Apply the friction if zoom level is out of the bounds
          var zoomFriction = 1,
            minZoomLevel = _getMinZoomLevel(),
            maxZoomLevel = _getMaxZoomLevel();
          if (zoomLevel < minZoomLevel) {
            if (_options.pinchToClose && !_wasOverInitialZoom && _startZoomLevel <= self.currItem.initialZoomLevel) {
              // fade out background if zooming out
              var minusDiff = minZoomLevel - zoomLevel;
              var percent = 1 - minusDiff / (minZoomLevel / 1.2);
              _applyBgOpacity(percent);
              _shout('onPinchClose', percent);
              _opacityChanged = true;
            } else {
              zoomFriction = (minZoomLevel - zoomLevel) / minZoomLevel;
              if (zoomFriction > 1) {
                zoomFriction = 1;
              }
              zoomLevel = minZoomLevel - zoomFriction * (minZoomLevel / 3);
            }
          } else if (zoomLevel > maxZoomLevel) {
            // 1.5 - extra zoom level above the max. E.g. if max is x6, real max 6 + 1.5 = 7.5
            zoomFriction = (zoomLevel - maxZoomLevel) / (minZoomLevel * 6);
            if (zoomFriction > 1) {
              zoomFriction = 1;
            }
            zoomLevel = maxZoomLevel + zoomFriction * minZoomLevel;
          }
          if (zoomFriction < 0) {
            zoomFriction = 0;
          }

          // distance between touch points after friction is applied
          _currPointsDistance = pointsDistance;

          // _centerPoint - The point in the middle of two pointers
          _findCenterOfPoints(p, p2, _centerPoint);

          // paning with two pointers pressed
          _currPanDist.x += _centerPoint.x - _currCenterPoint.x;
          _currPanDist.y += _centerPoint.y - _currCenterPoint.y;
          _equalizePoints(_currCenterPoint, _centerPoint);
          _panOffset.x = _calculatePanOffset('x', zoomLevel);
          _panOffset.y = _calculatePanOffset('y', zoomLevel);
          _isZoomingIn = zoomLevel > _currZoomLevel;
          _currZoomLevel = zoomLevel;
          _applyCurrentZoomPan();
        } else {
          // handle behaviour for one point (dragging or panning)

          if (!_direction) {
            return;
          }
          if (_isFirstMove) {
            _isFirstMove = false;

            // subtract drag distance that was used during the detection direction  

            if (Math.abs(delta.x) >= DIRECTION_CHECK_OFFSET) {
              delta.x -= _currentPoints[0].x - _startPoint.x;
            }
            if (Math.abs(delta.y) >= DIRECTION_CHECK_OFFSET) {
              delta.y -= _currentPoints[0].y - _startPoint.y;
            }
          }
          _currPoint.x = p.x;
          _currPoint.y = p.y;

          // do nothing if pointers position hasn't changed
          if (delta.x === 0 && delta.y === 0) {
            return;
          }
          if (_direction === 'v' && _options.closeOnVerticalDrag) {
            if (!_canPan()) {
              _currPanDist.y += delta.y;
              _panOffset.y += delta.y;
              var opacityRatio = _calculateVerticalDragOpacityRatio();
              _verticalDragInitiated = true;
              _shout('onVerticalDrag', opacityRatio);
              _applyBgOpacity(opacityRatio);
              _applyCurrentZoomPan();
              return;
            }
          }
          _pushPosPoint(_getCurrentTime(), p.x, p.y);
          _moved = true;
          _currPanBounds = self.currItem.bounds;
          var mainScrollChanged = _panOrMoveMainScroll('x', delta);
          if (!mainScrollChanged) {
            _panOrMoveMainScroll('y', delta);
            _roundPoint(_panOffset);
            _applyCurrentZoomPan();
          }
        }
      },
      // Pointerup/pointercancel/touchend/touchcancel/mouseup event handler
      _onDragRelease = function _onDragRelease(e) {
        if (_features.isOldAndroid) {
          if (_oldAndroidTouchEndTimeout && e.type === 'mouseup') {
            return;
          }

          // on Android (v4.1, 4.2, 4.3 & possibly older) 
          // ghost mousedown/up event isn't preventable via e.preventDefault,
          // which causes fake mousedown event
          // so we block mousedown/up for 600ms
          if (e.type.indexOf('touch') > -1) {
            clearTimeout(_oldAndroidTouchEndTimeout);
            _oldAndroidTouchEndTimeout = setTimeout(function () {
              _oldAndroidTouchEndTimeout = 0;
            }, 600);
          }
        }
        _shout('pointerUp');
        if (_preventDefaultEventBehaviour(e, false)) {
          e.preventDefault();
        }
        var releasePoint;
        if (_pointerEventEnabled) {
          var pointerIndex = framework.arraySearch(_currPointers, e.pointerId, 'id');
          if (pointerIndex > -1) {
            releasePoint = _currPointers.splice(pointerIndex, 1)[0];
            if (navigator.pointerEnabled) {
              releasePoint.type = e.pointerType || 'mouse';
            } else {
              var MSPOINTER_TYPES = {
                4: 'mouse',
                // event.MSPOINTER_TYPE_MOUSE
                2: 'touch',
                // event.MSPOINTER_TYPE_TOUCH 
                3: 'pen' // event.MSPOINTER_TYPE_PEN
              };
              releasePoint.type = MSPOINTER_TYPES[e.pointerType];
              if (!releasePoint.type) {
                releasePoint.type = e.pointerType || 'mouse';
              }
            }
          }
        }
        var touchList = _getTouchPoints(e),
          gestureType,
          numPoints = touchList.length;
        if (e.type === 'mouseup') {
          numPoints = 0;
        }

        // Do nothing if there were 3 touch points or more
        if (numPoints === 2) {
          _currentPoints = null;
          return true;
        }

        // if second pointer released
        if (numPoints === 1) {
          _equalizePoints(_startPoint, touchList[0]);
        }

        // pointer hasn't moved, send "tap release" point
        if (numPoints === 0 && !_direction && !_mainScrollAnimating) {
          if (!releasePoint) {
            if (e.type === 'mouseup') {
              releasePoint = {
                x: e.pageX,
                y: e.pageY,
                type: 'mouse'
              };
            } else if (e.changedTouches && e.changedTouches[0]) {
              releasePoint = {
                x: e.changedTouches[0].pageX,
                y: e.changedTouches[0].pageY,
                type: 'touch'
              };
            }
          }
          _shout('touchRelease', e, releasePoint);
        }

        // Difference in time between releasing of two last touch points (zoom gesture)
        var releaseTimeDiff = -1;

        // Gesture completed, no pointers left
        if (numPoints === 0) {
          _isDragging = false;
          framework.unbind(window, _upMoveEvents, self);
          _stopDragUpdateLoop();
          if (_isZooming) {
            // Two points released at the same time
            releaseTimeDiff = 0;
          } else if (_lastReleaseTime !== -1) {
            releaseTimeDiff = _getCurrentTime() - _lastReleaseTime;
          }
        }
        _lastReleaseTime = numPoints === 1 ? _getCurrentTime() : -1;
        if (releaseTimeDiff !== -1 && releaseTimeDiff < 150) {
          gestureType = 'zoom';
        } else {
          gestureType = 'swipe';
        }
        if (_isZooming && numPoints < 2) {
          _isZooming = false;

          // Only second point released
          if (numPoints === 1) {
            gestureType = 'zoomPointerUp';
          }
          _shout('zoomGestureEnded');
        }
        _currentPoints = null;
        if (!_moved && !_zoomStarted && !_mainScrollAnimating && !_verticalDragInitiated) {
          // nothing to animate
          return;
        }
        _stopAllAnimations();
        if (!_releaseAnimData) {
          _releaseAnimData = _initDragReleaseAnimationData();
        }
        _releaseAnimData.calculateSwipeSpeed('x');
        if (_verticalDragInitiated) {
          var opacityRatio = _calculateVerticalDragOpacityRatio();
          if (opacityRatio < _options.verticalDragRange) {
            self.close();
          } else {
            var initalPanY = _panOffset.y,
              initialBgOpacity = _bgOpacity;
            _animateProp('verticalDrag', 0, 1, 300, framework.easing.cubic.out, function (now) {
              _panOffset.y = (self.currItem.initialPosition.y - initalPanY) * now + initalPanY;
              _applyBgOpacity((1 - initialBgOpacity) * now + initialBgOpacity);
              _applyCurrentZoomPan();
            });
            _shout('onVerticalDrag', 1);
          }
          return;
        }

        // main scroll 
        if ((_mainScrollShifted || _mainScrollAnimating) && numPoints === 0) {
          var itemChanged = _finishSwipeMainScrollGesture(gestureType, _releaseAnimData);
          if (itemChanged) {
            return;
          }
          gestureType = 'zoomPointerUp';
        }

        // prevent zoom/pan animation when main scroll animation runs
        if (_mainScrollAnimating) {
          return;
        }

        // Complete simple zoom gesture (reset zoom level if it's out of the bounds)  
        if (gestureType !== 'swipe') {
          _completeZoomGesture();
          return;
        }

        // Complete pan gesture if main scroll is not shifted, and it's possible to pan current image
        if (!_mainScrollShifted && _currZoomLevel > self.currItem.fitRatio) {
          _completePanGesture(_releaseAnimData);
        }
      },
      // Returns object with data about gesture
      // It's created only once and then reused
      _initDragReleaseAnimationData = function _initDragReleaseAnimationData() {
        // temp local vars
        var lastFlickDuration, tempReleasePos;

        // s = this
        var s = {
          lastFlickOffset: {},
          lastFlickDist: {},
          lastFlickSpeed: {},
          slowDownRatio: {},
          slowDownRatioReverse: {},
          speedDecelerationRatio: {},
          speedDecelerationRatioAbs: {},
          distanceOffset: {},
          backAnimDestination: {},
          backAnimStarted: {},
          calculateSwipeSpeed: function calculateSwipeSpeed(axis) {
            if (_posPoints.length > 1) {
              lastFlickDuration = _getCurrentTime() - _gestureCheckSpeedTime + 50;
              tempReleasePos = _posPoints[_posPoints.length - 2][axis];
            } else {
              lastFlickDuration = _getCurrentTime() - _gestureStartTime; // total gesture duration
              tempReleasePos = _startPoint[axis];
            }
            s.lastFlickOffset[axis] = _currPoint[axis] - tempReleasePos;
            s.lastFlickDist[axis] = Math.abs(s.lastFlickOffset[axis]);
            if (s.lastFlickDist[axis] > 20) {
              s.lastFlickSpeed[axis] = s.lastFlickOffset[axis] / lastFlickDuration;
            } else {
              s.lastFlickSpeed[axis] = 0;
            }
            if (Math.abs(s.lastFlickSpeed[axis]) < 0.1) {
              s.lastFlickSpeed[axis] = 0;
            }
            s.slowDownRatio[axis] = 0.95;
            s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
            s.speedDecelerationRatio[axis] = 1;
          },
          calculateOverBoundsAnimOffset: function calculateOverBoundsAnimOffset(axis, speed) {
            if (!s.backAnimStarted[axis]) {
              if (_panOffset[axis] > _currPanBounds.min[axis]) {
                s.backAnimDestination[axis] = _currPanBounds.min[axis];
              } else if (_panOffset[axis] < _currPanBounds.max[axis]) {
                s.backAnimDestination[axis] = _currPanBounds.max[axis];
              }
              if (s.backAnimDestination[axis] !== undefined) {
                s.slowDownRatio[axis] = 0.7;
                s.slowDownRatioReverse[axis] = 1 - s.slowDownRatio[axis];
                if (s.speedDecelerationRatioAbs[axis] < 0.05) {
                  s.lastFlickSpeed[axis] = 0;
                  s.backAnimStarted[axis] = true;
                  _animateProp('bounceZoomPan' + axis, _panOffset[axis], s.backAnimDestination[axis], speed || 300, framework.easing.sine.out, function (pos) {
                    _panOffset[axis] = pos;
                    _applyCurrentZoomPan();
                  });
                }
              }
            }
          },
          // Reduces the speed by slowDownRatio (per 10ms)
          calculateAnimOffset: function calculateAnimOffset(axis) {
            if (!s.backAnimStarted[axis]) {
              s.speedDecelerationRatio[axis] = s.speedDecelerationRatio[axis] * (s.slowDownRatio[axis] + s.slowDownRatioReverse[axis] - s.slowDownRatioReverse[axis] * s.timeDiff / 10);
              s.speedDecelerationRatioAbs[axis] = Math.abs(s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis]);
              s.distanceOffset[axis] = s.lastFlickSpeed[axis] * s.speedDecelerationRatio[axis] * s.timeDiff;
              _panOffset[axis] += s.distanceOffset[axis];
            }
          },
          panAnimLoop: function panAnimLoop() {
            if (_animations.zoomPan) {
              _animations.zoomPan.raf = _requestAF(s.panAnimLoop);
              s.now = _getCurrentTime();
              s.timeDiff = s.now - s.lastNow;
              s.lastNow = s.now;
              s.calculateAnimOffset('x');
              s.calculateAnimOffset('y');
              _applyCurrentZoomPan();
              s.calculateOverBoundsAnimOffset('x');
              s.calculateOverBoundsAnimOffset('y');
              if (s.speedDecelerationRatioAbs.x < 0.05 && s.speedDecelerationRatioAbs.y < 0.05) {
                // round pan position
                _panOffset.x = Math.round(_panOffset.x);
                _panOffset.y = Math.round(_panOffset.y);
                _applyCurrentZoomPan();
                _stopAnimation('zoomPan');
                return;
              }
            }
          }
        };
        return s;
      },
      _completePanGesture = function _completePanGesture(animData) {
        // calculate swipe speed for Y axis (paanning)
        animData.calculateSwipeSpeed('y');
        _currPanBounds = self.currItem.bounds;
        animData.backAnimDestination = {};
        animData.backAnimStarted = {};

        // Avoid acceleration animation if speed is too low
        if (Math.abs(animData.lastFlickSpeed.x) <= 0.05 && Math.abs(animData.lastFlickSpeed.y) <= 0.05) {
          animData.speedDecelerationRatioAbs.x = animData.speedDecelerationRatioAbs.y = 0;

          // Run pan drag release animation. E.g. if you drag image and release finger without momentum.
          animData.calculateOverBoundsAnimOffset('x');
          animData.calculateOverBoundsAnimOffset('y');
          return true;
        }

        // Animation loop that controls the acceleration after pan gesture ends
        _registerStartAnimation('zoomPan');
        animData.lastNow = _getCurrentTime();
        animData.panAnimLoop();
      },
      _finishSwipeMainScrollGesture = function _finishSwipeMainScrollGesture(gestureType, _releaseAnimData) {
        var itemChanged;
        if (!_mainScrollAnimating) {
          _currZoomedItemIndex = _currentItemIndex;
        }
        var itemsDiff;
        if (gestureType === 'swipe') {
          var totalShiftDist = _currPoint.x - _startPoint.x,
            isFastLastFlick = _releaseAnimData.lastFlickDist.x < 10;

          // if container is shifted for more than MIN_SWIPE_DISTANCE, 
          // and last flick gesture was in right direction
          if (totalShiftDist > MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x > 20)) {
            // go to prev item
            itemsDiff = -1;
          } else if (totalShiftDist < -MIN_SWIPE_DISTANCE && (isFastLastFlick || _releaseAnimData.lastFlickOffset.x < -20)) {
            // go to next item
            itemsDiff = 1;
          }
        }
        var nextCircle;
        if (itemsDiff) {
          _currentItemIndex += itemsDiff;
          if (_currentItemIndex < 0) {
            _currentItemIndex = _options.loop ? _getNumItems() - 1 : 0;
            nextCircle = true;
          } else if (_currentItemIndex >= _getNumItems()) {
            _currentItemIndex = _options.loop ? 0 : _getNumItems() - 1;
            nextCircle = true;
          }
          if (!nextCircle || _options.loop) {
            _indexDiff += itemsDiff;
            _currPositionIndex -= itemsDiff;
            itemChanged = true;
          }
        }
        var animateToX = _slideSize.x * _currPositionIndex;
        var animateToDist = Math.abs(animateToX - _mainScrollPos.x);
        var finishAnimDuration;
        if (!itemChanged && animateToX > _mainScrollPos.x !== _releaseAnimData.lastFlickSpeed.x > 0) {
          // "return to current" duration, e.g. when dragging from slide 0 to -1
          finishAnimDuration = 333;
        } else {
          finishAnimDuration = Math.abs(_releaseAnimData.lastFlickSpeed.x) > 0 ? animateToDist / Math.abs(_releaseAnimData.lastFlickSpeed.x) : 333;
          finishAnimDuration = Math.min(finishAnimDuration, 400);
          finishAnimDuration = Math.max(finishAnimDuration, 250);
        }
        if (_currZoomedItemIndex === _currentItemIndex) {
          itemChanged = false;
        }
        _mainScrollAnimating = true;
        _shout('mainScrollAnimStart');
        _animateProp('mainScroll', _mainScrollPos.x, animateToX, finishAnimDuration, framework.easing.cubic.out, _moveMainScroll, function () {
          _stopAllAnimations();
          _mainScrollAnimating = false;
          _currZoomedItemIndex = -1;
          if (itemChanged || _currZoomedItemIndex !== _currentItemIndex) {
            self.updateCurrItem();
          }
          _shout('mainScrollAnimComplete');
        });
        if (itemChanged) {
          self.updateCurrItem(true);
        }
        return itemChanged;
      },
      _calculateZoomLevel = function _calculateZoomLevel(touchesDistance) {
        return 1 / _startPointsDistance * touchesDistance * _startZoomLevel;
      },
      // Resets zoom if it's out of bounds
      _completeZoomGesture = function _completeZoomGesture() {
        var destZoomLevel = _currZoomLevel,
          minZoomLevel = _getMinZoomLevel(),
          maxZoomLevel = _getMaxZoomLevel();
        if (_currZoomLevel < minZoomLevel) {
          destZoomLevel = minZoomLevel;
        } else if (_currZoomLevel > maxZoomLevel) {
          destZoomLevel = maxZoomLevel;
        }
        var destOpacity = 1,
          onUpdate,
          initialOpacity = _bgOpacity;
        if (_opacityChanged && !_isZoomingIn && !_wasOverInitialZoom && _currZoomLevel < minZoomLevel) {
          //_closedByScroll = true;
          self.close();
          return true;
        }
        if (_opacityChanged) {
          onUpdate = function onUpdate(now) {
            _applyBgOpacity((destOpacity - initialOpacity) * now + initialOpacity);
          };
        }
        self.zoomTo(destZoomLevel, 0, 200, framework.easing.cubic.out, onUpdate);
        return true;
      };
    _registerModule('Gestures', {
      publicMethods: {
        initGestures: function initGestures() {
          // helper function that builds touch/pointer/mouse events
          var addEventNames = function addEventNames(pref, down, move, up, cancel) {
            _dragStartEvent = pref + down;
            _dragMoveEvent = pref + move;
            _dragEndEvent = pref + up;
            if (cancel) {
              _dragCancelEvent = pref + cancel;
            } else {
              _dragCancelEvent = '';
            }
          };
          _pointerEventEnabled = _features.pointerEvent;
          if (_pointerEventEnabled && _features.touch) {
            // we don't need touch events, if browser supports pointer events
            _features.touch = false;
          }
          if (_pointerEventEnabled) {
            if (navigator.pointerEnabled) {
              addEventNames('pointer', 'down', 'move', 'up', 'cancel');
            } else {
              // IE10 pointer events are case-sensitive
              addEventNames('MSPointer', 'Down', 'Move', 'Up', 'Cancel');
            }
          } else if (_features.touch) {
            addEventNames('touch', 'start', 'move', 'end', 'cancel');
            _likelyTouchDevice = true;
          } else {
            addEventNames('mouse', 'down', 'move', 'up');
          }
          _upMoveEvents = _dragMoveEvent + ' ' + _dragEndEvent + ' ' + _dragCancelEvent;
          _downEvents = _dragStartEvent;
          if (_pointerEventEnabled && !_likelyTouchDevice) {
            _likelyTouchDevice = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1;
          }
          // make variable public
          self.likelyTouchDevice = _likelyTouchDevice;
          _globalEventHandlers[_dragStartEvent] = _onDragStart;
          _globalEventHandlers[_dragMoveEvent] = _onDragMove;
          _globalEventHandlers[_dragEndEvent] = _onDragRelease; // the Kraken

          if (_dragCancelEvent) {
            _globalEventHandlers[_dragCancelEvent] = _globalEventHandlers[_dragEndEvent];
          }

          // Bind mouse events on device with detected hardware touch support, in case it supports multiple types of input.
          if (_features.touch) {
            _downEvents += ' mousedown';
            _upMoveEvents += ' mousemove mouseup';
            _globalEventHandlers.mousedown = _globalEventHandlers[_dragStartEvent];
            _globalEventHandlers.mousemove = _globalEventHandlers[_dragMoveEvent];
            _globalEventHandlers.mouseup = _globalEventHandlers[_dragEndEvent];
          }
          if (!_likelyTouchDevice) {
            // don't allow pan to next slide from zoomed state on Desktop
            _options.allowPanToNext = false;
          }
        }
      }
    });

    /*>>gestures*/

    /*>>show-hide-transition*/
    /**
     * show-hide-transition.js:
     *
     * Manages initial opening or closing transition.
     *
     * If you're not planning to use transition for gallery at all,
     * you may set options hideAnimationDuration and showAnimationDuration to 0,
     * and just delete startAnimation function.
     * 
     */

    var _showOrHideTimeout,
      _showOrHide = function _showOrHide(item, img, out, completeFn) {
        if (_showOrHideTimeout) {
          clearTimeout(_showOrHideTimeout);
        }
        _initialZoomRunning = true;
        _initialContentSet = true;

        // dimensions of small thumbnail {x:,y:,w:}.
        // Height is optional, as calculated based on large image.
        var thumbBounds;
        if (item.initialLayout) {
          thumbBounds = item.initialLayout;
          item.initialLayout = null;
        } else {
          thumbBounds = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
        }
        var duration = out ? _options.hideAnimationDuration : _options.showAnimationDuration;
        var onComplete = function onComplete() {
          _stopAnimation('initialZoom');
          if (!out) {
            _applyBgOpacity(1);
            if (img) {
              img.style.display = 'block';
            }
            framework.addClass(template, 'pswp--animated-in');
            _shout('initialZoom' + (out ? 'OutEnd' : 'InEnd'));
          } else {
            self.template.removeAttribute('style');
            self.bg.removeAttribute('style');
          }
          if (completeFn) {
            completeFn();
          }
          _initialZoomRunning = false;
        };

        // if bounds aren't provided, just open gallery without animation
        if (!duration || !thumbBounds || thumbBounds.x === undefined) {
          _shout('initialZoom' + (out ? 'Out' : 'In'));
          _currZoomLevel = item.initialZoomLevel;
          _equalizePoints(_panOffset, item.initialPosition);
          _applyCurrentZoomPan();
          template.style.opacity = out ? 0 : 1;
          _applyBgOpacity(1);
          if (duration) {
            setTimeout(function () {
              onComplete();
            }, duration);
          } else {
            onComplete();
          }
          return;
        }
        var startAnimation = function startAnimation() {
          var closeWithRaf = _closedByScroll,
            fadeEverything = !self.currItem.src || self.currItem.loadError || _options.showHideOpacity;

          // apply hw-acceleration to image
          if (item.miniImg) {
            item.miniImg.style.webkitBackfaceVisibility = 'hidden';
          }
          if (!out) {
            _currZoomLevel = thumbBounds.w / item.w;
            _panOffset.x = thumbBounds.x;
            _panOffset.y = thumbBounds.y - _initalWindowScrollY;
            self[fadeEverything ? 'template' : 'bg'].style.opacity = 0.001;
            _applyCurrentZoomPan();
          }
          _registerStartAnimation('initialZoom');
          if (out && !closeWithRaf) {
            framework.removeClass(template, 'pswp--animated-in');
          }
          if (fadeEverything) {
            if (out) {
              framework[(closeWithRaf ? 'remove' : 'add') + 'Class'](template, 'pswp--animate_opacity');
            } else {
              setTimeout(function () {
                framework.addClass(template, 'pswp--animate_opacity');
              }, 30);
            }
          }
          _showOrHideTimeout = setTimeout(function () {
            _shout('initialZoom' + (out ? 'Out' : 'In'));
            if (!out) {
              // "in" animation always uses CSS transitions (instead of rAF).
              // CSS transition work faster here, 
              // as developer may also want to animate other things, 
              // like ui on top of sliding area, which can be animated just via CSS

              _currZoomLevel = item.initialZoomLevel;
              _equalizePoints(_panOffset, item.initialPosition);
              _applyCurrentZoomPan();
              _applyBgOpacity(1);
              if (fadeEverything) {
                template.style.opacity = 1;
              } else {
                _applyBgOpacity(1);
              }
              _showOrHideTimeout = setTimeout(onComplete, duration + 20);
            } else {
              // "out" animation uses rAF only when PhotoSwipe is closed by browser scroll, to recalculate position
              var destZoomLevel = thumbBounds.w / item.w,
                initialPanOffset = {
                  x: _panOffset.x,
                  y: _panOffset.y
                },
                initialZoomLevel = _currZoomLevel,
                initalBgOpacity = _bgOpacity,
                onUpdate = function onUpdate(now) {
                  if (now === 1) {
                    _currZoomLevel = destZoomLevel;
                    _panOffset.x = thumbBounds.x;
                    _panOffset.y = thumbBounds.y - _currentWindowScrollY;
                  } else {
                    _currZoomLevel = (destZoomLevel - initialZoomLevel) * now + initialZoomLevel;
                    _panOffset.x = (thumbBounds.x - initialPanOffset.x) * now + initialPanOffset.x;
                    _panOffset.y = (thumbBounds.y - _currentWindowScrollY - initialPanOffset.y) * now + initialPanOffset.y;
                  }
                  _applyCurrentZoomPan();
                  if (fadeEverything) {
                    template.style.opacity = 1 - now;
                  } else {
                    _applyBgOpacity(initalBgOpacity - now * initalBgOpacity);
                  }
                };
              if (closeWithRaf) {
                _animateProp('initialZoom', 0, 1, duration, framework.easing.cubic.out, onUpdate, onComplete);
              } else {
                onUpdate(1);
                _showOrHideTimeout = setTimeout(onComplete, duration + 20);
              }
            }
          }, out ? 25 : 90); // Main purpose of this delay is to give browser time to paint and
          // create composite layers of PhotoSwipe UI parts (background, controls, caption, arrows).
          // Which avoids lag at the beginning of scale transition.
        };
        startAnimation();
      };

    /*>>show-hide-transition*/

    /*>>items-controller*/
    /**
    *
    * Controller manages gallery items, their dimensions, and their content.
    * 
    */

    var _items,
      _tempPanAreaSize = {},
      _imagesToAppendPool = [],
      _initialContentSet,
      _initialZoomRunning,
      _controllerDefaultOptions = {
        index: 0,
        errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
        forceProgressiveLoading: false,
        // TODO
        preload: [1, 1],
        getNumItemsFn: function getNumItemsFn() {
          return _items.length;
        }
      };
    var _getItemAt,
      _getNumItems,
      _initialIsLoop,
      _getZeroBounds = function _getZeroBounds() {
        return {
          center: {
            x: 0,
            y: 0
          },
          max: {
            x: 0,
            y: 0
          },
          min: {
            x: 0,
            y: 0
          }
        };
      },
      _calculateSingleItemPanBounds = function _calculateSingleItemPanBounds(item, realPanElementW, realPanElementH) {
        var bounds = item.bounds;

        // position of element when it's centered
        bounds.center.x = Math.round((_tempPanAreaSize.x - realPanElementW) / 2);
        bounds.center.y = Math.round((_tempPanAreaSize.y - realPanElementH) / 2) + item.vGap.top;

        // maximum pan position
        bounds.max.x = realPanElementW > _tempPanAreaSize.x ? Math.round(_tempPanAreaSize.x - realPanElementW) : bounds.center.x;
        bounds.max.y = realPanElementH > _tempPanAreaSize.y ? Math.round(_tempPanAreaSize.y - realPanElementH) + item.vGap.top : bounds.center.y;

        // minimum pan position
        bounds.min.x = realPanElementW > _tempPanAreaSize.x ? 0 : bounds.center.x;
        bounds.min.y = realPanElementH > _tempPanAreaSize.y ? item.vGap.top : bounds.center.y;
      },
      _calculateItemSize = function _calculateItemSize(item, viewportSize, zoomLevel) {
        if (item.src && !item.loadError) {
          var isInitial = !zoomLevel;
          if (isInitial) {
            if (!item.vGap) {
              item.vGap = {
                top: 0,
                bottom: 0
              };
            }
            // allows overriding vertical margin for individual items
            _shout('parseVerticalMargin', item);
          }
          _tempPanAreaSize.x = viewportSize.x;
          _tempPanAreaSize.y = viewportSize.y - item.vGap.top - item.vGap.bottom;
          if (isInitial) {
            var hRatio = _tempPanAreaSize.x / item.w;
            var vRatio = _tempPanAreaSize.y / item.h;
            item.fitRatio = hRatio < vRatio ? hRatio : vRatio;
            //item.fillRatio = hRatio > vRatio ? hRatio : vRatio;

            var scaleMode = _options.scaleMode;
            if (scaleMode === 'orig') {
              zoomLevel = 1;
            } else if (scaleMode === 'fit') {
              zoomLevel = item.fitRatio;
            }
            if (zoomLevel > 1) {
              zoomLevel = 1;
            }
            item.initialZoomLevel = zoomLevel;
            if (!item.bounds) {
              // reuse bounds object
              item.bounds = _getZeroBounds();
            }
          }
          if (!zoomLevel) {
            return;
          }
          _calculateSingleItemPanBounds(item, item.w * zoomLevel, item.h * zoomLevel);
          if (isInitial && zoomLevel === item.initialZoomLevel) {
            item.initialPosition = item.bounds.center;
          }
          return item.bounds;
        } else {
          item.w = item.h = 0;
          item.initialZoomLevel = item.fitRatio = 1;
          item.bounds = _getZeroBounds();
          item.initialPosition = item.bounds.center;

          // if it's not image, we return zero bounds (content is not zoomable)
          return item.bounds;
        }
      },
      _appendImage = function _appendImage(index, item, baseDiv, img, preventAnimation, keepPlaceholder) {
        if (item.loadError) {
          return;
        }
        if (img) {
          item.imageAppended = true;
          _setImageSize(item, img, item === self.currItem && _renderMaxResolution);
          baseDiv.appendChild(img);
          if (keepPlaceholder) {
            setTimeout(function () {
              if (item && item.loaded && item.placeholder) {
                item.placeholder.style.display = 'none';
                item.placeholder = null;
              }
            }, 500);
          }
        }
      },
      _preloadImage = function _preloadImage(item) {
        item.loading = true;
        item.loaded = false;
        var img = item.img = framework.createEl('pswp__img', 'img');
        var onComplete = function onComplete() {
          item.loading = false;
          item.loaded = true;
          if (item.loadComplete) {
            item.loadComplete(item);
          } else {
            item.img = null; // no need to store image object
          }
          img.onload = img.onerror = null;
          img = null;
        };
        img.onload = onComplete;
        img.onerror = function () {
          item.loadError = true;
          onComplete();
        };
        img.src = item.src; // + '?a=' + Math.random();

        return img;
      },
      _checkForError = function _checkForError(item, cleanUp) {
        if (item.src && item.loadError && item.container) {
          if (cleanUp) {
            item.container.innerHTML = '';
          }
          item.container.innerHTML = _options.errorMsg.replace('%url%', item.src);
          return true;
        }
      },
      _setImageSize = function _setImageSize(item, img, maxRes) {
        if (!item.src) {
          return;
        }
        if (!img) {
          img = item.container.lastChild;
        }
        var w = maxRes ? item.w : Math.round(item.w * item.fitRatio),
          h = maxRes ? item.h : Math.round(item.h * item.fitRatio);
        if (item.placeholder && !item.loaded) {
          item.placeholder.style.width = w + 'px';
          item.placeholder.style.height = h + 'px';
        }
        img.style.width = w + 'px';
        img.style.height = h + 'px';
      },
      _appendImagesPool = function _appendImagesPool() {
        if (_imagesToAppendPool.length) {
          var poolItem;
          for (var i = 0; i < _imagesToAppendPool.length; i++) {
            poolItem = _imagesToAppendPool[i];
            if (poolItem.holder.index === poolItem.index) {
              _appendImage(poolItem.index, poolItem.item, poolItem.baseDiv, poolItem.img, false, poolItem.clearPlaceholder);
            }
          }
          _imagesToAppendPool = [];
        }
      };
    _registerModule('Controller', {
      publicMethods: {
        lazyLoadItem: function lazyLoadItem(index) {
          index = _getLoopedId(index);
          var item = _getItemAt(index);
          if (!item || (item.loaded || item.loading) && !_itemsNeedUpdate) {
            return;
          }
          _shout('gettingData', index, item);
          if (!item.src) {
            return;
          }
          _preloadImage(item);
        },
        initController: function initController() {
          framework.extend(_options, _controllerDefaultOptions, true);
          self.items = _items = items;
          _getItemAt = self.getItemAt;
          _getNumItems = _options.getNumItemsFn; //self.getNumItems;

          _initialIsLoop = _options.loop;
          if (_getNumItems() < 3) {
            _options.loop = false; // disable loop if less then 3 items
          }
          _listen('beforeChange', function (diff) {
            var p = _options.preload,
              isNext = diff === null ? true : diff >= 0,
              preloadBefore = Math.min(p[0], _getNumItems()),
              preloadAfter = Math.min(p[1], _getNumItems()),
              i;
            for (i = 1; i <= (isNext ? preloadAfter : preloadBefore); i++) {
              self.lazyLoadItem(_currentItemIndex + i);
            }
            for (i = 1; i <= (isNext ? preloadBefore : preloadAfter); i++) {
              self.lazyLoadItem(_currentItemIndex - i);
            }
          });
          _listen('initialLayout', function () {
            self.currItem.initialLayout = _options.getThumbBoundsFn && _options.getThumbBoundsFn(_currentItemIndex);
          });
          _listen('mainScrollAnimComplete', _appendImagesPool);
          _listen('initialZoomInEnd', _appendImagesPool);
          _listen('destroy', function () {
            var item;
            for (var i = 0; i < _items.length; i++) {
              item = _items[i];
              // remove reference to DOM elements, for GC
              if (item.container) {
                item.container = null;
              }
              if (item.placeholder) {
                item.placeholder = null;
              }
              if (item.img) {
                item.img = null;
              }
              if (item.preloader) {
                item.preloader = null;
              }
              if (item.loadError) {
                item.loaded = item.loadError = false;
              }
            }
            _imagesToAppendPool = null;
          });
        },
        getItemAt: function getItemAt(index) {
          if (index >= 0) {
            return _items[index] !== undefined ? _items[index] : false;
          }
          return false;
        },
        allowProgressiveImg: function allowProgressiveImg() {
          // 1. Progressive image loading isn't working on webkit/blink 
          //    when hw-acceleration (e.g. translateZ) is applied to IMG element.
          //    That's why in PhotoSwipe parent element gets zoom transform, not image itself.
          //    
          // 2. Progressive image loading sometimes blinks in webkit/blink when applying animation to parent element.
          //    That's why it's disabled on touch devices (mainly because of swipe transition)
          //    
          // 3. Progressive image loading sometimes doesn't work in IE (up to 11).

          // Don't allow progressive loading on non-large touch devices
          return _options.forceProgressiveLoading || !_likelyTouchDevice || _options.mouseUsed || screen.width > 1200;
          // 1200 - to eliminate touch devices with large screen (like Chromebook Pixel)
        },
        setContent: function setContent(holder, index) {
          if (_options.loop) {
            index = _getLoopedId(index);
          }
          var prevItem = self.getItemAt(holder.index);
          if (prevItem) {
            prevItem.container = null;
          }
          var item = self.getItemAt(index),
            img;
          if (!item) {
            holder.el.innerHTML = '';
            return;
          }

          // allow to override data
          _shout('gettingData', index, item);
          holder.index = index;
          holder.item = item;

          // base container DIV is created only once for each of 3 holders
          var baseDiv = item.container = framework.createEl('pswp__zoom-wrap');
          if (!item.src && item.html) {
            if (item.html.tagName) {
              baseDiv.appendChild(item.html);
            } else {
              baseDiv.innerHTML = item.html;
            }
          }
          _checkForError(item);
          _calculateItemSize(item, _viewportSize);
          if (item.src && !item.loadError && !item.loaded) {
            item.loadComplete = function (item) {
              // gallery closed before image finished loading
              if (!_isOpen) {
                return;
              }

              // check if holder hasn't changed while image was loading
              if (holder && holder.index === index) {
                if (_checkForError(item, true)) {
                  item.loadComplete = item.img = null;
                  _calculateItemSize(item, _viewportSize);
                  _applyZoomPanToItem(item);
                  if (holder.index === _currentItemIndex) {
                    // recalculate dimensions
                    self.updateCurrZoomItem();
                  }
                  return;
                }
                if (!item.imageAppended) {
                  if (_features.transform && (_mainScrollAnimating || _initialZoomRunning)) {
                    _imagesToAppendPool.push({
                      item: item,
                      baseDiv: baseDiv,
                      img: item.img,
                      index: index,
                      holder: holder,
                      clearPlaceholder: true
                    });
                  } else {
                    _appendImage(index, item, baseDiv, item.img, _mainScrollAnimating || _initialZoomRunning, true);
                  }
                } else {
                  // remove preloader & mini-img
                  if (!_initialZoomRunning && item.placeholder) {
                    item.placeholder.style.display = 'none';
                    item.placeholder = null;
                  }
                }
              }
              item.loadComplete = null;
              item.img = null; // no need to store image element after it's added

              _shout('imageLoadComplete', index, item);
            };
            if (framework.features.transform) {
              var placeholderClassName = 'pswp__img pswp__img--placeholder';
              placeholderClassName += item.msrc ? '' : ' pswp__img--placeholder--blank';
              var placeholder = framework.createEl(placeholderClassName, item.msrc ? 'img' : '');
              if (item.msrc) {
                placeholder.src = item.msrc;
              }
              _setImageSize(item, placeholder);
              baseDiv.appendChild(placeholder);
              item.placeholder = placeholder;
            }
            if (!item.loading) {
              _preloadImage(item);
            }
            if (self.allowProgressiveImg()) {
              // just append image
              if (!_initialContentSet && _features.transform) {
                _imagesToAppendPool.push({
                  item: item,
                  baseDiv: baseDiv,
                  img: item.img,
                  index: index,
                  holder: holder
                });
              } else {
                _appendImage(index, item, baseDiv, item.img, true, true);
              }
            }
          } else if (item.src && !item.loadError) {
            // image object is created every time, due to bugs of image loading & delay when switching images
            img = framework.createEl('pswp__img', 'img');
            img.style.opacity = 1;
            img.src = item.src;
            _setImageSize(item, img);
            _appendImage(index, item, baseDiv, img, true);
          }
          if (!_initialContentSet && index === _currentItemIndex) {
            _currZoomElementStyle = baseDiv.style;
            _showOrHide(item, img || item.img);
          } else {
            _applyZoomPanToItem(item);
          }
          holder.el.innerHTML = '';
          holder.el.appendChild(baseDiv);
        },
        cleanSlide: function cleanSlide(item) {
          if (item.img) {
            item.img.onload = item.img.onerror = null;
          }
          item.loaded = item.loading = item.img = item.imageAppended = false;
        }
      }
    });

    /*>>items-controller*/

    /*>>tap*/
    /**
     * tap.js:
     *
     * Displatches tap and double-tap events.
     * 
     */

    var tapTimer,
      tapReleasePoint = {},
      _dispatchTapEvent = function _dispatchTapEvent(origEvent, releasePoint, pointerType) {
        var e = document.createEvent('CustomEvent'),
          eDetail = {
            origEvent: origEvent,
            target: origEvent.target,
            releasePoint: releasePoint,
            pointerType: pointerType || 'touch'
          };
        e.initCustomEvent('pswpTap', true, true, eDetail);
        origEvent.target.dispatchEvent(e);
      };
    _registerModule('Tap', {
      publicMethods: {
        initTap: function initTap() {
          _listen('firstTouchStart', self.onTapStart);
          _listen('touchRelease', self.onTapRelease);
          _listen('destroy', function () {
            tapReleasePoint = {};
            tapTimer = null;
          });
        },
        onTapStart: function onTapStart(touchList) {
          if (touchList.length > 1) {
            clearTimeout(tapTimer);
            tapTimer = null;
          }
        },
        onTapRelease: function onTapRelease(e, releasePoint) {
          if (!releasePoint) {
            return;
          }
          if (!_moved && !_isMultitouch && !_numAnimations) {
            var p0 = releasePoint;
            if (tapTimer) {
              clearTimeout(tapTimer);
              tapTimer = null;

              // Check if taped on the same place
              if (_isNearbyPoints(p0, tapReleasePoint)) {
                _shout('doubleTap', p0);
                return;
              }
            }
            if (releasePoint.type === 'mouse') {
              _dispatchTapEvent(e, releasePoint, 'mouse');
              return;
            }
            var clickedTagName = e.target.tagName.toUpperCase();
            // avoid double tap delay on buttons and elements that have class pswp__single-tap
            if (clickedTagName === 'BUTTON' || framework.hasClass(e.target, 'pswp__single-tap')) {
              _dispatchTapEvent(e, releasePoint);
              return;
            }
            _equalizePoints(tapReleasePoint, p0);
            tapTimer = setTimeout(function () {
              _dispatchTapEvent(e, releasePoint);
              tapTimer = null;
            }, 300);
          }
        }
      }
    });

    /*>>tap*/

    /*>>desktop-zoom*/
    /**
     *
     * desktop-zoom.js:
     *
     * - Binds mousewheel event for paning zoomed image.
     * - Manages "dragging", "zoomed-in", "zoom-out" classes.
     *   (which are used for cursors and zoom icon)
     * - Adds toggleDesktopZoom function.
     * 
     */

    var _wheelDelta;
    _registerModule('DesktopZoom', {
      publicMethods: {
        initDesktopZoom: function initDesktopZoom() {
          if (_oldIE) {
            // no zoom for old IE (<=8)
            return;
          }
          if (_likelyTouchDevice) {
            // if detected hardware touch support, we wait until mouse is used,
            // and only then apply desktop-zoom features
            _listen('mouseUsed', function () {
              self.setupDesktopZoom();
            });
          } else {
            self.setupDesktopZoom(true);
          }
        },
        setupDesktopZoom: function setupDesktopZoom(onInit) {
          _wheelDelta = {};
          var events = 'wheel mousewheel DOMMouseScroll';
          _listen('bindEvents', function () {
            framework.bind(template, events, self.handleMouseWheel);
          });
          _listen('unbindEvents', function () {
            if (_wheelDelta) {
              framework.unbind(template, events, self.handleMouseWheel);
            }
          });
          self.mouseZoomedIn = false;
          var hasDraggingClass,
            updateZoomable = function updateZoomable() {
              if (self.mouseZoomedIn) {
                framework.removeClass(template, 'pswp--zoomed-in');
                self.mouseZoomedIn = false;
              }
              if (_currZoomLevel < 1) {
                framework.addClass(template, 'pswp--zoom-allowed');
              } else {
                framework.removeClass(template, 'pswp--zoom-allowed');
              }
              removeDraggingClass();
            },
            removeDraggingClass = function removeDraggingClass() {
              if (hasDraggingClass) {
                framework.removeClass(template, 'pswp--dragging');
                hasDraggingClass = false;
              }
            };
          _listen('resize', updateZoomable);
          _listen('afterChange', updateZoomable);
          _listen('pointerDown', function () {
            if (self.mouseZoomedIn) {
              hasDraggingClass = true;
              framework.addClass(template, 'pswp--dragging');
            }
          });
          _listen('pointerUp', removeDraggingClass);
          if (!onInit) {
            updateZoomable();
          }
        },
        handleMouseWheel: function handleMouseWheel(e) {
          if (_currZoomLevel <= self.currItem.fitRatio) {
            if (_options.modal) {
              if (!_options.closeOnScroll || _numAnimations || _isDragging) {
                e.preventDefault();
              } else if (_transformKey && Math.abs(e.deltaY) > 2) {
                // close PhotoSwipe
                // if browser supports transforms & scroll changed enough
                _closedByScroll = true;
                self.close();
              }
            }
            return true;
          }

          // allow just one event to fire
          e.stopPropagation();

          // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
          _wheelDelta.x = 0;
          if ('deltaX' in e) {
            if (e.deltaMode === 1 /* DOM_DELTA_LINE */) {
              // 18 - average line height
              _wheelDelta.x = e.deltaX * 18;
              _wheelDelta.y = e.deltaY * 18;
            } else {
              _wheelDelta.x = e.deltaX;
              _wheelDelta.y = e.deltaY;
            }
          } else if ('wheelDelta' in e) {
            if (e.wheelDeltaX) {
              _wheelDelta.x = -0.16 * e.wheelDeltaX;
            }
            if (e.wheelDeltaY) {
              _wheelDelta.y = -0.16 * e.wheelDeltaY;
            } else {
              _wheelDelta.y = -0.16 * e.wheelDelta;
            }
          } else if ('detail' in e) {
            _wheelDelta.y = e.detail;
          } else {
            return;
          }
          _calculatePanBounds(_currZoomLevel, true);
          var newPanX = _panOffset.x - _wheelDelta.x,
            newPanY = _panOffset.y - _wheelDelta.y;

          // only prevent scrolling in nonmodal mode when not at edges
          if (_options.modal || newPanX <= _currPanBounds.min.x && newPanX >= _currPanBounds.max.x && newPanY <= _currPanBounds.min.y && newPanY >= _currPanBounds.max.y) {
            e.preventDefault();
          }

          // TODO: use rAF instead of mousewheel?
          self.panTo(newPanX, newPanY);
        },
        toggleDesktopZoom: function toggleDesktopZoom(centerPoint) {
          centerPoint = centerPoint || {
            x: _viewportSize.x / 2 + _offset.x,
            y: _viewportSize.y / 2 + _offset.y
          };
          var doubleTapZoomLevel = _options.getDoubleTapZoom(true, self.currItem);
          var zoomOut = _currZoomLevel === doubleTapZoomLevel;
          self.mouseZoomedIn = !zoomOut;
          self.zoomTo(zoomOut ? self.currItem.initialZoomLevel : doubleTapZoomLevel, centerPoint, 333);
          framework[(!zoomOut ? 'add' : 'remove') + 'Class'](template, 'pswp--zoomed-in');
        }
      }
    });

    /*>>desktop-zoom*/

    /*>>history*/
    /**
     *
     * history.js:
     *
     * - Back button to close gallery.
     * 
     * - Unique URL for each slide: example.com/&pid=1&gid=3
     *   (where PID is picture index, and GID and gallery index)
     *   
     * - Switch URL when slides change.
     * 
     */

    var _historyDefaultOptions = {
      history: true,
      galleryUID: 1
    };
    var _historyUpdateTimeout,
      _hashChangeTimeout,
      _hashAnimCheckTimeout,
      _hashChangedByScript,
      _hashChangedByHistory,
      _hashReseted,
      _initialHash,
      _historyChanged,
      _closedFromURL,
      _urlChangedOnce,
      _windowLoc,
      _supportsPushState,
      _getHash = function _getHash() {
        return _windowLoc.hash.substring(1);
      },
      _cleanHistoryTimeouts = function _cleanHistoryTimeouts() {
        if (_historyUpdateTimeout) {
          clearTimeout(_historyUpdateTimeout);
        }
        if (_hashAnimCheckTimeout) {
          clearTimeout(_hashAnimCheckTimeout);
        }
      },
      // pid - Picture index
      // gid - Gallery index
      _parseItemIndexFromURL = function _parseItemIndexFromURL() {
        var hash = _getHash(),
          params = {};
        if (hash.length < 5) {
          // pid=1
          return params;
        }
        var i,
          vars = hash.split('&');
        for (i = 0; i < vars.length; i++) {
          if (!vars[i]) {
            continue;
          }
          var pair = vars[i].split('=');
          if (pair.length < 2) {
            continue;
          }
          params[pair[0]] = pair[1];
        }
        if (_options.galleryPIDs) {
          // detect custom pid in hash and search for it among the items collection
          var searchfor = params.pid;
          params.pid = 0; // if custom pid cannot be found, fallback to the first item
          for (i = 0; i < _items.length; i++) {
            if (_items[i].pid === searchfor) {
              params.pid = i;
              break;
            }
          }
        } else {
          params.pid = parseInt(params.pid, 10) - 1;
        }
        if (params.pid < 0) {
          params.pid = 0;
        }
        return params;
      },
      _updateHash = function _updateHash() {
        if (_hashAnimCheckTimeout) {
          clearTimeout(_hashAnimCheckTimeout);
        }
        if (_numAnimations || _isDragging) {
          // changing browser URL forces layout/paint in some browsers, which causes noticable lag during animation
          // that's why we update hash only when no animations running
          _hashAnimCheckTimeout = setTimeout(_updateHash, 500);
          return;
        }
        if (_hashChangedByScript) {
          clearTimeout(_hashChangeTimeout);
        } else {
          _hashChangedByScript = true;
        }
        var pid = _currentItemIndex + 1;
        var item = _getItemAt(_currentItemIndex);
        if (item.hasOwnProperty('pid')) {
          // carry forward any custom pid assigned to the item
          pid = item.pid;
        }
        var newHash = _initialHash + '&' + 'gid=' + _options.galleryUID + '&' + 'pid=' + pid;
        if (!_historyChanged) {
          if (_windowLoc.hash.indexOf(newHash) === -1) {
            _urlChangedOnce = true;
          }
          // first time - add new hisory record, then just replace
        }
        var newURL = _windowLoc.href.split('#')[0] + '#' + newHash;
        if (_supportsPushState) {
          if ('#' + newHash !== window.location.hash) {
            history[_historyChanged ? 'replaceState' : 'pushState']('', document.title, newURL);
          }
        } else {
          if (_historyChanged) {
            _windowLoc.replace(newURL);
          } else {
            _windowLoc.hash = newHash;
          }
        }
        _historyChanged = true;
        _hashChangeTimeout = setTimeout(function () {
          _hashChangedByScript = false;
        }, 60);
      };
    _registerModule('History', {
      publicMethods: {
        initHistory: function initHistory() {
          framework.extend(_options, _historyDefaultOptions, true);
          if (!_options.history) {
            return;
          }
          _windowLoc = window.location;
          _urlChangedOnce = false;
          _closedFromURL = false;
          _historyChanged = false;
          _initialHash = _getHash();
          _supportsPushState = 'pushState' in history;
          if (_initialHash.indexOf('gid=') > -1) {
            _initialHash = _initialHash.split('&gid=')[0];
            _initialHash = _initialHash.split('?gid=')[0];
          }
          _listen('afterChange', self.updateURL);
          _listen('unbindEvents', function () {
            framework.unbind(window, 'hashchange', self.onHashChange);
          });
          var returnToOriginal = function returnToOriginal() {
            _hashReseted = true;
            if (!_closedFromURL) {
              if (_urlChangedOnce) {
                history.back();
              } else {
                if (_initialHash) {
                  _windowLoc.hash = _initialHash;
                } else {
                  if (_supportsPushState) {
                    // remove hash from url without refreshing it or scrolling to top
                    history.pushState('', document.title, _windowLoc.pathname + _windowLoc.search);
                  } else {
                    _windowLoc.hash = '';
                  }
                }
              }
            }
            _cleanHistoryTimeouts();
          };
          _listen('unbindEvents', function () {
            if (_closedByScroll) {
              // if PhotoSwipe is closed by scroll, we go "back" before the closing animation starts
              // this is done to keep the scroll position
              returnToOriginal();
            }
          });
          _listen('destroy', function () {
            if (!_hashReseted) {
              returnToOriginal();
            }
          });
          _listen('firstUpdate', function () {
            _currentItemIndex = _parseItemIndexFromURL().pid;
          });
          var index = _initialHash.indexOf('pid=');
          if (index > -1) {
            _initialHash = _initialHash.substring(0, index);
            if (_initialHash.slice(-1) === '&') {
              _initialHash = _initialHash.slice(0, -1);
            }
          }
          setTimeout(function () {
            if (_isOpen) {
              // hasn't destroyed yet
              framework.bind(window, 'hashchange', self.onHashChange);
            }
          }, 40);
        },
        onHashChange: function onHashChange() {
          if (_getHash() === _initialHash) {
            _closedFromURL = true;
            self.close();
            return;
          }
          if (!_hashChangedByScript) {
            _hashChangedByHistory = true;
            self.goTo(_parseItemIndexFromURL().pid);
            _hashChangedByHistory = false;
          }
        },
        updateURL: function updateURL() {
          // Delay the update of URL, to avoid lag during transition, 
          // and to not to trigger actions like "refresh page sound" or "blinking favicon" to often

          _cleanHistoryTimeouts();
          if (_hashChangedByHistory) {
            return;
          }
          if (!_historyChanged) {
            _updateHash(); // first time
          } else {
            _historyUpdateTimeout = setTimeout(_updateHash, 0);
          }
        }
      }
    });

    /*>>history*/
    framework.extend(self, publicMethods);
  };
  return PhotoSwipe;
});

/***/ }),

/***/ "./javascripts/modules/productCarousel.js":
/*!************************************************!*\
  !*** ./javascripts/modules/productCarousel.js ***!
  \************************************************/
/*! exports provided: productCarousel */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productCarousel", function() { return productCarousel; });
var Flickity = __webpack_require__(/*! flickity */ "./node_modules/flickity/js/index.js");
function productCarousel() {
  var carouselDesktopContainer = document.querySelectorAll('.js-product-carousel-desktop-container');
  if (carouselDesktopContainer.length) {
    var _loop = function _loop(i) {
      var _carouselContainer = carouselDesktopContainer[i];
      var labelMore = _carouselContainer.querySelector('.carousel-more-label');
      var carousel = _carouselContainer.querySelector('.js-product-carousel');
      var cell = _carouselContainer.querySelectorAll('.js-cell');
      var thumbnailContainer = _carouselContainer.querySelector('.product-thumbnails');
      var thumbnail = _carouselContainer.querySelectorAll('.js-product-thumbnail');
      var prev = _carouselContainer.querySelector('.carousel-prev');
      var next = _carouselContainer.querySelector('.carousel-next');
      if (carousel && cell.length > 1) {
        (function () {
          var flkty = new Flickity(carousel, {
            cellSelector: '.js-cell',
            cellAlign: 'left',
            setGallerySize: false,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true
          });
          if (thumbnail.length) {
            thumbnail[0].classList.add('is-carousel-current');
            flkty.on('change', function (index) {
              for (var _i = 0; _i < thumbnail.length; _i++) {
                thumbnail[_i].classList.remove('is-carousel-current');
              }
              var currentThumbnail = thumbnail[index];
              currentThumbnail.classList.add('is-carousel-current');
            });
            var _loop2 = function _loop2(_i2) {
              var el = thumbnail[_i2];
              el.addEventListener('click', function (e) {
                if (carousel.classList.contains('flickity-enabled')) {
                  flkty.select(_i2);
                  e.preventDefault();
                }
              });
            };
            for (var _i2 = 0; _i2 < thumbnail.length; _i2++) {
              _loop2(_i2);
            }
          }
          if (prev) {
            prev.addEventListener('click', function (e) {
              if (carousel.classList.contains('flickity-enabled')) {
                flkty.previous();
                e.preventDefault();
              }
            });
          }
          if (next) {
            next.addEventListener('click', function (e) {
              if (carousel.classList.contains('flickity-enabled')) {
                flkty.next();
                e.preventDefault();
              }
            });
          }
        })();
      } else {
        labelMore.classList.add('display-none');
        thumbnailContainer.classList.add('display-none');
      }
    };
    for (var i = 0; i < carouselDesktopContainer.length; i++) {
      _loop(i);
    }
  }
  var carouselContainer = document.querySelectorAll('.js-product-carousel-container');
  if (carouselContainer.length) {
    var _loop3 = function _loop3(_i3) {
      var _carouselContainer = carouselContainer[_i3];
      var carousel = _carouselContainer.querySelector('.js-product-carousel');
      var cell = _carouselContainer.querySelectorAll('.js-cell');
      var thumbnail = _carouselContainer.querySelectorAll('.js-product-thumbnail');
      if (carousel && cell.length > 1) {
        (function () {
          var flkty = new Flickity(carousel, {
            cellSelector: '.js-cell',
            cellAlign: 'left',
            setGallerySize: false,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            watchCSS: true
          });
          if (thumbnail.length) {
            thumbnail[0].classList.add('is-carousel-current');
            flkty.on('change', function (index) {
              for (var _i4 = 0; _i4 < thumbnail.length; _i4++) {
                thumbnail[_i4].classList.remove('is-carousel-current');
              }
              var currentThumbnail = thumbnail[index];
              currentThumbnail.classList.add('is-carousel-current');
            });
            var _loop4 = function _loop4(_i5) {
              var el = thumbnail[_i5];
              el.addEventListener('click', function (e) {
                if (carousel.classList.contains('flickity-enabled')) {
                  flkty.select(_i5);
                  e.preventDefault();
                }
              });
            };
            for (var _i5 = 0; _i5 < thumbnail.length; _i5++) {
              _loop4(_i5);
            }
          }
        })();
      }
    };
    for (var _i3 = 0; _i3 < carouselContainer.length; _i3++) {
      _loop3(_i3);
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/productForm.js":
/*!********************************************!*\
  !*** ./javascripts/modules/productForm.js ***!
  \********************************************/
/*! exports provided: productForm */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "productForm", function() { return productForm; });
function productForm() {
  var productForm = document.querySelectorAll('.js-product-form');
  if (productForm.length) {
    var _loop = function _loop(i) {
      var form = productForm[i];
      var view = form.querySelectorAll('.js-product-select-view');
      var hidden = form.querySelectorAll('.js-product-select-hidden');
      var price = form.querySelectorAll('.js-product-price');
      var addToCart = form.querySelectorAll('.js-product-addtocart');
      function changeSelect(el, index) {
        var value = el.value;
        var title = el.getAttribute('data-title');
        var currentPrice = el.getAttribute('data-current-price');
        var compareAtPrice = el.getAttribute('data-compare-at-price');
        if (hidden) {
          for (var _i = 0; _i < hidden.length; _i++) {
            var _form = hidden[_i];
            _form.options[index].selected = true;
          }
        }
        if (title && view.length) {
          for (var _i2 = 0; _i2 < view.length; _i2++) {
            var label = view[_i2];
            label.innerHTML = title;
          }
        }
        if (currentPrice && price.length) {
          for (var _i3 = 0; _i3 < price.length; _i3++) {
            var _label = price[_i3];
            if (compareAtPrice && compareAtPrice > currentPrice) {
              _label.innerHTML = "<s>".concat(compareAtPrice, "</s>").concat(currentPrice);
            } else {
              _label.innerHTML = currentPrice;
            }
          }
        }
        if (value && addToCart.length) {
          for (var _i4 = 0; _i4 < addToCart.length; _i4++) {
            var _el2 = addToCart[_i4];
            _el2.disabled = false;
          }
        } else if (addToCart.length) {
          for (var _i5 = 0; _i5 < addToCart.length; _i5++) {
            var _el3 = addToCart[_i5];
            _el3.disabled = true;
          }
        }
      }
      if (hidden.length) {
        var _loop2 = function _loop2(_i6) {
          var el = hidden[_i6];

          // Init
          for (var _i7 = 0; _i7 < el.options.length; _i7++) {
            var _el = el.options[_i7];
            if (_el.selected) {
              changeSelect(_el, _i7);
            }
          }

          // Change
          el.addEventListener('change', function (e) {
            var index = el.selectedIndex;
            var selectedOption = el.options[index];
            changeSelect(selectedOption, index);
          });
        };
        for (var _i6 = 0; _i6 < hidden.length; _i6++) {
          _loop2(_i6);
        }
      }
    };
    for (var i = 0; i < productForm.length; i++) {
      _loop(i);
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/scrollDirection.js":
/*!************************************************!*\
  !*** ./javascripts/modules/scrollDirection.js ***!
  \************************************************/
/*! exports provided: scrollDirection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollDirection", function() { return scrollDirection; });
function scrollDirection() {
  var prevScrollpos = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
  var currentScTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
  var SCROLL_HEADER_SHOWHIDE = function SCROLL_HEADER_SHOWHIDE() {
    var currentScrollPos = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
    if (!document.body.classList.contains('is-disable-scroll-direction')) {
      if (currentScTop < currentScrollPos || currentScrollPos < currentScTop) {
        document.body.classList.add('is-scrolled');
        if (prevScrollpos < currentScrollPos) {
          document.body.classList.add('dir-bottom');
        } else {
          document.body.classList.remove('dir-bottom');
        }
      }
    }
    prevScrollpos = currentScrollPos;
  };
  SCROLL_HEADER_SHOWHIDE();
  document.addEventListener('DOMContentLoaded', SCROLL_HEADER_SHOWHIDE);
  window.addEventListener("scroll", SCROLL_HEADER_SHOWHIDE);
  var lastInnerWidth = window.innerWidth;
  var resizeSto = '';
  window.addEventListener("resize", function () {
    this.clearTimeout(resizeSto);
    resizeSto = setTimeout(function () {
      if (lastInnerWidth != window.innerWidth) {
        lastInnerWidth = window.innerWidth;
      }
    }, 300);
  });
}

/***/ }),

/***/ "./javascripts/modules/shopifyAjaxCart.js":
/*!************************************************!*\
  !*** ./javascripts/modules/shopifyAjaxCart.js ***!
  \************************************************/
/*! exports provided: shopifyAjaxCart */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shopifyAjaxCart", function() { return shopifyAjaxCart; });
/* harmony import */ var liquid_ajax_cart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! liquid-ajax-cart */ "./node_modules/liquid-ajax-cart/liquid-ajax-cart.js");
/* harmony import */ var liquid_ajax_cart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(liquid_ajax_cart__WEBPACK_IMPORTED_MODULE_0__);

function shopifyAjaxCart() {
  document.addEventListener('liquid-ajax-cart:request-end', function (event) {
    var _requestState$respons;
    var requestState = event.detail.requestState;
    // If the "add to cart" request is successful
    if (requestState.requestType === 'add' && (_requestState$respons = requestState.responseData) !== null && _requestState$respons !== void 0 && _requestState$respons.ok) {
      // Add the CSS class to the "body" tag
      document.body.classList.add('is-cart-active');
    }
  });
}

/***/ }),

/***/ "./javascripts/modules/shopifyLocaliozation.js":
/*!*****************************************************!*\
  !*** ./javascripts/modules/shopifyLocaliozation.js ***!
  \*****************************************************/
/*! exports provided: shopifyLocalization */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shopifyLocalization", function() { return shopifyLocalization; });
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function shopifyLocalization() {
  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', /*#__PURE__*/function (_HTMLElement) {
      _inherits(LocalizationForm, _HTMLElement);
      var _super = _createSuper(LocalizationForm);
      function LocalizationForm() {
        var _this;
        _classCallCheck(this, LocalizationForm);
        _this = _super.call(this);
        _this.mql = window.matchMedia('(min-width: 750px)');
        _this.header = document.querySelector('.header-wrapper');
        _this.elements = {
          input: _this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: _this.querySelector('button.localization-form__select'),
          panel: _this.querySelector('.disclosure__list-wrapper'),
          search: _this.querySelector('input[name="country_filter"]'),
          closeButton: _this.querySelector('.country-selector__close-button'),
          resetButton: _this.querySelector('.country-filter__reset-button'),
          searchIcon: _this.querySelector('.country-filter__search-icon'),
          liveRegion: _this.querySelector('#sr-country-search-results')
        };
        _this.addEventListener('keyup', _this.onContainerKeyUp.bind(_assertThisInitialized(_this)));
        _this.addEventListener('keydown', _this.onContainerKeyDown.bind(_assertThisInitialized(_this)));
        _this.addEventListener('focusout', _this.closeSelector.bind(_assertThisInitialized(_this)));
        _this.elements.button.addEventListener('click', _this.openSelector.bind(_assertThisInitialized(_this)));
        if (_this.elements.search) {
          _this.elements.search.addEventListener('keyup', _this.filterCountries.bind(_assertThisInitialized(_this)));
          _this.elements.search.addEventListener('focus', _this.onSearchFocus.bind(_assertThisInitialized(_this)));
          _this.elements.search.addEventListener('blur', _this.onSearchBlur.bind(_assertThisInitialized(_this)));
          _this.elements.search.addEventListener('keydown', _this.onSearchKeyDown.bind(_assertThisInitialized(_this)));
        }
        if (_this.elements.closeButton) {
          _this.elements.closeButton.addEventListener('click', _this.hidePanel.bind(_assertThisInitialized(_this)));
        }
        if (_this.elements.resetButton) {
          _this.elements.resetButton.addEventListener('click', _this.resetFilter.bind(_assertThisInitialized(_this)));
          _this.elements.resetButton.addEventListener('mousedown', function (event) {
            return event.preventDefault();
          });
        }
        _this.querySelectorAll('a').forEach(function (item) {
          return item.addEventListener('click', _this.onItemClick.bind(_assertThisInitialized(_this)));
        });
        return _this;
      }
      _createClass(LocalizationForm, [{
        key: "hidePanel",
        value: function hidePanel() {
          this.elements.button.setAttribute('aria-expanded', 'false');
          this.elements.panel.setAttribute('hidden', true);
          if (this.elements.search) {
            this.elements.search.value = '';
            this.filterCountries();
            this.elements.search.setAttribute('aria-activedescendant', '');
          }
          document.body.classList.remove('overflow-hidden-mobile');
          document.querySelector('.menu-drawer').classList.remove('country-selector-open');
          this.header.preventHide = false;
        }
      }, {
        key: "onContainerKeyDown",
        value: function onContainerKeyDown(event) {
          var _this2 = this;
          var focusableItems = Array.from(this.querySelectorAll('a')).filter(function (item) {
            return !item.parentElement.classList.contains('hidden');
          });
          var focusedItemIndex = focusableItems.findIndex(function (item) {
            return item === document.activeElement;
          });
          var itemToFocus;
          switch (event.code.toUpperCase()) {
            case 'ARROWUP':
              event.preventDefault();
              itemToFocus = focusedItemIndex > 0 ? focusableItems[focusedItemIndex - 1] : focusableItems[focusableItems.length - 1];
              itemToFocus.focus();
              break;
            case 'ARROWDOWN':
              event.preventDefault();
              itemToFocus = focusedItemIndex < focusableItems.length - 1 ? focusableItems[focusedItemIndex + 1] : focusableItems[0];
              itemToFocus.focus();
              break;
          }
          if (!this.elements.search) return;
          setTimeout(function () {
            focusedItemIndex = focusableItems.findIndex(function (item) {
              return item === document.activeElement;
            });
            if (focusedItemIndex > -1) {
              _this2.elements.search.setAttribute('aria-activedescendant', focusableItems[focusedItemIndex].id);
            } else {
              _this2.elements.search.setAttribute('aria-activedescendant', '');
            }
          });
        }
      }, {
        key: "onContainerKeyUp",
        value: function onContainerKeyUp(event) {
          event.preventDefault();
          switch (event.code.toUpperCase()) {
            case 'ESCAPE':
              if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
              this.hidePanel();
              event.stopPropagation();
              this.elements.button.focus();
              break;
            case 'SPACE':
              if (this.elements.button.getAttribute('aria-expanded') == 'true') return;
              this.openSelector();
              break;
          }
        }
      }, {
        key: "onItemClick",
        value: function onItemClick(event) {
          event.preventDefault();
          var form = this.querySelector('form');
          this.elements.input.value = event.currentTarget.dataset.value;
          if (form) form.submit();
        }
      }, {
        key: "openSelector",
        value: function openSelector() {
          this.elements.button.focus();
          this.elements.panel.toggleAttribute('hidden');
          this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
          if (!document.body.classList.contains('overflow-hidden-tablet')) {
            document.body.classList.add('overflow-hidden-mobile');
          }
          if (this.elements.search && this.mql.matches) {
            this.elements.search.focus();
          }
          if (this.hasAttribute('data-prevent-hide')) {
            this.header.preventHide = true;
          }
          document.querySelector('.menu-drawer').classList.add('country-selector-open');
        }
      }, {
        key: "closeSelector",
        value: function closeSelector(event) {
          if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
            this.hidePanel();
          }
        }
      }, {
        key: "filterCountries",
        value: function filterCountries() {
          var searchValue = this.elements.search.value.toLowerCase();
          var popularCountries = this.querySelector('.popular-countries');
          var allCountries = this.querySelectorAll('a');
          var visibleCountries = allCountries.length;
          this.elements.resetButton.classList.toggle('hidden', !searchValue);
          if (popularCountries) {
            popularCountries.classList.toggle('hidden', searchValue);
          }
          allCountries.forEach(function (item) {
            var countryName = item.querySelector('.country').textContent.toLowerCase();
            if (countryName.indexOf(searchValue) > -1) {
              item.parentElement.classList.remove('hidden');
              visibleCountries++;
            } else {
              item.parentElement.classList.add('hidden');
              visibleCountries--;
            }
          });
          if (this.elements.liveRegion) {
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.countrySelectorSearchCount.replace('[count]', visibleCountries);
          }
          this.querySelector('.country-selector').scrollTop = 0;
          this.querySelector('.country-selector__list').scrollTop = 0;
        }
      }, {
        key: "resetFilter",
        value: function resetFilter(event) {
          event.stopPropagation();
          this.elements.search.value = '';
          this.filterCountries();
          this.elements.search.focus();
        }
      }, {
        key: "onSearchFocus",
        value: function onSearchFocus() {
          this.elements.searchIcon.classList.add('country-filter__search-icon--hidden');
        }
      }, {
        key: "onSearchBlur",
        value: function onSearchBlur() {
          if (!this.elements.search.value) {
            this.elements.searchIcon.classList.remove('country-filter__search-icon--hidden');
          }
        }
      }, {
        key: "onSearchKeyDown",
        value: function onSearchKeyDown(event) {
          if (event.code.toUpperCase() === 'ENTER') {
            event.preventDefault();
          }
        }
      }]);
      return LocalizationForm;
    }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
  }
}

/***/ }),

/***/ "./javascripts/modules/sortCollection.js":
/*!***********************************************!*\
  !*** ./javascripts/modules/sortCollection.js ***!
  \***********************************************/
/*! exports provided: sortCollection */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortCollection", function() { return sortCollection; });
function sortCollection() {
  // Function to get URL parameter
  var getParam = function getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    var results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  };

  // Getting the 'sort_by' query parameter from the URL
  var url_string = window.location.href;
  var url = new URL(url_string);
  var query = url.searchParams.get('sort_by');

  // Adding 'is-current' class based on the query parameter
  if (query === null) {
    var s = document.querySelector('[data-sort-by=default]');
    if (s) s.classList.add('textdecoration-underline');
  } else {
    var _s = document.querySelector('[data-sort-by=' + query + ']');
    if (_s) _s.classList.add('textdecoration-underline');
  }

  // An object to hold the query parameters
  var Shopify = {
    queryParams: {}
  };

  // Click event handler for elements with 'data-sort-by'
  var sortEl = document.querySelectorAll('[data-sort-by]');
  if (sortEl.length) {
    sortEl.forEach(function (element) {
      element.addEventListener('click', function (e) {
        e.preventDefault();
        var sort = element.getAttribute('data-sort-by');
        var q = getParam('q');
        if (sort === 'default') {
          if (q !== null) {
            Shopify.queryParams.q = q;
            window.location.search = new URLSearchParams(Shopify.queryParams).toString();
          } else {
            window.location.href = window.location.href.replace(/\?.*$/, '');
          }
        } else {
          if (q !== null) {
            Shopify.queryParams.q = q;
          }
          Shopify.queryParams.sort_by = sort;
          window.location.search = new URLSearchParams(Shopify.queryParams).toString();
        }
      });
    });
  }
}
;

/***/ }),

/***/ "./javascripts/modules/stickyHeader.js":
/*!*********************************************!*\
  !*** ./javascripts/modules/stickyHeader.js ***!
  \*********************************************/
/*! exports provided: stickyHeader */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stickyHeader", function() { return stickyHeader; });
/* harmony import */ var _getOffset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_getOffset */ "./javascripts/modules/_getOffset.js");

function stickyHeader() {
  var stickyNavContainer = document.querySelector('.sticky-header');
  if (stickyNavContainer) {
    var stickyNavContainerOffsetTop = '';
    var setSize = function setSize() {
      var stickyNavContainerOffset = Object(_getOffset__WEBPACK_IMPORTED_MODULE_0__["getOffset"])(stickyNavContainer);
      stickyNavContainerOffsetTop = stickyNavContainerOffset.top;
    };
    var scroller = function scroller() {
      var scTop = document.documentElement && document.documentElement.scrollTop || document.body.scrollTop;
      if (stickyNavContainerOffsetTop <= scTop) {
        document.body.classList.add('is-header-fixed');
      } else {
        document.body.classList.remove('is-header-fixed');
      }
    };
    var lastInnerWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (lastInnerWidth != window.innerWidth) {
        lastInnerWidth = window.innerWidth;
        setSize();
        scroller();
      }
    });
    window.addEventListener('scroll', scroller, {
      passive: true
    });
    try {
      Typekit.load({
        loading: function loading() {},
        active: function active() {
          setSize();
          scroller();
        },
        inactive: function inactive() {}
      });
    } catch (e) {}
    setInterval(function () {
      setSize();
      scroller();
    }, 1000);
    setSize();
    scroller();
  }
}

/***/ }),

/***/ "./javascripts/modules/stickySidebar.js":
/*!**********************************************!*\
  !*** ./javascripts/modules/stickySidebar.js ***!
  \**********************************************/
/*! exports provided: stickySidebarFunc */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stickySidebarFunc", function() { return stickySidebarFunc; });
/* harmony import */ var sticky_sidebar__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! sticky-sidebar */ "./node_modules/sticky-sidebar/src/sticky-sidebar.js");
/* harmony import */ var _getHeight__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./_getHeight */ "./javascripts/modules/_getHeight.js");


function stickySidebarFunc() {
  var sidebar = document.querySelectorAll('.js-stickySidebar-container');
  var ww = window.innerWidth;
  if (sidebar.length) {
    var _loop = function _loop(i) {
      var el = sidebar[i];
      var bar = el.querySelector('.js-stickySidebar');
      var spacingTop = 0;
      var spacingBottom = 0;
      var isInit = false;
      var stickySidebar = null;
      var init = function init() {
        ww = window.innerWidth;
        if (ww >= 1024) {
          if (bar) bar.removeAttribute('style');
          if (!isInit) {
            stickySidebar = new sticky_sidebar__WEBPACK_IMPORTED_MODULE_0__["default"](el, {
              topSpacing: spacingTop,
              bottomSpacing: spacingBottom,
              containerSelector: '.js-stickySidebar-container',
              innerWrapperSelector: '.js-stickySidebar'
            });
            isInit = true;
          } else {
            stickySidebar.updateSticky();
          }
        } else {
          if (bar) bar.removeAttribute('style');
          if (stickySidebar) stickySidebar.destroy();
          stickySidebar = null;
          isInit = false;
        }
      };
      setInterval(init, 1000);
      window.addEventListener('resize', init);
      window.addEventListener('orientationchange', init);
      init();
    };
    for (var i = 0; i < sidebar.length; i++) {
      _loop(i);
    }
  }
}

/***/ }),

/***/ "./javascripts/modules/trigger.js":
/*!****************************************!*\
  !*** ./javascripts/modules/trigger.js ***!
  \****************************************/
/*! exports provided: trigger */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function() { return trigger; });
/* harmony import */ var _closest__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./_closest */ "./javascripts/modules/_closest.js");

function trigger() {
  function removeNavNest() {
    var navNested = document.querySelectorAll('.nav-nested');
    if (navNested.length) {
      for (var i = 0; i < navNested.length; i++) {
        var el = navNested[i];
        el.classList.remove('is-active');
        var parent = Object(_closest__WEBPACK_IMPORTED_MODULE_0__["closest"])(el, 'js-nav-container');
        if (parent) {
          parent.classList.remove('is-active');
        }
      }
    }
  }
  var triggerNav = document.querySelector('.trigger-nav');
  if (triggerNav) {
    triggerNav.addEventListener('click', function (e) {
      document.body.classList.remove('is-cart-active', 'is-search-active', 'is-login-active', 'dir-bottom');
      if (document.body.classList.contains('is-nav-active')) {
        document.body.classList.remove('is-nav-active');
        removeNavNest();
      } else {
        document.body.classList.add('is-nav-active');
      }
      e.preventDefault();
    });
  }
  var triggerSearch = document.querySelectorAll('.trigger-search');
  var inputSearch = document.querySelector('.input-search');
  if (triggerSearch.length) {
    triggerSearch.forEach(function (el, index) {
      el.addEventListener('click', function (e) {
        document.body.classList.remove('is-nav-active', 'is-cart-active', 'is-login-active', 'dir-bottom');
        removeNavNest();
        if (document.body.classList.contains('is-search-active')) {
          document.body.classList.remove('is-search-active');
          if (inputSearch) inputSearch.blur();
        } else {
          document.body.classList.add('is-search-active');
          if (inputSearch) inputSearch.focus();
        }
        e.preventDefault();
      });
    });
  }
  var triggerLogin = document.querySelectorAll('.trigger-login');
  if (triggerLogin.length) {
    triggerLogin.forEach(function (el, index) {
      el.addEventListener('click', function (e) {
        document.body.classList.remove('is-nav-active', 'is-cart-active', 'is-search-active', 'dir-bottom');
        removeNavNest();
        if (document.body.classList.contains('is-login-active')) {
          document.body.classList.remove('is-login-active');
        } else {
          document.body.classList.add('is-login-active');
        }
        e.preventDefault();
      });
    });
  }
  var cartTrigger = document.querySelectorAll('.trigger-cart');
  if (cartTrigger.length) {
    for (var i = 0; i < cartTrigger.length; i++) {
      var el = cartTrigger[i];
      el.addEventListener('click', function (e) {
        document.body.classList.remove('is-nav-active', 'is-search-active', 'is-login-active', 'dir-bottom');
        removeNavNest();
        if (document.body.classList.contains('is-cart-active')) {
          document.body.classList.remove('is-cart-active');
        } else {
          document.body.classList.add('is-cart-active');
        }
        e.preventDefault();
      });
    }
  }
  var triggerReset = document.querySelectorAll('.trigger-reset');
  if (triggerReset.length) {
    for (var _i = 0; _i < triggerReset.length; _i++) {
      var _el = triggerReset[_i];
      _el.addEventListener('click', function (e) {
        document.body.classList.remove('is-nav-active', 'is-cart-active', 'is-search-active', 'is-login-active', 'dir-bottom');
        removeNavNest();
        e.preventDefault();
      });
    }
  }
}

/***/ }),

/***/ "./javascripts/site.js":
/*!*****************************!*\
  !*** ./javascripts/site.js ***!
  \*****************************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_hover__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/hover */ "./javascripts/modules/hover.js");
/* harmony import */ var _modules_externalLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/externalLink */ "./javascripts/modules/externalLink.js");
/* harmony import */ var _modules_fluidvideo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/fluidvideo */ "./javascripts/modules/fluidvideo.js");
/* harmony import */ var _modules_openClose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/openClose */ "./javascripts/modules/openClose.js");
/* harmony import */ var _modules_scrollDirection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/scrollDirection */ "./javascripts/modules/scrollDirection.js");
/* harmony import */ var _modules_marquee__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/marquee */ "./javascripts/modules/marquee.js");
/* harmony import */ var _modules_stickyHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/stickyHeader */ "./javascripts/modules/stickyHeader.js");
/* harmony import */ var _modules_stickySidebar__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/stickySidebar */ "./javascripts/modules/stickySidebar.js");
/* harmony import */ var _modules_photoswipe_init__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/photoswipe-init */ "./javascripts/modules/photoswipe-init.js");
/* harmony import */ var _modules_trigger__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/trigger */ "./javascripts/modules/trigger.js");
/* harmony import */ var _modules_headerLogo__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/headerLogo */ "./javascripts/modules/headerLogo.js");
/* harmony import */ var _modules_navNested__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/navNested */ "./javascripts/modules/navNested.js");
/* harmony import */ var _modules_productCarousel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/productCarousel */ "./javascripts/modules/productCarousel.js");
/* harmony import */ var _modules_homeLayout__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/homeLayout */ "./javascripts/modules/homeLayout.js");
/* harmony import */ var _modules_exhibitionImages__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/exhibitionImages */ "./javascripts/modules/exhibitionImages.js");
/* harmony import */ var _modules_draggable__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/draggable */ "./javascripts/modules/draggable.js");
/* harmony import */ var _modules_sortCollection__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/sortCollection */ "./javascripts/modules/sortCollection.js");
/* harmony import */ var _modules_shopifyLocaliozation__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/shopifyLocaliozation */ "./javascripts/modules/shopifyLocaliozation.js");
/* harmony import */ var _modules_shopifyAjaxCart__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/shopifyAjaxCart */ "./javascripts/modules/shopifyAjaxCart.js");
/* harmony import */ var _modules_productForm__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/productForm */ "./javascripts/modules/productForm.js");




















var init = function init() {
  Object(_modules_hover__WEBPACK_IMPORTED_MODULE_0__["hover"])();
  Object(_modules_externalLink__WEBPACK_IMPORTED_MODULE_1__["externalLink"])();
  Object(_modules_fluidvideo__WEBPACK_IMPORTED_MODULE_2__["fluidvideo"])();
  Object(_modules_openClose__WEBPACK_IMPORTED_MODULE_3__["openClose"])();
  Object(_modules_scrollDirection__WEBPACK_IMPORTED_MODULE_4__["scrollDirection"])();
  Object(_modules_marquee__WEBPACK_IMPORTED_MODULE_5__["marquee"])();
  Object(_modules_stickyHeader__WEBPACK_IMPORTED_MODULE_6__["stickyHeader"])();
  Object(_modules_stickySidebar__WEBPACK_IMPORTED_MODULE_7__["stickySidebarFunc"])();
  Object(_modules_photoswipe_init__WEBPACK_IMPORTED_MODULE_8__["initPhotoSwipeFromDOM"])('.js-pswp-container');
  Object(_modules_trigger__WEBPACK_IMPORTED_MODULE_9__["trigger"])();
  Object(_modules_headerLogo__WEBPACK_IMPORTED_MODULE_10__["headerLogo"])();
  Object(_modules_navNested__WEBPACK_IMPORTED_MODULE_11__["navNested"])();
  Object(_modules_productCarousel__WEBPACK_IMPORTED_MODULE_12__["productCarousel"])();
  Object(_modules_homeLayout__WEBPACK_IMPORTED_MODULE_13__["homeLayout"])();
  Object(_modules_exhibitionImages__WEBPACK_IMPORTED_MODULE_14__["exhibitionImages"])();
  Object(_modules_draggable__WEBPACK_IMPORTED_MODULE_15__["draggable"])();
  Object(_modules_sortCollection__WEBPACK_IMPORTED_MODULE_16__["sortCollection"])();
  Object(_modules_shopifyAjaxCart__WEBPACK_IMPORTED_MODULE_18__["shopifyAjaxCart"])();
  Object(_modules_productForm__WEBPACK_IMPORTED_MODULE_19__["productForm"])();
};
init();

/***/ }),

/***/ "./node_modules/desandro-matches-selector/matches-selector.js":
/*!********************************************************************!*\
  !*** ./node_modules/desandro-matches-selector/matches-selector.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
  /*global define: false, module: false */
  'use strict';

  // universal module definition
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory() {
  'use strict';

  var matchesMethod = function () {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if (ElemProto.matches) {
      return 'matches';
    }
    // check un-prefixed
    if (ElemProto.matchesSelector) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = ['webkit', 'moz', 'ms', 'o'];
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if (ElemProto[method]) {
        return method;
      }
    }
  }();
  return function matchesSelector(elem, selector) {
    return elem[matchesMethod](selector);
  };
});

/***/ }),

/***/ "./node_modules/ev-emitter/ev-emitter.js":
/*!***********************************************!*\
  !*** ./node_modules/ev-emitter/ev-emitter.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

(function (global, factory) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if (true) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(typeof window != 'undefined' ? window : this, function () {
  "use strict";

  function EvEmitter() {}
  var proto = EvEmitter.prototype;
  proto.on = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    }
    // set events hash
    var events = this._events = this._events || {};
    // set listeners array
    var listeners = events[eventName] = events[eventName] || [];
    // only add once
    if (listeners.indexOf(listener) == -1) {
      listeners.push(listener);
    }
    return this;
  };
  proto.once = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    }
    // add event
    this.on(eventName, listener);
    // set once flag
    // set onceEvents hash
    var onceEvents = this._onceEvents = this._onceEvents || {};
    // set onceListeners object
    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
    // set flag
    onceListeners[listener] = true;
    return this;
  };
  proto.off = function (eventName, listener) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) {
      return;
    }
    var index = listeners.indexOf(listener);
    if (index != -1) {
      listeners.splice(index, 1);
    }
    return this;
  };
  proto.emitEvent = function (eventName, args) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) {
      return;
    }
    // copy over to avoid interference if .off() in listener
    listeners = listeners.slice(0);
    args = args || [];
    // once stuff
    var onceListeners = this._onceEvents && this._onceEvents[eventName];
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      var isOnce = onceListeners && onceListeners[listener];
      if (isOnce) {
        // remove listener
        // remove before trigger to prevent recursion
        this.off(eventName, listener);
        // unset once flag
        delete onceListeners[listener];
      }
      // trigger listener
      listener.apply(this, args);
    }
    return this;
  };
  proto.allOff = function () {
    delete this._events;
    delete this._onceEvents;
  };
  return EvEmitter;
});

/***/ }),

/***/ "./node_modules/fizzy-ui-utils/utils.js":
/*!**********************************************!*\
  !*** ./node_modules/fizzy-ui-utils/utils.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! desandro-matches-selector/matches-selector */ "./node_modules/desandro-matches-selector/matches-selector.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (matchesSelector) {
      return factory(window, matchesSelector);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, matchesSelector) {
  'use strict';

  var utils = {};

  // ----- extend ----- //

  // extends objects
  utils.extend = function (a, b) {
    for (var prop in b) {
      a[prop] = b[prop];
    }
    return a;
  };

  // ----- modulo ----- //

  utils.modulo = function (num, div) {
    return (num % div + div) % div;
  };

  // ----- makeArray ----- //

  var arraySlice = Array.prototype.slice;

  // turn element or nodeList into an array
  utils.makeArray = function (obj) {
    if (Array.isArray(obj)) {
      // use object if already an array
      return obj;
    }
    // return empty array if undefined or null. #6
    if (obj === null || obj === undefined) {
      return [];
    }
    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number';
    if (isArrayLike) {
      // convert nodeList to array
      return arraySlice.call(obj);
    }

    // array of single index
    return [obj];
  };

  // ----- removeFrom ----- //

  utils.removeFrom = function (ary, obj) {
    var index = ary.indexOf(obj);
    if (index != -1) {
      ary.splice(index, 1);
    }
  };

  // ----- getParent ----- //

  utils.getParent = function (elem, selector) {
    while (elem.parentNode && elem != document.body) {
      elem = elem.parentNode;
      if (matchesSelector(elem, selector)) {
        return elem;
      }
    }
  };

  // ----- getQueryElement ----- //

  // use element as selector string
  utils.getQueryElement = function (elem) {
    if (typeof elem == 'string') {
      return document.querySelector(elem);
    }
    return elem;
  };

  // ----- handleEvent ----- //

  // enable .ontype to trigger from .addEventListener( elem, 'type' )
  utils.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };

  // ----- filterFindElements ----- //

  utils.filterFindElements = function (elems, selector) {
    // make array of elems
    elems = utils.makeArray(elems);
    var ffElems = [];
    elems.forEach(function (elem) {
      // check that elem is an actual element
      if (!(elem instanceof HTMLElement)) {
        return;
      }
      // add elem if no selector
      if (!selector) {
        ffElems.push(elem);
        return;
      }
      // filter & find items if we have a selector
      // filter
      if (matchesSelector(elem, selector)) {
        ffElems.push(elem);
      }
      // find children
      var childElems = elem.querySelectorAll(selector);
      // concat childElems to filterFound array
      for (var i = 0; i < childElems.length; i++) {
        ffElems.push(childElems[i]);
      }
    });
    return ffElems;
  };

  // ----- debounceMethod ----- //

  utils.debounceMethod = function (_class, methodName, threshold) {
    threshold = threshold || 100;
    // original method
    var method = _class.prototype[methodName];
    var timeoutName = methodName + 'Timeout';
    _class.prototype[methodName] = function () {
      var timeout = this[timeoutName];
      clearTimeout(timeout);
      var args = arguments;
      var _this = this;
      this[timeoutName] = setTimeout(function () {
        method.apply(_this, args);
        delete _this[timeoutName];
      }, threshold);
    };
  };

  // ----- docReady ----- //

  utils.docReady = function (callback) {
    var readyState = document.readyState;
    if (readyState == 'complete' || readyState == 'interactive') {
      // do async to allow for other scripts to run. metafizzy/flickity#441
      setTimeout(callback);
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  };

  // ----- htmlInit ----- //

  // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
  utils.toDashed = function (str) {
    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
      return $1 + '-' + $2;
    }).toLowerCase();
  };
  var console = window.console;
  /**
   * allow user to initialize classes via [data-namespace] or .js-namespace class
   * htmlInit( Widget, 'widgetName' )
   * options are parsed from data-namespace-options
   */
  utils.htmlInit = function (WidgetClass, namespace) {
    utils.docReady(function () {
      var dashedNamespace = utils.toDashed(namespace);
      var dataAttr = 'data-' + dashedNamespace;
      var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
      var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
      var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
      var dataOptionsAttr = dataAttr + '-options';
      var jQuery = window.jQuery;
      elems.forEach(function (elem) {
        var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
        var options;
        try {
          options = attr && JSON.parse(attr);
        } catch (error) {
          // log error, do not initialize
          if (console) {
            console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
          }
          return;
        }
        // initialize
        var instance = new WidgetClass(elem, options);
        // make available via $().data('namespace')
        if (jQuery) {
          jQuery.data(elem, namespace, instance);
        }
      });
    });
  };

  // -----  ----- //

  return utils;
});

/***/ }),

/***/ "./node_modules/flickity/js/add-remove-cell.js":
/*!*****************************************************!*\
  !*** ./node_modules/flickity/js/add-remove-cell.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// add, remove cell
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Flickity, utils) {
      return factory(window, Flickity, utils);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, Flickity, utils) {
  'use strict';

  // append cells to a document fragment
  function getCellsFragment(cells) {
    var fragment = document.createDocumentFragment();
    cells.forEach(function (cell) {
      fragment.appendChild(cell.element);
    });
    return fragment;
  }

  // -------------------------- add/remove cell prototype -------------------------- //

  var proto = Flickity.prototype;

  /**
   * Insert, prepend, or append cells
   * @param {Element, Array, NodeList} elems
   * @param {Integer} index
   */
  proto.insert = function (elems, index) {
    var cells = this._makeCells(elems);
    if (!cells || !cells.length) {
      return;
    }
    var len = this.cells.length;
    // default to append
    index = index === undefined ? len : index;
    // add cells with document fragment
    var fragment = getCellsFragment(cells);
    // append to slider
    var isAppend = index == len;
    if (isAppend) {
      this.slider.appendChild(fragment);
    } else {
      var insertCellElement = this.cells[index].element;
      this.slider.insertBefore(fragment, insertCellElement);
    }
    // add to this.cells
    if (index === 0) {
      // prepend, add to start
      this.cells = cells.concat(this.cells);
    } else if (isAppend) {
      // append, add to end
      this.cells = this.cells.concat(cells);
    } else {
      // insert in this.cells
      var endCells = this.cells.splice(index, len - index);
      this.cells = this.cells.concat(cells).concat(endCells);
    }
    this._sizeCells(cells);
    this.cellChange(index, true);
  };
  proto.append = function (elems) {
    this.insert(elems, this.cells.length);
  };
  proto.prepend = function (elems) {
    this.insert(elems, 0);
  };

  /**
   * Remove cells
   * @param {Element, Array, NodeList} elems
   */
  proto.remove = function (elems) {
    var cells = this.getCells(elems);
    if (!cells || !cells.length) {
      return;
    }
    var minCellIndex = this.cells.length - 1;
    // remove cells from collection & DOM
    cells.forEach(function (cell) {
      cell.remove();
      var index = this.cells.indexOf(cell);
      minCellIndex = Math.min(index, minCellIndex);
      utils.removeFrom(this.cells, cell);
    }, this);
    this.cellChange(minCellIndex, true);
  };

  /**
   * logic to be run after a cell's size changes
   * @param {Element} elem - cell's element
   */
  proto.cellSizeChange = function (elem) {
    var cell = this.getCell(elem);
    if (!cell) {
      return;
    }
    cell.getSize();
    var index = this.cells.indexOf(cell);
    this.cellChange(index);
  };

  /**
   * logic any time a cell is changed: added, removed, or size changed
   * @param {Integer} changedCellIndex - index of the changed cell, optional
   */
  proto.cellChange = function (changedCellIndex, isPositioningSlider) {
    var prevSelectedElem = this.selectedElement;
    this._positionCells(changedCellIndex);
    this._getWrapShiftCells();
    this.setGallerySize();
    // update selectedIndex
    // try to maintain position & select previous selected element
    var cell = this.getCell(prevSelectedElem);
    if (cell) {
      this.selectedIndex = this.getCellSlideIndex(cell);
    }
    this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex);
    this.emitEvent('cellChange', [changedCellIndex]);
    // position slider
    this.select(this.selectedIndex);
    // do not position slider after lazy load
    if (isPositioningSlider) {
      this.positionSliderAtSelected();
    }
  };

  // -----  ----- //

  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/animate.js":
/*!*********************************************!*\
  !*** ./node_modules/flickity/js/animate.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// animate
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (utils) {
      return factory(window, utils);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, utils) {
  'use strict';

  // -------------------------- animate -------------------------- //
  var proto = {};
  proto.startAnimation = function () {
    if (this.isAnimating) {
      return;
    }
    this.isAnimating = true;
    this.restingFrames = 0;
    this.animate();
  };
  proto.animate = function () {
    this.applyDragForce();
    this.applySelectedAttraction();
    var previousX = this.x;
    this.integratePhysics();
    this.positionSlider();
    this.settle(previousX);
    // animate next frame
    if (this.isAnimating) {
      var _this = this;
      requestAnimationFrame(function animateFrame() {
        _this.animate();
      });
    }
  };
  proto.positionSlider = function () {
    var x = this.x;
    // wrap position around
    if (this.options.wrapAround && this.cells.length > 1) {
      x = utils.modulo(x, this.slideableWidth);
      x = x - this.slideableWidth;
      this.shiftWrapCells(x);
    }
    this.setTranslateX(x, this.isAnimating);
    this.dispatchScrollEvent();
  };
  proto.setTranslateX = function (x, is3d) {
    x += this.cursorPosition;
    // reverse if right-to-left and using transform
    x = this.options.rightToLeft ? -x : x;
    var translateX = this.getPositionValue(x);
    // use 3D tranforms for hardware acceleration on iOS
    // but use 2D when settled, for better font-rendering
    this.slider.style.transform = is3d ? 'translate3d(' + translateX + ',0,0)' : 'translateX(' + translateX + ')';
  };
  proto.dispatchScrollEvent = function () {
    var firstSlide = this.slides[0];
    if (!firstSlide) {
      return;
    }
    var positionX = -this.x - firstSlide.target;
    var progress = positionX / this.slidesWidth;
    this.dispatchEvent('scroll', null, [progress, positionX]);
  };
  proto.positionSliderAtSelected = function () {
    if (!this.cells.length) {
      return;
    }
    this.x = -this.selectedSlide.target;
    this.velocity = 0; // stop wobble
    this.positionSlider();
  };
  proto.getPositionValue = function (position) {
    if (this.options.percentPosition) {
      // percent position, round to 2 digits, like 12.34%
      return Math.round(position / this.size.innerWidth * 10000) * 0.01 + '%';
    } else {
      // pixel positioning
      return Math.round(position) + 'px';
    }
  };
  proto.settle = function (previousX) {
    // keep track of frames where x hasn't moved
    if (!this.isPointerDown && Math.round(this.x * 100) == Math.round(previousX * 100)) {
      this.restingFrames++;
    }
    // stop animating if resting for 3 or more frames
    if (this.restingFrames > 2) {
      this.isAnimating = false;
      delete this.isFreeScrolling;
      // render position with translateX when settled
      this.positionSlider();
      this.dispatchEvent('settle', null, [this.selectedIndex]);
    }
  };
  proto.shiftWrapCells = function (x) {
    // shift before cells
    var beforeGap = this.cursorPosition + x;
    this._shiftCells(this.beforeShiftCells, beforeGap, -1);
    // shift after cells
    var afterGap = this.size.innerWidth - (x + this.slideableWidth + this.cursorPosition);
    this._shiftCells(this.afterShiftCells, afterGap, 1);
  };
  proto._shiftCells = function (cells, gap, shift) {
    for (var i = 0; i < cells.length; i++) {
      var cell = cells[i];
      var cellShift = gap > 0 ? shift : 0;
      cell.wrapShift(cellShift);
      gap -= cell.size.outerWidth;
    }
  };
  proto._unshiftCells = function (cells) {
    if (!cells || !cells.length) {
      return;
    }
    for (var i = 0; i < cells.length; i++) {
      cells[i].wrapShift(0);
    }
  };

  // -------------------------- physics -------------------------- //

  proto.integratePhysics = function () {
    this.x += this.velocity;
    this.velocity *= this.getFrictionFactor();
  };
  proto.applyForce = function (force) {
    this.velocity += force;
  };
  proto.getFrictionFactor = function () {
    return 1 - this.options[this.isFreeScrolling ? 'freeScrollFriction' : 'friction'];
  };
  proto.getRestingPosition = function () {
    // my thanks to Steven Wittens, who simplified this math greatly
    return this.x + this.velocity / (1 - this.getFrictionFactor());
  };
  proto.applyDragForce = function () {
    if (!this.isDraggable || !this.isPointerDown) {
      return;
    }
    // change the position to drag position by applying force
    var dragVelocity = this.dragX - this.x;
    var dragForce = dragVelocity - this.velocity;
    this.applyForce(dragForce);
  };
  proto.applySelectedAttraction = function () {
    // do not attract if pointer down or no slides
    var dragDown = this.isDraggable && this.isPointerDown;
    if (dragDown || this.isFreeScrolling || !this.slides.length) {
      return;
    }
    var distance = this.selectedSlide.target * -1 - this.x;
    var force = distance * this.options.selectedAttraction;
    this.applyForce(force);
  };
  return proto;
});

/***/ }),

/***/ "./node_modules/flickity/js/cell.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/cell.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// Flickity.Cell
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! get-size/get-size */ "./node_modules/get-size/get-size.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (getSize) {
      return factory(window, getSize);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, getSize) {
  'use strict';

  function Cell(elem, parent) {
    this.element = elem;
    this.parent = parent;
    this.create();
  }
  var proto = Cell.prototype;
  proto.create = function () {
    this.element.style.position = 'absolute';
    this.element.setAttribute('aria-hidden', 'true');
    this.x = 0;
    this.shift = 0;
  };
  proto.destroy = function () {
    // reset style
    this.unselect();
    this.element.style.position = '';
    var side = this.parent.originSide;
    this.element.style[side] = '';
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
  };
  proto.setPosition = function (x) {
    this.x = x;
    this.updateTarget();
    this.renderPosition(x);
  };

  // setDefaultTarget v1 method, backwards compatibility, remove in v3
  proto.updateTarget = proto.setDefaultTarget = function () {
    var marginProperty = this.parent.originSide == 'left' ? 'marginLeft' : 'marginRight';
    this.target = this.x + this.size[marginProperty] + this.size.width * this.parent.cellAlign;
  };
  proto.renderPosition = function (x) {
    // render position of cell with in slider
    var side = this.parent.originSide;
    this.element.style[side] = this.parent.getPositionValue(x);
  };
  proto.select = function () {
    this.element.classList.add('is-selected');
    this.element.removeAttribute('aria-hidden');
  };
  proto.unselect = function () {
    this.element.classList.remove('is-selected');
    this.element.setAttribute('aria-hidden', 'true');
  };

  /**
   * @param {Integer} factor - 0, 1, or -1
  **/
  proto.wrapShift = function (shift) {
    this.shift = shift;
    this.renderPosition(this.x + this.parent.slideableWidth * shift);
  };
  proto.remove = function () {
    this.element.parentNode.removeChild(this.element);
  };
  return Cell;
});

/***/ }),

/***/ "./node_modules/flickity/js/drag.js":
/*!******************************************!*\
  !*** ./node_modules/flickity/js/drag.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// drag
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js"), __webpack_require__(/*! unidragger/unidragger */ "./node_modules/unidragger/unidragger.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Flickity, Unidragger, utils) {
      return factory(window, Flickity, Unidragger, utils);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, Flickity, Unidragger, utils) {
  'use strict';

  // ----- defaults ----- //
  utils.extend(Flickity.defaults, {
    draggable: '>1',
    dragThreshold: 3
  });

  // ----- create ----- //

  Flickity.createMethods.push('_createDrag');

  // -------------------------- drag prototype -------------------------- //

  var proto = Flickity.prototype;
  utils.extend(proto, Unidragger.prototype);
  proto._touchActionValue = 'pan-y';

  // --------------------------  -------------------------- //

  var isTouch = ('createTouch' in document);
  var isTouchmoveScrollCanceled = false;
  proto._createDrag = function () {
    this.on('activate', this.onActivateDrag);
    this.on('uiChange', this._uiChangeDrag);
    this.on('deactivate', this.onDeactivateDrag);
    this.on('cellChange', this.updateDraggable);
    // TODO updateDraggable on resize? if groupCells & slides change
    // HACK - add seemingly innocuous handler to fix iOS 10 scroll behavior
    // #457, RubaXa/Sortable#973
    if (isTouch && !isTouchmoveScrollCanceled) {
      window.addEventListener('touchmove', function () {});
      isTouchmoveScrollCanceled = true;
    }
  };
  proto.onActivateDrag = function () {
    this.handles = [this.viewport];
    this.bindHandles();
    this.updateDraggable();
  };
  proto.onDeactivateDrag = function () {
    this.unbindHandles();
    this.element.classList.remove('is-draggable');
  };
  proto.updateDraggable = function () {
    // disable dragging if less than 2 slides. #278
    if (this.options.draggable == '>1') {
      this.isDraggable = this.slides.length > 1;
    } else {
      this.isDraggable = this.options.draggable;
    }
    if (this.isDraggable) {
      this.element.classList.add('is-draggable');
    } else {
      this.element.classList.remove('is-draggable');
    }
  };

  // backwards compatibility
  proto.bindDrag = function () {
    this.options.draggable = true;
    this.updateDraggable();
  };
  proto.unbindDrag = function () {
    this.options.draggable = false;
    this.updateDraggable();
  };
  proto._uiChangeDrag = function () {
    delete this.isFreeScrolling;
  };

  // -------------------------- pointer events -------------------------- //

  proto.pointerDown = function (event, pointer) {
    if (!this.isDraggable) {
      this._pointerDownDefault(event, pointer);
      return;
    }
    var isOkay = this.okayPointerDown(event);
    if (!isOkay) {
      return;
    }
    this._pointerDownPreventDefault(event);
    this.pointerDownFocus(event);
    // blur
    if (document.activeElement != this.element) {
      // do not blur if already focused
      this.pointerDownBlur();
    }

    // stop if it was moving
    this.dragX = this.x;
    this.viewport.classList.add('is-pointer-down');
    // track scrolling
    this.pointerDownScroll = getScrollPosition();
    window.addEventListener('scroll', this);
    this._pointerDownDefault(event, pointer);
  };

  // default pointerDown logic, used for staticClick
  proto._pointerDownDefault = function (event, pointer) {
    // track start event position
    // Safari 9 overrides pageX and pageY. These values needs to be copied. #779
    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    };
    // bind move and end events
    this._bindPostStartEvents(event);
    this.dispatchEvent('pointerDown', event, [pointer]);
  };
  var focusNodes = {
    INPUT: true,
    TEXTAREA: true,
    SELECT: true
  };
  proto.pointerDownFocus = function (event) {
    var isFocusNode = focusNodes[event.target.nodeName];
    if (!isFocusNode) {
      this.focus();
    }
  };
  proto._pointerDownPreventDefault = function (event) {
    var isTouchStart = event.type == 'touchstart';
    var isTouchPointer = event.pointerType == 'touch';
    var isFocusNode = focusNodes[event.target.nodeName];
    if (!isTouchStart && !isTouchPointer && !isFocusNode) {
      event.preventDefault();
    }
  };

  // ----- move ----- //

  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > this.options.dragThreshold;
  };

  // ----- up ----- //

  proto.pointerUp = function (event, pointer) {
    delete this.isTouchScrolling;
    this.viewport.classList.remove('is-pointer-down');
    this.dispatchEvent('pointerUp', event, [pointer]);
    this._dragPointerUp(event, pointer);
  };
  proto.pointerDone = function () {
    window.removeEventListener('scroll', this);
    delete this.pointerDownScroll;
  };

  // -------------------------- dragging -------------------------- //

  proto.dragStart = function (event, pointer) {
    if (!this.isDraggable) {
      return;
    }
    this.dragStartPosition = this.x;
    this.startAnimation();
    window.removeEventListener('scroll', this);
    this.dispatchEvent('dragStart', event, [pointer]);
  };
  proto.pointerMove = function (event, pointer) {
    var moveVector = this._dragPointerMove(event, pointer);
    this.dispatchEvent('pointerMove', event, [pointer, moveVector]);
    this._dragMove(event, pointer, moveVector);
  };
  proto.dragMove = function (event, pointer, moveVector) {
    if (!this.isDraggable) {
      return;
    }
    event.preventDefault();
    this.previousDragX = this.dragX;
    // reverse if right-to-left
    var direction = this.options.rightToLeft ? -1 : 1;
    if (this.options.wrapAround) {
      // wrap around move. #589
      moveVector.x = moveVector.x % this.slideableWidth;
    }
    var dragX = this.dragStartPosition + moveVector.x * direction;
    if (!this.options.wrapAround && this.slides.length) {
      // slow drag
      var originBound = Math.max(-this.slides[0].target, this.dragStartPosition);
      dragX = dragX > originBound ? (dragX + originBound) * 0.5 : dragX;
      var endBound = Math.min(-this.getLastSlide().target, this.dragStartPosition);
      dragX = dragX < endBound ? (dragX + endBound) * 0.5 : dragX;
    }
    this.dragX = dragX;
    this.dragMoveTime = new Date();
    this.dispatchEvent('dragMove', event, [pointer, moveVector]);
  };
  proto.dragEnd = function (event, pointer) {
    if (!this.isDraggable) {
      return;
    }
    if (this.options.freeScroll) {
      this.isFreeScrolling = true;
    }
    // set selectedIndex based on where flick will end up
    var index = this.dragEndRestingSelect();
    if (this.options.freeScroll && !this.options.wrapAround) {
      // if free-scroll & not wrap around
      // do not free-scroll if going outside of bounding slides
      // so bounding slides can attract slider, and keep it in bounds
      var restingX = this.getRestingPosition();
      this.isFreeScrolling = -restingX > this.slides[0].target && -restingX < this.getLastSlide().target;
    } else if (!this.options.freeScroll && index == this.selectedIndex) {
      // boost selection if selected index has not changed
      index += this.dragEndBoostSelect();
    }
    delete this.previousDragX;
    // apply selection
    // TODO refactor this, selecting here feels weird
    // HACK, set flag so dragging stays in correct direction
    this.isDragSelect = this.options.wrapAround;
    this.select(index);
    delete this.isDragSelect;
    this.dispatchEvent('dragEnd', event, [pointer]);
  };
  proto.dragEndRestingSelect = function () {
    var restingX = this.getRestingPosition();
    // how far away from selected slide
    var distance = Math.abs(this.getSlideDistance(-restingX, this.selectedIndex));
    // get closet resting going up and going down
    var positiveResting = this._getClosestResting(restingX, distance, 1);
    var negativeResting = this._getClosestResting(restingX, distance, -1);
    // use closer resting for wrap-around
    var index = positiveResting.distance < negativeResting.distance ? positiveResting.index : negativeResting.index;
    return index;
  };

  /**
   * given resting X and distance to selected cell
   * get the distance and index of the closest cell
   * @param {Number} restingX - estimated post-flick resting position
   * @param {Number} distance - distance to selected cell
   * @param {Integer} increment - +1 or -1, going up or down
   * @returns {Object} - { distance: {Number}, index: {Integer} }
   */
  proto._getClosestResting = function (restingX, distance, increment) {
    var index = this.selectedIndex;
    var minDistance = Infinity;
    var condition = this.options.contain && !this.options.wrapAround ?
    // if contain, keep going if distance is equal to minDistance
    function (d, md) {
      return d <= md;
    } : function (d, md) {
      return d < md;
    };
    while (condition(distance, minDistance)) {
      // measure distance to next cell
      index += increment;
      minDistance = distance;
      distance = this.getSlideDistance(-restingX, index);
      if (distance === null) {
        break;
      }
      distance = Math.abs(distance);
    }
    return {
      distance: minDistance,
      // selected was previous index
      index: index - increment
    };
  };

  /**
   * measure distance between x and a slide target
   * @param {Number} x
   * @param {Integer} index - slide index
   */
  proto.getSlideDistance = function (x, index) {
    var len = this.slides.length;
    // wrap around if at least 2 slides
    var isWrapAround = this.options.wrapAround && len > 1;
    var slideIndex = isWrapAround ? utils.modulo(index, len) : index;
    var slide = this.slides[slideIndex];
    if (!slide) {
      return null;
    }
    // add distance for wrap-around slides
    var wrap = isWrapAround ? this.slideableWidth * Math.floor(index / len) : 0;
    return x - (slide.target + wrap);
  };
  proto.dragEndBoostSelect = function () {
    // do not boost if no previousDragX or dragMoveTime
    if (this.previousDragX === undefined || !this.dragMoveTime ||
    // or if drag was held for 100 ms
    new Date() - this.dragMoveTime > 100) {
      return 0;
    }
    var distance = this.getSlideDistance(-this.dragX, this.selectedIndex);
    var delta = this.previousDragX - this.dragX;
    if (distance > 0 && delta > 0) {
      // boost to next if moving towards the right, and positive velocity
      return 1;
    } else if (distance < 0 && delta < 0) {
      // boost to previous if moving towards the left, and negative velocity
      return -1;
    }
    return 0;
  };

  // ----- staticClick ----- //

  proto.staticClick = function (event, pointer) {
    // get clickedCell, if cell was clicked
    var clickedCell = this.getParentCell(event.target);
    var cellElem = clickedCell && clickedCell.element;
    var cellIndex = clickedCell && this.cells.indexOf(clickedCell);
    this.dispatchEvent('staticClick', event, [pointer, cellElem, cellIndex]);
  };

  // ----- scroll ----- //

  proto.onscroll = function () {
    var scroll = getScrollPosition();
    var scrollMoveX = this.pointerDownScroll.x - scroll.x;
    var scrollMoveY = this.pointerDownScroll.y - scroll.y;
    // cancel click/tap if scroll is too much
    if (Math.abs(scrollMoveX) > 3 || Math.abs(scrollMoveY) > 3) {
      this._pointerDone();
    }
  };

  // ----- utils ----- //

  function getScrollPosition() {
    return {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }

  // -----  ----- //

  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/flickity.js":
/*!**********************************************!*\
  !*** ./node_modules/flickity/js/flickity.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// Flickity main
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ev-emitter/ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"), __webpack_require__(/*! get-size/get-size */ "./node_modules/get-size/get-size.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js"), __webpack_require__(/*! ./cell */ "./node_modules/flickity/js/cell.js"), __webpack_require__(/*! ./slide */ "./node_modules/flickity/js/slide.js"), __webpack_require__(/*! ./animate */ "./node_modules/flickity/js/animate.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
      return factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var _Flickity; }
})(window, function factory(window, EvEmitter, getSize, utils, Cell, Slide, animatePrototype) {
  'use strict';

  // vars
  var jQuery = window.jQuery;
  var getComputedStyle = window.getComputedStyle;
  var console = window.console;
  function moveElements(elems, toElem) {
    elems = utils.makeArray(elems);
    while (elems.length) {
      toElem.appendChild(elems.shift());
    }
  }

  // -------------------------- Flickity -------------------------- //

  // globally unique identifiers
  var GUID = 0;
  // internal store of all Flickity intances
  var instances = {};
  function Flickity(element, options) {
    var queryElement = utils.getQueryElement(element);
    if (!queryElement) {
      if (console) {
        console.error('Bad element for Flickity: ' + (queryElement || element));
      }
      return;
    }
    this.element = queryElement;
    // do not initialize twice on same element
    if (this.element.flickityGUID) {
      var instance = instances[this.element.flickityGUID];
      instance.option(options);
      return instance;
    }

    // add jQuery
    if (jQuery) {
      this.$element = jQuery(this.element);
    }
    // options
    this.options = utils.extend({}, this.constructor.defaults);
    this.option(options);

    // kick things off
    this._create();
  }
  Flickity.defaults = {
    accessibility: true,
    // adaptiveHeight: false,
    cellAlign: 'center',
    // cellSelector: undefined,
    // contain: false,
    freeScrollFriction: 0.075,
    // friction when free-scrolling
    friction: 0.28,
    // friction when selecting
    namespaceJQueryEvents: true,
    // initialIndex: 0,
    percentPosition: true,
    resize: true,
    selectedAttraction: 0.025,
    setGallerySize: true
    // watchCSS: false,
    // wrapAround: false
  };

  // hash of methods triggered on _create()
  Flickity.createMethods = [];
  var proto = Flickity.prototype;
  // inherit EventEmitter
  utils.extend(proto, EvEmitter.prototype);
  proto._create = function () {
    // add id for Flickity.data
    var id = this.guid = ++GUID;
    this.element.flickityGUID = id; // expando
    instances[id] = this; // associate via id
    // initial properties
    this.selectedIndex = 0;
    // how many frames slider has been in same position
    this.restingFrames = 0;
    // initial physics properties
    this.x = 0;
    this.velocity = 0;
    this.originSide = this.options.rightToLeft ? 'right' : 'left';
    // create viewport & slider
    this.viewport = document.createElement('div');
    this.viewport.className = 'flickity-viewport';
    this._createSlider();
    if (this.options.resize || this.options.watchCSS) {
      window.addEventListener('resize', this);
    }

    // add listeners from on option
    for (var eventName in this.options.on) {
      var listener = this.options.on[eventName];
      this.on(eventName, listener);
    }
    Flickity.createMethods.forEach(function (method) {
      this[method]();
    }, this);
    if (this.options.watchCSS) {
      this.watchCSS();
    } else {
      this.activate();
    }
  };

  /**
   * set options
   * @param {Object} opts
   */
  proto.option = function (opts) {
    utils.extend(this.options, opts);
  };
  proto.activate = function () {
    if (this.isActive) {
      return;
    }
    this.isActive = true;
    this.element.classList.add('flickity-enabled');
    if (this.options.rightToLeft) {
      this.element.classList.add('flickity-rtl');
    }
    this.getSize();
    // move initial cell elements so they can be loaded as cells
    var cellElems = this._filterFindCellElements(this.element.children);
    moveElements(cellElems, this.slider);
    this.viewport.appendChild(this.slider);
    this.element.appendChild(this.viewport);
    // get cells from children
    this.reloadCells();
    if (this.options.accessibility) {
      // allow element to focusable
      this.element.tabIndex = 0;
      // listen for key presses
      this.element.addEventListener('keydown', this);
    }
    this.emitEvent('activate');
    this.selectInitialIndex();
    // flag for initial activation, for using initialIndex
    this.isInitActivated = true;
    // ready event. #493
    this.dispatchEvent('ready');
  };

  // slider positions the cells
  proto._createSlider = function () {
    // slider element does all the positioning
    var slider = document.createElement('div');
    slider.className = 'flickity-slider';
    slider.style[this.originSide] = 0;
    this.slider = slider;
  };
  proto._filterFindCellElements = function (elems) {
    return utils.filterFindElements(elems, this.options.cellSelector);
  };

  // goes through all children
  proto.reloadCells = function () {
    // collection of item elements
    this.cells = this._makeCells(this.slider.children);
    this.positionCells();
    this._getWrapShiftCells();
    this.setGallerySize();
  };

  /**
   * turn elements into Flickity.Cells
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - collection of new Flickity Cells
   */
  proto._makeCells = function (elems) {
    var cellElems = this._filterFindCellElements(elems);

    // create new Flickity for collection
    var cells = cellElems.map(function (cellElem) {
      return new Cell(cellElem, this);
    }, this);
    return cells;
  };
  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };
  proto.getLastSlide = function () {
    return this.slides[this.slides.length - 1];
  };

  // positions all cells
  proto.positionCells = function () {
    // size all cells
    this._sizeCells(this.cells);
    // position all cells
    this._positionCells(0);
  };

  /**
   * position certain cells
   * @param {Integer} index - which cell to start with
   */
  proto._positionCells = function (index) {
    index = index || 0;
    // also measure maxCellHeight
    // start 0 if positioning all cells
    this.maxCellHeight = index ? this.maxCellHeight || 0 : 0;
    var cellX = 0;
    // get cellX
    if (index > 0) {
      var startCell = this.cells[index - 1];
      cellX = startCell.x + startCell.size.outerWidth;
    }
    var len = this.cells.length;
    for (var i = index; i < len; i++) {
      var cell = this.cells[i];
      cell.setPosition(cellX);
      cellX += cell.size.outerWidth;
      this.maxCellHeight = Math.max(cell.size.outerHeight, this.maxCellHeight);
    }
    // keep track of cellX for wrap-around
    this.slideableWidth = cellX;
    // slides
    this.updateSlides();
    // contain slides target
    this._containSlides();
    // update slidesWidth
    this.slidesWidth = len ? this.getLastSlide().target - this.slides[0].target : 0;
  };

  /**
   * cell.getSize() on multiple cells
   * @param {Array} cells
   */
  proto._sizeCells = function (cells) {
    cells.forEach(function (cell) {
      cell.getSize();
    });
  };

  // --------------------------  -------------------------- //

  proto.updateSlides = function () {
    this.slides = [];
    if (!this.cells.length) {
      return;
    }
    var slide = new Slide(this);
    this.slides.push(slide);
    var isOriginLeft = this.originSide == 'left';
    var nextMargin = isOriginLeft ? 'marginRight' : 'marginLeft';
    var canCellFit = this._getCanCellFit();
    this.cells.forEach(function (cell, i) {
      // just add cell if first cell in slide
      if (!slide.cells.length) {
        slide.addCell(cell);
        return;
      }
      var slideWidth = slide.outerWidth - slide.firstMargin + (cell.size.outerWidth - cell.size[nextMargin]);
      if (canCellFit.call(this, i, slideWidth)) {
        slide.addCell(cell);
      } else {
        // doesn't fit, new slide
        slide.updateTarget();
        slide = new Slide(this);
        this.slides.push(slide);
        slide.addCell(cell);
      }
    }, this);
    // last slide
    slide.updateTarget();
    // update .selectedSlide
    this.updateSelectedSlide();
  };
  proto._getCanCellFit = function () {
    var groupCells = this.options.groupCells;
    if (!groupCells) {
      return function () {
        return false;
      };
    } else if (typeof groupCells == 'number') {
      // group by number. 3 -> [0,1,2], [3,4,5], ...
      var number = parseInt(groupCells, 10);
      return function (i) {
        return i % number !== 0;
      };
    }
    // default, group by width of slide
    // parse '75%
    var percentMatch = typeof groupCells == 'string' && groupCells.match(/^(\d+)%$/);
    var percent = percentMatch ? parseInt(percentMatch[1], 10) / 100 : 1;
    return function (i, slideWidth) {
      return slideWidth <= (this.size.innerWidth + 1) * percent;
    };
  };

  // alias _init for jQuery plugin .flickity()
  proto._init = proto.reposition = function () {
    this.positionCells();
    this.positionSliderAtSelected();
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
    this.setCellAlign();
    this.cursorPosition = this.size.innerWidth * this.cellAlign;
  };
  var cellAlignShorthands = {
    // cell align, then based on origin side
    center: {
      left: 0.5,
      right: 0.5
    },
    left: {
      left: 0,
      right: 1
    },
    right: {
      right: 0,
      left: 1
    }
  };
  proto.setCellAlign = function () {
    var shorthand = cellAlignShorthands[this.options.cellAlign];
    this.cellAlign = shorthand ? shorthand[this.originSide] : this.options.cellAlign;
  };
  proto.setGallerySize = function () {
    if (this.options.setGallerySize) {
      var height = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
      this.viewport.style.height = height + 'px';
    }
  };
  proto._getWrapShiftCells = function () {
    // only for wrap-around
    if (!this.options.wrapAround) {
      return;
    }
    // unshift previous cells
    this._unshiftCells(this.beforeShiftCells);
    this._unshiftCells(this.afterShiftCells);
    // get before cells
    // initial gap
    var gapX = this.cursorPosition;
    var cellIndex = this.cells.length - 1;
    this.beforeShiftCells = this._getGapCells(gapX, cellIndex, -1);
    // get after cells
    // ending gap between last cell and end of gallery viewport
    gapX = this.size.innerWidth - this.cursorPosition;
    // start cloning at first cell, working forwards
    this.afterShiftCells = this._getGapCells(gapX, 0, 1);
  };
  proto._getGapCells = function (gapX, cellIndex, increment) {
    // keep adding cells until the cover the initial gap
    var cells = [];
    while (gapX > 0) {
      var cell = this.cells[cellIndex];
      if (!cell) {
        break;
      }
      cells.push(cell);
      cellIndex += increment;
      gapX -= cell.size.outerWidth;
    }
    return cells;
  };

  // ----- contain ----- //

  // contain cell targets so no excess sliding
  proto._containSlides = function () {
    if (!this.options.contain || this.options.wrapAround || !this.cells.length) {
      return;
    }
    var isRightToLeft = this.options.rightToLeft;
    var beginMargin = isRightToLeft ? 'marginRight' : 'marginLeft';
    var endMargin = isRightToLeft ? 'marginLeft' : 'marginRight';
    var contentWidth = this.slideableWidth - this.getLastCell().size[endMargin];
    // content is less than gallery size
    var isContentSmaller = contentWidth < this.size.innerWidth;
    // bounds
    var beginBound = this.cursorPosition + this.cells[0].size[beginMargin];
    var endBound = contentWidth - this.size.innerWidth * (1 - this.cellAlign);
    // contain each cell target
    this.slides.forEach(function (slide) {
      if (isContentSmaller) {
        // all cells fit inside gallery
        slide.target = contentWidth * this.cellAlign;
      } else {
        // contain to bounds
        slide.target = Math.max(slide.target, beginBound);
        slide.target = Math.min(slide.target, endBound);
      }
    }, this);
  };

  // -----  ----- //

  /**
   * emits events via eventEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */
  proto.dispatchEvent = function (type, event, args) {
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);
    if (jQuery && this.$element) {
      // default trigger with type if no event
      type += this.options.namespaceJQueryEvents ? '.flickity' : '';
      var $event = type;
      if (event) {
        // create jQuery event
        var jQEvent = jQuery.Event(event);
        jQEvent.type = type;
        $event = jQEvent;
      }
      this.$element.trigger($event, args);
    }
  };

  // -------------------------- select -------------------------- //

  /**
   * @param {Integer} index - index of the slide
   * @param {Boolean} isWrap - will wrap-around to last/first if at the end
   * @param {Boolean} isInstant - will immediately set position at selected cell
   */
  proto.select = function (index, isWrap, isInstant) {
    if (!this.isActive) {
      return;
    }
    index = parseInt(index, 10);
    this._wrapSelect(index);
    if (this.options.wrapAround || isWrap) {
      index = utils.modulo(index, this.slides.length);
    }
    // bail if invalid index
    if (!this.slides[index]) {
      return;
    }
    var prevIndex = this.selectedIndex;
    this.selectedIndex = index;
    this.updateSelectedSlide();
    if (isInstant) {
      this.positionSliderAtSelected();
    } else {
      this.startAnimation();
    }
    if (this.options.adaptiveHeight) {
      this.setGallerySize();
    }
    // events
    this.dispatchEvent('select', null, [index]);
    // change event if new index
    if (index != prevIndex) {
      this.dispatchEvent('change', null, [index]);
    }
    // old v1 event name, remove in v3
    this.dispatchEvent('cellSelect');
  };

  // wraps position for wrapAround, to move to closest slide. #113
  proto._wrapSelect = function (index) {
    var len = this.slides.length;
    var isWrapping = this.options.wrapAround && len > 1;
    if (!isWrapping) {
      return index;
    }
    var wrapIndex = utils.modulo(index, len);
    // go to shortest
    var delta = Math.abs(wrapIndex - this.selectedIndex);
    var backWrapDelta = Math.abs(wrapIndex + len - this.selectedIndex);
    var forewardWrapDelta = Math.abs(wrapIndex - len - this.selectedIndex);
    if (!this.isDragSelect && backWrapDelta < delta) {
      index += len;
    } else if (!this.isDragSelect && forewardWrapDelta < delta) {
      index -= len;
    }
    // wrap position so slider is within normal area
    if (index < 0) {
      this.x -= this.slideableWidth;
    } else if (index >= len) {
      this.x += this.slideableWidth;
    }
  };
  proto.previous = function (isWrap, isInstant) {
    this.select(this.selectedIndex - 1, isWrap, isInstant);
  };
  proto.next = function (isWrap, isInstant) {
    this.select(this.selectedIndex + 1, isWrap, isInstant);
  };
  proto.updateSelectedSlide = function () {
    var slide = this.slides[this.selectedIndex];
    // selectedIndex could be outside of slides, if triggered before resize()
    if (!slide) {
      return;
    }
    // unselect previous selected slide
    this.unselectSelectedSlide();
    // update new selected slide
    this.selectedSlide = slide;
    slide.select();
    this.selectedCells = slide.cells;
    this.selectedElements = slide.getCellElements();
    // HACK: selectedCell & selectedElement is first cell in slide, backwards compatibility
    // Remove in v3?
    this.selectedCell = slide.cells[0];
    this.selectedElement = this.selectedElements[0];
  };
  proto.unselectSelectedSlide = function () {
    if (this.selectedSlide) {
      this.selectedSlide.unselect();
    }
  };
  proto.selectInitialIndex = function () {
    var initialIndex = this.options.initialIndex;
    // already activated, select previous selectedIndex
    if (this.isInitActivated) {
      this.select(this.selectedIndex, false, true);
      return;
    }
    // select with selector string
    if (initialIndex && typeof initialIndex == 'string') {
      var cell = this.queryCell(initialIndex);
      if (cell) {
        this.selectCell(initialIndex, false, true);
        return;
      }
    }
    var index = 0;
    // select with number
    if (initialIndex && this.slides[initialIndex]) {
      index = initialIndex;
    }
    // select instantly
    this.select(index, false, true);
  };

  /**
   * select slide from number or cell element
   * @param {Element or Number} elem
   */
  proto.selectCell = function (value, isWrap, isInstant) {
    // get cell
    var cell = this.queryCell(value);
    if (!cell) {
      return;
    }
    var index = this.getCellSlideIndex(cell);
    this.select(index, isWrap, isInstant);
  };
  proto.getCellSlideIndex = function (cell) {
    // get index of slides that has cell
    for (var i = 0; i < this.slides.length; i++) {
      var slide = this.slides[i];
      var index = slide.cells.indexOf(cell);
      if (index != -1) {
        return i;
      }
    }
  };

  // -------------------------- get cells -------------------------- //

  /**
   * get Flickity.Cell, given an Element
   * @param {Element} elem
   * @returns {Flickity.Cell} item
   */
  proto.getCell = function (elem) {
    // loop through cells to get the one that matches
    for (var i = 0; i < this.cells.length; i++) {
      var cell = this.cells[i];
      if (cell.element == elem) {
        return cell;
      }
    }
  };

  /**
   * get collection of Flickity.Cells, given Elements
   * @param {Element, Array, NodeList} elems
   * @returns {Array} cells - Flickity.Cells
   */
  proto.getCells = function (elems) {
    elems = utils.makeArray(elems);
    var cells = [];
    elems.forEach(function (elem) {
      var cell = this.getCell(elem);
      if (cell) {
        cells.push(cell);
      }
    }, this);
    return cells;
  };

  /**
   * get cell elements
   * @returns {Array} cellElems
   */
  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };

  /**
   * get parent cell from an element
   * @param {Element} elem
   * @returns {Flickit.Cell} cell
   */
  proto.getParentCell = function (elem) {
    // first check if elem is cell
    var cell = this.getCell(elem);
    if (cell) {
      return cell;
    }
    // try to get parent cell elem
    elem = utils.getParent(elem, '.flickity-slider > *');
    return this.getCell(elem);
  };

  /**
   * get cells adjacent to a slide
   * @param {Integer} adjCount - number of adjacent slides
   * @param {Integer} index - index of slide to start
   * @returns {Array} cells - array of Flickity.Cells
   */
  proto.getAdjacentCellElements = function (adjCount, index) {
    if (!adjCount) {
      return this.selectedSlide.getCellElements();
    }
    index = index === undefined ? this.selectedIndex : index;
    var len = this.slides.length;
    if (1 + adjCount * 2 >= len) {
      return this.getCellElements();
    }
    var cellElems = [];
    for (var i = index - adjCount; i <= index + adjCount; i++) {
      var slideIndex = this.options.wrapAround ? utils.modulo(i, len) : i;
      var slide = this.slides[slideIndex];
      if (slide) {
        cellElems = cellElems.concat(slide.getCellElements());
      }
    }
    return cellElems;
  };

  /**
   * select slide from number or cell element
   * @param {Element, Selector String, or Number} selector
   */
  proto.queryCell = function (selector) {
    if (typeof selector == 'number') {
      // use number as index
      return this.cells[selector];
    }
    if (typeof selector == 'string') {
      // do not select invalid selectors from hash: #123, #/. #791
      if (selector.match(/^[#\.]?[\d\/]/)) {
        return;
      }
      // use string as selector, get element
      selector = this.element.querySelector(selector);
    }
    // get cell from element
    return this.getCell(selector);
  };

  // -------------------------- events -------------------------- //

  proto.uiChange = function () {
    this.emitEvent('uiChange');
  };

  // keep focus on element when child UI elements are clicked
  proto.childUIPointerDown = function (event) {
    // HACK iOS does not allow touch events to bubble up?!
    if (event.type != 'touchstart') {
      event.preventDefault();
    }
    this.focus();
  };

  // ----- resize ----- //

  proto.onresize = function () {
    this.watchCSS();
    this.resize();
  };
  utils.debounceMethod(Flickity, 'onresize', 150);
  proto.resize = function () {
    if (!this.isActive) {
      return;
    }
    this.getSize();
    // wrap values
    if (this.options.wrapAround) {
      this.x = utils.modulo(this.x, this.slideableWidth);
    }
    this.positionCells();
    this._getWrapShiftCells();
    this.setGallerySize();
    this.emitEvent('resize');
    // update selected index for group slides, instant
    // TODO: position can be lost between groups of various numbers
    var selectedElement = this.selectedElements && this.selectedElements[0];
    this.selectCell(selectedElement, false, true);
  };

  // watches the :after property, activates/deactivates
  proto.watchCSS = function () {
    var watchOption = this.options.watchCSS;
    if (!watchOption) {
      return;
    }
    var afterContent = getComputedStyle(this.element, ':after').content;
    // activate if :after { content: 'flickity' }
    if (afterContent.indexOf('flickity') != -1) {
      this.activate();
    } else {
      this.deactivate();
    }
  };

  // ----- keydown ----- //

  // go previous/next if left/right keys pressed
  proto.onkeydown = function (event) {
    // only work if element is in focus
    var isNotFocused = document.activeElement && document.activeElement != this.element;
    if (!this.options.accessibility || isNotFocused) {
      return;
    }
    var handler = Flickity.keyboardHandlers[event.keyCode];
    if (handler) {
      handler.call(this);
    }
  };
  Flickity.keyboardHandlers = {
    // left arrow
    37: function _() {
      var leftMethod = this.options.rightToLeft ? 'next' : 'previous';
      this.uiChange();
      this[leftMethod]();
    },
    // right arrow
    39: function _() {
      var rightMethod = this.options.rightToLeft ? 'previous' : 'next';
      this.uiChange();
      this[rightMethod]();
    }
  };

  // ----- focus ----- //

  proto.focus = function () {
    // TODO remove scrollTo once focus options gets more support
    // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/focus#Browser_compatibility
    var prevScrollY = window.pageYOffset;
    this.element.focus({
      preventScroll: true
    });
    // hack to fix scroll jump after focus, #76
    if (window.pageYOffset != prevScrollY) {
      window.scrollTo(window.pageXOffset, prevScrollY);
    }
  };

  // -------------------------- destroy -------------------------- //

  // deactivate all Flickity functionality, but keep stuff available
  proto.deactivate = function () {
    if (!this.isActive) {
      return;
    }
    this.element.classList.remove('flickity-enabled');
    this.element.classList.remove('flickity-rtl');
    this.unselectSelectedSlide();
    // destroy cells
    this.cells.forEach(function (cell) {
      cell.destroy();
    });
    this.element.removeChild(this.viewport);
    // move child elements back into element
    moveElements(this.slider.children, this.element);
    if (this.options.accessibility) {
      this.element.removeAttribute('tabIndex');
      this.element.removeEventListener('keydown', this);
    }
    // set flags
    this.isActive = false;
    this.emitEvent('deactivate');
  };
  proto.destroy = function () {
    this.deactivate();
    window.removeEventListener('resize', this);
    this.allOff();
    this.emitEvent('destroy');
    if (jQuery && this.$element) {
      jQuery.removeData(this.element, 'flickity');
    }
    delete this.element.flickityGUID;
    delete instances[this.guid];
  };

  // -------------------------- prototype -------------------------- //

  utils.extend(proto, animatePrototype);

  // -------------------------- extras -------------------------- //

  /**
   * get Flickity instance from element
   * @param {Element} elem
   * @returns {Flickity}
   */
  Flickity.data = function (elem) {
    elem = utils.getQueryElement(elem);
    var id = elem && elem.flickityGUID;
    return id && instances[id];
  };
  utils.htmlInit(Flickity, 'flickity');
  if (jQuery && jQuery.bridget) {
    jQuery.bridget('flickity', Flickity);
  }

  // set internal jQuery, for Webpack + jQuery v3, #478
  Flickity.setJQuery = function (jq) {
    jQuery = jq;
  };
  Flickity.Cell = Cell;
  Flickity.Slide = Slide;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/index.js":
/*!*******************************************!*\
  !*** ./node_modules/flickity/js/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Flickity v2.2.1
 * Touch, responsive, flickable carousels
 *
 * Licensed GPLv3 for open source use
 * or Flickity Commercial License for commercial use
 *
 * https://flickity.metafizzy.co
 * Copyright 2015-2019 Metafizzy
 */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js"), __webpack_require__(/*! ./drag */ "./node_modules/flickity/js/drag.js"), __webpack_require__(/*! ./prev-next-button */ "./node_modules/flickity/js/prev-next-button.js"), __webpack_require__(/*! ./page-dots */ "./node_modules/flickity/js/page-dots.js"), __webpack_require__(/*! ./player */ "./node_modules/flickity/js/player.js"), __webpack_require__(/*! ./add-remove-cell */ "./node_modules/flickity/js/add-remove-cell.js"), __webpack_require__(/*! ./lazyload */ "./node_modules/flickity/js/lazyload.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(Flickity) {
  /*jshint strict: false*/
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/lazyload.js":
/*!**********************************************!*\
  !*** ./node_modules/flickity/js/lazyload.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// lazyload
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Flickity, utils) {
      return factory(window, Flickity, utils);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, Flickity, utils) {
  'use strict';

  Flickity.createMethods.push('_createLazyload');
  var proto = Flickity.prototype;
  proto._createLazyload = function () {
    this.on('select', this.lazyLoad);
  };
  proto.lazyLoad = function () {
    var lazyLoad = this.options.lazyLoad;
    if (!lazyLoad) {
      return;
    }
    // get adjacent cells, use lazyLoad option for adjacent count
    var adjCount = typeof lazyLoad == 'number' ? lazyLoad : 0;
    var cellElems = this.getAdjacentCellElements(adjCount);
    // get lazy images in those cells
    var lazyImages = [];
    cellElems.forEach(function (cellElem) {
      var lazyCellImages = getCellLazyImages(cellElem);
      lazyImages = lazyImages.concat(lazyCellImages);
    });
    // load lazy images
    lazyImages.forEach(function (img) {
      new LazyLoader(img, this);
    }, this);
  };
  function getCellLazyImages(cellElem) {
    // check if cell element is lazy image
    if (cellElem.nodeName == 'IMG') {
      var lazyloadAttr = cellElem.getAttribute('data-flickity-lazyload');
      var srcAttr = cellElem.getAttribute('data-flickity-lazyload-src');
      var srcsetAttr = cellElem.getAttribute('data-flickity-lazyload-srcset');
      if (lazyloadAttr || srcAttr || srcsetAttr) {
        return [cellElem];
      }
    }
    // select lazy images in cell
    var lazySelector = 'img[data-flickity-lazyload], ' + 'img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]';
    var imgs = cellElem.querySelectorAll(lazySelector);
    return utils.makeArray(imgs);
  }

  // -------------------------- LazyLoader -------------------------- //

  /**
   * class to handle loading images
   */
  function LazyLoader(img, flickity) {
    this.img = img;
    this.flickity = flickity;
    this.load();
  }
  LazyLoader.prototype.handleEvent = utils.handleEvent;
  LazyLoader.prototype.load = function () {
    this.img.addEventListener('load', this);
    this.img.addEventListener('error', this);
    // get src & srcset
    var src = this.img.getAttribute('data-flickity-lazyload') || this.img.getAttribute('data-flickity-lazyload-src');
    var srcset = this.img.getAttribute('data-flickity-lazyload-srcset');
    // set src & serset
    this.img.src = src;
    if (srcset) {
      this.img.setAttribute('srcset', srcset);
    }
    // remove attr
    this.img.removeAttribute('data-flickity-lazyload');
    this.img.removeAttribute('data-flickity-lazyload-src');
    this.img.removeAttribute('data-flickity-lazyload-srcset');
  };
  LazyLoader.prototype.onload = function (event) {
    this.complete(event, 'flickity-lazyloaded');
  };
  LazyLoader.prototype.onerror = function (event) {
    this.complete(event, 'flickity-lazyerror');
  };
  LazyLoader.prototype.complete = function (event, className) {
    // unbind events
    this.img.removeEventListener('load', this);
    this.img.removeEventListener('error', this);
    var cell = this.flickity.getParentCell(this.img);
    var cellElem = cell && cell.element;
    this.flickity.cellSizeChange(cellElem);
    this.img.classList.add(className);
    this.flickity.dispatchEvent('lazyLoad', event, cellElem);
  };

  // -----  ----- //

  Flickity.LazyLoader = LazyLoader;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/page-dots.js":
/*!***********************************************!*\
  !*** ./node_modules/flickity/js/page-dots.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// page dots
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js"), __webpack_require__(/*! unipointer/unipointer */ "./node_modules/unipointer/unipointer.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Flickity, Unipointer, utils) {
      return factory(window, Flickity, Unipointer, utils);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, Flickity, Unipointer, utils) {
  // -------------------------- PageDots -------------------------- //

  'use strict';

  function PageDots(parent) {
    this.parent = parent;
    this._create();
  }
  PageDots.prototype = Object.create(Unipointer.prototype);
  PageDots.prototype._create = function () {
    // create holder element
    this.holder = document.createElement('ol');
    this.holder.className = 'flickity-page-dots';
    // create dots, array of elements
    this.dots = [];
    // events
    this.handleClick = this.onClick.bind(this);
    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
  };
  PageDots.prototype.activate = function () {
    this.setDots();
    this.holder.addEventListener('click', this.handleClick);
    this.bindStartEvent(this.holder);
    // add to DOM
    this.parent.element.appendChild(this.holder);
  };
  PageDots.prototype.deactivate = function () {
    this.holder.removeEventListener('click', this.handleClick);
    this.unbindStartEvent(this.holder);
    // remove from DOM
    this.parent.element.removeChild(this.holder);
  };
  PageDots.prototype.setDots = function () {
    // get difference between number of slides and number of dots
    var delta = this.parent.slides.length - this.dots.length;
    if (delta > 0) {
      this.addDots(delta);
    } else if (delta < 0) {
      this.removeDots(-delta);
    }
  };
  PageDots.prototype.addDots = function (count) {
    var fragment = document.createDocumentFragment();
    var newDots = [];
    var length = this.dots.length;
    var max = length + count;
    for (var i = length; i < max; i++) {
      var dot = document.createElement('li');
      dot.className = 'dot';
      dot.setAttribute('aria-label', 'Page dot ' + (i + 1));
      fragment.appendChild(dot);
      newDots.push(dot);
    }
    this.holder.appendChild(fragment);
    this.dots = this.dots.concat(newDots);
  };
  PageDots.prototype.removeDots = function (count) {
    // remove from this.dots collection
    var removeDots = this.dots.splice(this.dots.length - count, count);
    // remove from DOM
    removeDots.forEach(function (dot) {
      this.holder.removeChild(dot);
    }, this);
  };
  PageDots.prototype.updateSelected = function () {
    // remove selected class on previous
    if (this.selectedDot) {
      this.selectedDot.className = 'dot';
      this.selectedDot.removeAttribute('aria-current');
    }
    // don't proceed if no dots
    if (!this.dots.length) {
      return;
    }
    this.selectedDot = this.dots[this.parent.selectedIndex];
    this.selectedDot.className = 'dot is-selected';
    this.selectedDot.setAttribute('aria-current', 'step');
  };
  PageDots.prototype.onTap =
  // old method name, backwards-compatible
  PageDots.prototype.onClick = function (event) {
    var target = event.target;
    // only care about dot clicks
    if (target.nodeName != 'LI') {
      return;
    }
    this.parent.uiChange();
    var index = this.dots.indexOf(target);
    this.parent.select(index);
  };
  PageDots.prototype.destroy = function () {
    this.deactivate();
    this.allOff();
  };
  Flickity.PageDots = PageDots;

  // -------------------------- Flickity -------------------------- //

  utils.extend(Flickity.defaults, {
    pageDots: true
  });
  Flickity.createMethods.push('_createPageDots');
  var proto = Flickity.prototype;
  proto._createPageDots = function () {
    if (!this.options.pageDots) {
      return;
    }
    this.pageDots = new PageDots(this);
    // events
    this.on('activate', this.activatePageDots);
    this.on('select', this.updateSelectedPageDots);
    this.on('cellChange', this.updatePageDots);
    this.on('resize', this.updatePageDots);
    this.on('deactivate', this.deactivatePageDots);
  };
  proto.activatePageDots = function () {
    this.pageDots.activate();
  };
  proto.updateSelectedPageDots = function () {
    this.pageDots.updateSelected();
  };
  proto.updatePageDots = function () {
    this.pageDots.setDots();
  };
  proto.deactivatePageDots = function () {
    this.pageDots.deactivate();
  };

  // -----  ----- //

  Flickity.PageDots = PageDots;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/player.js":
/*!********************************************!*\
  !*** ./node_modules/flickity/js/player.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// player & autoPlay
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ev-emitter/ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js"), __webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (EvEmitter, utils, Flickity) {
      return factory(EvEmitter, utils, Flickity);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(EvEmitter, utils, Flickity) {
  'use strict';

  // -------------------------- Player -------------------------- //
  function Player(parent) {
    this.parent = parent;
    this.state = 'stopped';
    // visibility change event handler
    this.onVisibilityChange = this.visibilityChange.bind(this);
    this.onVisibilityPlay = this.visibilityPlay.bind(this);
  }
  Player.prototype = Object.create(EvEmitter.prototype);

  // start play
  Player.prototype.play = function () {
    if (this.state == 'playing') {
      return;
    }
    // do not play if page is hidden, start playing when page is visible
    var isPageHidden = document.hidden;
    if (isPageHidden) {
      document.addEventListener('visibilitychange', this.onVisibilityPlay);
      return;
    }
    this.state = 'playing';
    // listen to visibility change
    document.addEventListener('visibilitychange', this.onVisibilityChange);
    // start ticking
    this.tick();
  };
  Player.prototype.tick = function () {
    // do not tick if not playing
    if (this.state != 'playing') {
      return;
    }
    var time = this.parent.options.autoPlay;
    // default to 3 seconds
    time = typeof time == 'number' ? time : 3000;
    var _this = this;
    // HACK: reset ticks if stopped and started within interval
    this.clear();
    this.timeout = setTimeout(function () {
      _this.parent.next(true);
      _this.tick();
    }, time);
  };
  Player.prototype.stop = function () {
    this.state = 'stopped';
    this.clear();
    // remove visibility change event
    document.removeEventListener('visibilitychange', this.onVisibilityChange);
  };
  Player.prototype.clear = function () {
    clearTimeout(this.timeout);
  };
  Player.prototype.pause = function () {
    if (this.state == 'playing') {
      this.state = 'paused';
      this.clear();
    }
  };
  Player.prototype.unpause = function () {
    // re-start play if paused
    if (this.state == 'paused') {
      this.play();
    }
  };

  // pause if page visibility is hidden, unpause if visible
  Player.prototype.visibilityChange = function () {
    var isPageHidden = document.hidden;
    this[isPageHidden ? 'pause' : 'unpause']();
  };
  Player.prototype.visibilityPlay = function () {
    this.play();
    document.removeEventListener('visibilitychange', this.onVisibilityPlay);
  };

  // -------------------------- Flickity -------------------------- //

  utils.extend(Flickity.defaults, {
    pauseAutoPlayOnHover: true
  });
  Flickity.createMethods.push('_createPlayer');
  var proto = Flickity.prototype;
  proto._createPlayer = function () {
    this.player = new Player(this);
    this.on('activate', this.activatePlayer);
    this.on('uiChange', this.stopPlayer);
    this.on('pointerDown', this.stopPlayer);
    this.on('deactivate', this.deactivatePlayer);
  };
  proto.activatePlayer = function () {
    if (!this.options.autoPlay) {
      return;
    }
    this.player.play();
    this.element.addEventListener('mouseenter', this);
  };

  // Player API, don't hate the ... thanks I know where the door is

  proto.playPlayer = function () {
    this.player.play();
  };
  proto.stopPlayer = function () {
    this.player.stop();
  };
  proto.pausePlayer = function () {
    this.player.pause();
  };
  proto.unpausePlayer = function () {
    this.player.unpause();
  };
  proto.deactivatePlayer = function () {
    this.player.stop();
    this.element.removeEventListener('mouseenter', this);
  };

  // ----- mouseenter/leave ----- //

  // pause auto-play on hover
  proto.onmouseenter = function () {
    if (!this.options.pauseAutoPlayOnHover) {
      return;
    }
    this.player.pause();
    this.element.addEventListener('mouseleave', this);
  };

  // resume auto-play on hover off
  proto.onmouseleave = function () {
    this.player.unpause();
    this.element.removeEventListener('mouseleave', this);
  };

  // -----  ----- //

  Flickity.Player = Player;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/prev-next-button.js":
/*!******************************************************!*\
  !*** ./node_modules/flickity/js/prev-next-button.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// prev/next buttons
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ./flickity */ "./node_modules/flickity/js/flickity.js"), __webpack_require__(/*! unipointer/unipointer */ "./node_modules/unipointer/unipointer.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Flickity, Unipointer, utils) {
      return factory(window, Flickity, Unipointer, utils);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, Flickity, Unipointer, utils) {
  'use strict';

  var svgURI = 'http://www.w3.org/2000/svg';

  // -------------------------- PrevNextButton -------------------------- //

  function PrevNextButton(direction, parent) {
    this.direction = direction;
    this.parent = parent;
    this._create();
  }
  PrevNextButton.prototype = Object.create(Unipointer.prototype);
  PrevNextButton.prototype._create = function () {
    // properties
    this.isEnabled = true;
    this.isPrevious = this.direction == -1;
    var leftDirection = this.parent.options.rightToLeft ? 1 : -1;
    this.isLeft = this.direction == leftDirection;
    var element = this.element = document.createElement('button');
    element.className = 'flickity-button flickity-prev-next-button';
    element.className += this.isPrevious ? ' previous' : ' next';
    // prevent button from submitting form http://stackoverflow.com/a/10836076/182183
    element.setAttribute('type', 'button');
    // init as disabled
    this.disable();
    element.setAttribute('aria-label', this.isPrevious ? 'Previous' : 'Next');

    // create arrow
    var svg = this.createSVG();
    element.appendChild(svg);
    // events
    this.parent.on('select', this.update.bind(this));
    this.on('pointerDown', this.parent.childUIPointerDown.bind(this.parent));
  };
  PrevNextButton.prototype.activate = function () {
    this.bindStartEvent(this.element);
    this.element.addEventListener('click', this);
    // add to DOM
    this.parent.element.appendChild(this.element);
  };
  PrevNextButton.prototype.deactivate = function () {
    // remove from DOM
    this.parent.element.removeChild(this.element);
    // click events
    this.unbindStartEvent(this.element);
    this.element.removeEventListener('click', this);
  };
  PrevNextButton.prototype.createSVG = function () {
    var svg = document.createElementNS(svgURI, 'svg');
    svg.setAttribute('class', 'flickity-button-icon');
    svg.setAttribute('viewBox', '0 0 100 100');
    var path = document.createElementNS(svgURI, 'path');
    var pathMovements = getArrowMovements(this.parent.options.arrowShape);
    path.setAttribute('d', pathMovements);
    path.setAttribute('class', 'arrow');
    // rotate arrow
    if (!this.isLeft) {
      path.setAttribute('transform', 'translate(100, 100) rotate(180) ');
    }
    svg.appendChild(path);
    return svg;
  };

  // get SVG path movmement
  function getArrowMovements(shape) {
    // use shape as movement if string
    if (typeof shape == 'string') {
      return shape;
    }
    // create movement string
    return 'M ' + shape.x0 + ',50' + ' L ' + shape.x1 + ',' + (shape.y1 + 50) + ' L ' + shape.x2 + ',' + (shape.y2 + 50) + ' L ' + shape.x3 + ',50 ' + ' L ' + shape.x2 + ',' + (50 - shape.y2) + ' L ' + shape.x1 + ',' + (50 - shape.y1) + ' Z';
  }
  PrevNextButton.prototype.handleEvent = utils.handleEvent;
  PrevNextButton.prototype.onclick = function () {
    if (!this.isEnabled) {
      return;
    }
    this.parent.uiChange();
    var method = this.isPrevious ? 'previous' : 'next';
    this.parent[method]();
  };

  // -----  ----- //

  PrevNextButton.prototype.enable = function () {
    if (this.isEnabled) {
      return;
    }
    this.element.disabled = false;
    this.isEnabled = true;
  };
  PrevNextButton.prototype.disable = function () {
    if (!this.isEnabled) {
      return;
    }
    this.element.disabled = true;
    this.isEnabled = false;
  };
  PrevNextButton.prototype.update = function () {
    // index of first or last slide, if previous or next
    var slides = this.parent.slides;
    // enable is wrapAround and at least 2 slides
    if (this.parent.options.wrapAround && slides.length > 1) {
      this.enable();
      return;
    }
    var lastIndex = slides.length ? slides.length - 1 : 0;
    var boundIndex = this.isPrevious ? 0 : lastIndex;
    var method = this.parent.selectedIndex == boundIndex ? 'disable' : 'enable';
    this[method]();
  };
  PrevNextButton.prototype.destroy = function () {
    this.deactivate();
    this.allOff();
  };

  // -------------------------- Flickity prototype -------------------------- //

  utils.extend(Flickity.defaults, {
    prevNextButtons: true,
    arrowShape: {
      x0: 10,
      x1: 60,
      y1: 50,
      x2: 70,
      y2: 40,
      x3: 30
    }
  });
  Flickity.createMethods.push('_createPrevNextButtons');
  var proto = Flickity.prototype;
  proto._createPrevNextButtons = function () {
    if (!this.options.prevNextButtons) {
      return;
    }
    this.prevButton = new PrevNextButton(-1, this);
    this.nextButton = new PrevNextButton(1, this);
    this.on('activate', this.activatePrevNextButtons);
  };
  proto.activatePrevNextButtons = function () {
    this.prevButton.activate();
    this.nextButton.activate();
    this.on('deactivate', this.deactivatePrevNextButtons);
  };
  proto.deactivatePrevNextButtons = function () {
    this.prevButton.deactivate();
    this.nextButton.deactivate();
    this.off('deactivate', this.deactivatePrevNextButtons);
  };

  // --------------------------  -------------------------- //

  Flickity.PrevNextButton = PrevNextButton;
  return Flickity;
});

/***/ }),

/***/ "./node_modules/flickity/js/slide.js":
/*!*******************************************!*\
  !*** ./node_modules/flickity/js/slide.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// slide
(function (window, factory) {
  // universal module definition
  /* jshint strict: false */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory() {
  'use strict';

  function Slide(parent) {
    this.parent = parent;
    this.isOriginLeft = parent.originSide == 'left';
    this.cells = [];
    this.outerWidth = 0;
    this.height = 0;
  }
  var proto = Slide.prototype;
  proto.addCell = function (cell) {
    this.cells.push(cell);
    this.outerWidth += cell.size.outerWidth;
    this.height = Math.max(cell.size.outerHeight, this.height);
    // first cell stuff
    if (this.cells.length == 1) {
      this.x = cell.x; // x comes from first cell
      var beginMargin = this.isOriginLeft ? 'marginLeft' : 'marginRight';
      this.firstMargin = cell.size[beginMargin];
    }
  };
  proto.updateTarget = function () {
    var endMargin = this.isOriginLeft ? 'marginRight' : 'marginLeft';
    var lastCell = this.getLastCell();
    var lastMargin = lastCell ? lastCell.size[endMargin] : 0;
    var slideWidth = this.outerWidth - (this.firstMargin + lastMargin);
    this.target = this.x + this.firstMargin + slideWidth * this.parent.cellAlign;
  };
  proto.getLastCell = function () {
    return this.cells[this.cells.length - 1];
  };
  proto.select = function () {
    this.cells.forEach(function (cell) {
      cell.select();
    });
  };
  proto.unselect = function () {
    this.cells.forEach(function (cell) {
      cell.unselect();
    });
  };
  proto.getCellElements = function () {
    return this.cells.map(function (cell) {
      return cell.element;
    });
  };
  return Slide;
});

/***/ }),

/***/ "./node_modules/get-size/get-size.js":
/*!*******************************************!*\
  !*** ./node_modules/get-size/get-size.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

(function (window, factory) {
  /* jshint strict: false */ /* globals define, module */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory() {
  'use strict';

  // -------------------------- helpers -------------------------- //

  // get a number from a string, not a percentage
  function getStyleSize(value) {
    var num = parseFloat(value);
    // not a percent like '100%', and a number
    var isValid = value.indexOf('%') == -1 && !isNaN(num);
    return isValid && num;
  }
  function noop() {}
  var logError = typeof console == 'undefined' ? noop : function (message) {
    console.error(message);
  };

  // -------------------------- measurements -------------------------- //

  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
  var measurementsLength = measurements.length;
  function getZeroSize() {
    var size = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    };
    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      size[measurement] = 0;
    }
    return size;
  }

  // -------------------------- getStyle -------------------------- //

  /**
   * getStyle, get style of element, check for Firefox bug
   * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
   */
  function getStyle(elem) {
    var style = getComputedStyle(elem);
    if (!style) {
      logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
    }
    return style;
  }

  // -------------------------- setup -------------------------- //

  var isSetup = false;
  var isBoxSizeOuter;

  /**
   * setup
   * check isBoxSizerOuter
   * do on first getSize() rather than on page load for Firefox bug
   */
  function setup() {
    // setup once
    if (isSetup) {
      return;
    }
    isSetup = true;

    // -------------------------- box sizing -------------------------- //

    /**
     * Chrome & Safari measure the outer-width on style.width on border-box elems
     * IE11 & Firefox<29 measures the inner-width
     */
    var div = document.createElement('div');
    div.style.width = '200px';
    div.style.padding = '1px 2px 3px 4px';
    div.style.borderStyle = 'solid';
    div.style.borderWidth = '1px 2px 3px 4px';
    div.style.boxSizing = 'border-box';
    var body = document.body || document.documentElement;
    body.appendChild(div);
    var style = getStyle(div);
    // round value for browser zoom. desandro/masonry#928
    isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
    getSize.isBoxSizeOuter = isBoxSizeOuter;
    body.removeChild(div);
  }

  // -------------------------- getSize -------------------------- //

  function getSize(elem) {
    setup();

    // use querySeletor if elem is string
    if (typeof elem == 'string') {
      elem = document.querySelector(elem);
    }

    // do not proceed on non-objects
    if (!elem || _typeof(elem) != 'object' || !elem.nodeType) {
      return;
    }
    var style = getStyle(elem);

    // if hidden, everything is 0
    if (style.display == 'none') {
      return getZeroSize();
    }
    var size = {};
    size.width = elem.offsetWidth;
    size.height = elem.offsetHeight;
    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

    // get all measurements
    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      var value = style[measurement];
      var num = parseFloat(value);
      // any 'auto', 'medium' value will be 0
      size[measurement] = !isNaN(num) ? num : 0;
    }
    var paddingWidth = size.paddingLeft + size.paddingRight;
    var paddingHeight = size.paddingTop + size.paddingBottom;
    var marginWidth = size.marginLeft + size.marginRight;
    var marginHeight = size.marginTop + size.marginBottom;
    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
    var borderHeight = size.borderTopWidth + size.borderBottomWidth;
    var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

    // overwrite width and height if we can get it from style
    var styleWidth = getStyleSize(style.width);
    if (styleWidth !== false) {
      size.width = styleWidth + (
      // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
    }
    var styleHeight = getStyleSize(style.height);
    if (styleHeight !== false) {
      size.height = styleHeight + (
      // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
    }
    size.innerWidth = size.width - (paddingWidth + borderWidth);
    size.innerHeight = size.height - (paddingHeight + borderHeight);
    size.outerWidth = size.width + marginWidth;
    size.outerHeight = size.height + marginHeight;
    return size;
  }
  return getSize;
});

/***/ }),

/***/ "./node_modules/interactjs/dist/interact.min.js":
/*!******************************************************!*\
  !*** ./node_modules/interactjs/dist/interact.min.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/* interact.js 1.10.26 | https://raw.github.com/taye/interact.js/main/LICENSE */

!function (t, e) {
  "object" == ( false ? undefined : _typeof(exports)) && "undefined" != typeof module ? module.exports = e() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (e),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : undefined;
}(this, function () {
  "use strict";

  function t(t, e) {
    var n = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(t);
      e && (r = r.filter(function (e) {
        return Object.getOwnPropertyDescriptor(t, e).enumerable;
      })), n.push.apply(n, r);
    }
    return n;
  }
  function e(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = null != arguments[n] ? arguments[n] : {};
      n % 2 ? t(Object(r), !0).forEach(function (t) {
        a(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : t(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }
    return e;
  }
  function n(t) {
    return n = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : _typeof(t);
    }, n(t);
  }
  function r(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  }
  function i(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, d(r.key), r);
    }
  }
  function o(t, e, n) {
    return e && i(t.prototype, e), n && i(t, n), Object.defineProperty(t, "prototype", {
      writable: !1
    }), t;
  }
  function a(t, e, n) {
    return (e = d(e)) in t ? Object.defineProperty(t, e, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = n, t;
  }
  function s(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), Object.defineProperty(t, "prototype", {
      writable: !1
    }), e && l(t, e);
  }
  function c(t) {
    return c = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, c(t);
  }
  function l(t, e) {
    return l = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, l(t, e);
  }
  function u(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }
  function p(t) {
    var e = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }();
    return function () {
      var n,
        r = c(t);
      if (e) {
        var i = c(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);
      return function (t, e) {
        if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return u(t);
      }(this, n);
    };
  }
  function f() {
    return f = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (t, e, n) {
      var r = function (t, e) {
        for (; !Object.prototype.hasOwnProperty.call(t, e) && null !== (t = c(t));) {
          ;
        }
        return t;
      }(t, e);
      if (r) {
        var i = Object.getOwnPropertyDescriptor(r, e);
        return i.get ? i.get.call(arguments.length < 3 ? t : n) : i.value;
      }
    }, f.apply(this, arguments);
  }
  function d(t) {
    var e = function (t, e) {
      if ("object" != _typeof(t) || null === t) return t;
      var n = t[Symbol.toPrimitive];
      if (void 0 !== n) {
        var r = n.call(t, e || "default");
        if ("object" != _typeof(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === e ? String : Number)(t);
    }(t, "string");
    return "symbol" == _typeof(e) ? e : e + "";
  }
  var h = function h(t) {
      return !(!t || !t.Window) && t instanceof t.Window;
    },
    v = void 0,
    g = void 0;
  function m(t) {
    v = t;
    var e = t.document.createTextNode("");
    e.ownerDocument !== t.document && "function" == typeof t.wrap && t.wrap(e) === e && (t = t.wrap(t)), g = t;
  }
  function y(t) {
    return h(t) ? t : (t.ownerDocument || t).defaultView || g.window;
  }
  "undefined" != typeof window && window && m(window);
  var b = function b(t) {
      return !!t && "object" === n(t);
    },
    x = function x(t) {
      return "function" == typeof t;
    },
    w = {
      window: function window(t) {
        return t === g || h(t);
      },
      docFrag: function docFrag(t) {
        return b(t) && 11 === t.nodeType;
      },
      object: b,
      func: x,
      number: function number(t) {
        return "number" == typeof t;
      },
      bool: function bool(t) {
        return "boolean" == typeof t;
      },
      string: function string(t) {
        return "string" == typeof t;
      },
      element: function element(t) {
        if (!t || "object" !== n(t)) return !1;
        var e = y(t) || g;
        return /object|function/.test("undefined" == typeof Element ? "undefined" : n(Element)) ? t instanceof Element || t instanceof e.Element : 1 === t.nodeType && "string" == typeof t.nodeName;
      },
      plainObject: function plainObject(t) {
        return b(t) && !!t.constructor && /function Object\b/.test(t.constructor.toString());
      },
      array: function array(t) {
        return b(t) && void 0 !== t.length && x(t.splice);
      }
    };
  function E(t) {
    var e = t.interaction;
    if ("drag" === e.prepared.name) {
      var n = e.prepared.axis;
      "x" === n ? (e.coords.cur.page.y = e.coords.start.page.y, e.coords.cur.client.y = e.coords.start.client.y, e.coords.velocity.client.y = 0, e.coords.velocity.page.y = 0) : "y" === n && (e.coords.cur.page.x = e.coords.start.page.x, e.coords.cur.client.x = e.coords.start.client.x, e.coords.velocity.client.x = 0, e.coords.velocity.page.x = 0);
    }
  }
  function T(t) {
    var e = t.iEvent,
      n = t.interaction;
    if ("drag" === n.prepared.name) {
      var r = n.prepared.axis;
      if ("x" === r || "y" === r) {
        var i = "x" === r ? "y" : "x";
        e.page[i] = n.coords.start.page[i], e.client[i] = n.coords.start.client[i], e.delta[i] = 0;
      }
    }
  }
  var S = {
      id: "actions/drag",
      install: function install(t) {
        var e = t.actions,
          n = t.Interactable,
          r = t.defaults;
        n.prototype.draggable = S.draggable, e.map.drag = S, e.methodDict.drag = "draggable", r.actions.drag = S.defaults;
      },
      listeners: {
        "interactions:before-action-move": E,
        "interactions:action-resume": E,
        "interactions:action-move": T,
        "auto-start:check": function autoStartCheck(t) {
          var e = t.interaction,
            n = t.interactable,
            r = t.buttons,
            i = n.options.drag;
          if (i && i.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (r & n.options.drag.mouseButtons))) return t.action = {
            name: "drag",
            axis: "start" === i.lockAxis ? i.startAxis : i.lockAxis
          }, !1;
        }
      },
      draggable: function draggable(t) {
        return w.object(t) ? (this.options.drag.enabled = !1 !== t.enabled, this.setPerAction("drag", t), this.setOnEvents("drag", t), /^(xy|x|y|start)$/.test(t.lockAxis) && (this.options.drag.lockAxis = t.lockAxis), /^(xy|x|y)$/.test(t.startAxis) && (this.options.drag.startAxis = t.startAxis), this) : w.bool(t) ? (this.options.drag.enabled = t, this) : this.options.drag;
      },
      beforeMove: E,
      move: T,
      defaults: {
        startAxis: "xy",
        lockAxis: "xy"
      },
      getCursor: function getCursor() {
        return "move";
      },
      filterEventType: function filterEventType(t) {
        return 0 === t.search("drag");
      }
    },
    _ = S,
    P = {
      init: function init(t) {
        var e = t;
        P.document = e.document, P.DocumentFragment = e.DocumentFragment || O, P.SVGElement = e.SVGElement || O, P.SVGSVGElement = e.SVGSVGElement || O, P.SVGElementInstance = e.SVGElementInstance || O, P.Element = e.Element || O, P.HTMLElement = e.HTMLElement || P.Element, P.Event = e.Event, P.Touch = e.Touch || O, P.PointerEvent = e.PointerEvent || e.MSPointerEvent;
      },
      document: null,
      DocumentFragment: null,
      SVGElement: null,
      SVGSVGElement: null,
      SVGElementInstance: null,
      Element: null,
      HTMLElement: null,
      Event: null,
      Touch: null,
      PointerEvent: null
    };
  function O() {}
  var k = P;
  var D = {
    init: function init(t) {
      var e = k.Element,
        n = t.navigator || {};
      D.supportsTouch = "ontouchstart" in t || w.func(t.DocumentTouch) && k.document instanceof t.DocumentTouch, D.supportsPointerEvent = !1 !== n.pointerEnabled && !!k.PointerEvent, D.isIOS = /iP(hone|od|ad)/.test(n.platform), D.isIOS7 = /iP(hone|od|ad)/.test(n.platform) && /OS 7[^\d]/.test(n.appVersion), D.isIe9 = /MSIE 9/.test(n.userAgent), D.isOperaMobile = "Opera" === n.appName && D.supportsTouch && /Presto/.test(n.userAgent), D.prefixedMatchesSelector = "matches" in e.prototype ? "matches" : "webkitMatchesSelector" in e.prototype ? "webkitMatchesSelector" : "mozMatchesSelector" in e.prototype ? "mozMatchesSelector" : "oMatchesSelector" in e.prototype ? "oMatchesSelector" : "msMatchesSelector", D.pEventTypes = D.supportsPointerEvent ? k.PointerEvent === t.MSPointerEvent ? {
        up: "MSPointerUp",
        down: "MSPointerDown",
        over: "mouseover",
        out: "mouseout",
        move: "MSPointerMove",
        cancel: "MSPointerCancel"
      } : {
        up: "pointerup",
        down: "pointerdown",
        over: "pointerover",
        out: "pointerout",
        move: "pointermove",
        cancel: "pointercancel"
      } : null, D.wheelEvent = k.document && "onmousewheel" in k.document ? "mousewheel" : "wheel";
    },
    supportsTouch: null,
    supportsPointerEvent: null,
    isIOS7: null,
    isIOS: null,
    isIe9: null,
    isOperaMobile: null,
    prefixedMatchesSelector: null,
    pEventTypes: null,
    wheelEvent: null
  };
  var I = D;
  function M(t, e) {
    if (t.contains) return t.contains(e);
    for (; e;) {
      if (e === t) return !0;
      e = e.parentNode;
    }
    return !1;
  }
  function z(t, e) {
    for (; w.element(t);) {
      if (R(t, e)) return t;
      t = A(t);
    }
    return null;
  }
  function A(t) {
    var e = t.parentNode;
    if (w.docFrag(e)) {
      for (; (e = e.host) && w.docFrag(e);) {
        ;
      }
      return e;
    }
    return e;
  }
  function R(t, e) {
    return g !== v && (e = e.replace(/\/deep\//g, " ")), t[I.prefixedMatchesSelector](e);
  }
  var C = function C(t) {
    return t.parentNode || t.host;
  };
  function j(t, e) {
    for (var n, r = [], i = t; (n = C(i)) && i !== e && n !== i.ownerDocument;) {
      r.unshift(i), i = n;
    }
    return r;
  }
  function F(t, e, n) {
    for (; w.element(t);) {
      if (R(t, e)) return !0;
      if ((t = A(t)) === n) return R(t, e);
    }
    return !1;
  }
  function X(t) {
    return t.correspondingUseElement || t;
  }
  function Y(t) {
    var e = t instanceof k.SVGElement ? t.getBoundingClientRect() : t.getClientRects()[0];
    return e && {
      left: e.left,
      right: e.right,
      top: e.top,
      bottom: e.bottom,
      width: e.width || e.right - e.left,
      height: e.height || e.bottom - e.top
    };
  }
  function L(t) {
    var e,
      n = Y(t);
    if (!I.isIOS7 && n) {
      var r = {
        x: (e = (e = y(t)) || g).scrollX || e.document.documentElement.scrollLeft,
        y: e.scrollY || e.document.documentElement.scrollTop
      };
      n.left += r.x, n.right += r.x, n.top += r.y, n.bottom += r.y;
    }
    return n;
  }
  function q(t) {
    for (var e = []; t;) {
      e.push(t), t = A(t);
    }
    return e;
  }
  function B(t) {
    return !!w.string(t) && (k.document.querySelector(t), !0);
  }
  function V(t, e) {
    for (var n in e) {
      t[n] = e[n];
    }
    return t;
  }
  function W(t, e, n) {
    return "parent" === t ? A(n) : "self" === t ? e.getRect(n) : z(n, t);
  }
  function G(t, e, n, r) {
    var i = t;
    return w.string(i) ? i = W(i, e, n) : w.func(i) && (i = i.apply(void 0, r)), w.element(i) && (i = L(i)), i;
  }
  function N(t) {
    return t && {
      x: "x" in t ? t.x : t.left,
      y: "y" in t ? t.y : t.top
    };
  }
  function U(t) {
    return !t || "x" in t && "y" in t || ((t = V({}, t)).x = t.left || 0, t.y = t.top || 0, t.width = t.width || (t.right || 0) - t.x, t.height = t.height || (t.bottom || 0) - t.y), t;
  }
  function H(t, e, n) {
    t.left && (e.left += n.x), t.right && (e.right += n.x), t.top && (e.top += n.y), t.bottom && (e.bottom += n.y), e.width = e.right - e.left, e.height = e.bottom - e.top;
  }
  function K(t, e, n) {
    var r = n && t.options[n];
    return N(G(r && r.origin || t.options.origin, t, e, [t && e])) || {
      x: 0,
      y: 0
    };
  }
  function $(t, e) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (t) {
        return !0;
      },
      r = arguments.length > 3 ? arguments[3] : void 0;
    if (r = r || {}, w.string(t) && -1 !== t.search(" ") && (t = J(t)), w.array(t)) return t.forEach(function (t) {
      return $(t, e, n, r);
    }), r;
    if (w.object(t) && (e = t, t = ""), w.func(e) && n(t)) r[t] = r[t] || [], r[t].push(e);else if (w.array(e)) for (var i = 0, o = e; i < o.length; i++) {
      var a = o[i];
      $(t, a, n, r);
    } else if (w.object(e)) for (var s in e) {
      $(J(s).map(function (e) {
        return "".concat(t).concat(e);
      }), e[s], n, r);
    }
    return r;
  }
  function J(t) {
    return t.trim().split(/ +/);
  }
  var Q = function Q(t, e) {
      return Math.sqrt(t * t + e * e);
    },
    Z = ["webkit", "moz"];
  function tt(t, e) {
    t.__set || (t.__set = {});
    var n = function n(_n2) {
      if (Z.some(function (t) {
        return 0 === _n2.indexOf(t);
      })) return 1;
      "function" != typeof t[_n2] && "__set" !== _n2 && Object.defineProperty(t, _n2, {
        get: function get() {
          return _n2 in t.__set ? t.__set[_n2] : t.__set[_n2] = e[_n2];
        },
        set: function set(e) {
          t.__set[_n2] = e;
        },
        configurable: !0
      });
    };
    for (var r in e) {
      n(r);
    }
    return t;
  }
  function et(t, e) {
    t.page = t.page || {}, t.page.x = e.page.x, t.page.y = e.page.y, t.client = t.client || {}, t.client.x = e.client.x, t.client.y = e.client.y, t.timeStamp = e.timeStamp;
  }
  function nt(t) {
    t.page.x = 0, t.page.y = 0, t.client.x = 0, t.client.y = 0;
  }
  function rt(t) {
    return t instanceof k.Event || t instanceof k.Touch;
  }
  function it(t, e, n) {
    return t = t || "page", (n = n || {}).x = e[t + "X"], n.y = e[t + "Y"], n;
  }
  function ot(t, e) {
    return e = e || {
      x: 0,
      y: 0
    }, I.isOperaMobile && rt(t) ? (it("screen", t, e), e.x += window.scrollX, e.y += window.scrollY) : it("page", t, e), e;
  }
  function at(t) {
    return w.number(t.pointerId) ? t.pointerId : t.identifier;
  }
  function st(t, e, n) {
    var r = e.length > 1 ? lt(e) : e[0];
    ot(r, t.page), function (t, e) {
      e = e || {}, I.isOperaMobile && rt(t) ? it("screen", t, e) : it("client", t, e);
    }(r, t.client), t.timeStamp = n;
  }
  function ct(t) {
    var e = [];
    return w.array(t) ? (e[0] = t[0], e[1] = t[1]) : "touchend" === t.type ? 1 === t.touches.length ? (e[0] = t.touches[0], e[1] = t.changedTouches[0]) : 0 === t.touches.length && (e[0] = t.changedTouches[0], e[1] = t.changedTouches[1]) : (e[0] = t.touches[0], e[1] = t.touches[1]), e;
  }
  function lt(t) {
    for (var e = {
        pageX: 0,
        pageY: 0,
        clientX: 0,
        clientY: 0,
        screenX: 0,
        screenY: 0
      }, n = 0; n < t.length; n++) {
      var r = t[n];
      for (var i in e) {
        e[i] += r[i];
      }
    }
    for (var o in e) {
      e[o] /= t.length;
    }
    return e;
  }
  function ut(t) {
    if (!t.length) return null;
    var e = ct(t),
      n = Math.min(e[0].pageX, e[1].pageX),
      r = Math.min(e[0].pageY, e[1].pageY),
      i = Math.max(e[0].pageX, e[1].pageX),
      o = Math.max(e[0].pageY, e[1].pageY);
    return {
      x: n,
      y: r,
      left: n,
      top: r,
      right: i,
      bottom: o,
      width: i - n,
      height: o - r
    };
  }
  function pt(t, e) {
    var n = e + "X",
      r = e + "Y",
      i = ct(t),
      o = i[0][n] - i[1][n],
      a = i[0][r] - i[1][r];
    return Q(o, a);
  }
  function ft(t, e) {
    var n = e + "X",
      r = e + "Y",
      i = ct(t),
      o = i[1][n] - i[0][n],
      a = i[1][r] - i[0][r];
    return 180 * Math.atan2(a, o) / Math.PI;
  }
  function dt(t) {
    return w.string(t.pointerType) ? t.pointerType : w.number(t.pointerType) ? [void 0, void 0, "touch", "pen", "mouse"][t.pointerType] : /touch/.test(t.type || "") || t instanceof k.Touch ? "touch" : "mouse";
  }
  function ht(t) {
    var e = w.func(t.composedPath) ? t.composedPath() : t.path;
    return [X(e ? e[0] : t.target), X(t.currentTarget)];
  }
  var vt = function () {
    function t(e) {
      r(this, t), this.immediatePropagationStopped = !1, this.propagationStopped = !1, this._interaction = e;
    }
    return o(t, [{
      key: "preventDefault",
      value: function value() {}
    }, {
      key: "stopPropagation",
      value: function value() {
        this.propagationStopped = !0;
      }
    }, {
      key: "stopImmediatePropagation",
      value: function value() {
        this.immediatePropagationStopped = this.propagationStopped = !0;
      }
    }]), t;
  }();
  Object.defineProperty(vt.prototype, "interaction", {
    get: function get() {
      return this._interaction._proxy;
    },
    set: function set() {}
  });
  var gt = function gt(t, e) {
      for (var n = 0; n < e.length; n++) {
        var r = e[n];
        t.push(r);
      }
      return t;
    },
    mt = function mt(t) {
      return gt([], t);
    },
    yt = function yt(t, e) {
      for (var n = 0; n < t.length; n++) {
        if (e(t[n], n, t)) return n;
      }
      return -1;
    },
    bt = function bt(t, e) {
      return t[yt(t, e)];
    },
    xt = function (t) {
      s(n, t);
      var e = p(n);
      function n(t, i, o) {
        var a;
        r(this, n), (a = e.call(this, i._interaction)).dropzone = void 0, a.dragEvent = void 0, a.relatedTarget = void 0, a.draggable = void 0, a.propagationStopped = !1, a.immediatePropagationStopped = !1;
        var s = "dragleave" === o ? t.prev : t.cur,
          c = s.element,
          l = s.dropzone;
        return a.type = o, a.target = c, a.currentTarget = c, a.dropzone = l, a.dragEvent = i, a.relatedTarget = i.target, a.draggable = i.interactable, a.timeStamp = i.timeStamp, a;
      }
      return o(n, [{
        key: "reject",
        value: function value() {
          var t = this,
            e = this._interaction.dropState;
          if ("dropactivate" === this.type || this.dropzone && e.cur.dropzone === this.dropzone && e.cur.element === this.target) if (e.prev.dropzone = this.dropzone, e.prev.element = this.target, e.rejected = !0, e.events.enter = null, this.stopImmediatePropagation(), "dropactivate" === this.type) {
            var r = e.activeDrops,
              i = yt(r, function (e) {
                var n = e.dropzone,
                  r = e.element;
                return n === t.dropzone && r === t.target;
              });
            e.activeDrops.splice(i, 1);
            var o = new n(e, this.dragEvent, "dropdeactivate");
            o.dropzone = this.dropzone, o.target = this.target, this.dropzone.fire(o);
          } else this.dropzone.fire(new n(e, this.dragEvent, "dragleave"));
        }
      }, {
        key: "preventDefault",
        value: function value() {}
      }, {
        key: "stopPropagation",
        value: function value() {
          this.propagationStopped = !0;
        }
      }, {
        key: "stopImmediatePropagation",
        value: function value() {
          this.immediatePropagationStopped = this.propagationStopped = !0;
        }
      }]), n;
    }(vt);
  function wt(t, e) {
    for (var n = 0, r = t.slice(); n < r.length; n++) {
      var i = r[n],
        o = i.dropzone,
        a = i.element;
      e.dropzone = o, e.target = a, o.fire(e), e.propagationStopped = e.immediatePropagationStopped = !1;
    }
  }
  function Et(t, e) {
    for (var n = function (t, e) {
        for (var n = [], r = 0, i = t.interactables.list; r < i.length; r++) {
          var o = i[r];
          if (o.options.drop.enabled) {
            var a = o.options.drop.accept;
            if (!(w.element(a) && a !== e || w.string(a) && !R(e, a) || w.func(a) && !a({
              dropzone: o,
              draggableElement: e
            }))) for (var s = 0, c = o.getAllElements(); s < c.length; s++) {
              var l = c[s];
              l !== e && n.push({
                dropzone: o,
                element: l,
                rect: o.getRect(l)
              });
            }
          }
        }
        return n;
      }(t, e), r = 0; r < n.length; r++) {
      var i = n[r];
      i.rect = i.dropzone.getRect(i.element);
    }
    return n;
  }
  function Tt(t, e, n) {
    for (var r = t.dropState, i = t.interactable, o = t.element, a = [], s = 0, c = r.activeDrops; s < c.length; s++) {
      var l = c[s],
        u = l.dropzone,
        p = l.element,
        f = l.rect,
        d = u.dropCheck(e, n, i, o, p, f);
      a.push(d ? p : null);
    }
    var h = function (t) {
      for (var e, n, r, i = [], o = 0; o < t.length; o++) {
        var a = t[o],
          s = t[e];
        if (a && o !== e) if (s) {
          var c = C(a),
            l = C(s);
          if (c !== a.ownerDocument) if (l !== a.ownerDocument) {
            if (c !== l) {
              i = i.length ? i : j(s);
              var u = void 0;
              if (s instanceof k.HTMLElement && a instanceof k.SVGElement && !(a instanceof k.SVGSVGElement)) {
                if (a === l) continue;
                u = a.ownerSVGElement;
              } else u = a;
              for (var p = j(u, s.ownerDocument), f = 0; p[f] && p[f] === i[f];) {
                f++;
              }
              var d = [p[f - 1], p[f], i[f]];
              if (d[0]) for (var h = d[0].lastChild; h;) {
                if (h === d[1]) {
                  e = o, i = p;
                  break;
                }
                if (h === d[2]) break;
                h = h.previousSibling;
              }
            } else r = s, void 0, void 0, (parseInt(y(n = a).getComputedStyle(n).zIndex, 10) || 0) >= (parseInt(y(r).getComputedStyle(r).zIndex, 10) || 0) && (e = o);
          } else e = o;
        } else e = o;
      }
      return e;
    }(a);
    return r.activeDrops[h] || null;
  }
  function St(t, e, n) {
    var r = t.dropState,
      i = {
        enter: null,
        leave: null,
        activate: null,
        deactivate: null,
        move: null,
        drop: null
      };
    return "dragstart" === n.type && (i.activate = new xt(r, n, "dropactivate"), i.activate.target = null, i.activate.dropzone = null), "dragend" === n.type && (i.deactivate = new xt(r, n, "dropdeactivate"), i.deactivate.target = null, i.deactivate.dropzone = null), r.rejected || (r.cur.element !== r.prev.element && (r.prev.dropzone && (i.leave = new xt(r, n, "dragleave"), n.dragLeave = i.leave.target = r.prev.element, n.prevDropzone = i.leave.dropzone = r.prev.dropzone), r.cur.dropzone && (i.enter = new xt(r, n, "dragenter"), n.dragEnter = r.cur.element, n.dropzone = r.cur.dropzone)), "dragend" === n.type && r.cur.dropzone && (i.drop = new xt(r, n, "drop"), n.dropzone = r.cur.dropzone, n.relatedTarget = r.cur.element), "dragmove" === n.type && r.cur.dropzone && (i.move = new xt(r, n, "dropmove"), n.dropzone = r.cur.dropzone)), i;
  }
  function _t(t, e) {
    var n = t.dropState,
      r = n.activeDrops,
      i = n.cur,
      o = n.prev;
    e.leave && o.dropzone.fire(e.leave), e.enter && i.dropzone.fire(e.enter), e.move && i.dropzone.fire(e.move), e.drop && i.dropzone.fire(e.drop), e.deactivate && wt(r, e.deactivate), n.prev.dropzone = i.dropzone, n.prev.element = i.element;
  }
  function Pt(t, e) {
    var n = t.interaction,
      r = t.iEvent,
      i = t.event;
    if ("dragmove" === r.type || "dragend" === r.type) {
      var o = n.dropState;
      e.dynamicDrop && (o.activeDrops = Et(e, n.element));
      var a = r,
        s = Tt(n, a, i);
      o.rejected = o.rejected && !!s && s.dropzone === o.cur.dropzone && s.element === o.cur.element, o.cur.dropzone = s && s.dropzone, o.cur.element = s && s.element, o.events = St(n, 0, a);
    }
  }
  var Ot = {
      id: "actions/drop",
      install: function install(t) {
        var e = t.actions,
          n = t.interactStatic,
          r = t.Interactable,
          i = t.defaults;
        t.usePlugin(_), r.prototype.dropzone = function (t) {
          return function (t, e) {
            if (w.object(e)) {
              if (t.options.drop.enabled = !1 !== e.enabled, e.listeners) {
                var n = $(e.listeners),
                  r = Object.keys(n).reduce(function (t, e) {
                    return t[/^(enter|leave)/.test(e) ? "drag".concat(e) : /^(activate|deactivate|move)/.test(e) ? "drop".concat(e) : e] = n[e], t;
                  }, {}),
                  i = t.options.drop.listeners;
                i && t.off(i), t.on(r), t.options.drop.listeners = r;
              }
              return w.func(e.ondrop) && t.on("drop", e.ondrop), w.func(e.ondropactivate) && t.on("dropactivate", e.ondropactivate), w.func(e.ondropdeactivate) && t.on("dropdeactivate", e.ondropdeactivate), w.func(e.ondragenter) && t.on("dragenter", e.ondragenter), w.func(e.ondragleave) && t.on("dragleave", e.ondragleave), w.func(e.ondropmove) && t.on("dropmove", e.ondropmove), /^(pointer|center)$/.test(e.overlap) ? t.options.drop.overlap = e.overlap : w.number(e.overlap) && (t.options.drop.overlap = Math.max(Math.min(1, e.overlap), 0)), "accept" in e && (t.options.drop.accept = e.accept), "checker" in e && (t.options.drop.checker = e.checker), t;
            }
            if (w.bool(e)) return t.options.drop.enabled = e, t;
            return t.options.drop;
          }(this, t);
        }, r.prototype.dropCheck = function (t, e, n, r, i, o) {
          return function (t, e, n, r, i, o, a) {
            var s = !1;
            if (!(a = a || t.getRect(o))) return !!t.options.drop.checker && t.options.drop.checker(e, n, s, t, o, r, i);
            var c = t.options.drop.overlap;
            if ("pointer" === c) {
              var l = K(r, i, "drag"),
                u = ot(e);
              u.x += l.x, u.y += l.y;
              var p = u.x > a.left && u.x < a.right,
                f = u.y > a.top && u.y < a.bottom;
              s = p && f;
            }
            var d = r.getRect(i);
            if (d && "center" === c) {
              var h = d.left + d.width / 2,
                v = d.top + d.height / 2;
              s = h >= a.left && h <= a.right && v >= a.top && v <= a.bottom;
            }
            if (d && w.number(c)) {
              s = Math.max(0, Math.min(a.right, d.right) - Math.max(a.left, d.left)) * Math.max(0, Math.min(a.bottom, d.bottom) - Math.max(a.top, d.top)) / (d.width * d.height) >= c;
            }
            t.options.drop.checker && (s = t.options.drop.checker(e, n, s, t, o, r, i));
            return s;
          }(this, t, e, n, r, i, o);
        }, n.dynamicDrop = function (e) {
          return w.bool(e) ? (t.dynamicDrop = e, n) : t.dynamicDrop;
        }, V(e.phaselessTypes, {
          dragenter: !0,
          dragleave: !0,
          dropactivate: !0,
          dropdeactivate: !0,
          dropmove: !0,
          drop: !0
        }), e.methodDict.drop = "dropzone", t.dynamicDrop = !1, i.actions.drop = Ot.defaults;
      },
      listeners: {
        "interactions:before-action-start": function interactionsBeforeActionStart(t) {
          var e = t.interaction;
          "drag" === e.prepared.name && (e.dropState = {
            cur: {
              dropzone: null,
              element: null
            },
            prev: {
              dropzone: null,
              element: null
            },
            rejected: null,
            events: null,
            activeDrops: []
          });
        },
        "interactions:after-action-start": function interactionsAfterActionStart(t, e) {
          var n = t.interaction,
            r = (t.event, t.iEvent);
          if ("drag" === n.prepared.name) {
            var i = n.dropState;
            i.activeDrops = [], i.events = {}, i.activeDrops = Et(e, n.element), i.events = St(n, 0, r), i.events.activate && (wt(i.activeDrops, i.events.activate), e.fire("actions/drop:start", {
              interaction: n,
              dragEvent: r
            }));
          }
        },
        "interactions:action-move": Pt,
        "interactions:after-action-move": function interactionsAfterActionMove(t, e) {
          var n = t.interaction,
            r = t.iEvent;
          if ("drag" === n.prepared.name) {
            var i = n.dropState;
            _t(n, i.events), e.fire("actions/drop:move", {
              interaction: n,
              dragEvent: r
            }), i.events = {};
          }
        },
        "interactions:action-end": function interactionsActionEnd(t, e) {
          if ("drag" === t.interaction.prepared.name) {
            var n = t.interaction,
              r = t.iEvent;
            Pt(t, e), _t(n, n.dropState.events), e.fire("actions/drop:end", {
              interaction: n,
              dragEvent: r
            });
          }
        },
        "interactions:stop": function interactionsStop(t) {
          var e = t.interaction;
          if ("drag" === e.prepared.name) {
            var n = e.dropState;
            n && (n.activeDrops = null, n.events = null, n.cur.dropzone = null, n.cur.element = null, n.prev.dropzone = null, n.prev.element = null, n.rejected = !1);
          }
        }
      },
      getActiveDrops: Et,
      getDrop: Tt,
      getDropEvents: St,
      fireDropEvents: _t,
      filterEventType: function filterEventType(t) {
        return 0 === t.search("drag") || 0 === t.search("drop");
      },
      defaults: {
        enabled: !1,
        accept: null,
        overlap: "pointer"
      }
    },
    kt = Ot;
  function Dt(t) {
    var e = t.interaction,
      n = t.iEvent,
      r = t.phase;
    if ("gesture" === e.prepared.name) {
      var i = e.pointers.map(function (t) {
          return t.pointer;
        }),
        o = "start" === r,
        a = "end" === r,
        s = e.interactable.options.deltaSource;
      if (n.touches = [i[0], i[1]], o) n.distance = pt(i, s), n.box = ut(i), n.scale = 1, n.ds = 0, n.angle = ft(i, s), n.da = 0, e.gesture.startDistance = n.distance, e.gesture.startAngle = n.angle;else if (a || e.pointers.length < 2) {
        var c = e.prevEvent;
        n.distance = c.distance, n.box = c.box, n.scale = c.scale, n.ds = 0, n.angle = c.angle, n.da = 0;
      } else n.distance = pt(i, s), n.box = ut(i), n.scale = n.distance / e.gesture.startDistance, n.angle = ft(i, s), n.ds = n.scale - e.gesture.scale, n.da = n.angle - e.gesture.angle;
      e.gesture.distance = n.distance, e.gesture.angle = n.angle, w.number(n.scale) && n.scale !== 1 / 0 && !isNaN(n.scale) && (e.gesture.scale = n.scale);
    }
  }
  var It = {
      id: "actions/gesture",
      before: ["actions/drag", "actions/resize"],
      install: function install(t) {
        var e = t.actions,
          n = t.Interactable,
          r = t.defaults;
        n.prototype.gesturable = function (t) {
          return w.object(t) ? (this.options.gesture.enabled = !1 !== t.enabled, this.setPerAction("gesture", t), this.setOnEvents("gesture", t), this) : w.bool(t) ? (this.options.gesture.enabled = t, this) : this.options.gesture;
        }, e.map.gesture = It, e.methodDict.gesture = "gesturable", r.actions.gesture = It.defaults;
      },
      listeners: {
        "interactions:action-start": Dt,
        "interactions:action-move": Dt,
        "interactions:action-end": Dt,
        "interactions:new": function interactionsNew(t) {
          t.interaction.gesture = {
            angle: 0,
            distance: 0,
            scale: 1,
            startAngle: 0,
            startDistance: 0
          };
        },
        "auto-start:check": function autoStartCheck(t) {
          if (!(t.interaction.pointers.length < 2)) {
            var e = t.interactable.options.gesture;
            if (e && e.enabled) return t.action = {
              name: "gesture"
            }, !1;
          }
        }
      },
      defaults: {},
      getCursor: function getCursor() {
        return "";
      },
      filterEventType: function filterEventType(t) {
        return 0 === t.search("gesture");
      }
    },
    Mt = It;
  function zt(t, e, n, r, i, o, a) {
    if (!e) return !1;
    if (!0 === e) {
      var s = w.number(o.width) ? o.width : o.right - o.left,
        c = w.number(o.height) ? o.height : o.bottom - o.top;
      if (a = Math.min(a, Math.abs(("left" === t || "right" === t ? s : c) / 2)), s < 0 && ("left" === t ? t = "right" : "right" === t && (t = "left")), c < 0 && ("top" === t ? t = "bottom" : "bottom" === t && (t = "top")), "left" === t) {
        var l = s >= 0 ? o.left : o.right;
        return n.x < l + a;
      }
      if ("top" === t) {
        var u = c >= 0 ? o.top : o.bottom;
        return n.y < u + a;
      }
      if ("right" === t) return n.x > (s >= 0 ? o.right : o.left) - a;
      if ("bottom" === t) return n.y > (c >= 0 ? o.bottom : o.top) - a;
    }
    return !!w.element(r) && (w.element(e) ? e === r : F(r, e, i));
  }
  function At(t) {
    var e = t.iEvent,
      n = t.interaction;
    if ("resize" === n.prepared.name && n.resizeAxes) {
      var r = e;
      n.interactable.options.resize.square ? ("y" === n.resizeAxes ? r.delta.x = r.delta.y : r.delta.y = r.delta.x, r.axes = "xy") : (r.axes = n.resizeAxes, "x" === n.resizeAxes ? r.delta.y = 0 : "y" === n.resizeAxes && (r.delta.x = 0));
    }
  }
  var Rt,
    Ct,
    jt = {
      id: "actions/resize",
      before: ["actions/drag"],
      install: function install(t) {
        var e = t.actions,
          n = t.browser,
          r = t.Interactable,
          i = t.defaults;
        jt.cursors = function (t) {
          return t.isIe9 ? {
            x: "e-resize",
            y: "s-resize",
            xy: "se-resize",
            top: "n-resize",
            left: "w-resize",
            bottom: "s-resize",
            right: "e-resize",
            topleft: "se-resize",
            bottomright: "se-resize",
            topright: "ne-resize",
            bottomleft: "ne-resize"
          } : {
            x: "ew-resize",
            y: "ns-resize",
            xy: "nwse-resize",
            top: "ns-resize",
            left: "ew-resize",
            bottom: "ns-resize",
            right: "ew-resize",
            topleft: "nwse-resize",
            bottomright: "nwse-resize",
            topright: "nesw-resize",
            bottomleft: "nesw-resize"
          };
        }(n), jt.defaultMargin = n.supportsTouch || n.supportsPointerEvent ? 20 : 10, r.prototype.resizable = function (e) {
          return function (t, e, n) {
            if (w.object(e)) return t.options.resize.enabled = !1 !== e.enabled, t.setPerAction("resize", e), t.setOnEvents("resize", e), w.string(e.axis) && /^x$|^y$|^xy$/.test(e.axis) ? t.options.resize.axis = e.axis : null === e.axis && (t.options.resize.axis = n.defaults.actions.resize.axis), w.bool(e.preserveAspectRatio) ? t.options.resize.preserveAspectRatio = e.preserveAspectRatio : w.bool(e.square) && (t.options.resize.square = e.square), t;
            if (w.bool(e)) return t.options.resize.enabled = e, t;
            return t.options.resize;
          }(this, e, t);
        }, e.map.resize = jt, e.methodDict.resize = "resizable", i.actions.resize = jt.defaults;
      },
      listeners: {
        "interactions:new": function interactionsNew(t) {
          t.interaction.resizeAxes = "xy";
        },
        "interactions:action-start": function interactionsActionStart(t) {
          !function (t) {
            var e = t.iEvent,
              n = t.interaction;
            if ("resize" === n.prepared.name && n.prepared.edges) {
              var r = e,
                i = n.rect;
              n._rects = {
                start: V({}, i),
                corrected: V({}, i),
                previous: V({}, i),
                delta: {
                  left: 0,
                  right: 0,
                  width: 0,
                  top: 0,
                  bottom: 0,
                  height: 0
                }
              }, r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
            }
          }(t), At(t);
        },
        "interactions:action-move": function interactionsActionMove(t) {
          !function (t) {
            var e = t.iEvent,
              n = t.interaction;
            if ("resize" === n.prepared.name && n.prepared.edges) {
              var r = e,
                i = n.interactable.options.resize.invert,
                o = "reposition" === i || "negate" === i,
                a = n.rect,
                s = n._rects,
                c = s.start,
                l = s.corrected,
                u = s.delta,
                p = s.previous;
              if (V(p, l), o) {
                if (V(l, a), "reposition" === i) {
                  if (l.top > l.bottom) {
                    var f = l.top;
                    l.top = l.bottom, l.bottom = f;
                  }
                  if (l.left > l.right) {
                    var d = l.left;
                    l.left = l.right, l.right = d;
                  }
                }
              } else l.top = Math.min(a.top, c.bottom), l.bottom = Math.max(a.bottom, c.top), l.left = Math.min(a.left, c.right), l.right = Math.max(a.right, c.left);
              for (var h in l.width = l.right - l.left, l.height = l.bottom - l.top, l) {
                u[h] = l[h] - p[h];
              }
              r.edges = n.prepared.edges, r.rect = l, r.deltaRect = u;
            }
          }(t), At(t);
        },
        "interactions:action-end": function interactionsActionEnd(t) {
          var e = t.iEvent,
            n = t.interaction;
          if ("resize" === n.prepared.name && n.prepared.edges) {
            var r = e;
            r.edges = n.prepared.edges, r.rect = n._rects.corrected, r.deltaRect = n._rects.delta;
          }
        },
        "auto-start:check": function autoStartCheck(t) {
          var e = t.interaction,
            n = t.interactable,
            r = t.element,
            i = t.rect,
            o = t.buttons;
          if (i) {
            var a = V({}, e.coords.cur.page),
              s = n.options.resize;
            if (s && s.enabled && (!e.pointerIsDown || !/mouse|pointer/.test(e.pointerType) || 0 != (o & s.mouseButtons))) {
              if (w.object(s.edges)) {
                var c = {
                  left: !1,
                  right: !1,
                  top: !1,
                  bottom: !1
                };
                for (var l in c) {
                  c[l] = zt(l, s.edges[l], a, e._latestPointer.eventTarget, r, i, s.margin || jt.defaultMargin);
                }
                c.left = c.left && !c.right, c.top = c.top && !c.bottom, (c.left || c.right || c.top || c.bottom) && (t.action = {
                  name: "resize",
                  edges: c
                });
              } else {
                var u = "y" !== s.axis && a.x > i.right - jt.defaultMargin,
                  p = "x" !== s.axis && a.y > i.bottom - jt.defaultMargin;
                (u || p) && (t.action = {
                  name: "resize",
                  axes: (u ? "x" : "") + (p ? "y" : "")
                });
              }
              return !t.action && void 0;
            }
          }
        }
      },
      defaults: {
        square: !1,
        preserveAspectRatio: !1,
        axis: "xy",
        margin: NaN,
        edges: null,
        invert: "none"
      },
      cursors: null,
      getCursor: function getCursor(t) {
        var e = t.edges,
          n = t.axis,
          r = t.name,
          i = jt.cursors,
          o = null;
        if (n) o = i[r + n];else if (e) {
          for (var a = "", s = 0, c = ["top", "bottom", "left", "right"]; s < c.length; s++) {
            var l = c[s];
            e[l] && (a += l);
          }
          o = i[a];
        }
        return o;
      },
      filterEventType: function filterEventType(t) {
        return 0 === t.search("resize");
      },
      defaultMargin: null
    },
    Ft = jt,
    Xt = {
      id: "actions",
      install: function install(t) {
        t.usePlugin(Mt), t.usePlugin(Ft), t.usePlugin(_), t.usePlugin(kt);
      }
    },
    Yt = 0;
  var Lt = {
    request: function request(t) {
      return Rt(t);
    },
    cancel: function cancel(t) {
      return Ct(t);
    },
    init: function init(t) {
      if (Rt = t.requestAnimationFrame, Ct = t.cancelAnimationFrame, !Rt) for (var e = ["ms", "moz", "webkit", "o"], n = 0; n < e.length; n++) {
        var r = e[n];
        Rt = t["".concat(r, "RequestAnimationFrame")], Ct = t["".concat(r, "CancelAnimationFrame")] || t["".concat(r, "CancelRequestAnimationFrame")];
      }
      Rt = Rt && Rt.bind(t), Ct = Ct && Ct.bind(t), Rt || (Rt = function Rt(e) {
        var n = Date.now(),
          r = Math.max(0, 16 - (n - Yt)),
          i = t.setTimeout(function () {
            e(n + r);
          }, r);
        return Yt = n + r, i;
      }, Ct = function Ct(t) {
        return clearTimeout(t);
      });
    }
  };
  var qt = {
    defaults: {
      enabled: !1,
      margin: 60,
      container: null,
      speed: 300
    },
    now: Date.now,
    interaction: null,
    i: 0,
    x: 0,
    y: 0,
    isScrolling: !1,
    prevTime: 0,
    margin: 0,
    speed: 0,
    start: function start(t) {
      qt.isScrolling = !0, Lt.cancel(qt.i), t.autoScroll = qt, qt.interaction = t, qt.prevTime = qt.now(), qt.i = Lt.request(qt.scroll);
    },
    stop: function stop() {
      qt.isScrolling = !1, qt.interaction && (qt.interaction.autoScroll = null), Lt.cancel(qt.i);
    },
    scroll: function scroll() {
      var t = qt.interaction,
        e = t.interactable,
        n = t.element,
        r = t.prepared.name,
        i = e.options[r].autoScroll,
        o = Bt(i.container, e, n),
        a = qt.now(),
        s = (a - qt.prevTime) / 1e3,
        c = i.speed * s;
      if (c >= 1) {
        var l = {
          x: qt.x * c,
          y: qt.y * c
        };
        if (l.x || l.y) {
          var u = Vt(o);
          w.window(o) ? o.scrollBy(l.x, l.y) : o && (o.scrollLeft += l.x, o.scrollTop += l.y);
          var p = Vt(o),
            f = {
              x: p.x - u.x,
              y: p.y - u.y
            };
          (f.x || f.y) && e.fire({
            type: "autoscroll",
            target: n,
            interactable: e,
            delta: f,
            interaction: t,
            container: o
          });
        }
        qt.prevTime = a;
      }
      qt.isScrolling && (Lt.cancel(qt.i), qt.i = Lt.request(qt.scroll));
    },
    check: function check(t, e) {
      var n;
      return null == (n = t.options[e].autoScroll) ? void 0 : n.enabled;
    },
    onInteractionMove: function onInteractionMove(t) {
      var e = t.interaction,
        n = t.pointer;
      if (e.interacting() && qt.check(e.interactable, e.prepared.name)) if (e.simulation) qt.x = qt.y = 0;else {
        var r,
          i,
          o,
          a,
          s = e.interactable,
          c = e.element,
          l = e.prepared.name,
          u = s.options[l].autoScroll,
          p = Bt(u.container, s, c);
        if (w.window(p)) a = n.clientX < qt.margin, r = n.clientY < qt.margin, i = n.clientX > p.innerWidth - qt.margin, o = n.clientY > p.innerHeight - qt.margin;else {
          var f = Y(p);
          a = n.clientX < f.left + qt.margin, r = n.clientY < f.top + qt.margin, i = n.clientX > f.right - qt.margin, o = n.clientY > f.bottom - qt.margin;
        }
        qt.x = i ? 1 : a ? -1 : 0, qt.y = o ? 1 : r ? -1 : 0, qt.isScrolling || (qt.margin = u.margin, qt.speed = u.speed, qt.start(e));
      }
    }
  };
  function Bt(t, e, n) {
    return (w.string(t) ? W(t, e, n) : t) || y(n);
  }
  function Vt(t) {
    return w.window(t) && (t = window.document.body), {
      x: t.scrollLeft,
      y: t.scrollTop
    };
  }
  var Wt = {
      id: "auto-scroll",
      install: function install(t) {
        var e = t.defaults,
          n = t.actions;
        t.autoScroll = qt, qt.now = function () {
          return t.now();
        }, n.phaselessTypes.autoscroll = !0, e.perAction.autoScroll = qt.defaults;
      },
      listeners: {
        "interactions:new": function interactionsNew(t) {
          t.interaction.autoScroll = null;
        },
        "interactions:destroy": function interactionsDestroy(t) {
          t.interaction.autoScroll = null, qt.stop(), qt.interaction && (qt.interaction = null);
        },
        "interactions:stop": qt.stop,
        "interactions:action-move": function interactionsActionMove(t) {
          return qt.onInteractionMove(t);
        }
      }
    },
    Gt = Wt;
  function Nt(t, e) {
    var n = !1;
    return function () {
      return n || (g.console.warn(e), n = !0), t.apply(this, arguments);
    };
  }
  function Ut(t, e) {
    return t.name = e.name, t.axis = e.axis, t.edges = e.edges, t;
  }
  function Ht(t) {
    return w.bool(t) ? (this.options.styleCursor = t, this) : null === t ? (delete this.options.styleCursor, this) : this.options.styleCursor;
  }
  function Kt(t) {
    return w.func(t) ? (this.options.actionChecker = t, this) : null === t ? (delete this.options.actionChecker, this) : this.options.actionChecker;
  }
  var $t = {
    id: "auto-start/interactableMethods",
    install: function install(t) {
      var e = t.Interactable;
      e.prototype.getAction = function (e, n, r, i) {
        var o = function (t, e, n, r, i) {
          var o = t.getRect(r),
            a = e.buttons || {
              0: 1,
              1: 4,
              3: 8,
              4: 16
            }[e.button],
            s = {
              action: null,
              interactable: t,
              interaction: n,
              element: r,
              rect: o,
              buttons: a
            };
          return i.fire("auto-start:check", s), s.action;
        }(this, n, r, i, t);
        return this.options.actionChecker ? this.options.actionChecker(e, n, o, this, i, r) : o;
      }, e.prototype.ignoreFrom = Nt(function (t) {
        return this._backCompatOption("ignoreFrom", t);
      }, "Interactable.ignoreFrom() has been deprecated. Use Interactble.draggable({ignoreFrom: newValue})."), e.prototype.allowFrom = Nt(function (t) {
        return this._backCompatOption("allowFrom", t);
      }, "Interactable.allowFrom() has been deprecated. Use Interactble.draggable({allowFrom: newValue})."), e.prototype.actionChecker = Kt, e.prototype.styleCursor = Ht;
    }
  };
  function Jt(t, e, n, r, i) {
    return e.testIgnoreAllow(e.options[t.name], n, r) && e.options[t.name].enabled && ee(e, n, t, i) ? t : null;
  }
  function Qt(t, e, n, r, i, o, a) {
    for (var s = 0, c = r.length; s < c; s++) {
      var l = r[s],
        u = i[s],
        p = l.getAction(e, n, t, u);
      if (p) {
        var f = Jt(p, l, u, o, a);
        if (f) return {
          action: f,
          interactable: l,
          element: u
        };
      }
    }
    return {
      action: null,
      interactable: null,
      element: null
    };
  }
  function Zt(t, e, n, r, i) {
    var o = [],
      a = [],
      s = r;
    function c(t) {
      o.push(t), a.push(s);
    }
    for (; w.element(s);) {
      o = [], a = [], i.interactables.forEachMatch(s, c);
      var l = Qt(t, e, n, o, a, r, i);
      if (l.action && !l.interactable.options[l.action.name].manualStart) return l;
      s = A(s);
    }
    return {
      action: null,
      interactable: null,
      element: null
    };
  }
  function te(t, e, n) {
    var r = e.action,
      i = e.interactable,
      o = e.element;
    r = r || {
      name: null
    }, t.interactable = i, t.element = o, Ut(t.prepared, r), t.rect = i && r.name ? i.getRect(o) : null, ie(t, n), n.fire("autoStart:prepared", {
      interaction: t
    });
  }
  function ee(t, e, n, r) {
    var i = t.options,
      o = i[n.name].max,
      a = i[n.name].maxPerElement,
      s = r.autoStart.maxInteractions,
      c = 0,
      l = 0,
      u = 0;
    if (!(o && a && s)) return !1;
    for (var p = 0, f = r.interactions.list; p < f.length; p++) {
      var d = f[p],
        h = d.prepared.name;
      if (d.interacting()) {
        if (++c >= s) return !1;
        if (d.interactable === t) {
          if ((l += h === n.name ? 1 : 0) >= o) return !1;
          if (d.element === e && (u++, h === n.name && u >= a)) return !1;
        }
      }
    }
    return s > 0;
  }
  function ne(t, e) {
    return w.number(t) ? (e.autoStart.maxInteractions = t, this) : e.autoStart.maxInteractions;
  }
  function re(t, e, n) {
    var r = n.autoStart.cursorElement;
    r && r !== t && (r.style.cursor = ""), t.ownerDocument.documentElement.style.cursor = e, t.style.cursor = e, n.autoStart.cursorElement = e ? t : null;
  }
  function ie(t, e) {
    var n = t.interactable,
      r = t.element,
      i = t.prepared;
    if ("mouse" === t.pointerType && n && n.options.styleCursor) {
      var o = "";
      if (i.name) {
        var a = n.options[i.name].cursorChecker;
        o = w.func(a) ? a(i, n, r, t._interacting) : e.actions.map[i.name].getCursor(i);
      }
      re(t.element, o || "", e);
    } else e.autoStart.cursorElement && re(e.autoStart.cursorElement, "", e);
  }
  var oe = {
      id: "auto-start/base",
      before: ["actions"],
      install: function install(t) {
        var e = t.interactStatic,
          n = t.defaults;
        t.usePlugin($t), n.base.actionChecker = null, n.base.styleCursor = !0, V(n.perAction, {
          manualStart: !1,
          max: 1 / 0,
          maxPerElement: 1,
          allowFrom: null,
          ignoreFrom: null,
          mouseButtons: 1
        }), e.maxInteractions = function (e) {
          return ne(e, t);
        }, t.autoStart = {
          maxInteractions: 1 / 0,
          withinInteractionLimit: ee,
          cursorElement: null
        };
      },
      listeners: {
        "interactions:down": function interactionsDown(t, e) {
          var n = t.interaction,
            r = t.pointer,
            i = t.event,
            o = t.eventTarget;
          n.interacting() || te(n, Zt(n, r, i, o, e), e);
        },
        "interactions:move": function interactionsMove(t, e) {
          !function (t, e) {
            var n = t.interaction,
              r = t.pointer,
              i = t.event,
              o = t.eventTarget;
            "mouse" !== n.pointerType || n.pointerIsDown || n.interacting() || te(n, Zt(n, r, i, o, e), e);
          }(t, e), function (t, e) {
            var n = t.interaction;
            if (n.pointerIsDown && !n.interacting() && n.pointerWasMoved && n.prepared.name) {
              e.fire("autoStart:before-start", t);
              var r = n.interactable,
                i = n.prepared.name;
              i && r && (r.options[i].manualStart || !ee(r, n.element, n.prepared, e) ? n.stop() : (n.start(n.prepared, r, n.element), ie(n, e)));
            }
          }(t, e);
        },
        "interactions:stop": function interactionsStop(t, e) {
          var n = t.interaction,
            r = n.interactable;
          r && r.options.styleCursor && re(n.element, "", e);
        }
      },
      maxInteractions: ne,
      withinInteractionLimit: ee,
      validateAction: Jt
    },
    ae = oe;
  var se = {
    id: "auto-start/dragAxis",
    listeners: {
      "autoStart:before-start": function autoStartBeforeStart(t, e) {
        var n = t.interaction,
          r = t.eventTarget,
          i = t.dx,
          o = t.dy;
        if ("drag" === n.prepared.name) {
          var a = Math.abs(i),
            s = Math.abs(o),
            c = n.interactable.options.drag,
            l = c.startAxis,
            u = a > s ? "x" : a < s ? "y" : "xy";
          if (n.prepared.axis = "start" === c.lockAxis ? u[0] : c.lockAxis, "xy" !== u && "xy" !== l && l !== u) {
            n.prepared.name = null;
            for (var p = r, f = function f(t) {
                if (t !== n.interactable) {
                  var i = n.interactable.options.drag;
                  if (!i.manualStart && t.testIgnoreAllow(i, p, r)) {
                    var o = t.getAction(n.downPointer, n.downEvent, n, p);
                    if (o && "drag" === o.name && function (t, e) {
                      if (!e) return !1;
                      var n = e.options.drag.startAxis;
                      return "xy" === t || "xy" === n || n === t;
                    }(u, t) && ae.validateAction(o, t, p, r, e)) return t;
                  }
                }
              }; w.element(p);) {
              var d = e.interactables.forEachMatch(p, f);
              if (d) {
                n.prepared.name = "drag", n.interactable = d, n.element = p;
                break;
              }
              p = A(p);
            }
          }
        }
      }
    }
  };
  function ce(t) {
    var e = t.prepared && t.prepared.name;
    if (!e) return null;
    var n = t.interactable.options;
    return n[e].hold || n[e].delay;
  }
  var le = {
      id: "auto-start/hold",
      install: function install(t) {
        var e = t.defaults;
        t.usePlugin(ae), e.perAction.hold = 0, e.perAction.delay = 0;
      },
      listeners: {
        "interactions:new": function interactionsNew(t) {
          t.interaction.autoStartHoldTimer = null;
        },
        "autoStart:prepared": function autoStartPrepared(t) {
          var e = t.interaction,
            n = ce(e);
          n > 0 && (e.autoStartHoldTimer = setTimeout(function () {
            e.start(e.prepared, e.interactable, e.element);
          }, n));
        },
        "interactions:move": function interactionsMove(t) {
          var e = t.interaction,
            n = t.duplicate;
          e.autoStartHoldTimer && e.pointerWasMoved && !n && (clearTimeout(e.autoStartHoldTimer), e.autoStartHoldTimer = null);
        },
        "autoStart:before-start": function autoStartBeforeStart(t) {
          var e = t.interaction;
          ce(e) > 0 && (e.prepared.name = null);
        }
      },
      getHoldDuration: ce
    },
    ue = le,
    pe = {
      id: "auto-start",
      install: function install(t) {
        t.usePlugin(ae), t.usePlugin(ue), t.usePlugin(se);
      }
    },
    fe = function fe(t) {
      return /^(always|never|auto)$/.test(t) ? (this.options.preventDefault = t, this) : w.bool(t) ? (this.options.preventDefault = t ? "always" : "never", this) : this.options.preventDefault;
    };
  function de(t) {
    var e = t.interaction,
      n = t.event;
    e.interactable && e.interactable.checkAndPreventDefault(n);
  }
  var he = {
    id: "core/interactablePreventDefault",
    install: function install(t) {
      var e = t.Interactable;
      e.prototype.preventDefault = fe, e.prototype.checkAndPreventDefault = function (e) {
        return function (t, e, n) {
          var r = t.options.preventDefault;
          if ("never" !== r) if ("always" !== r) {
            if (e.events.supportsPassive && /^touch(start|move)$/.test(n.type)) {
              var i = y(n.target).document,
                o = e.getDocOptions(i);
              if (!o || !o.events || !1 !== o.events.passive) return;
            }
            /^(mouse|pointer|touch)*(down|start)/i.test(n.type) || w.element(n.target) && R(n.target, "input,select,textarea,[contenteditable=true],[contenteditable=true] *") || n.preventDefault();
          } else n.preventDefault();
        }(this, t, e);
      }, t.interactions.docEvents.push({
        type: "dragstart",
        listener: function listener(e) {
          for (var n = 0, r = t.interactions.list; n < r.length; n++) {
            var i = r[n];
            if (i.element && (i.element === e.target || M(i.element, e.target))) return void i.interactable.checkAndPreventDefault(e);
          }
        }
      });
    },
    listeners: ["down", "move", "up", "cancel"].reduce(function (t, e) {
      return t["interactions:".concat(e)] = de, t;
    }, {})
  };
  function ve(t, e) {
    if (e.phaselessTypes[t]) return !0;
    for (var n in e.map) {
      if (0 === t.indexOf(n) && t.substr(n.length) in e.phases) return !0;
    }
    return !1;
  }
  function ge(t) {
    var e = {};
    for (var n in t) {
      var r = t[n];
      w.plainObject(r) ? e[n] = ge(r) : w.array(r) ? e[n] = mt(r) : e[n] = r;
    }
    return e;
  }
  var me = function () {
    function t(e) {
      r(this, t), this.states = [], this.startOffset = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, this.startDelta = void 0, this.result = void 0, this.endResult = void 0, this.startEdges = void 0, this.edges = void 0, this.interaction = void 0, this.interaction = e, this.result = ye(), this.edges = {
        left: !1,
        right: !1,
        top: !1,
        bottom: !1
      };
    }
    return o(t, [{
      key: "start",
      value: function value(t, e) {
        var n,
          r,
          i = t.phase,
          o = this.interaction,
          a = function (t) {
            var e = t.interactable.options[t.prepared.name],
              n = e.modifiers;
            if (n && n.length) return n;
            return ["snap", "snapSize", "snapEdges", "restrict", "restrictEdges", "restrictSize"].map(function (t) {
              var n = e[t];
              return n && n.enabled && {
                options: n,
                methods: n._methods
              };
            }).filter(function (t) {
              return !!t;
            });
          }(o);
        this.prepareStates(a), this.startEdges = V({}, o.edges), this.edges = V({}, this.startEdges), this.startOffset = (n = o.rect, r = e, n ? {
          left: r.x - n.left,
          top: r.y - n.top,
          right: n.right - r.x,
          bottom: n.bottom - r.y
        } : {
          left: 0,
          top: 0,
          right: 0,
          bottom: 0
        }), this.startDelta = {
          x: 0,
          y: 0
        };
        var s = this.fillArg({
          phase: i,
          pageCoords: e,
          preEnd: !1
        });
        return this.result = ye(), this.startAll(s), this.result = this.setAll(s);
      }
    }, {
      key: "fillArg",
      value: function value(t) {
        var e = this.interaction;
        return t.interaction = e, t.interactable = e.interactable, t.element = e.element, t.rect || (t.rect = e.rect), t.edges || (t.edges = this.startEdges), t.startOffset = this.startOffset, t;
      }
    }, {
      key: "startAll",
      value: function value(t) {
        for (var e = 0, n = this.states; e < n.length; e++) {
          var r = n[e];
          r.methods.start && (t.state = r, r.methods.start(t));
        }
      }
    }, {
      key: "setAll",
      value: function value(t) {
        var e = t.phase,
          n = t.preEnd,
          r = t.skipModifiers,
          i = t.rect,
          o = t.edges;
        t.coords = V({}, t.pageCoords), t.rect = V({}, i), t.edges = V({}, o);
        for (var a = r ? this.states.slice(r) : this.states, s = ye(t.coords, t.rect), c = 0; c < a.length; c++) {
          var l,
            u = a[c],
            p = u.options,
            f = V({}, t.coords),
            d = null;
          null != (l = u.methods) && l.set && this.shouldDo(p, n, e) && (t.state = u, d = u.methods.set(t), H(t.edges, t.rect, {
            x: t.coords.x - f.x,
            y: t.coords.y - f.y
          })), s.eventProps.push(d);
        }
        V(this.edges, t.edges), s.delta.x = t.coords.x - t.pageCoords.x, s.delta.y = t.coords.y - t.pageCoords.y, s.rectDelta.left = t.rect.left - i.left, s.rectDelta.right = t.rect.right - i.right, s.rectDelta.top = t.rect.top - i.top, s.rectDelta.bottom = t.rect.bottom - i.bottom;
        var h = this.result.coords,
          v = this.result.rect;
        if (h && v) {
          var g = s.rect.left !== v.left || s.rect.right !== v.right || s.rect.top !== v.top || s.rect.bottom !== v.bottom;
          s.changed = g || h.x !== s.coords.x || h.y !== s.coords.y;
        }
        return s;
      }
    }, {
      key: "applyToInteraction",
      value: function value(t) {
        var e = this.interaction,
          n = t.phase,
          r = e.coords.cur,
          i = e.coords.start,
          o = this.result,
          a = this.startDelta,
          s = o.delta;
        "start" === n && V(this.startDelta, o.delta);
        for (var c = 0, l = [[i, a], [r, s]]; c < l.length; c++) {
          var u = l[c],
            p = u[0],
            f = u[1];
          p.page.x += f.x, p.page.y += f.y, p.client.x += f.x, p.client.y += f.y;
        }
        var d = this.result.rectDelta,
          h = t.rect || e.rect;
        h.left += d.left, h.right += d.right, h.top += d.top, h.bottom += d.bottom, h.width = h.right - h.left, h.height = h.bottom - h.top;
      }
    }, {
      key: "setAndApply",
      value: function value(t) {
        var e = this.interaction,
          n = t.phase,
          r = t.preEnd,
          i = t.skipModifiers,
          o = this.setAll(this.fillArg({
            preEnd: r,
            phase: n,
            pageCoords: t.modifiedCoords || e.coords.cur.page
          }));
        if (this.result = o, !o.changed && (!i || i < this.states.length) && e.interacting()) return !1;
        if (t.modifiedCoords) {
          var a = e.coords.cur.page,
            s = {
              x: t.modifiedCoords.x - a.x,
              y: t.modifiedCoords.y - a.y
            };
          o.coords.x += s.x, o.coords.y += s.y, o.delta.x += s.x, o.delta.y += s.y;
        }
        this.applyToInteraction(t);
      }
    }, {
      key: "beforeEnd",
      value: function value(t) {
        var e = t.interaction,
          n = t.event,
          r = this.states;
        if (r && r.length) {
          for (var i = !1, o = 0; o < r.length; o++) {
            var a = r[o];
            t.state = a;
            var s = a.options,
              c = a.methods,
              l = c.beforeEnd && c.beforeEnd(t);
            if (l) return this.endResult = l, !1;
            i = i || !i && this.shouldDo(s, !0, t.phase, !0);
          }
          i && e.move({
            event: n,
            preEnd: !0
          });
        }
      }
    }, {
      key: "stop",
      value: function value(t) {
        var e = t.interaction;
        if (this.states && this.states.length) {
          var n = V({
            states: this.states,
            interactable: e.interactable,
            element: e.element,
            rect: null
          }, t);
          this.fillArg(n);
          for (var r = 0, i = this.states; r < i.length; r++) {
            var o = i[r];
            n.state = o, o.methods.stop && o.methods.stop(n);
          }
          this.states = null, this.endResult = null;
        }
      }
    }, {
      key: "prepareStates",
      value: function value(t) {
        this.states = [];
        for (var e = 0; e < t.length; e++) {
          var n = t[e],
            r = n.options,
            i = n.methods,
            o = n.name;
          this.states.push({
            options: r,
            methods: i,
            index: e,
            name: o
          });
        }
        return this.states;
      }
    }, {
      key: "restoreInteractionCoords",
      value: function value(t) {
        var e = t.interaction,
          n = e.coords,
          r = e.rect,
          i = e.modification;
        if (i.result) {
          for (var o = i.startDelta, a = i.result, s = a.delta, c = a.rectDelta, l = 0, u = [[n.start, o], [n.cur, s]]; l < u.length; l++) {
            var p = u[l],
              f = p[0],
              d = p[1];
            f.page.x -= d.x, f.page.y -= d.y, f.client.x -= d.x, f.client.y -= d.y;
          }
          r.left -= c.left, r.right -= c.right, r.top -= c.top, r.bottom -= c.bottom;
        }
      }
    }, {
      key: "shouldDo",
      value: function value(t, e, n, r) {
        return !(!t || !1 === t.enabled || r && !t.endOnly || t.endOnly && !e || "start" === n && !t.setStart);
      }
    }, {
      key: "copyFrom",
      value: function value(t) {
        this.startOffset = t.startOffset, this.startDelta = t.startDelta, this.startEdges = t.startEdges, this.edges = t.edges, this.states = t.states.map(function (t) {
          return ge(t);
        }), this.result = ye(V({}, t.result.coords), V({}, t.result.rect));
      }
    }, {
      key: "destroy",
      value: function value() {
        for (var t in this) {
          this[t] = null;
        }
      }
    }]), t;
  }();
  function ye(t, e) {
    return {
      rect: e,
      coords: t,
      delta: {
        x: 0,
        y: 0
      },
      rectDelta: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      },
      eventProps: [],
      changed: !0
    };
  }
  function be(t, e) {
    var n = t.defaults,
      r = {
        start: t.start,
        set: t.set,
        beforeEnd: t.beforeEnd,
        stop: t.stop
      },
      i = function i(t) {
        var i = t || {};
        for (var o in i.enabled = !1 !== i.enabled, n) {
          o in i || (i[o] = n[o]);
        }
        var a = {
          options: i,
          methods: r,
          name: e,
          enable: function enable() {
            return i.enabled = !0, a;
          },
          disable: function disable() {
            return i.enabled = !1, a;
          }
        };
        return a;
      };
    return e && "string" == typeof e && (i._defaults = n, i._methods = r), i;
  }
  function xe(t) {
    var e = t.iEvent,
      n = t.interaction.modification.result;
    n && (e.modifiers = n.eventProps);
  }
  var we = {
      id: "modifiers/base",
      before: ["actions"],
      install: function install(t) {
        t.defaults.perAction.modifiers = [];
      },
      listeners: {
        "interactions:new": function interactionsNew(t) {
          var e = t.interaction;
          e.modification = new me(e);
        },
        "interactions:before-action-start": function interactionsBeforeActionStart(t) {
          var e = t.interaction,
            n = t.interaction.modification;
          n.start(t, e.coords.start.page), e.edges = n.edges, n.applyToInteraction(t);
        },
        "interactions:before-action-move": function interactionsBeforeActionMove(t) {
          var e = t.interaction,
            n = e.modification,
            r = n.setAndApply(t);
          return e.edges = n.edges, r;
        },
        "interactions:before-action-end": function interactionsBeforeActionEnd(t) {
          var e = t.interaction,
            n = e.modification,
            r = n.beforeEnd(t);
          return e.edges = n.startEdges, r;
        },
        "interactions:action-start": xe,
        "interactions:action-move": xe,
        "interactions:action-end": xe,
        "interactions:after-action-start": function interactionsAfterActionStart(t) {
          return t.interaction.modification.restoreInteractionCoords(t);
        },
        "interactions:after-action-move": function interactionsAfterActionMove(t) {
          return t.interaction.modification.restoreInteractionCoords(t);
        },
        "interactions:stop": function interactionsStop(t) {
          return t.interaction.modification.stop(t);
        }
      }
    },
    Ee = we,
    Te = {
      base: {
        preventDefault: "auto",
        deltaSource: "page"
      },
      perAction: {
        enabled: !1,
        origin: {
          x: 0,
          y: 0
        }
      },
      actions: {}
    },
    Se = function (t) {
      s(n, t);
      var e = p(n);
      function n(t, i, o, a, s, c, l) {
        var p;
        r(this, n), (p = e.call(this, t)).relatedTarget = null, p.screenX = void 0, p.screenY = void 0, p.button = void 0, p.buttons = void 0, p.ctrlKey = void 0, p.shiftKey = void 0, p.altKey = void 0, p.metaKey = void 0, p.page = void 0, p.client = void 0, p.delta = void 0, p.rect = void 0, p.x0 = void 0, p.y0 = void 0, p.t0 = void 0, p.dt = void 0, p.duration = void 0, p.clientX0 = void 0, p.clientY0 = void 0, p.velocity = void 0, p.speed = void 0, p.swipe = void 0, p.axes = void 0, p.preEnd = void 0, s = s || t.element;
        var f = t.interactable,
          d = (f && f.options || Te).deltaSource,
          h = K(f, s, o),
          v = "start" === a,
          g = "end" === a,
          m = v ? u(p) : t.prevEvent,
          y = v ? t.coords.start : g ? {
            page: m.page,
            client: m.client,
            timeStamp: t.coords.cur.timeStamp
          } : t.coords.cur;
        return p.page = V({}, y.page), p.client = V({}, y.client), p.rect = V({}, t.rect), p.timeStamp = y.timeStamp, g || (p.page.x -= h.x, p.page.y -= h.y, p.client.x -= h.x, p.client.y -= h.y), p.ctrlKey = i.ctrlKey, p.altKey = i.altKey, p.shiftKey = i.shiftKey, p.metaKey = i.metaKey, p.button = i.button, p.buttons = i.buttons, p.target = s, p.currentTarget = s, p.preEnd = c, p.type = l || o + (a || ""), p.interactable = f, p.t0 = v ? t.pointers[t.pointers.length - 1].downTime : m.t0, p.x0 = t.coords.start.page.x - h.x, p.y0 = t.coords.start.page.y - h.y, p.clientX0 = t.coords.start.client.x - h.x, p.clientY0 = t.coords.start.client.y - h.y, p.delta = v || g ? {
          x: 0,
          y: 0
        } : {
          x: p[d].x - m[d].x,
          y: p[d].y - m[d].y
        }, p.dt = t.coords.delta.timeStamp, p.duration = p.timeStamp - p.t0, p.velocity = V({}, t.coords.velocity[d]), p.speed = Q(p.velocity.x, p.velocity.y), p.swipe = g || "inertiastart" === a ? p.getSwipe() : null, p;
      }
      return o(n, [{
        key: "getSwipe",
        value: function value() {
          var t = this._interaction;
          if (t.prevEvent.speed < 600 || this.timeStamp - t.prevEvent.timeStamp > 150) return null;
          var e = 180 * Math.atan2(t.prevEvent.velocityY, t.prevEvent.velocityX) / Math.PI;
          e < 0 && (e += 360);
          var n = 112.5 <= e && e < 247.5,
            r = 202.5 <= e && e < 337.5;
          return {
            up: r,
            down: !r && 22.5 <= e && e < 157.5,
            left: n,
            right: !n && (292.5 <= e || e < 67.5),
            angle: e,
            speed: t.prevEvent.speed,
            velocity: {
              x: t.prevEvent.velocityX,
              y: t.prevEvent.velocityY
            }
          };
        }
      }, {
        key: "preventDefault",
        value: function value() {}
      }, {
        key: "stopImmediatePropagation",
        value: function value() {
          this.immediatePropagationStopped = this.propagationStopped = !0;
        }
      }, {
        key: "stopPropagation",
        value: function value() {
          this.propagationStopped = !0;
        }
      }]), n;
    }(vt);
  Object.defineProperties(Se.prototype, {
    pageX: {
      get: function get() {
        return this.page.x;
      },
      set: function set(t) {
        this.page.x = t;
      }
    },
    pageY: {
      get: function get() {
        return this.page.y;
      },
      set: function set(t) {
        this.page.y = t;
      }
    },
    clientX: {
      get: function get() {
        return this.client.x;
      },
      set: function set(t) {
        this.client.x = t;
      }
    },
    clientY: {
      get: function get() {
        return this.client.y;
      },
      set: function set(t) {
        this.client.y = t;
      }
    },
    dx: {
      get: function get() {
        return this.delta.x;
      },
      set: function set(t) {
        this.delta.x = t;
      }
    },
    dy: {
      get: function get() {
        return this.delta.y;
      },
      set: function set(t) {
        this.delta.y = t;
      }
    },
    velocityX: {
      get: function get() {
        return this.velocity.x;
      },
      set: function set(t) {
        this.velocity.x = t;
      }
    },
    velocityY: {
      get: function get() {
        return this.velocity.y;
      },
      set: function set(t) {
        this.velocity.y = t;
      }
    }
  });
  var _e = o(function t(e, n, i, o, a) {
      r(this, t), this.id = void 0, this.pointer = void 0, this.event = void 0, this.downTime = void 0, this.downTarget = void 0, this.id = e, this.pointer = n, this.event = i, this.downTime = o, this.downTarget = a;
    }),
    Pe = function (t) {
      return t.interactable = "", t.element = "", t.prepared = "", t.pointerIsDown = "", t.pointerWasMoved = "", t._proxy = "", t;
    }({}),
    Oe = function (t) {
      return t.start = "", t.move = "", t.end = "", t.stop = "", t.interacting = "", t;
    }({}),
    ke = 0,
    De = function () {
      function t(e) {
        var n = this,
          i = e.pointerType,
          o = e.scopeFire;
        r(this, t), this.interactable = null, this.element = null, this.rect = null, this._rects = void 0, this.edges = null, this._scopeFire = void 0, this.prepared = {
          name: null,
          axis: null,
          edges: null
        }, this.pointerType = void 0, this.pointers = [], this.downEvent = null, this.downPointer = {}, this._latestPointer = {
          pointer: null,
          event: null,
          eventTarget: null
        }, this.prevEvent = null, this.pointerIsDown = !1, this.pointerWasMoved = !1, this._interacting = !1, this._ending = !1, this._stopped = !0, this._proxy = void 0, this.simulation = null, this.doMove = Nt(function (t) {
          this.move(t);
        }, "The interaction.doMove() method has been renamed to interaction.move()"), this.coords = {
          start: {
            page: {
              x: 0,
              y: 0
            },
            client: {
              x: 0,
              y: 0
            },
            timeStamp: 0
          },
          prev: {
            page: {
              x: 0,
              y: 0
            },
            client: {
              x: 0,
              y: 0
            },
            timeStamp: 0
          },
          cur: {
            page: {
              x: 0,
              y: 0
            },
            client: {
              x: 0,
              y: 0
            },
            timeStamp: 0
          },
          delta: {
            page: {
              x: 0,
              y: 0
            },
            client: {
              x: 0,
              y: 0
            },
            timeStamp: 0
          },
          velocity: {
            page: {
              x: 0,
              y: 0
            },
            client: {
              x: 0,
              y: 0
            },
            timeStamp: 0
          }
        }, this._id = ke++, this._scopeFire = o, this.pointerType = i;
        var a = this;
        this._proxy = {};
        var s = function s(t) {
          Object.defineProperty(n._proxy, t, {
            get: function get() {
              return a[t];
            }
          });
        };
        for (var c in Pe) {
          s(c);
        }
        var l = function l(t) {
          Object.defineProperty(n._proxy, t, {
            value: function value() {
              return a[t].apply(a, arguments);
            }
          });
        };
        for (var u in Oe) {
          l(u);
        }
        this._scopeFire("interactions:new", {
          interaction: this
        });
      }
      return o(t, [{
        key: "pointerMoveTolerance",
        get: function get() {
          return 1;
        }
      }, {
        key: "pointerDown",
        value: function value(t, e, n) {
          var r = this.updatePointer(t, e, n, !0),
            i = this.pointers[r];
          this._scopeFire("interactions:down", {
            pointer: t,
            event: e,
            eventTarget: n,
            pointerIndex: r,
            pointerInfo: i,
            type: "down",
            interaction: this
          });
        }
      }, {
        key: "start",
        value: function value(t, e, n) {
          return !(this.interacting() || !this.pointerIsDown || this.pointers.length < ("gesture" === t.name ? 2 : 1) || !e.options[t.name].enabled) && (Ut(this.prepared, t), this.interactable = e, this.element = n, this.rect = e.getRect(n), this.edges = this.prepared.edges ? V({}, this.prepared.edges) : {
            left: !0,
            right: !0,
            top: !0,
            bottom: !0
          }, this._stopped = !1, this._interacting = this._doPhase({
            interaction: this,
            event: this.downEvent,
            phase: "start"
          }) && !this._stopped, this._interacting);
        }
      }, {
        key: "pointerMove",
        value: function value(t, e, n) {
          this.simulation || this.modification && this.modification.endResult || this.updatePointer(t, e, n, !1);
          var r,
            i,
            o = this.coords.cur.page.x === this.coords.prev.page.x && this.coords.cur.page.y === this.coords.prev.page.y && this.coords.cur.client.x === this.coords.prev.client.x && this.coords.cur.client.y === this.coords.prev.client.y;
          this.pointerIsDown && !this.pointerWasMoved && (r = this.coords.cur.client.x - this.coords.start.client.x, i = this.coords.cur.client.y - this.coords.start.client.y, this.pointerWasMoved = Q(r, i) > this.pointerMoveTolerance);
          var a,
            s,
            c,
            l = this.getPointerIndex(t),
            u = {
              pointer: t,
              pointerIndex: l,
              pointerInfo: this.pointers[l],
              event: e,
              type: "move",
              eventTarget: n,
              dx: r,
              dy: i,
              duplicate: o,
              interaction: this
            };
          o || (a = this.coords.velocity, s = this.coords.delta, c = Math.max(s.timeStamp / 1e3, .001), a.page.x = s.page.x / c, a.page.y = s.page.y / c, a.client.x = s.client.x / c, a.client.y = s.client.y / c, a.timeStamp = c), this._scopeFire("interactions:move", u), o || this.simulation || (this.interacting() && (u.type = null, this.move(u)), this.pointerWasMoved && et(this.coords.prev, this.coords.cur));
        }
      }, {
        key: "move",
        value: function value(t) {
          t && t.event || nt(this.coords.delta), (t = V({
            pointer: this._latestPointer.pointer,
            event: this._latestPointer.event,
            eventTarget: this._latestPointer.eventTarget,
            interaction: this
          }, t || {})).phase = "move", this._doPhase(t);
        }
      }, {
        key: "pointerUp",
        value: function value(t, e, n, r) {
          var i = this.getPointerIndex(t);
          -1 === i && (i = this.updatePointer(t, e, n, !1));
          var o = /cancel$/i.test(e.type) ? "cancel" : "up";
          this._scopeFire("interactions:".concat(o), {
            pointer: t,
            pointerIndex: i,
            pointerInfo: this.pointers[i],
            event: e,
            eventTarget: n,
            type: o,
            curEventTarget: r,
            interaction: this
          }), this.simulation || this.end(e), this.removePointer(t, e);
        }
      }, {
        key: "documentBlur",
        value: function value(t) {
          this.end(t), this._scopeFire("interactions:blur", {
            event: t,
            type: "blur",
            interaction: this
          });
        }
      }, {
        key: "end",
        value: function value(t) {
          var e;
          this._ending = !0, t = t || this._latestPointer.event, this.interacting() && (e = this._doPhase({
            event: t,
            interaction: this,
            phase: "end"
          })), this._ending = !1, !0 === e && this.stop();
        }
      }, {
        key: "currentAction",
        value: function value() {
          return this._interacting ? this.prepared.name : null;
        }
      }, {
        key: "interacting",
        value: function value() {
          return this._interacting;
        }
      }, {
        key: "stop",
        value: function value() {
          this._scopeFire("interactions:stop", {
            interaction: this
          }), this.interactable = this.element = null, this._interacting = !1, this._stopped = !0, this.prepared.name = this.prevEvent = null;
        }
      }, {
        key: "getPointerIndex",
        value: function value(t) {
          var e = at(t);
          return "mouse" === this.pointerType || "pen" === this.pointerType ? this.pointers.length - 1 : yt(this.pointers, function (t) {
            return t.id === e;
          });
        }
      }, {
        key: "getPointerInfo",
        value: function value(t) {
          return this.pointers[this.getPointerIndex(t)];
        }
      }, {
        key: "updatePointer",
        value: function value(t, e, n, r) {
          var i,
            o,
            a,
            s = at(t),
            c = this.getPointerIndex(t),
            l = this.pointers[c];
          return r = !1 !== r && (r || /(down|start)$/i.test(e.type)), l ? l.pointer = t : (l = new _e(s, t, e, null, null), c = this.pointers.length, this.pointers.push(l)), st(this.coords.cur, this.pointers.map(function (t) {
            return t.pointer;
          }), this._now()), i = this.coords.delta, o = this.coords.prev, a = this.coords.cur, i.page.x = a.page.x - o.page.x, i.page.y = a.page.y - o.page.y, i.client.x = a.client.x - o.client.x, i.client.y = a.client.y - o.client.y, i.timeStamp = a.timeStamp - o.timeStamp, r && (this.pointerIsDown = !0, l.downTime = this.coords.cur.timeStamp, l.downTarget = n, tt(this.downPointer, t), this.interacting() || (et(this.coords.start, this.coords.cur), et(this.coords.prev, this.coords.cur), this.downEvent = e, this.pointerWasMoved = !1)), this._updateLatestPointer(t, e, n), this._scopeFire("interactions:update-pointer", {
            pointer: t,
            event: e,
            eventTarget: n,
            down: r,
            pointerInfo: l,
            pointerIndex: c,
            interaction: this
          }), c;
        }
      }, {
        key: "removePointer",
        value: function value(t, e) {
          var n = this.getPointerIndex(t);
          if (-1 !== n) {
            var r = this.pointers[n];
            this._scopeFire("interactions:remove-pointer", {
              pointer: t,
              event: e,
              eventTarget: null,
              pointerIndex: n,
              pointerInfo: r,
              interaction: this
            }), this.pointers.splice(n, 1), this.pointerIsDown = !1;
          }
        }
      }, {
        key: "_updateLatestPointer",
        value: function value(t, e, n) {
          this._latestPointer.pointer = t, this._latestPointer.event = e, this._latestPointer.eventTarget = n;
        }
      }, {
        key: "destroy",
        value: function value() {
          this._latestPointer.pointer = null, this._latestPointer.event = null, this._latestPointer.eventTarget = null;
        }
      }, {
        key: "_createPreparedEvent",
        value: function value(t, e, n, r) {
          return new Se(this, t, this.prepared.name, e, this.element, n, r);
        }
      }, {
        key: "_fireEvent",
        value: function value(t) {
          var e;
          null == (e = this.interactable) || e.fire(t), (!this.prevEvent || t.timeStamp >= this.prevEvent.timeStamp) && (this.prevEvent = t);
        }
      }, {
        key: "_doPhase",
        value: function value(t) {
          var e = t.event,
            n = t.phase,
            r = t.preEnd,
            i = t.type,
            o = this.rect;
          if (o && "move" === n && (H(this.edges, o, this.coords.delta[this.interactable.options.deltaSource]), o.width = o.right - o.left, o.height = o.bottom - o.top), !1 === this._scopeFire("interactions:before-action-".concat(n), t)) return !1;
          var a = t.iEvent = this._createPreparedEvent(e, n, r, i);
          return this._scopeFire("interactions:action-".concat(n), t), "start" === n && (this.prevEvent = a), this._fireEvent(a), this._scopeFire("interactions:after-action-".concat(n), t), !0;
        }
      }, {
        key: "_now",
        value: function value() {
          return Date.now();
        }
      }]), t;
    }();
  function Ie(t) {
    Me(t.interaction);
  }
  function Me(t) {
    if (!function (t) {
      return !(!t.offset.pending.x && !t.offset.pending.y);
    }(t)) return !1;
    var e = t.offset.pending;
    return Ae(t.coords.cur, e), Ae(t.coords.delta, e), H(t.edges, t.rect, e), e.x = 0, e.y = 0, !0;
  }
  function ze(t) {
    var e = t.x,
      n = t.y;
    this.offset.pending.x += e, this.offset.pending.y += n, this.offset.total.x += e, this.offset.total.y += n;
  }
  function Ae(t, e) {
    var n = t.page,
      r = t.client,
      i = e.x,
      o = e.y;
    n.x += i, n.y += o, r.x += i, r.y += o;
  }
  Oe.offsetBy = "";
  var Re = {
      id: "offset",
      before: ["modifiers", "pointer-events", "actions", "inertia"],
      install: function install(t) {
        t.Interaction.prototype.offsetBy = ze;
      },
      listeners: {
        "interactions:new": function interactionsNew(t) {
          t.interaction.offset = {
            total: {
              x: 0,
              y: 0
            },
            pending: {
              x: 0,
              y: 0
            }
          };
        },
        "interactions:update-pointer": function interactionsUpdatePointer(t) {
          return function (t) {
            t.pointerIsDown && (Ae(t.coords.cur, t.offset.total), t.offset.pending.x = 0, t.offset.pending.y = 0);
          }(t.interaction);
        },
        "interactions:before-action-start": Ie,
        "interactions:before-action-move": Ie,
        "interactions:before-action-end": function interactionsBeforeActionEnd(t) {
          var e = t.interaction;
          if (Me(e)) return e.move({
            offset: !0
          }), e.end(), !1;
        },
        "interactions:stop": function interactionsStop(t) {
          var e = t.interaction;
          e.offset.total.x = 0, e.offset.total.y = 0, e.offset.pending.x = 0, e.offset.pending.y = 0;
        }
      }
    },
    Ce = Re;
  var je = function () {
    function t(e) {
      r(this, t), this.active = !1, this.isModified = !1, this.smoothEnd = !1, this.allowResume = !1, this.modification = void 0, this.modifierCount = 0, this.modifierArg = void 0, this.startCoords = void 0, this.t0 = 0, this.v0 = 0, this.te = 0, this.targetOffset = void 0, this.modifiedOffset = void 0, this.currentOffset = void 0, this.lambda_v0 = 0, this.one_ve_v0 = 0, this.timeout = void 0, this.interaction = void 0, this.interaction = e;
    }
    return o(t, [{
      key: "start",
      value: function value(t) {
        var e = this.interaction,
          n = Fe(e);
        if (!n || !n.enabled) return !1;
        var r = e.coords.velocity.client,
          i = Q(r.x, r.y),
          o = this.modification || (this.modification = new me(e));
        if (o.copyFrom(e.modification), this.t0 = e._now(), this.allowResume = n.allowResume, this.v0 = i, this.currentOffset = {
          x: 0,
          y: 0
        }, this.startCoords = e.coords.cur.page, this.modifierArg = o.fillArg({
          pageCoords: this.startCoords,
          preEnd: !0,
          phase: "inertiastart"
        }), this.t0 - e.coords.cur.timeStamp < 50 && i > n.minSpeed && i > n.endSpeed) this.startInertia();else {
          if (o.result = o.setAll(this.modifierArg), !o.result.changed) return !1;
          this.startSmoothEnd();
        }
        return e.modification.result.rect = null, e.offsetBy(this.targetOffset), e._doPhase({
          interaction: e,
          event: t,
          phase: "inertiastart"
        }), e.offsetBy({
          x: -this.targetOffset.x,
          y: -this.targetOffset.y
        }), e.modification.result.rect = null, this.active = !0, e.simulation = this, !0;
      }
    }, {
      key: "startInertia",
      value: function value() {
        var t = this,
          e = this.interaction.coords.velocity.client,
          n = Fe(this.interaction),
          r = n.resistance,
          i = -Math.log(n.endSpeed / this.v0) / r;
        this.targetOffset = {
          x: (e.x - i) / r,
          y: (e.y - i) / r
        }, this.te = i, this.lambda_v0 = r / this.v0, this.one_ve_v0 = 1 - n.endSpeed / this.v0;
        var o = this.modification,
          a = this.modifierArg;
        a.pageCoords = {
          x: this.startCoords.x + this.targetOffset.x,
          y: this.startCoords.y + this.targetOffset.y
        }, o.result = o.setAll(a), o.result.changed && (this.isModified = !0, this.modifiedOffset = {
          x: this.targetOffset.x + o.result.delta.x,
          y: this.targetOffset.y + o.result.delta.y
        }), this.onNextFrame(function () {
          return t.inertiaTick();
        });
      }
    }, {
      key: "startSmoothEnd",
      value: function value() {
        var t = this;
        this.smoothEnd = !0, this.isModified = !0, this.targetOffset = {
          x: this.modification.result.delta.x,
          y: this.modification.result.delta.y
        }, this.onNextFrame(function () {
          return t.smoothEndTick();
        });
      }
    }, {
      key: "onNextFrame",
      value: function value(t) {
        var e = this;
        this.timeout = Lt.request(function () {
          e.active && t();
        });
      }
    }, {
      key: "inertiaTick",
      value: function value() {
        var t,
          e,
          n,
          r,
          i,
          o,
          a,
          s = this,
          c = this.interaction,
          l = Fe(c).resistance,
          u = (c._now() - this.t0) / 1e3;
        if (u < this.te) {
          var p,
            f = 1 - (Math.exp(-l * u) - this.lambda_v0) / this.one_ve_v0;
          this.isModified ? (t = 0, e = 0, n = this.targetOffset.x, r = this.targetOffset.y, i = this.modifiedOffset.x, o = this.modifiedOffset.y, p = {
            x: Ye(a = f, t, n, i),
            y: Ye(a, e, r, o)
          }) : p = {
            x: this.targetOffset.x * f,
            y: this.targetOffset.y * f
          };
          var d = {
            x: p.x - this.currentOffset.x,
            y: p.y - this.currentOffset.y
          };
          this.currentOffset.x += d.x, this.currentOffset.y += d.y, c.offsetBy(d), c.move(), this.onNextFrame(function () {
            return s.inertiaTick();
          });
        } else c.offsetBy({
          x: this.modifiedOffset.x - this.currentOffset.x,
          y: this.modifiedOffset.y - this.currentOffset.y
        }), this.end();
      }
    }, {
      key: "smoothEndTick",
      value: function value() {
        var t = this,
          e = this.interaction,
          n = e._now() - this.t0,
          r = Fe(e).smoothEndDuration;
        if (n < r) {
          var i = {
              x: Le(n, 0, this.targetOffset.x, r),
              y: Le(n, 0, this.targetOffset.y, r)
            },
            o = {
              x: i.x - this.currentOffset.x,
              y: i.y - this.currentOffset.y
            };
          this.currentOffset.x += o.x, this.currentOffset.y += o.y, e.offsetBy(o), e.move({
            skipModifiers: this.modifierCount
          }), this.onNextFrame(function () {
            return t.smoothEndTick();
          });
        } else e.offsetBy({
          x: this.targetOffset.x - this.currentOffset.x,
          y: this.targetOffset.y - this.currentOffset.y
        }), this.end();
      }
    }, {
      key: "resume",
      value: function value(t) {
        var e = t.pointer,
          n = t.event,
          r = t.eventTarget,
          i = this.interaction;
        i.offsetBy({
          x: -this.currentOffset.x,
          y: -this.currentOffset.y
        }), i.updatePointer(e, n, r, !0), i._doPhase({
          interaction: i,
          event: n,
          phase: "resume"
        }), et(i.coords.prev, i.coords.cur), this.stop();
      }
    }, {
      key: "end",
      value: function value() {
        this.interaction.move(), this.interaction.end(), this.stop();
      }
    }, {
      key: "stop",
      value: function value() {
        this.active = this.smoothEnd = !1, this.interaction.simulation = null, Lt.cancel(this.timeout);
      }
    }]), t;
  }();
  function Fe(t) {
    var e = t.interactable,
      n = t.prepared;
    return e && e.options && n.name && e.options[n.name].inertia;
  }
  var Xe = {
    id: "inertia",
    before: ["modifiers", "actions"],
    install: function install(t) {
      var e = t.defaults;
      t.usePlugin(Ce), t.usePlugin(Ee), t.actions.phases.inertiastart = !0, t.actions.phases.resume = !0, e.perAction.inertia = {
        enabled: !1,
        resistance: 10,
        minSpeed: 100,
        endSpeed: 10,
        allowResume: !0,
        smoothEndDuration: 300
      };
    },
    listeners: {
      "interactions:new": function interactionsNew(t) {
        var e = t.interaction;
        e.inertia = new je(e);
      },
      "interactions:before-action-end": function interactionsBeforeActionEnd(t) {
        var e = t.interaction,
          n = t.event;
        return (!e._interacting || e.simulation || !e.inertia.start(n)) && null;
      },
      "interactions:down": function interactionsDown(t) {
        var e = t.interaction,
          n = t.eventTarget,
          r = e.inertia;
        if (r.active) for (var i = n; w.element(i);) {
          if (i === e.element) {
            r.resume(t);
            break;
          }
          i = A(i);
        }
      },
      "interactions:stop": function interactionsStop(t) {
        var e = t.interaction.inertia;
        e.active && e.stop();
      },
      "interactions:before-action-resume": function interactionsBeforeActionResume(t) {
        var e = t.interaction.modification;
        e.stop(t), e.start(t, t.interaction.coords.cur.page), e.applyToInteraction(t);
      },
      "interactions:before-action-inertiastart": function interactionsBeforeActionInertiastart(t) {
        return t.interaction.modification.setAndApply(t);
      },
      "interactions:action-resume": xe,
      "interactions:action-inertiastart": xe,
      "interactions:after-action-inertiastart": function interactionsAfterActionInertiastart(t) {
        return t.interaction.modification.restoreInteractionCoords(t);
      },
      "interactions:after-action-resume": function interactionsAfterActionResume(t) {
        return t.interaction.modification.restoreInteractionCoords(t);
      }
    }
  };
  function Ye(t, e, n, r) {
    var i = 1 - t;
    return i * i * e + 2 * i * t * n + t * t * r;
  }
  function Le(t, e, n, r) {
    return -n * (t /= r) * (t - 2) + e;
  }
  var qe = Xe;
  function Be(t, e) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n];
      if (t.immediatePropagationStopped) break;
      r(t);
    }
  }
  var Ve = function () {
    function t(e) {
      r(this, t), this.options = void 0, this.types = {}, this.propagationStopped = !1, this.immediatePropagationStopped = !1, this.global = void 0, this.options = V({}, e || {});
    }
    return o(t, [{
      key: "fire",
      value: function value(t) {
        var e,
          n = this.global;
        (e = this.types[t.type]) && Be(t, e), !t.propagationStopped && n && (e = n[t.type]) && Be(t, e);
      }
    }, {
      key: "on",
      value: function value(t, e) {
        var n = $(t, e);
        for (t in n) {
          this.types[t] = gt(this.types[t] || [], n[t]);
        }
      }
    }, {
      key: "off",
      value: function value(t, e) {
        var n = $(t, e);
        for (t in n) {
          var r = this.types[t];
          if (r && r.length) for (var i = 0, o = n[t]; i < o.length; i++) {
            var a = o[i],
              s = r.indexOf(a);
            -1 !== s && r.splice(s, 1);
          }
        }
      }
    }, {
      key: "getRect",
      value: function value(t) {
        return null;
      }
    }]), t;
  }();
  var We = function () {
    function t(e) {
      r(this, t), this.currentTarget = void 0, this.originalEvent = void 0, this.type = void 0, this.originalEvent = e, tt(this, e);
    }
    return o(t, [{
      key: "preventOriginalDefault",
      value: function value() {
        this.originalEvent.preventDefault();
      }
    }, {
      key: "stopPropagation",
      value: function value() {
        this.originalEvent.stopPropagation();
      }
    }, {
      key: "stopImmediatePropagation",
      value: function value() {
        this.originalEvent.stopImmediatePropagation();
      }
    }]), t;
  }();
  function Ge(t) {
    return w.object(t) ? {
      capture: !!t.capture,
      passive: !!t.passive
    } : {
      capture: !!t,
      passive: !1
    };
  }
  function Ne(t, e) {
    return t === e || ("boolean" == typeof t ? !!e.capture === t && !1 == !!e.passive : !!t.capture == !!e.capture && !!t.passive == !!e.passive);
  }
  var Ue = {
      id: "events",
      install: function install(t) {
        var e,
          n = [],
          r = {},
          i = [],
          o = {
            add: a,
            remove: s,
            addDelegate: function addDelegate(t, e, n, o, s) {
              var u = Ge(s);
              if (!r[n]) {
                r[n] = [];
                for (var p = 0; p < i.length; p++) {
                  var f = i[p];
                  a(f, n, c), a(f, n, l, !0);
                }
              }
              var d = r[n],
                h = bt(d, function (n) {
                  return n.selector === t && n.context === e;
                });
              h || (h = {
                selector: t,
                context: e,
                listeners: []
              }, d.push(h));
              h.listeners.push({
                func: o,
                options: u
              });
            },
            removeDelegate: function removeDelegate(t, e, n, i, o) {
              var a,
                u = Ge(o),
                p = r[n],
                f = !1;
              if (!p) return;
              for (a = p.length - 1; a >= 0; a--) {
                var d = p[a];
                if (d.selector === t && d.context === e) {
                  for (var h = d.listeners, v = h.length - 1; v >= 0; v--) {
                    var g = h[v];
                    if (g.func === i && Ne(g.options, u)) {
                      h.splice(v, 1), h.length || (p.splice(a, 1), s(e, n, c), s(e, n, l, !0)), f = !0;
                      break;
                    }
                  }
                  if (f) break;
                }
              }
            },
            delegateListener: c,
            delegateUseCapture: l,
            delegatedEvents: r,
            documents: i,
            targets: n,
            supportsOptions: !1,
            supportsPassive: !1
          };
        function a(t, e, r, i) {
          if (t.addEventListener) {
            var a = Ge(i),
              s = bt(n, function (e) {
                return e.eventTarget === t;
              });
            s || (s = {
              eventTarget: t,
              events: {}
            }, n.push(s)), s.events[e] || (s.events[e] = []), bt(s.events[e], function (t) {
              return t.func === r && Ne(t.options, a);
            }) || (t.addEventListener(e, r, o.supportsOptions ? a : a.capture), s.events[e].push({
              func: r,
              options: a
            }));
          }
        }
        function s(t, e, r, i) {
          if (t.addEventListener && t.removeEventListener) {
            var a = yt(n, function (e) {
                return e.eventTarget === t;
              }),
              c = n[a];
            if (c && c.events) if ("all" !== e) {
              var l = !1,
                u = c.events[e];
              if (u) {
                if ("all" === r) {
                  for (var p = u.length - 1; p >= 0; p--) {
                    var f = u[p];
                    s(t, e, f.func, f.options);
                  }
                  return;
                }
                for (var d = Ge(i), h = 0; h < u.length; h++) {
                  var v = u[h];
                  if (v.func === r && Ne(v.options, d)) {
                    t.removeEventListener(e, r, o.supportsOptions ? d : d.capture), u.splice(h, 1), 0 === u.length && (delete c.events[e], l = !0);
                    break;
                  }
                }
              }
              l && !Object.keys(c.events).length && n.splice(a, 1);
            } else for (e in c.events) {
              c.events.hasOwnProperty(e) && s(t, e, "all");
            }
          }
        }
        function c(t, e) {
          for (var n = Ge(e), i = new We(t), o = r[t.type], a = ht(t)[0], s = a; w.element(s);) {
            for (var c = 0; c < o.length; c++) {
              var l = o[c],
                u = l.selector,
                p = l.context;
              if (R(s, u) && M(p, a) && M(p, s)) {
                var f = l.listeners;
                i.currentTarget = s;
                for (var d = 0; d < f.length; d++) {
                  var h = f[d];
                  Ne(h.options, n) && h.func(i);
                }
              }
            }
            s = A(s);
          }
        }
        function l(t) {
          return c(t, !0);
        }
        return null == (e = t.document) || e.createElement("div").addEventListener("test", null, {
          get capture() {
            return o.supportsOptions = !0;
          },
          get passive() {
            return o.supportsPassive = !0;
          }
        }), t.events = o, o;
      }
    },
    He = {
      methodOrder: ["simulationResume", "mouseOrPen", "hasPointer", "idle"],
      search: function search(t) {
        for (var e = 0, n = He.methodOrder; e < n.length; e++) {
          var r = n[e],
            i = He[r](t);
          if (i) return i;
        }
        return null;
      },
      simulationResume: function simulationResume(t) {
        var e = t.pointerType,
          n = t.eventType,
          r = t.eventTarget,
          i = t.scope;
        if (!/down|start/i.test(n)) return null;
        for (var o = 0, a = i.interactions.list; o < a.length; o++) {
          var s = a[o],
            c = r;
          if (s.simulation && s.simulation.allowResume && s.pointerType === e) for (; c;) {
            if (c === s.element) return s;
            c = A(c);
          }
        }
        return null;
      },
      mouseOrPen: function mouseOrPen(t) {
        var e,
          n = t.pointerId,
          r = t.pointerType,
          i = t.eventType,
          o = t.scope;
        if ("mouse" !== r && "pen" !== r) return null;
        for (var a = 0, s = o.interactions.list; a < s.length; a++) {
          var c = s[a];
          if (c.pointerType === r) {
            if (c.simulation && !Ke(c, n)) continue;
            if (c.interacting()) return c;
            e || (e = c);
          }
        }
        if (e) return e;
        for (var l = 0, u = o.interactions.list; l < u.length; l++) {
          var p = u[l];
          if (!(p.pointerType !== r || /down/i.test(i) && p.simulation)) return p;
        }
        return null;
      },
      hasPointer: function hasPointer(t) {
        for (var e = t.pointerId, n = 0, r = t.scope.interactions.list; n < r.length; n++) {
          var i = r[n];
          if (Ke(i, e)) return i;
        }
        return null;
      },
      idle: function idle(t) {
        for (var e = t.pointerType, n = 0, r = t.scope.interactions.list; n < r.length; n++) {
          var i = r[n];
          if (1 === i.pointers.length) {
            var o = i.interactable;
            if (o && (!o.options.gesture || !o.options.gesture.enabled)) continue;
          } else if (i.pointers.length >= 2) continue;
          if (!i.interacting() && e === i.pointerType) return i;
        }
        return null;
      }
    };
  function Ke(t, e) {
    return t.pointers.some(function (t) {
      return t.id === e;
    });
  }
  var $e = He,
    Je = ["pointerDown", "pointerMove", "pointerUp", "updatePointer", "removePointer", "windowBlur"];
  function Qe(t, e) {
    return function (n) {
      var r = e.interactions.list,
        i = dt(n),
        o = ht(n),
        a = o[0],
        s = o[1],
        c = [];
      if (/^touch/.test(n.type)) {
        e.prevTouchTime = e.now();
        for (var l = 0, u = n.changedTouches; l < u.length; l++) {
          var p = u[l],
            f = {
              pointer: p,
              pointerId: at(p),
              pointerType: i,
              eventType: n.type,
              eventTarget: a,
              curEventTarget: s,
              scope: e
            },
            d = Ze(f);
          c.push([f.pointer, f.eventTarget, f.curEventTarget, d]);
        }
      } else {
        var h = !1;
        if (!I.supportsPointerEvent && /mouse/.test(n.type)) {
          for (var v = 0; v < r.length && !h; v++) {
            h = "mouse" !== r[v].pointerType && r[v].pointerIsDown;
          }
          h = h || e.now() - e.prevTouchTime < 500 || 0 === n.timeStamp;
        }
        if (!h) {
          var g = {
              pointer: n,
              pointerId: at(n),
              pointerType: i,
              eventType: n.type,
              curEventTarget: s,
              eventTarget: a,
              scope: e
            },
            m = Ze(g);
          c.push([g.pointer, g.eventTarget, g.curEventTarget, m]);
        }
      }
      for (var y = 0; y < c.length; y++) {
        var b = c[y],
          x = b[0],
          w = b[1],
          E = b[2];
        b[3][t](x, n, w, E);
      }
    };
  }
  function Ze(t) {
    var e = t.pointerType,
      n = t.scope,
      r = {
        interaction: $e.search(t),
        searchDetails: t
      };
    return n.fire("interactions:find", r), r.interaction || n.interactions["new"]({
      pointerType: e
    });
  }
  function tn(t, e) {
    var n = t.doc,
      r = t.scope,
      i = t.options,
      o = r.interactions.docEvents,
      a = r.events,
      s = a[e];
    for (var c in r.browser.isIOS && !i.events && (i.events = {
      passive: !1
    }), a.delegatedEvents) {
      s(n, c, a.delegateListener), s(n, c, a.delegateUseCapture, !0);
    }
    for (var l = i && i.events, u = 0; u < o.length; u++) {
      var p = o[u];
      s(n, p.type, p.listener, l);
    }
  }
  var en = {
      id: "core/interactions",
      install: function install(t) {
        for (var e = {}, n = 0; n < Je.length; n++) {
          var i = Je[n];
          e[i] = Qe(i, t);
        }
        var a,
          c = I.pEventTypes;
        function l() {
          for (var e = 0, n = t.interactions.list; e < n.length; e++) {
            var r = n[e];
            if (r.pointerIsDown && "touch" === r.pointerType && !r._interacting) for (var i = function i() {
                var e = a[o];
                t.documents.some(function (t) {
                  return M(t.doc, e.downTarget);
                }) || r.removePointer(e.pointer, e.event);
              }, o = 0, a = r.pointers; o < a.length; o++) {
              i();
            }
          }
        }
        (a = k.PointerEvent ? [{
          type: c.down,
          listener: l
        }, {
          type: c.down,
          listener: e.pointerDown
        }, {
          type: c.move,
          listener: e.pointerMove
        }, {
          type: c.up,
          listener: e.pointerUp
        }, {
          type: c.cancel,
          listener: e.pointerUp
        }] : [{
          type: "mousedown",
          listener: e.pointerDown
        }, {
          type: "mousemove",
          listener: e.pointerMove
        }, {
          type: "mouseup",
          listener: e.pointerUp
        }, {
          type: "touchstart",
          listener: l
        }, {
          type: "touchstart",
          listener: e.pointerDown
        }, {
          type: "touchmove",
          listener: e.pointerMove
        }, {
          type: "touchend",
          listener: e.pointerUp
        }, {
          type: "touchcancel",
          listener: e.pointerUp
        }]).push({
          type: "blur",
          listener: function listener(e) {
            for (var n = 0, r = t.interactions.list; n < r.length; n++) {
              r[n].documentBlur(e);
            }
          }
        }), t.prevTouchTime = 0, t.Interaction = function (e) {
          s(i, e);
          var n = p(i);
          function i() {
            return r(this, i), n.apply(this, arguments);
          }
          return o(i, [{
            key: "pointerMoveTolerance",
            get: function get() {
              return t.interactions.pointerMoveTolerance;
            },
            set: function set(e) {
              t.interactions.pointerMoveTolerance = e;
            }
          }, {
            key: "_now",
            value: function value() {
              return t.now();
            }
          }]), i;
        }(De), t.interactions = {
          list: [],
          "new": function _new(e) {
            e.scopeFire = function (e, n) {
              return t.fire(e, n);
            };
            var n = new t.Interaction(e);
            return t.interactions.list.push(n), n;
          },
          listeners: e,
          docEvents: a,
          pointerMoveTolerance: 1
        }, t.usePlugin(he);
      },
      listeners: {
        "scope:add-document": function scopeAddDocument(t) {
          return tn(t, "add");
        },
        "scope:remove-document": function scopeRemoveDocument(t) {
          return tn(t, "remove");
        },
        "interactable:unset": function interactableUnset(t, e) {
          for (var n = t.interactable, r = e.interactions.list.length - 1; r >= 0; r--) {
            var i = e.interactions.list[r];
            i.interactable === n && (i.stop(), e.fire("interactions:destroy", {
              interaction: i
            }), i.destroy(), e.interactions.list.length > 2 && e.interactions.list.splice(r, 1));
          }
        }
      },
      onDocSignal: tn,
      doOnInteractions: Qe,
      methodNames: Je
    },
    nn = en,
    rn = function (t) {
      return t[t.On = 0] = "On", t[t.Off = 1] = "Off", t;
    }(rn || {}),
    on = function () {
      function t(e, n, i, o) {
        r(this, t), this.target = void 0, this.options = void 0, this._actions = void 0, this.events = new Ve(), this._context = void 0, this._win = void 0, this._doc = void 0, this._scopeEvents = void 0, this._actions = n.actions, this.target = e, this._context = n.context || i, this._win = y(B(e) ? this._context : e), this._doc = this._win.document, this._scopeEvents = o, this.set(n);
      }
      return o(t, [{
        key: "_defaults",
        get: function get() {
          return {
            base: {},
            perAction: {},
            actions: {}
          };
        }
      }, {
        key: "setOnEvents",
        value: function value(t, e) {
          return w.func(e.onstart) && this.on("".concat(t, "start"), e.onstart), w.func(e.onmove) && this.on("".concat(t, "move"), e.onmove), w.func(e.onend) && this.on("".concat(t, "end"), e.onend), w.func(e.oninertiastart) && this.on("".concat(t, "inertiastart"), e.oninertiastart), this;
        }
      }, {
        key: "updatePerActionListeners",
        value: function value(t, e, n) {
          var r,
            i = this,
            o = null == (r = this._actions.map[t]) ? void 0 : r.filterEventType,
            a = function a(t) {
              return (null == o || o(t)) && ve(t, i._actions);
            };
          (w.array(e) || w.object(e)) && this._onOff(rn.Off, t, e, void 0, a), (w.array(n) || w.object(n)) && this._onOff(rn.On, t, n, void 0, a);
        }
      }, {
        key: "setPerAction",
        value: function value(t, e) {
          var n = this._defaults;
          for (var r in e) {
            var i = r,
              o = this.options[t],
              a = e[i];
            "listeners" === i && this.updatePerActionListeners(t, o.listeners, a), w.array(a) ? o[i] = mt(a) : w.plainObject(a) ? (o[i] = V(o[i] || {}, ge(a)), w.object(n.perAction[i]) && "enabled" in n.perAction[i] && (o[i].enabled = !1 !== a.enabled)) : w.bool(a) && w.object(n.perAction[i]) ? o[i].enabled = a : o[i] = a;
          }
        }
      }, {
        key: "getRect",
        value: function value(t) {
          return t = t || (w.element(this.target) ? this.target : null), w.string(this.target) && (t = t || this._context.querySelector(this.target)), L(t);
        }
      }, {
        key: "rectChecker",
        value: function value(t) {
          var e = this;
          return w.func(t) ? (this.getRect = function (n) {
            var r = V({}, t.apply(e, n));
            return "width" in r || (r.width = r.right - r.left, r.height = r.bottom - r.top), r;
          }, this) : null === t ? (delete this.getRect, this) : this.getRect;
        }
      }, {
        key: "_backCompatOption",
        value: function value(t, e) {
          if (B(e) || w.object(e)) {
            for (var n in this.options[t] = e, this._actions.map) {
              this.options[n][t] = e;
            }
            return this;
          }
          return this.options[t];
        }
      }, {
        key: "origin",
        value: function value(t) {
          return this._backCompatOption("origin", t);
        }
      }, {
        key: "deltaSource",
        value: function value(t) {
          return "page" === t || "client" === t ? (this.options.deltaSource = t, this) : this.options.deltaSource;
        }
      }, {
        key: "getAllElements",
        value: function value() {
          var t = this.target;
          return w.string(t) ? Array.from(this._context.querySelectorAll(t)) : w.func(t) && t.getAllElements ? t.getAllElements() : w.element(t) ? [t] : [];
        }
      }, {
        key: "context",
        value: function value() {
          return this._context;
        }
      }, {
        key: "inContext",
        value: function value(t) {
          return this._context === t.ownerDocument || M(this._context, t);
        }
      }, {
        key: "testIgnoreAllow",
        value: function value(t, e, n) {
          return !this.testIgnore(t.ignoreFrom, e, n) && this.testAllow(t.allowFrom, e, n);
        }
      }, {
        key: "testAllow",
        value: function value(t, e, n) {
          return !t || !!w.element(n) && (w.string(t) ? F(n, t, e) : !!w.element(t) && M(t, n));
        }
      }, {
        key: "testIgnore",
        value: function value(t, e, n) {
          return !(!t || !w.element(n)) && (w.string(t) ? F(n, t, e) : !!w.element(t) && M(t, n));
        }
      }, {
        key: "fire",
        value: function value(t) {
          return this.events.fire(t), this;
        }
      }, {
        key: "_onOff",
        value: function value(t, e, n, r, i) {
          w.object(e) && !w.array(e) && (r = n, n = null);
          var o = $(e, n, i);
          for (var a in o) {
            "wheel" === a && (a = I.wheelEvent);
            for (var s = 0, c = o[a]; s < c.length; s++) {
              var l = c[s];
              ve(a, this._actions) ? this.events[t === rn.On ? "on" : "off"](a, l) : w.string(this.target) ? this._scopeEvents[t === rn.On ? "addDelegate" : "removeDelegate"](this.target, this._context, a, l, r) : this._scopeEvents[t === rn.On ? "add" : "remove"](this.target, a, l, r);
            }
          }
          return this;
        }
      }, {
        key: "on",
        value: function value(t, e, n) {
          return this._onOff(rn.On, t, e, n);
        }
      }, {
        key: "off",
        value: function value(t, e, n) {
          return this._onOff(rn.Off, t, e, n);
        }
      }, {
        key: "set",
        value: function value(t) {
          var e = this._defaults;
          for (var n in w.object(t) || (t = {}), this.options = ge(e.base), this._actions.methodDict) {
            var r = n,
              i = this._actions.methodDict[r];
            this.options[r] = {}, this.setPerAction(r, V(V({}, e.perAction), e.actions[r])), this[i](t[r]);
          }
          for (var o in t) {
            "getRect" !== o ? w.func(this[o]) && this[o](t[o]) : this.rectChecker(t.getRect);
          }
          return this;
        }
      }, {
        key: "unset",
        value: function value() {
          if (w.string(this.target)) for (var t in this._scopeEvents.delegatedEvents) {
            for (var e = this._scopeEvents.delegatedEvents[t], n = e.length - 1; n >= 0; n--) {
              var r = e[n],
                i = r.selector,
                o = r.context,
                a = r.listeners;
              i === this.target && o === this._context && e.splice(n, 1);
              for (var s = a.length - 1; s >= 0; s--) {
                this._scopeEvents.removeDelegate(this.target, this._context, t, a[s][0], a[s][1]);
              }
            }
          } else this._scopeEvents.remove(this.target, "all");
        }
      }]), t;
    }(),
    an = function () {
      function t(e) {
        var n = this;
        r(this, t), this.list = [], this.selectorMap = {}, this.scope = void 0, this.scope = e, e.addListeners({
          "interactable:unset": function interactableUnset(t) {
            var e = t.interactable,
              r = e.target,
              i = w.string(r) ? n.selectorMap[r] : r[n.scope.id],
              o = yt(i, function (t) {
                return t === e;
              });
            i.splice(o, 1);
          }
        });
      }
      return o(t, [{
        key: "new",
        value: function value(t, e) {
          e = V(e || {}, {
            actions: this.scope.actions
          });
          var n = new this.scope.Interactable(t, e, this.scope.document, this.scope.events);
          return this.scope.addDocument(n._doc), this.list.push(n), w.string(t) ? (this.selectorMap[t] || (this.selectorMap[t] = []), this.selectorMap[t].push(n)) : (n.target[this.scope.id] || Object.defineProperty(t, this.scope.id, {
            value: [],
            configurable: !0
          }), t[this.scope.id].push(n)), this.scope.fire("interactable:new", {
            target: t,
            options: e,
            interactable: n,
            win: this.scope._win
          }), n;
        }
      }, {
        key: "getExisting",
        value: function value(t, e) {
          var n = e && e.context || this.scope.document,
            r = w.string(t),
            i = r ? this.selectorMap[t] : t[this.scope.id];
          if (i) return bt(i, function (e) {
            return e._context === n && (r || e.inContext(t));
          });
        }
      }, {
        key: "forEachMatch",
        value: function value(t, e) {
          for (var n = 0, r = this.list; n < r.length; n++) {
            var i = r[n],
              o = void 0;
            if ((w.string(i.target) ? w.element(t) && R(t, i.target) : t === i.target) && i.inContext(t) && (o = e(i)), void 0 !== o) return o;
          }
        }
      }]), t;
    }();
  var sn = function () {
    function t() {
      var e = this;
      r(this, t), this.id = "__interact_scope_".concat(Math.floor(100 * Math.random())), this.isInitialized = !1, this.listenerMaps = [], this.browser = I, this.defaults = ge(Te), this.Eventable = Ve, this.actions = {
        map: {},
        phases: {
          start: !0,
          move: !0,
          end: !0
        },
        methodDict: {},
        phaselessTypes: {}
      }, this.interactStatic = function (t) {
        var e = function e(n, r) {
          var i = t.interactables.getExisting(n, r);
          return i || ((i = t.interactables["new"](n, r)).events.global = e.globalEvents), i;
        };
        return e.getPointerAverage = lt, e.getTouchBBox = ut, e.getTouchDistance = pt, e.getTouchAngle = ft, e.getElementRect = L, e.getElementClientRect = Y, e.matchesSelector = R, e.closest = z, e.globalEvents = {}, e.version = "1.10.26", e.scope = t, e.use = function (t, e) {
          return this.scope.usePlugin(t, e), this;
        }, e.isSet = function (t, e) {
          return !!this.scope.interactables.get(t, e && e.context);
        }, e.on = Nt(function (t, e, n) {
          if (w.string(t) && -1 !== t.search(" ") && (t = t.trim().split(/ +/)), w.array(t)) {
            for (var r = 0, i = t; r < i.length; r++) {
              var o = i[r];
              this.on(o, e, n);
            }
            return this;
          }
          if (w.object(t)) {
            for (var a in t) {
              this.on(a, t[a], e);
            }
            return this;
          }
          return ve(t, this.scope.actions) ? this.globalEvents[t] ? this.globalEvents[t].push(e) : this.globalEvents[t] = [e] : this.scope.events.add(this.scope.document, t, e, {
            options: n
          }), this;
        }, "The interact.on() method is being deprecated"), e.off = Nt(function (t, e, n) {
          if (w.string(t) && -1 !== t.search(" ") && (t = t.trim().split(/ +/)), w.array(t)) {
            for (var r = 0, i = t; r < i.length; r++) {
              var o = i[r];
              this.off(o, e, n);
            }
            return this;
          }
          if (w.object(t)) {
            for (var a in t) {
              this.off(a, t[a], e);
            }
            return this;
          }
          var s;
          return ve(t, this.scope.actions) ? t in this.globalEvents && -1 !== (s = this.globalEvents[t].indexOf(e)) && this.globalEvents[t].splice(s, 1) : this.scope.events.remove(this.scope.document, t, e, n), this;
        }, "The interact.off() method is being deprecated"), e.debug = function () {
          return this.scope;
        }, e.supportsTouch = function () {
          return I.supportsTouch;
        }, e.supportsPointerEvent = function () {
          return I.supportsPointerEvent;
        }, e.stop = function () {
          for (var t = 0, e = this.scope.interactions.list; t < e.length; t++) {
            e[t].stop();
          }
          return this;
        }, e.pointerMoveTolerance = function (t) {
          return w.number(t) ? (this.scope.interactions.pointerMoveTolerance = t, this) : this.scope.interactions.pointerMoveTolerance;
        }, e.addDocument = function (t, e) {
          this.scope.addDocument(t, e);
        }, e.removeDocument = function (t) {
          this.scope.removeDocument(t);
        }, e;
      }(this), this.InteractEvent = Se, this.Interactable = void 0, this.interactables = new an(this), this._win = void 0, this.document = void 0, this.window = void 0, this.documents = [], this._plugins = {
        list: [],
        map: {}
      }, this.onWindowUnload = function (t) {
        return e.removeDocument(t.target);
      };
      var n = this;
      this.Interactable = function (t) {
        s(i, t);
        var e = p(i);
        function i() {
          return r(this, i), e.apply(this, arguments);
        }
        return o(i, [{
          key: "_defaults",
          get: function get() {
            return n.defaults;
          }
        }, {
          key: "set",
          value: function value(t) {
            return f(c(i.prototype), "set", this).call(this, t), n.fire("interactable:set", {
              options: t,
              interactable: this
            }), this;
          }
        }, {
          key: "unset",
          value: function value() {
            f(c(i.prototype), "unset", this).call(this);
            var t = n.interactables.list.indexOf(this);
            t < 0 || (n.interactables.list.splice(t, 1), n.fire("interactable:unset", {
              interactable: this
            }));
          }
        }]), i;
      }(on);
    }
    return o(t, [{
      key: "addListeners",
      value: function value(t, e) {
        this.listenerMaps.push({
          id: e,
          map: t
        });
      }
    }, {
      key: "fire",
      value: function value(t, e) {
        for (var n = 0, r = this.listenerMaps; n < r.length; n++) {
          var i = r[n].map[t];
          if (i && !1 === i(e, this, t)) return !1;
        }
      }
    }, {
      key: "init",
      value: function value(t) {
        return this.isInitialized ? this : function (t, e) {
          t.isInitialized = !0, w.window(e) && m(e);
          return k.init(e), I.init(e), Lt.init(e), t.window = e, t.document = e.document, t.usePlugin(nn), t.usePlugin(Ue), t;
        }(this, t);
      }
    }, {
      key: "pluginIsInstalled",
      value: function value(t) {
        var e = t.id;
        return e ? !!this._plugins.map[e] : -1 !== this._plugins.list.indexOf(t);
      }
    }, {
      key: "usePlugin",
      value: function value(t, e) {
        if (!this.isInitialized) return this;
        if (this.pluginIsInstalled(t)) return this;
        if (t.id && (this._plugins.map[t.id] = t), this._plugins.list.push(t), t.install && t.install(this, e), t.listeners && t.before) {
          for (var n = 0, r = this.listenerMaps.length, i = t.before.reduce(function (t, e) {
              return t[e] = !0, t[cn(e)] = !0, t;
            }, {}); n < r; n++) {
            var o = this.listenerMaps[n].id;
            if (o && (i[o] || i[cn(o)])) break;
          }
          this.listenerMaps.splice(n, 0, {
            id: t.id,
            map: t.listeners
          });
        } else t.listeners && this.listenerMaps.push({
          id: t.id,
          map: t.listeners
        });
        return this;
      }
    }, {
      key: "addDocument",
      value: function value(t, e) {
        if (-1 !== this.getDocIndex(t)) return !1;
        var n = y(t);
        e = e ? V({}, e) : {}, this.documents.push({
          doc: t,
          options: e
        }), this.events.documents.push(t), t !== this.document && this.events.add(n, "unload", this.onWindowUnload), this.fire("scope:add-document", {
          doc: t,
          window: n,
          scope: this,
          options: e
        });
      }
    }, {
      key: "removeDocument",
      value: function value(t) {
        var e = this.getDocIndex(t),
          n = y(t),
          r = this.documents[e].options;
        this.events.remove(n, "unload", this.onWindowUnload), this.documents.splice(e, 1), this.events.documents.splice(e, 1), this.fire("scope:remove-document", {
          doc: t,
          window: n,
          scope: this,
          options: r
        });
      }
    }, {
      key: "getDocIndex",
      value: function value(t) {
        for (var e = 0; e < this.documents.length; e++) {
          if (this.documents[e].doc === t) return e;
        }
        return -1;
      }
    }, {
      key: "getDocOptions",
      value: function value(t) {
        var e = this.getDocIndex(t);
        return -1 === e ? null : this.documents[e].options;
      }
    }, {
      key: "now",
      value: function value() {
        return (this.window.Date || Date).now();
      }
    }]), t;
  }();
  function cn(t) {
    return t && t.replace(/\/.*$/, "");
  }
  var ln = new sn(),
    un = ln.interactStatic,
    pn = "undefined" != typeof globalThis ? globalThis : window;
  ln.init(pn);
  var fn = Object.freeze({
      __proto__: null,
      edgeTarget: function edgeTarget() {},
      elements: function elements() {},
      grid: function grid(t) {
        var e = [["x", "y"], ["left", "top"], ["right", "bottom"], ["width", "height"]].filter(function (e) {
            var n = e[0],
              r = e[1];
            return n in t || r in t;
          }),
          n = function n(_n3, r) {
            for (var i = t.range, o = t.limits, a = void 0 === o ? {
                left: -1 / 0,
                right: 1 / 0,
                top: -1 / 0,
                bottom: 1 / 0
              } : o, s = t.offset, c = void 0 === s ? {
                x: 0,
                y: 0
              } : s, l = {
                range: i,
                grid: t,
                x: null,
                y: null
              }, u = 0; u < e.length; u++) {
              var p = e[u],
                f = p[0],
                d = p[1],
                h = Math.round((_n3 - c.x) / t[f]),
                v = Math.round((r - c.y) / t[d]);
              l[f] = Math.max(a.left, Math.min(a.right, h * t[f] + c.x)), l[d] = Math.max(a.top, Math.min(a.bottom, v * t[d] + c.y));
            }
            return l;
          };
        return n.grid = t, n.coordFields = e, n;
      }
    }),
    dn = {
      id: "snappers",
      install: function install(t) {
        var e = t.interactStatic;
        e.snappers = V(e.snappers || {}, fn), e.createSnapGrid = e.snappers.grid;
      }
    },
    hn = dn,
    vn = {
      start: function start(t) {
        var n = t.state,
          r = t.rect,
          i = t.edges,
          o = t.pageCoords,
          a = n.options,
          s = a.ratio,
          c = a.enabled,
          l = n.options,
          u = l.equalDelta,
          p = l.modifiers;
        "preserve" === s && (s = r.width / r.height), n.startCoords = V({}, o), n.startRect = V({}, r), n.ratio = s, n.equalDelta = u;
        var f = n.linkedEdges = {
          top: i.top || i.left && !i.bottom,
          left: i.left || i.top && !i.right,
          bottom: i.bottom || i.right && !i.top,
          right: i.right || i.bottom && !i.left
        };
        if (n.xIsPrimaryAxis = !(!i.left && !i.right), n.equalDelta) {
          var d = (f.left ? 1 : -1) * (f.top ? 1 : -1);
          n.edgeSign = {
            x: d,
            y: d
          };
        } else n.edgeSign = {
          x: f.left ? -1 : 1,
          y: f.top ? -1 : 1
        };
        if (!1 !== c && V(i, f), null != p && p.length) {
          var h = new me(t.interaction);
          h.copyFrom(t.interaction.modification), h.prepareStates(p), n.subModification = h, h.startAll(e({}, t));
        }
      },
      set: function set(t) {
        var n = t.state,
          r = t.rect,
          i = t.coords,
          o = n.linkedEdges,
          a = V({}, i),
          s = n.equalDelta ? gn : mn;
        if (V(t.edges, o), s(n, n.xIsPrimaryAxis, i, r), !n.subModification) return null;
        var c = V({}, r);
        H(o, c, {
          x: i.x - a.x,
          y: i.y - a.y
        });
        var l = n.subModification.setAll(e(e({}, t), {}, {
            rect: c,
            edges: o,
            pageCoords: i,
            prevCoords: i,
            prevRect: c
          })),
          u = l.delta;
        l.changed && (s(n, Math.abs(u.x) > Math.abs(u.y), l.coords, l.rect), V(i, l.coords));
        return l.eventProps;
      },
      defaults: {
        ratio: "preserve",
        equalDelta: !1,
        modifiers: [],
        enabled: !1
      }
    };
  function gn(t, e, n) {
    var r = t.startCoords,
      i = t.edgeSign;
    e ? n.y = r.y + (n.x - r.x) * i.y : n.x = r.x + (n.y - r.y) * i.x;
  }
  function mn(t, e, n, r) {
    var i = t.startRect,
      o = t.startCoords,
      a = t.ratio,
      s = t.edgeSign;
    if (e) {
      var c = r.width / a;
      n.y = o.y + (c - i.height) * s.y;
    } else {
      var l = r.height * a;
      n.x = o.x + (l - i.width) * s.x;
    }
  }
  var yn = be(vn, "aspectRatio"),
    bn = function bn() {};
  bn._defaults = {};
  var xn = bn;
  function wn(t, e, n) {
    return w.func(t) ? G(t, e.interactable, e.element, [n.x, n.y, e]) : G(t, e.interactable, e.element);
  }
  var En = {
      start: function start(t) {
        var e = t.rect,
          n = t.startOffset,
          r = t.state,
          i = t.interaction,
          o = t.pageCoords,
          a = r.options,
          s = a.elementRect,
          c = V({
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
          }, a.offset || {});
        if (e && s) {
          var l = wn(a.restriction, i, o);
          if (l) {
            var u = l.right - l.left - e.width,
              p = l.bottom - l.top - e.height;
            u < 0 && (c.left += u, c.right += u), p < 0 && (c.top += p, c.bottom += p);
          }
          c.left += n.left - e.width * s.left, c.top += n.top - e.height * s.top, c.right += n.right - e.width * (1 - s.right), c.bottom += n.bottom - e.height * (1 - s.bottom);
        }
        r.offset = c;
      },
      set: function set(t) {
        var e = t.coords,
          n = t.interaction,
          r = t.state,
          i = r.options,
          o = r.offset,
          a = wn(i.restriction, n, e);
        if (a) {
          var s = function (t) {
            return !t || "left" in t && "top" in t || ((t = V({}, t)).left = t.x || 0, t.top = t.y || 0, t.right = t.right || t.left + t.width, t.bottom = t.bottom || t.top + t.height), t;
          }(a);
          e.x = Math.max(Math.min(s.right - o.right, e.x), s.left + o.left), e.y = Math.max(Math.min(s.bottom - o.bottom, e.y), s.top + o.top);
        }
      },
      defaults: {
        restriction: null,
        elementRect: null,
        offset: null,
        endOnly: !1,
        enabled: !1
      }
    },
    Tn = be(En, "restrict"),
    Sn = {
      top: 1 / 0,
      left: 1 / 0,
      bottom: -1 / 0,
      right: -1 / 0
    },
    _n = {
      top: -1 / 0,
      left: -1 / 0,
      bottom: 1 / 0,
      right: 1 / 0
    };
  function Pn(t, e) {
    for (var n = 0, r = ["top", "left", "bottom", "right"]; n < r.length; n++) {
      var i = r[n];
      i in t || (t[i] = e[i]);
    }
    return t;
  }
  var On = {
      noInner: Sn,
      noOuter: _n,
      start: function start(t) {
        var e,
          n = t.interaction,
          r = t.startOffset,
          i = t.state,
          o = i.options;
        o && (e = N(wn(o.offset, n, n.coords.start.page))), e = e || {
          x: 0,
          y: 0
        }, i.offset = {
          top: e.y + r.top,
          left: e.x + r.left,
          bottom: e.y - r.bottom,
          right: e.x - r.right
        };
      },
      set: function set(t) {
        var e = t.coords,
          n = t.edges,
          r = t.interaction,
          i = t.state,
          o = i.offset,
          a = i.options;
        if (n) {
          var s = V({}, e),
            c = wn(a.inner, r, s) || {},
            l = wn(a.outer, r, s) || {};
          Pn(c, Sn), Pn(l, _n), n.top ? e.y = Math.min(Math.max(l.top + o.top, s.y), c.top + o.top) : n.bottom && (e.y = Math.max(Math.min(l.bottom + o.bottom, s.y), c.bottom + o.bottom)), n.left ? e.x = Math.min(Math.max(l.left + o.left, s.x), c.left + o.left) : n.right && (e.x = Math.max(Math.min(l.right + o.right, s.x), c.right + o.right));
        }
      },
      defaults: {
        inner: null,
        outer: null,
        offset: null,
        endOnly: !1,
        enabled: !1
      }
    },
    kn = be(On, "restrictEdges"),
    Dn = V({
      get elementRect() {
        return {
          top: 0,
          left: 0,
          bottom: 1,
          right: 1
        };
      },
      set elementRect(t) {}
    }, En.defaults),
    In = be({
      start: En.start,
      set: En.set,
      defaults: Dn
    }, "restrictRect"),
    Mn = {
      width: -1 / 0,
      height: -1 / 0
    },
    zn = {
      width: 1 / 0,
      height: 1 / 0
    };
  var An = be({
    start: function start(t) {
      return On.start(t);
    },
    set: function set(t) {
      var e = t.interaction,
        n = t.state,
        r = t.rect,
        i = t.edges,
        o = n.options;
      if (i) {
        var a = U(wn(o.min, e, t.coords)) || Mn,
          s = U(wn(o.max, e, t.coords)) || zn;
        n.options = {
          endOnly: o.endOnly,
          inner: V({}, On.noInner),
          outer: V({}, On.noOuter)
        }, i.top ? (n.options.inner.top = r.bottom - a.height, n.options.outer.top = r.bottom - s.height) : i.bottom && (n.options.inner.bottom = r.top + a.height, n.options.outer.bottom = r.top + s.height), i.left ? (n.options.inner.left = r.right - a.width, n.options.outer.left = r.right - s.width) : i.right && (n.options.inner.right = r.left + a.width, n.options.outer.right = r.left + s.width), On.set(t), n.options = o;
      }
    },
    defaults: {
      min: null,
      max: null,
      endOnly: !1,
      enabled: !1
    }
  }, "restrictSize");
  var Rn = {
      start: function start(t) {
        var e,
          n = t.interaction,
          r = t.interactable,
          i = t.element,
          o = t.rect,
          a = t.state,
          s = t.startOffset,
          c = a.options,
          l = c.offsetWithOrigin ? function (t) {
            var e = t.interaction.element,
              n = N(G(t.state.options.origin, null, null, [e])),
              r = n || K(t.interactable, e, t.interaction.prepared.name);
            return r;
          }(t) : {
            x: 0,
            y: 0
          };
        if ("startCoords" === c.offset) e = {
          x: n.coords.start.page.x,
          y: n.coords.start.page.y
        };else {
          var u = G(c.offset, r, i, [n]);
          (e = N(u) || {
            x: 0,
            y: 0
          }).x += l.x, e.y += l.y;
        }
        var p = c.relativePoints;
        a.offsets = o && p && p.length ? p.map(function (t, n) {
          return {
            index: n,
            relativePoint: t,
            x: s.left - o.width * t.x + e.x,
            y: s.top - o.height * t.y + e.y
          };
        }) : [{
          index: 0,
          relativePoint: null,
          x: e.x,
          y: e.y
        }];
      },
      set: function set(t) {
        var e = t.interaction,
          n = t.coords,
          r = t.state,
          i = r.options,
          o = r.offsets,
          a = K(e.interactable, e.element, e.prepared.name),
          s = V({}, n),
          c = [];
        i.offsetWithOrigin || (s.x -= a.x, s.y -= a.y);
        for (var l = 0, u = o; l < u.length; l++) {
          for (var p = u[l], f = s.x - p.x, d = s.y - p.y, h = 0, v = i.targets.length; h < v; h++) {
            var g = i.targets[h],
              m = void 0;
            (m = w.func(g) ? g(f, d, e._proxy, p, h) : g) && c.push({
              x: (w.number(m.x) ? m.x : f) + p.x,
              y: (w.number(m.y) ? m.y : d) + p.y,
              range: w.number(m.range) ? m.range : i.range,
              source: g,
              index: h,
              offset: p
            });
          }
        }
        for (var y = {
            target: null,
            inRange: !1,
            distance: 0,
            range: 0,
            delta: {
              x: 0,
              y: 0
            }
          }, b = 0; b < c.length; b++) {
          var x = c[b],
            E = x.range,
            T = x.x - s.x,
            S = x.y - s.y,
            _ = Q(T, S),
            P = _ <= E;
          E === 1 / 0 && y.inRange && y.range !== 1 / 0 && (P = !1), y.target && !(P ? y.inRange && E !== 1 / 0 ? _ / E < y.distance / y.range : E === 1 / 0 && y.range !== 1 / 0 || _ < y.distance : !y.inRange && _ < y.distance) || (y.target = x, y.distance = _, y.range = E, y.inRange = P, y.delta.x = T, y.delta.y = S);
        }
        return y.inRange && (n.x = y.target.x, n.y = y.target.y), r.closest = y, y;
      },
      defaults: {
        range: 1 / 0,
        targets: null,
        offset: null,
        offsetWithOrigin: !0,
        origin: null,
        relativePoints: null,
        endOnly: !1,
        enabled: !1
      }
    },
    Cn = be(Rn, "snap");
  var jn = {
      start: function start(t) {
        var e = t.state,
          n = t.edges,
          r = e.options;
        if (!n) return null;
        t.state = {
          options: {
            targets: null,
            relativePoints: [{
              x: n.left ? 0 : 1,
              y: n.top ? 0 : 1
            }],
            offset: r.offset || "self",
            origin: {
              x: 0,
              y: 0
            },
            range: r.range
          }
        }, e.targetFields = e.targetFields || [["width", "height"], ["x", "y"]], Rn.start(t), e.offsets = t.state.offsets, t.state = e;
      },
      set: function set(t) {
        var e = t.interaction,
          n = t.state,
          r = t.coords,
          i = n.options,
          o = n.offsets,
          a = {
            x: r.x - o[0].x,
            y: r.y - o[0].y
          };
        n.options = V({}, i), n.options.targets = [];
        for (var s = 0, c = i.targets || []; s < c.length; s++) {
          var l = c[s],
            u = void 0;
          if (u = w.func(l) ? l(a.x, a.y, e) : l) {
            for (var p = 0, f = n.targetFields; p < f.length; p++) {
              var d = f[p],
                h = d[0],
                v = d[1];
              if (h in u || v in u) {
                u.x = u[h], u.y = u[v];
                break;
              }
            }
            n.options.targets.push(u);
          }
        }
        var g = Rn.set(t);
        return n.options = i, g;
      },
      defaults: {
        range: 1 / 0,
        targets: null,
        offset: null,
        endOnly: !1,
        enabled: !1
      }
    },
    Fn = be(jn, "snapSize");
  var Xn = {
      aspectRatio: yn,
      restrictEdges: kn,
      restrict: Tn,
      restrictRect: In,
      restrictSize: An,
      snapEdges: be({
        start: function start(t) {
          var e = t.edges;
          return e ? (t.state.targetFields = t.state.targetFields || [[e.left ? "left" : "right", e.top ? "top" : "bottom"]], jn.start(t)) : null;
        },
        set: jn.set,
        defaults: V(ge(jn.defaults), {
          targets: void 0,
          range: void 0,
          offset: {
            x: 0,
            y: 0
          }
        })
      }, "snapEdges"),
      snap: Cn,
      snapSize: Fn,
      spring: xn,
      avoid: xn,
      transform: xn,
      rubberband: xn
    },
    Yn = {
      id: "modifiers",
      install: function install(t) {
        var e = t.interactStatic;
        for (var n in t.usePlugin(Ee), t.usePlugin(hn), e.modifiers = Xn, Xn) {
          var r = Xn[n],
            i = r._defaults,
            o = r._methods;
          i._methods = o, t.defaults.perAction[n] = i;
        }
      }
    },
    Ln = Yn,
    qn = function (t) {
      s(n, t);
      var e = p(n);
      function n(t, i, o, a, s, c) {
        var l;
        if (r(this, n), tt(u(l = e.call(this, s)), o), o !== i && tt(u(l), i), l.timeStamp = c, l.originalEvent = o, l.type = t, l.pointerId = at(i), l.pointerType = dt(i), l.target = a, l.currentTarget = null, "tap" === t) {
          var p = s.getPointerIndex(i);
          l.dt = l.timeStamp - s.pointers[p].downTime;
          var f = l.timeStamp - s.tapTime;
          l["double"] = !!s.prevTap && "doubletap" !== s.prevTap.type && s.prevTap.target === l.target && f < 500;
        } else "doubletap" === t && (l.dt = i.timeStamp - s.tapTime, l["double"] = !0);
        return l;
      }
      return o(n, [{
        key: "_subtractOrigin",
        value: function value(t) {
          var e = t.x,
            n = t.y;
          return this.pageX -= e, this.pageY -= n, this.clientX -= e, this.clientY -= n, this;
        }
      }, {
        key: "_addOrigin",
        value: function value(t) {
          var e = t.x,
            n = t.y;
          return this.pageX += e, this.pageY += n, this.clientX += e, this.clientY += n, this;
        }
      }, {
        key: "preventDefault",
        value: function value() {
          this.originalEvent.preventDefault();
        }
      }]), n;
    }(vt),
    Bn = {
      id: "pointer-events/base",
      before: ["inertia", "modifiers", "auto-start", "actions"],
      install: function install(t) {
        t.pointerEvents = Bn, t.defaults.actions.pointerEvents = Bn.defaults, V(t.actions.phaselessTypes, Bn.types);
      },
      listeners: {
        "interactions:new": function interactionsNew(t) {
          var e = t.interaction;
          e.prevTap = null, e.tapTime = 0;
        },
        "interactions:update-pointer": function interactionsUpdatePointer(t) {
          var e = t.down,
            n = t.pointerInfo;
          if (!e && n.hold) return;
          n.hold = {
            duration: 1 / 0,
            timeout: null
          };
        },
        "interactions:move": function interactionsMove(t, e) {
          var n = t.interaction,
            r = t.pointer,
            i = t.event,
            o = t.eventTarget;
          t.duplicate || n.pointerIsDown && !n.pointerWasMoved || (n.pointerIsDown && Gn(t), Vn({
            interaction: n,
            pointer: r,
            event: i,
            eventTarget: o,
            type: "move"
          }, e));
        },
        "interactions:down": function interactionsDown(t, e) {
          !function (t, e) {
            for (var n = t.interaction, r = t.pointer, i = t.event, o = t.eventTarget, a = t.pointerIndex, s = n.pointers[a].hold, c = q(o), l = {
                interaction: n,
                pointer: r,
                event: i,
                eventTarget: o,
                type: "hold",
                targets: [],
                path: c,
                node: null
              }, u = 0; u < c.length; u++) {
              var p = c[u];
              l.node = p, e.fire("pointerEvents:collect-targets", l);
            }
            if (!l.targets.length) return;
            for (var f = 1 / 0, d = 0, h = l.targets; d < h.length; d++) {
              var v = h[d].eventable.options.holdDuration;
              v < f && (f = v);
            }
            s.duration = f, s.timeout = setTimeout(function () {
              Vn({
                interaction: n,
                eventTarget: o,
                pointer: r,
                event: i,
                type: "hold"
              }, e);
            }, f);
          }(t, e), Vn(t, e);
        },
        "interactions:up": function interactionsUp(t, e) {
          Gn(t), Vn(t, e), function (t, e) {
            var n = t.interaction,
              r = t.pointer,
              i = t.event,
              o = t.eventTarget;
            n.pointerWasMoved || Vn({
              interaction: n,
              eventTarget: o,
              pointer: r,
              event: i,
              type: "tap"
            }, e);
          }(t, e);
        },
        "interactions:cancel": function interactionsCancel(t, e) {
          Gn(t), Vn(t, e);
        }
      },
      PointerEvent: qn,
      fire: Vn,
      collectEventTargets: Wn,
      defaults: {
        holdDuration: 600,
        ignoreFrom: null,
        allowFrom: null,
        origin: {
          x: 0,
          y: 0
        }
      },
      types: {
        down: !0,
        move: !0,
        up: !0,
        cancel: !0,
        tap: !0,
        doubletap: !0,
        hold: !0
      }
    };
  function Vn(t, e) {
    var n = t.interaction,
      r = t.pointer,
      i = t.event,
      o = t.eventTarget,
      a = t.type,
      s = t.targets,
      c = void 0 === s ? Wn(t, e) : s,
      l = new qn(a, r, i, o, n, e.now());
    e.fire("pointerEvents:new", {
      pointerEvent: l
    });
    for (var u = {
        interaction: n,
        pointer: r,
        event: i,
        eventTarget: o,
        targets: c,
        type: a,
        pointerEvent: l
      }, p = 0; p < c.length; p++) {
      var f = c[p];
      for (var d in f.props || {}) {
        l[d] = f.props[d];
      }
      var h = K(f.eventable, f.node);
      if (l._subtractOrigin(h), l.eventable = f.eventable, l.currentTarget = f.node, f.eventable.fire(l), l._addOrigin(h), l.immediatePropagationStopped || l.propagationStopped && p + 1 < c.length && c[p + 1].node !== l.currentTarget) break;
    }
    if (e.fire("pointerEvents:fired", u), "tap" === a) {
      var v = l["double"] ? Vn({
        interaction: n,
        pointer: r,
        event: i,
        eventTarget: o,
        type: "doubletap"
      }, e) : l;
      n.prevTap = v, n.tapTime = v.timeStamp;
    }
    return l;
  }
  function Wn(t, e) {
    var n = t.interaction,
      r = t.pointer,
      i = t.event,
      o = t.eventTarget,
      a = t.type,
      s = n.getPointerIndex(r),
      c = n.pointers[s];
    if ("tap" === a && (n.pointerWasMoved || !c || c.downTarget !== o)) return [];
    for (var l = q(o), u = {
        interaction: n,
        pointer: r,
        event: i,
        eventTarget: o,
        type: a,
        path: l,
        targets: [],
        node: null
      }, p = 0; p < l.length; p++) {
      var f = l[p];
      u.node = f, e.fire("pointerEvents:collect-targets", u);
    }
    return "hold" === a && (u.targets = u.targets.filter(function (t) {
      var e, r;
      return t.eventable.options.holdDuration === (null == (e = n.pointers[s]) || null == (r = e.hold) ? void 0 : r.duration);
    })), u.targets;
  }
  function Gn(t) {
    var e = t.interaction,
      n = t.pointerIndex,
      r = e.pointers[n].hold;
    r && r.timeout && (clearTimeout(r.timeout), r.timeout = null);
  }
  var Nn = Object.freeze({
    __proto__: null,
    "default": Bn
  });
  function Un(t) {
    var e = t.interaction;
    e.holdIntervalHandle && (clearInterval(e.holdIntervalHandle), e.holdIntervalHandle = null);
  }
  var Hn = {
      id: "pointer-events/holdRepeat",
      install: function install(t) {
        t.usePlugin(Bn);
        var e = t.pointerEvents;
        e.defaults.holdRepeatInterval = 0, e.types.holdrepeat = t.actions.phaselessTypes.holdrepeat = !0;
      },
      listeners: ["move", "up", "cancel", "endall"].reduce(function (t, e) {
        return t["pointerEvents:".concat(e)] = Un, t;
      }, {
        "pointerEvents:new": function pointerEventsNew(t) {
          var e = t.pointerEvent;
          "hold" === e.type && (e.count = (e.count || 0) + 1);
        },
        "pointerEvents:fired": function pointerEventsFired(t, e) {
          var n = t.interaction,
            r = t.pointerEvent,
            i = t.eventTarget,
            o = t.targets;
          if ("hold" === r.type && o.length) {
            var a = o[0].eventable.options.holdRepeatInterval;
            a <= 0 || (n.holdIntervalHandle = setTimeout(function () {
              e.pointerEvents.fire({
                interaction: n,
                eventTarget: i,
                type: "hold",
                pointer: r,
                event: r
              }, e);
            }, a));
          }
        }
      })
    },
    Kn = Hn;
  var $n = {
      id: "pointer-events/interactableTargets",
      install: function install(t) {
        var e = t.Interactable;
        e.prototype.pointerEvents = function (t) {
          return V(this.events.options, t), this;
        };
        var n = e.prototype._backCompatOption;
        e.prototype._backCompatOption = function (t, e) {
          var r = n.call(this, t, e);
          return r === this && (this.events.options[t] = e), r;
        };
      },
      listeners: {
        "pointerEvents:collect-targets": function pointerEventsCollectTargets(t, e) {
          var n = t.targets,
            r = t.node,
            i = t.type,
            o = t.eventTarget;
          e.interactables.forEachMatch(r, function (t) {
            var e = t.events,
              a = e.options;
            e.types[i] && e.types[i].length && t.testIgnoreAllow(a, r, o) && n.push({
              node: r,
              eventable: e,
              props: {
                interactable: t
              }
            });
          });
        },
        "interactable:new": function interactableNew(t) {
          var e = t.interactable;
          e.events.getRect = function (t) {
            return e.getRect(t);
          };
        },
        "interactable:set": function interactableSet(t, e) {
          var n = t.interactable,
            r = t.options;
          V(n.events.options, e.pointerEvents.defaults), V(n.events.options, r.pointerEvents || {});
        }
      }
    },
    Jn = $n,
    Qn = {
      id: "pointer-events",
      install: function install(t) {
        t.usePlugin(Nn), t.usePlugin(Kn), t.usePlugin(Jn);
      }
    },
    Zn = Qn;
  var tr = {
      id: "reflow",
      install: function install(t) {
        var e = t.Interactable;
        t.actions.phases.reflow = !0, e.prototype.reflow = function (e) {
          return function (t, e, n) {
            for (var r = t.getAllElements(), i = n.window.Promise, o = i ? [] : null, a = function a() {
                var a = r[s],
                  c = t.getRect(a);
                if (!c) return 1;
                var l,
                  u = bt(n.interactions.list, function (n) {
                    return n.interacting() && n.interactable === t && n.element === a && n.prepared.name === e.name;
                  });
                if (u) u.move(), o && (l = u._reflowPromise || new i(function (t) {
                  u._reflowResolve = t;
                }));else {
                  var p = U(c),
                    f = function (t) {
                      return {
                        coords: t,
                        get page() {
                          return this.coords.page;
                        },
                        get client() {
                          return this.coords.client;
                        },
                        get timeStamp() {
                          return this.coords.timeStamp;
                        },
                        get pageX() {
                          return this.coords.page.x;
                        },
                        get pageY() {
                          return this.coords.page.y;
                        },
                        get clientX() {
                          return this.coords.client.x;
                        },
                        get clientY() {
                          return this.coords.client.y;
                        },
                        get pointerId() {
                          return this.coords.pointerId;
                        },
                        get target() {
                          return this.coords.target;
                        },
                        get type() {
                          return this.coords.type;
                        },
                        get pointerType() {
                          return this.coords.pointerType;
                        },
                        get buttons() {
                          return this.coords.buttons;
                        },
                        preventDefault: function preventDefault() {}
                      };
                    }({
                      page: {
                        x: p.x,
                        y: p.y
                      },
                      client: {
                        x: p.x,
                        y: p.y
                      },
                      timeStamp: n.now()
                    });
                  l = function (t, e, n, r, i) {
                    var o = t.interactions["new"]({
                        pointerType: "reflow"
                      }),
                      a = {
                        interaction: o,
                        event: i,
                        pointer: i,
                        eventTarget: n,
                        phase: "reflow"
                      };
                    o.interactable = e, o.element = n, o.prevEvent = i, o.updatePointer(i, i, n, !0), nt(o.coords.delta), Ut(o.prepared, r), o._doPhase(a);
                    var s = t.window,
                      c = s.Promise,
                      l = c ? new c(function (t) {
                        o._reflowResolve = t;
                      }) : void 0;
                    o._reflowPromise = l, o.start(r, e, n), o._interacting ? (o.move(a), o.end(i)) : (o.stop(), o._reflowResolve());
                    return o.removePointer(i, i), l;
                  }(n, t, a, e, f);
                }
                o && o.push(l);
              }, s = 0; s < r.length && !a(); s++) {
              ;
            }
            return o && i.all(o).then(function () {
              return t;
            });
          }(this, e, t);
        };
      },
      listeners: {
        "interactions:stop": function interactionsStop(t, e) {
          var n = t.interaction;
          "reflow" === n.pointerType && (n._reflowResolve && n._reflowResolve(), function (t, e) {
            t.splice(t.indexOf(e), 1);
          }(e.interactions.list, n));
        }
      }
    },
    er = tr;
  if (un.use(he), un.use(Ce), un.use(Zn), un.use(qe), un.use(Ln), un.use(pe), un.use(Xt), un.use(Gt), un.use(er), un["default"] = un, "object" === ( false ? undefined : n(module)) && module) try {
    module.exports = un;
  } catch (t) {}
  return un["default"] = un, un;
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module)))

/***/ }),

/***/ "./node_modules/liquid-ajax-cart/liquid-ajax-cart.js":
/*!***********************************************************!*\
  !*** ./node_modules/liquid-ajax-cart/liquid-ajax-cart.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var t = "liquid-ajax-cart",
  e = "data-ajax-cart",
  n = "ajax-cart",
  o = "js-ajax-cart",
  i = "".concat(t, ":init"),
  r = "add",
  a = "change",
  s = "update",
  u = "clear",
  c = "get",
  l = "".concat(t, ":queue-start"),
  d = "".concat(t, ":queue-start-internal"),
  h = "".concat(t, ":queue-empty-internal"),
  f = "".concat(t, ":queue-end-internal"),
  p = "".concat(t, ":queue-end"),
  m = "".concat(t, ":request-start-internal"),
  y = "".concat(t, ":request-start"),
  v = "".concat(t, ":request-end-internal"),
  b = "".concat(t, ":request-end"),
  q = [];
var g = !1;
function $(t) {
  var e;
  (null === (e = t.options) || void 0 === e ? void 0 : e.important) && 0 !== q.length ? q[0].push(t) : 1 === q.push([t]) && (A(!0), w());
}
function w() {
  if (1 === q.length && 0 === q[0].length) {
    var _t2 = new CustomEvent(h);
    document.dispatchEvent(_t2);
  }
  if (0 === q.length) return void A(!1);
  if (0 === q[0].length) return q.shift(), void w();
  var _q$0$ = q[0][0],
    t = _q$0$.requestType,
    e = _q$0$.body,
    n = _q$0$.options;
  !function (t, e, n, o) {
    var i = k(t);
    var a;
    t !== c && (a = e || {});
    var s = t === c ? "GET" : "POST",
      u = n.info || {},
      l = {
        requestType: t,
        endpoint: i,
        requestBody: a,
        info: u
      },
      d = [],
      h = new CustomEvent(m, {
        detail: {
          requestState: {
            requestType: t,
            endpoint: i,
            info: u,
            requestBody: a
          }
        }
      });
    document.dispatchEvent(h);
    var f = new CustomEvent(y, {
      detail: {
        requestState: {
          requestType: t,
          endpoint: i,
          info: u,
          requestBody: a
        }
      }
    });
    if (document.dispatchEvent(f), u.cancel) return l.responseData = null, void E(n, o, l);
    if (void 0 !== a) {
      var _e;
      if (a instanceof FormData || a instanceof URLSearchParams ? a.has("sections") && (_e = a.get("sections").toString()) : _e = a.sections, "string" == typeof _e || _e instanceof String || Array.isArray(_e)) {
        var _n = [];
        if (Array.isArray(_e) ? _n.push.apply(_n, _toConsumableArray(_e)) : _n.push.apply(_n, _toConsumableArray(_e.split(","))), r === t && d.push.apply(d, _toConsumableArray(_n.slice(0, 5))), _n.length > 5) {
          d.push.apply(d, _toConsumableArray(_n.slice(5)));
          var _t3 = _n.slice(0, 5).join(",");
          a instanceof FormData || a instanceof URLSearchParams ? a.set("sections", _t3) : a.sections = _t3;
        }
      } else null != _e && console.error("Liquid Ajax Cart: \"sections\" parameter in a Cart Ajax API request must be a string or an array. Now it is ".concat(_e));
    }
    var p = {
      method: s
    };
    t !== c && (a instanceof FormData || a instanceof URLSearchParams ? (p.body = a, p.headers = {
      "x-requested-with": "XMLHttpRequest"
    }) : (p.body = JSON.stringify(a), p.headers = {
      "Content-Type": "application/json"
    })), fetch(i, p).then(function (t) {
      return t.json().then(function (e) {
        return {
          ok: t.ok,
          status: t.status,
          body: e
        };
      });
    }).then(function (t) {
      return l.responseData = t, !l.responseData.ok || l.responseData.body.token && 0 === d.length ? l : L(d).then(function (t) {
        return l.extraResponseData = t, l;
      });
    })["catch"](function (t) {
      console.error("Liquid Ajax Cart: Error while performing cart Ajax request"), console.error(t), l.responseData = null, l.fetchError = t;
    })["finally"](function () {
      E(n, o, l);
    });
  }(t, e, n, function () {
    q[0].shift(), w();
  });
}
function A(t) {
  g = t;
  var e = new CustomEvent(g ? d : f);
  document.dispatchEvent(e);
  var n = new CustomEvent(g ? l : p);
  document.dispatchEvent(n);
}
function E(t, e, n) {
  if ("firstCallback" in t) try {
    t.firstCallback(n);
  } catch (t) {
    console.error('Liquid Ajax Cart: Error in request "firstCallback" function'), console.error(t);
  }
  var o = {
      requestState: n
    },
    i = new CustomEvent(v, {
      detail: o
    });
  document.dispatchEvent(i);
  var r = new CustomEvent(b, {
    detail: o
  });
  if (document.dispatchEvent(r), "lastCallback" in t) try {
    t.lastCallback(n);
  } catch (t) {
    console.error('Liquid Ajax Cart: Error in request "lastCallback" function'), console.error(t);
  }
  e();
}
function L() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var e = {};
  return t.length > 0 && (e.sections = t.slice(0, 5).join(",")), fetch(k(s), {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(e)
  }).then(function (e) {
    return e.json().then(function (n) {
      var o = {
        ok: e.ok,
        status: e.status,
        body: n
      };
      return t.length < 6 ? o : L(t.slice(5)).then(function (t) {
        var e;
        return t.ok && (null === (e = t.body) || void 0 === e ? void 0 : e.sections) && "object" == _typeof(t.body.sections) && ("sections" in o.body || (o.body.sections = {}), o.body.sections = Object.assign(Object.assign({}, o.body.sections), t.body.sections)), o;
      });
    });
  });
}
function S() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  $({
    requestType: c,
    body: void 0,
    options: t
  });
}
function j() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $({
    requestType: r,
    body: t,
    options: e
  });
}
function C() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $({
    requestType: a,
    body: t,
    options: e
  });
}
function x() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $({
    requestType: s,
    body: t,
    options: e
  });
}
function T() {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  $({
    requestType: u,
    body: t,
    options: e
  });
}
function k(t) {
  var e, n, o, i, l, d, h, f, p, m;
  switch (t) {
    case r:
      return "".concat((null === (n = null === (e = window.Shopify) || void 0 === e ? void 0 : e.routes) || void 0 === n ? void 0 : n.root) || "/", "cart/add.js");
    case a:
      return "".concat((null === (i = null === (o = window.Shopify) || void 0 === o ? void 0 : o.routes) || void 0 === i ? void 0 : i.root) || "/", "cart/change.js");
    case c:
      return "".concat((null === (d = null === (l = window.Shopify) || void 0 === l ? void 0 : l.routes) || void 0 === d ? void 0 : d.root) || "/", "cart.js");
    case u:
      return "".concat((null === (f = null === (h = window.Shopify) || void 0 === h ? void 0 : h.routes) || void 0 === f ? void 0 : f.root) || "/", "cart/clear.js");
    case s:
      return "".concat((null === (m = null === (p = window.Shopify) || void 0 === p ? void 0 : p.routes) || void 0 === m ? void 0 : m.root) || "/", "cart/update.js");
    default:
      return;
  }
}
function D() {
  return g;
}
var _ = "".concat(e, "-initial-state");
var N,
  O = null;
function B() {
  return {
    cart: O,
    previousCart: N
  };
}
var M = "".concat(e, "-bind");
function R() {
  B().cart && document.querySelectorAll("[".concat(M, "]")).forEach(function (t) {
    var e = t.getAttribute(M);
    t.textContent = function (t) {
      var e = Z.binderFormatters,
        _t$split = t.split("|"),
        _t$split2 = _toArray(_t$split),
        n = _t$split2[0],
        o = _t$split2.slice(1);
      var i = F(n, B().cart);
      return o.forEach(function (t) {
        var n = t.trim();
        "" !== n && ("object" == _typeof(e) && n in e ? i = e[n](i) : n in H ? i = H[n](i) : console.warn("Liquid Ajax Cart: the \"".concat(n, "\" formatter is not found")));
      }), "string" == typeof i || i instanceof String || "number" == typeof i || i instanceof Number ? i.toString() : (console.error("Liquid Ajax Cart: the calculated value for the ".concat(M, "=\"").concat(t, "\" element must be string or number. But the value is"), i), "");
    }(e);
  });
}
function F(t, e) {
  var n = t.split("."),
    o = n.shift().trim();
  return "" !== o && o in e && n.length > 0 ? F(n.join("."), e[o]) : e[o];
}
var H = {
  money_with_currency: function money_with_currency(t) {
    var e;
    var n = B();
    if ("number" != typeof t && !(t instanceof Number)) return console.error("Liquid Ajax Cart: the 'money_with_currency' formatter is not applied because the value is not a number. The value is ", t), t;
    var o = t / 100;
    return "Intl" in window && (null === (e = window.Shopify) || void 0 === e ? void 0 : e.locale) ? Intl.NumberFormat(window.Shopify.locale, {
      style: "currency",
      currency: n.cart.currency
    }).format(o) : "".concat(o.toFixed(2), " ").concat(n.cart.currency);
  }
};
var U,
  P = !1;
function I() {
  var t = Z.mutations;
  Array.isArray(t) || console.error('Liquid Ajax Cart: the "mutations" settings parameter must be an array'), 0 !== t.length && (P = !1, U = -1, J());
}
function J() {
  var t = Z.mutations;
  if (U++, U >= t.length) return;
  var e = [];
  try {
    var _n2 = t[U]();
    _n2 && (e = (null == _n2 ? void 0 : _n2.requests) || []);
  } catch (t) {
    console.error("Liquid Ajax Cart: Error in the \"mutation\" function with index ".concat(U)), console.error(t);
  }
  Array.isArray(e) ? V(e) : J();
}
function V(t) {
  var e = t.shift();
  if (e) {
    if (e.type && [r, a, s, u, c].includes(e.type)) return void $({
      requestType: e.type,
      body: e.body,
      options: {
        info: {
          initiator: "mutation"
        },
        important: !0,
        lastCallback: function lastCallback(e) {
          V(t);
        }
      }
    });
    console.error("Liquid Ajax Cart: wrong request type in the mutation with index ".concat(U));
  }
  t.length > 0 ? V(t) : J();
}
var Z = {
    binderFormatters: {},
    requestErrorText: "There was an error while updating your cart. Please try again.",
    updateOnWindowFocus: !0,
    quantityTagAllowZero: !1,
    quantityTagDebounce: 300,
    mutations: []
  },
  W = "".concat(e, "-section"),
  z = "".concat(e, "-static-element"),
  G = "".concat(e, "-section-scroll"),
  K = "shopify-section-",
  X = "".concat(n, "-product-form"),
  Q = "processing";
var Y = /*#__PURE__*/function (_HTMLElement) {
  _inherits(Y, _HTMLElement);
  var _super = _createSuper(Y);
  function Y() {
    _classCallCheck(this, Y);
    return _super.apply(this, arguments);
  }
  _createClass(Y, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var t, e;
      var n = this,
        o = this.querySelectorAll("form");
      if (1 !== o.length) return void console.error("Liquid Ajax Cart: \"".concat(X, "\" element must have one \"form\" element as a child, ").concat(o.length, " found"), n);
      var i = o[0];
      new URL(i.action).pathname === "".concat((null === (e = null === (t = window.Shopify) || void 0 === t ? void 0 : t.routes) || void 0 === e ? void 0 : e.root) || "/", "cart/add") ? i.addEventListener("submit", function (t) {
        if (!n.hasAttribute(Q)) {
          var _t4 = new FormData(i);
          n.setAttribute(Q, ""), j(_t4, {
            lastCallback: function lastCallback() {
              n.removeAttribute(Q);
            },
            info: {
              initiator: n
            }
          });
        }
        t.preventDefault();
      }) : console.error("Liquid Ajax Cart: \"".concat(X, "\" element's form \"action\" attribute value isn't a product form action URL"), i, n);
    }
  }]);
  return Y;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
var tt, et, nt, ot, it, rt, at, st;
var ut = "".concat((null === (et = null === (tt = window.Shopify) || void 0 === tt ? void 0 : tt.routes) || void 0 === et ? void 0 : et.root) || "/", "cart/change"),
  ct = "".concat((null === (ot = null === (nt = window.Shopify) || void 0 === nt ? void 0 : nt.routes) || void 0 === ot ? void 0 : ot.root) || "/", "cart/add"),
  lt = "".concat((null === (rt = null === (it = window.Shopify) || void 0 === it ? void 0 : it.routes) || void 0 === rt ? void 0 : rt.root) || "/", "cart/clear"),
  dt = "".concat((null === (st = null === (at = window.Shopify) || void 0 === at ? void 0 : at.routes) || void 0 === st ? void 0 : st.root) || "/", "cart/update"),
  ht = "".concat(e, "-request-button");
function ft(t, e) {
  var n;
  var o = [ut, ct, lt, dt];
  if (!t.hasAttribute(ht)) return;
  var i = t.getAttribute(ht);
  if (i) {
    var _t5;
    try {
      if (_t5 = new URL(i, window.location.origin), !o.includes(_t5.pathname)) throw "URL should be one of the following: ".concat(ut, ", ").concat(ct, ", ").concat(dt, ", ").concat(lt);
      n = _t5;
    } catch (t) {
      console.error("Liquid Ajax Cart: ".concat(ht, " contains an invalid URL as a parameter."), t);
    }
  } else if (t instanceof HTMLAnchorElement && t.hasAttribute("href")) {
    var _e2 = new URL(t.href);
    o.includes(_e2.pathname) ? n = _e2 : t.hasAttribute(ht) && console.error("Liquid Ajax Cart: a link with the ".concat(ht, " contains an invalid href URL."), "URL should be one of the following: ".concat(ut, ", ").concat(ct, ", ").concat(dt, ", ").concat(lt));
  }
  if (void 0 === n) return void console.error("Liquid Ajax Cart: a ".concat(ht, " element doesn't have a valid URL"));
  if (e && e.preventDefault(), D()) return;
  var r = new FormData();
  switch (n.searchParams.forEach(function (t, e) {
    r.append(e, t);
  }), n.pathname) {
    case ct:
      j(r, {
        info: {
          initiator: t
        }
      });
      break;
    case ut:
      C(r, {
        info: {
          initiator: t
        }
      });
      break;
    case dt:
      x(r, {
        info: {
          initiator: t
        }
      });
      break;
    case lt:
      T({}, {
        info: {
          initiator: t
        }
      });
  }
}
function pt(t, e) {
  var n, o;
  return t.length > 3 ? (n = e.cart.items.find(function (e) {
    return e.key === t;
  }), o = "id") : (n = e.cart.items[Number(t) - 1], o = "line"), void 0 === n && (n = null, console.error("Liquid Ajax Cart: line item with ".concat(o, "=\"").concat(t, "\" not found"))), [n, o];
}
var mt = "".concat(e, "-quantity-input");
function yt(t) {
  return !!t.hasAttribute(mt) && (t instanceof HTMLInputElement && ("text" === t.type || "number" === t.type) || (console.error("Liquid Ajax Cart: the ".concat(mt, " attribute supports \"input\" elements only with the \"text\" and the \"number\" types")), !1));
}
function vt() {
  document.querySelectorAll("input[".concat(mt, "]")).forEach(function (t) {
    if (!yt(t)) return;
    if (D()) return void (t.disabled = !0);
    var e = B(),
      n = t.getAttribute(mt).trim(),
      _pt = pt(n, e),
      _pt2 = _slicedToArray(_pt, 1),
      o = _pt2[0];
    o ? t.value = o.quantity.toString() : null === o && (t.value = "0"), t.disabled = !1;
  });
}
function bt(t, e) {
  if (!yt(t)) return;
  if (e && e.preventDefault(), D()) return;
  var n = Number(t.value.trim());
  var o = t.getAttribute(mt).trim();
  if (isNaN(n)) return void console.error("Liquid Ajax Cart: input value of a ".concat(mt, " must be an Integer number"));
  if (n < 1 && (n = 0), !o) return void console.error("Liquid Ajax Cart: attribute value of a ".concat(mt, " must be an item key or an item index"));
  var i = o.length > 3 ? "id" : "line",
    r = new FormData();
  r.set(i, o), r.set("quantity", n.toString()), C(r, {
    info: {
      initiator: t
    }
  }), t.blur();
}
var qt = "".concat(e, "-property-input");
function gt(t) {
  var e = t.getAttribute(qt),
    n = t.getAttribute("name");
  console.error("Liquid Ajax Cart: the element [".concat(qt, "=\"").concat(e, "\"]").concat(n ? "[name=\"".concat(n, "\"]") : "", " has wrong attributes."));
}
function $t(t) {
  return !!t.hasAttribute(qt) && !!(t instanceof HTMLInputElement && "hidden" !== t.type || t instanceof HTMLTextAreaElement || t instanceof HTMLSelectElement);
}
function wt(t) {
  var e = {
    objectCode: void 0,
    propertyName: void 0,
    attributeValue: void 0
  };
  if (!t.hasAttribute(qt)) return e;
  var n = t.getAttribute(qt).trim();
  if (!n) {
    var _e3 = t.getAttribute("name").trim();
    _e3 && (n = _e3);
  }
  if (!n) return gt(t), e;
  if (e.attributeValue = n, "note" === n) return e.objectCode = "note", e;
  var _n$trim$split = n.trim().split("["),
    _n$trim$split2 = _toArray(_n$trim$split),
    o = _n$trim$split2[0],
    i = _n$trim$split2.slice(1);
  return !i || 1 !== i.length || i[0].length < 2 || i[0].indexOf("]") !== i[0].length - 1 ? (gt(t), e) : (e.objectCode = o, e.propertyName = i[0].replace("]", ""), e);
}
function At() {
  document.querySelectorAll("[".concat(qt, "]")).forEach(function (t) {
    if (!$t(t)) return;
    if (D()) return void (t.disabled = !0);
    var _wt = wt(t),
      e = _wt.objectCode,
      n = _wt.propertyName,
      o = _wt.attributeValue;
    if (!e) return;
    var i = B();
    var r,
      a = !1;
    if ("note" === e) r = i.cart.note;else if ("attributes" === e) r = i.cart.attributes[n];else {
      var _pt3 = pt(e, i),
        _pt4 = _slicedToArray(_pt3, 2),
        _t6 = _pt4[0],
        _s2 = _pt4[1];
      _t6 && (r = _t6.properties[n]), null === _t6 && (console.error("Liquid Ajax Cart: line item with ".concat(_s2, "=\"").concat(e, "\" was not found when the [").concat(qt, "] element with \"").concat(o, "\" value tried to get updated from the State")), a = !0);
    }
    t instanceof HTMLInputElement && ("checkbox" === t.type || "radio" === t.type) ? t.checked = t.value === r : ("string" == typeof r || r instanceof String || "number" == typeof r || r instanceof Number || (Array.isArray(r) || r instanceof Object ? (r = JSON.stringify(r), console.warn("Liquid Ajax Cart: the ".concat(qt, " with the \"").concat(o, "\" value is bound to the ").concat(n, " ").concat("attributes" === e ? "attribute" : "property", " that is not string or number: ").concat(r))) : r = ""), t.value = r), a || (t.disabled = !1);
  });
}
function Et(t, e) {
  if (!$t(t)) return;
  e && e.preventDefault(), t.blur();
  var n = B();
  if (D()) return;
  var _wt2 = wt(t),
    o = _wt2.objectCode,
    i = _wt2.propertyName,
    r = _wt2.attributeValue;
  if (!o) return;
  var a = t.value;
  if (t instanceof HTMLInputElement && "checkbox" === t.type && !t.checked) {
    var _t7 = document.querySelector("input[type=\"hidden\"][".concat(qt, "=\"").concat(r, "\"]"));
    _t7 || "note" !== o && "attributes" !== o || (_t7 = document.querySelector("input[type=\"hidden\"][".concat(qt, "][name=\"").concat(r, "\"]"))), a = _t7 ? _t7.value : "";
  }
  if ("note" === o) {
    var _e4 = new FormData();
    _e4.set("note", a), x(_e4, {
      info: {
        initiator: t
      }
    });
  } else if ("attributes" === o) {
    var _e5 = new FormData();
    _e5.set("attributes[".concat(i, "]"), a), x(_e5, {
      info: {
        initiator: t
      }
    });
  } else {
    var _pt5 = pt(o, n),
      _pt6 = _slicedToArray(_pt5, 2),
      _e6 = _pt6[0],
      _s3 = _pt6[1];
    if (null === _e6 && console.error("Liquid Ajax Cart: line item with ".concat(_s3, "=\"").concat(o, "\" was not found when the [").concat(qt, "] element with \"").concat(r, "\" value tried to update the cart")), !_e6) return;
    var _u = Object.assign({}, _e6.properties);
    _u[i] = a;
    var _c = new FormData();
    var _l = _c;
    _c.set(_s3, o), _c.set("quantity", _e6.quantity.toString());
    for (var _t8 in _u) {
      var _l2;
      var _n3 = _u[_t8];
      "string" == typeof _n3 || _n3 instanceof String ? _c.set("properties[".concat(_t8, "]"), _u[_t8]) : _l = (_l2 = {}, _defineProperty(_l2, _s3, o), _defineProperty(_l2, "quantity", _e6.quantity), _defineProperty(_l2, "properties", _u), _l2);
    }
    C(_l, {
      info: {
        initiator: t
      }
    });
  }
}
var Lt = "".concat(n, "-quantity"),
  St = "".concat(e, "-quantity-plus"),
  jt = "".concat(e, "-quantity-minus");
function Ct() {
  customElements.define(X, Y), document.addEventListener("click", function (t) {
    for (var _e7 = t.target; _e7 && _e7 != document.documentElement; _e7 = _e7.parentElement) {
      ft(_e7, t);
    }
  }, !1), document.addEventListener("change", function (t) {
    Et(t.target, t);
  }, !1), document.addEventListener("keydown", function (t) {
    var e = t.target;
    "Enter" === t.key && (e instanceof HTMLTextAreaElement && !t.ctrlKey || Et(e, t)), "Escape" === t.key && function (t) {
      if (!$t(t)) return;
      if (!(t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement)) return;
      if (t instanceof HTMLInputElement && ("checkbox" === t.type || "radio" === t.type)) return;
      var e = B(),
        _wt3 = wt(t),
        n = _wt3.objectCode,
        o = _wt3.propertyName;
      if (!n) return;
      var i;
      if ("note" === n) i = e.cart.note;else if ("attributes" === n) i = e.cart.attributes[o];else {
        var _pt7 = pt(n, e),
          _pt8 = _slicedToArray(_pt7, 1),
          _t9 = _pt8[0];
        _t9 && (i = _t9.properties[o]);
      }
      void 0 !== i && (i || "string" == typeof i || i instanceof String || (i = ""), t.value = String(i)), t.blur();
    }(e);
  }, !1), document.addEventListener(d, At), document.addEventListener(v, At), document.addEventListener(f, At), At(), document.addEventListener("change", function (t) {
    bt(t.target, t);
  }, !1), document.addEventListener("keydown", function (t) {
    "Enter" === t.key && bt(t.target, t), "Escape" === t.key && function (t) {
      if (!yt(t)) return;
      var e = t.getAttribute(mt).trim();
      var n;
      var o = B();
      if (e.length > 3) n = o.cart.items.find(function (t) {
        return t.key === e;
      });else {
        var _t10 = Number(e) - 1;
        n = o.cart.items[_t10];
      }
      n && (t.value = n.quantity.toString()), t.blur();
    }(t.target);
  }, !1), document.addEventListener(d, vt), document.addEventListener(v, vt), document.addEventListener(f, vt), vt(), customElements.define(Lt, /*#__PURE__*/function (_HTMLElement2) {
    _inherits(_class, _HTMLElement2);
    var _super2 = _createSuper(_class);
    function _class() {
      var _this;
      _classCallCheck(this, _class);
      _this = _super2.apply(this, arguments), _this._timer = void 0;
      return _this;
    }
    _createClass(_class, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        var _this2 = this;
        var t = this.querySelectorAll("input");
        1 === t.length ? (this._$input = t[0], this._$input.hasAttribute(mt) ? (this._$buttons = Array.from(this.querySelectorAll("[".concat(jt, "], [").concat(St, "]"))), this._$input.addEventListener("change", this._updateDOM.bind(this)), document.addEventListener(d, this._updateDOM.bind(this)), document.addEventListener(v, this._updateDOM.bind(this)), document.addEventListener(f, this._updateDOM.bind(this)), this._updateDOM(), this._$buttons.forEach(function (t) {
          t.addEventListener("click", function (e) {
            var n = Z.quantityTagAllowZero,
              o = !0 === n ? 0 : 1;
            if (!D()) {
              var _e8 = Number(_this2._$input.value);
              if (isNaN(_e8)) return void console.error("Liquid Ajax Cart: \"".concat(Lt, "\" element's input value isn't a number"), _this2._$input, _this2);
              var _n4 = _e8;
              _n4 = t.hasAttribute(St) ? _n4 + 1 : _n4 - 1, _n4 < o && (_n4 = o), _n4 !== _e8 && (_this2._$input.value = _n4.toString(), _this2._runAwaiting(), _this2._updateDOM());
            }
            e.preventDefault();
          }), t.addEventListener("focusout", function (e) {
            e.relatedTarget && t.contains(e.relatedTarget) || void 0 !== _this2._timer && _this2._runRequest();
          });
        })) : console.error("Liquid Ajax Cart: \"".concat(Lt, "\" element's input must have the \"").concat(mt, "\" attribute"), this._$input, this)) : console.error("Liquid Ajax Cart: \"".concat(Lt, "\" element must have one \"input\" element as a child, ").concat(t.length, " found"), this);
      }
    }, {
      key: "_runAwaiting",
      value: function _runAwaiting() {
        var _this3 = this;
        var t = Z.quantityTagDebounce;
        void 0 !== this._timer && clearTimeout(this._timer), t > 0 ? this._timer = setTimeout(function () {
          _this3._runRequest();
        }, Number(t)) : this._runRequest();
      }
    }, {
      key: "_runRequest",
      value: function _runRequest() {
        void 0 !== this._timer && clearTimeout(this._timer), this._timer = void 0, D() || this._$input.dispatchEvent(new Event("change", {
          bubbles: !0
        }));
      }
    }, {
      key: "_updateDOM",
      value: function _updateDOM() {
        var _this4 = this;
        this._$buttons.forEach(function (t) {
          var e = D() || t.hasAttribute(jt) && !Z.quantityTagAllowZero && "1" === _this4._$input.value;
          e ? t.setAttribute("aria-disabled", "true") : t.removeAttribute("aria-disabled"), t instanceof HTMLButtonElement && t.toggleAttribute("disabled", e);
        });
      }
    }]);
    return _class;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
}
var xt = "".concat(e, "-errors"),
  Tt = "".concat(o, "-init"),
  kt = "".concat(o, "-processing"),
  Dt = "".concat(o, "-empty"),
  _t = "".concat(o, "-not-empty");
function Nt() {
  var t = document.querySelector("html"),
    e = B();
  t.classList.toggle(Tt, null !== e.cart), t.classList.toggle(kt, D()), t.classList.toggle(Dt, 0 === e.cart.item_count), t.classList.toggle(_t, e.cart.item_count > 0);
}
var Ot = !1;
if (!("liquidAjaxCart" in window)) {
  var Bt = function Bt(t, e) {
    Object.defineProperty(window.liquidAjaxCart, t, {
      get: e,
      set: function set() {
        throw new Error("Liquid Ajax Cart: the \"".concat(t, "\" is a read-only property"));
      },
      enumerable: !0
    });
  };
  window.liquidAjaxCart = {
    conf: function conf(t, e) {
      t in Z ? (Z[t] = e, window.liquidAjaxCart.init && ("binderFormatters" === t && R(), "mutations" === t && I())) : console.error("Liquid Ajax Cart: unknown configuration parameter \"".concat(t, "\""));
    }
  }, Bt("init", function () {
    return Ot;
  }), document.addEventListener(m, function (t) {
    var e = t.detail.requestState;
    if (void 0 !== e.requestBody) {
      var _t11 = [];
      if (document.querySelectorAll("[".concat(W, "]")).forEach(function (e) {
        var n = e.closest("[id^=\"".concat(K, "\"]"));
        if (n) {
          var _e9 = n.id.replace(K, "");
          -1 === _t11.indexOf(_e9) && _t11.push(_e9);
        } else console.error("Liquid Ajax Cart: there is a ".concat(W, " element that is not inside a Shopify section. All the ").concat(W, " elements must be inside Shopify sections."));
      }), _t11.length) {
        var _n5,
          _o = _t11.join(",");
        e.requestBody instanceof FormData || e.requestBody instanceof URLSearchParams ? e.requestBody.has("sections") && (_n5 = e.requestBody.get("sections").toString()) : _n5 = e.requestBody.sections, (("string" == typeof _n5 || _n5 instanceof String) && "" !== _n5 || _n5 && Array.isArray(_n5) && _n5.length > 0) && (_o = "".concat(_n5.toString(), ",").concat(_o)), e.requestBody instanceof FormData || e.requestBody instanceof URLSearchParams ? e.requestBody.set("sections", _o) : e.requestBody.sections = _o;
      }
    }
  }), document.addEventListener(v, function (t) {
    var e, n, o;
    t.detail.sections = [];
    var i = t.detail.requestState,
      a = new DOMParser(),
      s = [];
    if ((null === (e = i.responseData) || void 0 === e ? void 0 : e.ok) && "sections" in i.responseData.body) {
      (function () {
        var t = i.responseData.body.sections;
        (null === (o = null === (n = i.extraResponseData) || void 0 === n ? void 0 : n.body) || void 0 === o ? void 0 : o.sections) && (t = Object.assign(Object.assign({}, t), i.extraResponseData.body.sections));
        var _loop = function _loop(_e10) {
          t[_e10] ? document.querySelectorAll("#shopify-section-".concat(_e10)).forEach(function (n) {
            var o = [];
            var u = "__noId__",
              c = {};
            n.querySelectorAll(" [".concat(G, "] ")).forEach(function (t) {
              var e = t.getAttribute(G).toString().trim();
              "" === e && (e = u), e in c || (c[e] = []), c[e].push({
                scroll: t.scrollTop,
                height: t.scrollHeight
              });
            });
            var l = {},
              d = n.querySelectorAll("[".concat(z, "]"));
            d && d.forEach(function (t) {
              var e = t.getAttribute(z).toString().trim();
              "" === e && (e = u), e in l || (l[e] = []), l[e].push(t);
            });
            var h = n.querySelectorAll("[".concat(W, "]"));
            if (h) {
              var _i2 = a.parseFromString(t[_e10], "text/html");
              _i2.querySelectorAll('img[loading="lazy"]').forEach(function (t) {
                t.removeAttribute("loading");
              });
              var _loop2 = function _loop2(_t12) {
                _i2.querySelectorAll(" [".concat(z, "=\"").concat(_t12.replace(u, ""), "\"] ")).forEach(function (e, n) {
                  n + 1 <= l[_t12].length && (e.before(l[_t12][n]), e.parentElement.removeChild(e));
                });
              };
              for (var _t12 in l) {
                _loop2(_t12);
              }
              var _r = _i2.querySelectorAll("[".concat(W, "]"));
              if (h.length !== _r.length) {
                console.error("Liquid Ajax Cart: the received HTML for the \"".concat(_e10, "\" section has a different quantity of the \"").concat(W, "\" containers. The section will be updated completely."));
                var _t13 = _i2.querySelector("#".concat(K).concat(_e10));
                if (_t13) {
                  for (n.innerHTML = ""; _t13.childNodes.length;) {
                    n.appendChild(_t13.firstChild);
                  }
                  o.push(n);
                }
              } else h.forEach(function (t, e) {
                t.before(_r[e]), t.parentElement.removeChild(t), o.push(_r[e]);
              });
            }
            var _loop3 = function _loop3(_t14) {
              n.querySelectorAll(" [".concat(G, "=\"").concat(_t14.replace(u, ""), "\"] ")).forEach(function (e, n) {
                n + 1 <= c[_t14].length && (i.requestType !== r || c[_t14][n].height >= e.scrollHeight) && (e.scrollTop = c[_t14][n].scroll);
              });
            };
            for (var _t14 in c) {
              _loop3(_t14);
            }
            o.length > 0 && s.push({
              id: _e10,
              elements: o
            });
          }) : console.error("Liquid Ajax Cart: the HTML for the \"".concat(_e10, "\" section was requested but the response is ").concat(t[_e10]));
        };
        for (var _e10 in t) {
          _loop(_e10);
        }
      })();
    }
    s.length > 0 && (t.detail.sections = s);
  }), function () {
    var t;
    document.addEventListener(m, function (e) {
      var n = e.detail.requestState;
      t = void 0, n.requestType === r ? t = function (t) {
        var e;
        var n;
        var o = null === (e = t.info) || void 0 === e ? void 0 : e.initiator;
        return o instanceof Y && (n = o.querySelectorAll("[".concat(xt, "=\"form\"]"))), n;
      }(n) : n.requestType === a && (t = function (t) {
        var e;
        var n;
        var o = B();
        var i, r;
        if (t.requestBody instanceof FormData || t.requestBody instanceof URLSearchParams ? (t.requestBody.has("line") && (r = t.requestBody.get("line").toString()), t.requestBody.has("id") && (i = t.requestBody.get("id").toString())) : ("line" in t.requestBody && (r = String(t.requestBody.line)), "id" in t.requestBody && (i = String(t.requestBody.id))), r) {
          var _t15 = Number(r);
          if (_t15 > 0) {
            var _n6 = _t15 - 1;
            i = null === (e = o.cart.items[_n6]) || void 0 === e ? void 0 : e.key;
          }
        }
        return i && (n = i.indexOf(":") > -1 ? document.querySelectorAll("[".concat(xt, "=\"").concat(i, "\"]")) : document.querySelectorAll(o.cart.items.reduce(function (t, e) {
          return e.key !== i && e.id !== Number(i) || t.push("[".concat(xt, "=\"").concat(e.key, "\"]")), t;
        }, []).join(","))), n;
      }(n)), t && t.length > 0 && t.forEach(function (t) {
        t.textContent = "";
      });
    }), document.addEventListener(v, function (e) {
      var n = e.detail.requestState;
      if (n.info.cancel) return;
      if (!t || 0 === t.length) return;
      var o = function (t) {
        var e, n, o, i, r;
        var a = Z.requestErrorText;
        return (null === (e = t.responseData) || void 0 === e ? void 0 : e.ok) ? "" : (null === (o = null === (n = t.responseData) || void 0 === n ? void 0 : n.body) || void 0 === o ? void 0 : o.description) || (null === (r = null === (i = t.responseData) || void 0 === i ? void 0 : i.body) || void 0 === r ? void 0 : r.message) || a;
      }(n);
      o && t.forEach(function (t) {
        t.textContent = o;
      });
    });
  }(), document.addEventListener(i, I), document.addEventListener(h, function () {
    P && I();
  }), document.addEventListener(m, function (t) {
    var e = t.detail.requestState;
    "mutation" !== e.info.initiator && (P = !0);
  }), function () {
    document.addEventListener(v, function (t) {
      var e, n;
      var o = t.detail.requestState;
      var i;
      (null === (e = o.extraResponseData) || void 0 === e ? void 0 : e.ok) && o.extraResponseData.body.token ? i = o.extraResponseData.body : (null === (n = o.responseData) || void 0 === n ? void 0 : n.ok) && o.responseData.body.token && (i = o.responseData.body), i && (N = O, O = i, t.detail.previousCart = N, t.detail.cart = O);
    });
    var t = document.querySelector("[".concat(_, "]"));
    if (t) try {
      O = JSON.parse(t.textContent);
    } catch (t) {
      console.error("Liquid Ajax Cart: can't parse cart JSON from the \"".concat(_, "\" script")), console.error(t);
    }
    return new Promise(function (t, e) {
      var n, o;
      O ? t() : fetch("".concat((null === (o = null === (n = window.Shopify) || void 0 === n ? void 0 : n.routes) || void 0 === o ? void 0 : o.root) || "/", "cart.js"), {
        headers: {
          "Content-Type": "application/json"
        }
      }).then(function (t) {
        return t.json();
      }).then(function (e) {
        O = e, t();
      })["catch"](function (t) {
        console.error(t), e('Can\'t load the cart state from the "/cart.js" endpoint');
      });
    });
  }().then(function () {
    document.addEventListener(v, R), R(), Ct(), document.addEventListener(d, Nt), document.addEventListener(v, Nt), document.addEventListener(f, Nt), Nt(), window.liquidAjaxCart.get = S, window.liquidAjaxCart.add = j, window.liquidAjaxCart.change = C, window.liquidAjaxCart.update = x, window.liquidAjaxCart.clear = T, Bt("cart", function () {
      return B().cart;
    }), Bt("processing", D), window.addEventListener("focus", function () {
      Z.updateOnWindowFocus && x({}, {});
    }), window.addEventListener("pageshow", function (t) {
      (t.persisted || "back_forward" === performance.getEntriesByType("navigation")[0].type) && window.liquidAjaxCart.update({}, {});
    }), Ot = !0;
    var t = new CustomEvent(i);
    document.dispatchEvent(t);
  });
}

/***/ }),

/***/ "./node_modules/masonry-layout/masonry.js":
/*!************************************************!*\
  !*** ./node_modules/masonry-layout/masonry.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! outlayer/outlayer */ "./node_modules/outlayer/outlayer.js"), __webpack_require__(/*! get-size/get-size */ "./node_modules/get-size/get-size.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(Outlayer, getSize) {
  'use strict';

  // -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';
  var proto = Masonry.prototype;
  proto._resetLayout = function () {
    this.getSize();
    this._getMeasurement('columnWidth', 'outerWidth');
    this._getMeasurement('gutter', 'outerWidth');
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for (var i = 0; i < this.cols; i++) {
      this.colYs.push(0);
    }
    this.maxY = 0;
    this.horizontalColIndex = 0;
  };
  proto.measureColumns = function () {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if (!this.columnWidth) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth ||
      // if first elem has no width, default to size of container
      this.containerWidth;
    }
    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[mathMethod](cols);
    this.cols = Math.max(cols, 1);
  };
  proto.getContainerWidth = function () {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize(container);
    this.containerWidth = size && size.innerWidth;
  };
  proto._getItemLayoutPosition = function (item) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
    colSpan = Math.min(colSpan, this.cols);
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ? '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[colPosMethod](colSpan, item);
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for (var i = colPosition.col; i < setMax; i++) {
      this.colYs[i] = setHeight;
    }
    return position;
  };
  proto._getTopColPosition = function (colSpan) {
    var colGroup = this._getTopColGroup(colSpan);
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply(Math, colGroup);
    return {
      col: colGroup.indexOf(minimumY),
      y: minimumY
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function (colSpan) {
    if (colSpan < 2) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }
    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for (var i = 0; i < groupCount; i++) {
      colGroup[i] = this._getColGroupY(i, colSpan);
    }
    return colGroup;
  };
  proto._getColGroupY = function (col, colSpan) {
    if (colSpan < 2) {
      return this.colYs[col];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice(col, col + colSpan);
    // and get the max value of the array
    return Math.max.apply(Math, groupColYs);
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function (colSpan, item) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
    return {
      col: col,
      y: this._getColGroupY(col, colSpan)
    };
  };
  proto._manageStamp = function (stamp) {
    var stampSize = getSize(stamp);
    var offset = this._getElementOffset(stamp);
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor(firstX / this.columnWidth);
    firstCol = Math.max(0, firstCol);
    var lastCol = Math.floor(lastX / this.columnWidth);
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min(this.cols - 1, lastCol);
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
    for (var i = firstCol; i <= lastCol; i++) {
      this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
    }
  };
  proto._getContainerSize = function () {
    this.maxY = Math.max.apply(Math, this.colYs);
    var size = {
      height: this.maxY
    };
    if (this._getOption('fitWidth')) {
      size.width = this._getContainerFitWidth();
    }
    return size;
  };
  proto._getContainerFitWidth = function () {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while (--i) {
      if (this.colYs[i] !== 0) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return (this.cols - unusedCols) * this.columnWidth - this.gutter;
  };
  proto.needsResizeLayout = function () {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };
  return Masonry;
});

/***/ }),

/***/ "./node_modules/outlayer/item.js":
/*!***************************************!*\
  !*** ./node_modules/outlayer/item.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/**
 * Outlayer Item
 */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if (true) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ev-emitter/ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"), __webpack_require__(/*! get-size/get-size */ "./node_modules/get-size/get-size.js")], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(EvEmitter, getSize) {
  'use strict';

  // ----- helpers ----- //
  function isEmptyObj(obj) {
    for (var prop in obj) {
      return false;
    }
    prop = null;
    return true;
  }

  // -------------------------- CSS3 support -------------------------- //

  var docElemStyle = document.documentElement.style;
  var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
  var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
  var transitionEndEvent = {
    WebkitTransition: 'webkitTransitionEnd',
    transition: 'transitionend'
  }[transitionProperty];

  // cache all vendor properties that could have vendor prefix
  var vendorProperties = {
    transform: transformProperty,
    transition: transitionProperty,
    transitionDuration: transitionProperty + 'Duration',
    transitionProperty: transitionProperty + 'Property',
    transitionDelay: transitionProperty + 'Delay'
  };

  // -------------------------- Item -------------------------- //

  function Item(element, layout) {
    if (!element) {
      return;
    }
    this.element = element;
    // parent layout class, i.e. Masonry, Isotope, or Packery
    this.layout = layout;
    this.position = {
      x: 0,
      y: 0
    };
    this._create();
  }

  // inherit EvEmitter
  var proto = Item.prototype = Object.create(EvEmitter.prototype);
  proto.constructor = Item;
  proto._create = function () {
    // transition objects
    this._transn = {
      ingProperties: {},
      clean: {},
      onEnd: {}
    };
    this.css({
      position: 'absolute'
    });
  };

  // trigger specified handler for event type
  proto.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  /**
   * apply CSS styles to element
   * @param {Object} style
   */
  proto.css = function (style) {
    var elemStyle = this.element.style;
    for (var prop in style) {
      // use vendor property if available
      var supportedProp = vendorProperties[prop] || prop;
      elemStyle[supportedProp] = style[prop];
    }
  };

  // measure position, and sets it
  proto.getPosition = function () {
    var style = getComputedStyle(this.element);
    var isOriginLeft = this.layout._getOption('originLeft');
    var isOriginTop = this.layout._getOption('originTop');
    var xValue = style[isOriginLeft ? 'left' : 'right'];
    var yValue = style[isOriginTop ? 'top' : 'bottom'];
    var x = parseFloat(xValue);
    var y = parseFloat(yValue);
    // convert percent to pixels
    var layoutSize = this.layout.size;
    if (xValue.indexOf('%') != -1) {
      x = x / 100 * layoutSize.width;
    }
    if (yValue.indexOf('%') != -1) {
      y = y / 100 * layoutSize.height;
    }
    // clean up 'auto' or other non-integer values
    x = isNaN(x) ? 0 : x;
    y = isNaN(y) ? 0 : y;
    // remove padding from measurement
    x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
    y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
    this.position.x = x;
    this.position.y = y;
  };

  // set settled position, apply padding
  proto.layoutPosition = function () {
    var layoutSize = this.layout.size;
    var style = {};
    var isOriginLeft = this.layout._getOption('originLeft');
    var isOriginTop = this.layout._getOption('originTop');

    // x
    var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
    var xProperty = isOriginLeft ? 'left' : 'right';
    var xResetProperty = isOriginLeft ? 'right' : 'left';
    var x = this.position.x + layoutSize[xPadding];
    // set in percentage or pixels
    style[xProperty] = this.getXValue(x);
    // reset other property
    style[xResetProperty] = '';

    // y
    var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
    var yProperty = isOriginTop ? 'top' : 'bottom';
    var yResetProperty = isOriginTop ? 'bottom' : 'top';
    var y = this.position.y + layoutSize[yPadding];
    // set in percentage or pixels
    style[yProperty] = this.getYValue(y);
    // reset other property
    style[yResetProperty] = '';
    this.css(style);
    this.emitEvent('layout', [this]);
  };
  proto.getXValue = function (x) {
    var isHorizontal = this.layout._getOption('horizontal');
    return this.layout.options.percentPosition && !isHorizontal ? x / this.layout.size.width * 100 + '%' : x + 'px';
  };
  proto.getYValue = function (y) {
    var isHorizontal = this.layout._getOption('horizontal');
    return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + '%' : y + 'px';
  };
  proto._transitionTo = function (x, y) {
    this.getPosition();
    // get current x & y from top/left
    var curX = this.position.x;
    var curY = this.position.y;
    var didNotMove = x == this.position.x && y == this.position.y;

    // save end position
    this.setPosition(x, y);

    // if did not move and not transitioning, just go to layout
    if (didNotMove && !this.isTransitioning) {
      this.layoutPosition();
      return;
    }
    var transX = x - curX;
    var transY = y - curY;
    var transitionStyle = {};
    transitionStyle.transform = this.getTranslate(transX, transY);
    this.transition({
      to: transitionStyle,
      onTransitionEnd: {
        transform: this.layoutPosition
      },
      isCleaning: true
    });
  };
  proto.getTranslate = function (x, y) {
    // flip cooridinates if origin on right or bottom
    var isOriginLeft = this.layout._getOption('originLeft');
    var isOriginTop = this.layout._getOption('originTop');
    x = isOriginLeft ? x : -x;
    y = isOriginTop ? y : -y;
    return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
  };

  // non transition + transform support
  proto.goTo = function (x, y) {
    this.setPosition(x, y);
    this.layoutPosition();
  };
  proto.moveTo = proto._transitionTo;
  proto.setPosition = function (x, y) {
    this.position.x = parseFloat(x);
    this.position.y = parseFloat(y);
  };

  // ----- transition ----- //

  /**
   * @param {Object} style - CSS
   * @param {Function} onTransitionEnd
   */

  // non transition, just trigger callback
  proto._nonTransition = function (args) {
    this.css(args.to);
    if (args.isCleaning) {
      this._removeStyles(args.to);
    }
    for (var prop in args.onTransitionEnd) {
      args.onTransitionEnd[prop].call(this);
    }
  };

  /**
   * proper transition
   * @param {Object} args - arguments
   *   @param {Object} to - style to transition to
   *   @param {Object} from - style to start transition from
   *   @param {Boolean} isCleaning - removes transition styles after transition
   *   @param {Function} onTransitionEnd - callback
   */
  proto.transition = function (args) {
    // redirect to nonTransition if no transition duration
    if (!parseFloat(this.layout.options.transitionDuration)) {
      this._nonTransition(args);
      return;
    }
    var _transition = this._transn;
    // keep track of onTransitionEnd callback by css property
    for (var prop in args.onTransitionEnd) {
      _transition.onEnd[prop] = args.onTransitionEnd[prop];
    }
    // keep track of properties that are transitioning
    for (prop in args.to) {
      _transition.ingProperties[prop] = true;
      // keep track of properties to clean up when transition is done
      if (args.isCleaning) {
        _transition.clean[prop] = true;
      }
    }

    // set from styles
    if (args.from) {
      this.css(args.from);
      // force redraw. http://blog.alexmaccaw.com/css-transitions
      var h = this.element.offsetHeight;
      // hack for JSHint to hush about unused var
      h = null;
    }
    // enable transition
    this.enableTransition(args.to);
    // set styles that are transitioning
    this.css(args.to);
    this.isTransitioning = true;
  };

  // dash before all cap letters, including first for
  // WebkitTransform => -webkit-transform
  function toDashedAll(str) {
    return str.replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    });
  }
  var transitionProps = 'opacity,' + toDashedAll(transformProperty);
  proto.enableTransition = function /* style */
  () {
    // HACK changing transitionProperty during a transition
    // will cause transition to jump
    if (this.isTransitioning) {
      return;
    }

    // make `transition: foo, bar, baz` from style object
    // HACK un-comment this when enableTransition can work
    // while a transition is happening
    // var transitionValues = [];
    // for ( var prop in style ) {
    //   // dash-ify camelCased properties like WebkitTransition
    //   prop = vendorProperties[ prop ] || prop;
    //   transitionValues.push( toDashedAll( prop ) );
    // }
    // munge number to millisecond, to match stagger
    var duration = this.layout.options.transitionDuration;
    duration = typeof duration == 'number' ? duration + 'ms' : duration;
    // enable transition styles
    this.css({
      transitionProperty: transitionProps,
      transitionDuration: duration,
      transitionDelay: this.staggerDelay || 0
    });
    // listen for transition end event
    this.element.addEventListener(transitionEndEvent, this, false);
  };

  // ----- events ----- //

  proto.onwebkitTransitionEnd = function (event) {
    this.ontransitionend(event);
  };
  proto.onotransitionend = function (event) {
    this.ontransitionend(event);
  };

  // properties that I munge to make my life easier
  var dashedVendorProperties = {
    '-webkit-transform': 'transform'
  };
  proto.ontransitionend = function (event) {
    // disregard bubbled events from children
    if (event.target !== this.element) {
      return;
    }
    var _transition = this._transn;
    // get property name of transitioned property, convert to prefix-free
    var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;

    // remove property that has completed transitioning
    delete _transition.ingProperties[propertyName];
    // check if any properties are still transitioning
    if (isEmptyObj(_transition.ingProperties)) {
      // all properties have completed transitioning
      this.disableTransition();
    }
    // clean style
    if (propertyName in _transition.clean) {
      // clean up style
      this.element.style[event.propertyName] = '';
      delete _transition.clean[propertyName];
    }
    // trigger onTransitionEnd callback
    if (propertyName in _transition.onEnd) {
      var onTransitionEnd = _transition.onEnd[propertyName];
      onTransitionEnd.call(this);
      delete _transition.onEnd[propertyName];
    }
    this.emitEvent('transitionEnd', [this]);
  };
  proto.disableTransition = function () {
    this.removeTransitionStyles();
    this.element.removeEventListener(transitionEndEvent, this, false);
    this.isTransitioning = false;
  };

  /**
   * removes style property from element
   * @param {Object} style
  **/
  proto._removeStyles = function (style) {
    // clean up transition styles
    var cleanStyle = {};
    for (var prop in style) {
      cleanStyle[prop] = '';
    }
    this.css(cleanStyle);
  };
  var cleanTransitionStyle = {
    transitionProperty: '',
    transitionDuration: '',
    transitionDelay: ''
  };
  proto.removeTransitionStyles = function () {
    // remove transition
    this.css(cleanTransitionStyle);
  };

  // ----- stagger ----- //

  proto.stagger = function (delay) {
    delay = isNaN(delay) ? 0 : delay;
    this.staggerDelay = delay + 'ms';
  };

  // ----- show/hide/remove ----- //

  // remove element from DOM
  proto.removeElem = function () {
    this.element.parentNode.removeChild(this.element);
    // remove display: none
    this.css({
      display: ''
    });
    this.emitEvent('remove', [this]);
  };
  proto.remove = function () {
    // just remove element if no transition support or no transition
    if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
      this.removeElem();
      return;
    }

    // start transition
    this.once('transitionEnd', function () {
      this.removeElem();
    });
    this.hide();
  };
  proto.reveal = function () {
    delete this.isHidden;
    // remove display: none
    this.css({
      display: ''
    });
    var options = this.layout.options;
    var onTransitionEnd = {};
    var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
    onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
    this.transition({
      from: options.hiddenStyle,
      to: options.visibleStyle,
      isCleaning: true,
      onTransitionEnd: onTransitionEnd
    });
  };
  proto.onRevealTransitionEnd = function () {
    // check if still visible
    // during transition, item may have been hidden
    if (!this.isHidden) {
      this.emitEvent('reveal');
    }
  };

  /**
   * get style property use for hide/reveal transition end
   * @param {String} styleProperty - hiddenStyle/visibleStyle
   * @returns {String}
   */
  proto.getHideRevealTransitionEndProperty = function (styleProperty) {
    var optionStyle = this.layout.options[styleProperty];
    // use opacity
    if (optionStyle.opacity) {
      return 'opacity';
    }
    // get first property
    for (var prop in optionStyle) {
      return prop;
    }
  };
  proto.hide = function () {
    // set flag
    this.isHidden = true;
    // remove display: none
    this.css({
      display: ''
    });
    var options = this.layout.options;
    var onTransitionEnd = {};
    var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
    onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
    this.transition({
      from: options.visibleStyle,
      to: options.hiddenStyle,
      // keep hidden stuff hidden
      isCleaning: true,
      onTransitionEnd: onTransitionEnd
    });
  };
  proto.onHideTransitionEnd = function () {
    // check if still hidden
    // during transition, item may have been un-hidden
    if (this.isHidden) {
      this.css({
        display: 'none'
      });
      this.emitEvent('hide');
    }
  };
  proto.destroy = function () {
    this.css({
      position: '',
      left: '',
      right: '',
      top: '',
      bottom: '',
      transition: '',
      transform: ''
    });
  };
  return Item;
});

/***/ }),

/***/ "./node_modules/outlayer/outlayer.js":
/*!*******************************************!*\
  !*** ./node_modules/outlayer/outlayer.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

(function (window, factory) {
  'use strict';

  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if (true) {
    // AMD - RequireJS
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ev-emitter/ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js"), __webpack_require__(/*! get-size/get-size */ "./node_modules/get-size/get-size.js"), __webpack_require__(/*! fizzy-ui-utils/utils */ "./node_modules/fizzy-ui-utils/utils.js"), __webpack_require__(/*! ./item */ "./node_modules/outlayer/item.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (EvEmitter, getSize, utils, Item) {
      return factory(window, EvEmitter, getSize, utils, Item);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, EvEmitter, getSize, utils, Item) {
  'use strict';

  // ----- vars ----- //
  var console = window.console;
  var jQuery = window.jQuery;
  var noop = function noop() {};

  // -------------------------- Outlayer -------------------------- //

  // globally unique identifiers
  var GUID = 0;
  // internal store of all Outlayer intances
  var instances = {};

  /**
   * @param {Element, String} element
   * @param {Object} options
   * @constructor
   */
  function Outlayer(element, options) {
    var queryElement = utils.getQueryElement(element);
    if (!queryElement) {
      if (console) {
        console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
      }
      return;
    }
    this.element = queryElement;
    // add jQuery
    if (jQuery) {
      this.$element = jQuery(this.element);
    }

    // options
    this.options = utils.extend({}, this.constructor.defaults);
    this.option(options);

    // add id for Outlayer.getFromElement
    var id = ++GUID;
    this.element.outlayerGUID = id; // expando
    instances[id] = this; // associate via id

    // kick it off
    this._create();
    var isInitLayout = this._getOption('initLayout');
    if (isInitLayout) {
      this.layout();
    }
  }

  // settings are for internal use only
  Outlayer.namespace = 'outlayer';
  Outlayer.Item = Item;

  // default options
  Outlayer.defaults = {
    containerStyle: {
      position: 'relative'
    },
    initLayout: true,
    originLeft: true,
    originTop: true,
    resize: true,
    resizeContainer: true,
    // item options
    transitionDuration: '0.4s',
    hiddenStyle: {
      opacity: 0,
      transform: 'scale(0.001)'
    },
    visibleStyle: {
      opacity: 1,
      transform: 'scale(1)'
    }
  };
  var proto = Outlayer.prototype;
  // inherit EvEmitter
  utils.extend(proto, EvEmitter.prototype);

  /**
   * set options
   * @param {Object} opts
   */
  proto.option = function (opts) {
    utils.extend(this.options, opts);
  };

  /**
   * get backwards compatible option value, check old name
   */
  proto._getOption = function (option) {
    var oldOption = this.constructor.compatOptions[option];
    return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
  };
  Outlayer.compatOptions = {
    // currentName: oldName
    initLayout: 'isInitLayout',
    horizontal: 'isHorizontal',
    layoutInstant: 'isLayoutInstant',
    originLeft: 'isOriginLeft',
    originTop: 'isOriginTop',
    resize: 'isResizeBound',
    resizeContainer: 'isResizingContainer'
  };
  proto._create = function () {
    // get items from children
    this.reloadItems();
    // elements that affect layout, but are not laid out
    this.stamps = [];
    this.stamp(this.options.stamp);
    // set container style
    utils.extend(this.element.style, this.options.containerStyle);

    // bind resize method
    var canBindResize = this._getOption('resize');
    if (canBindResize) {
      this.bindResize();
    }
  };

  // goes through all children again and gets bricks in proper order
  proto.reloadItems = function () {
    // collection of item elements
    this.items = this._itemize(this.element.children);
  };

  /**
   * turn elements into Outlayer.Items to be used in layout
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - collection of new Outlayer Items
   */
  proto._itemize = function (elems) {
    var itemElems = this._filterFindItemElements(elems);
    var Item = this.constructor.Item;

    // create new Outlayer Items for collection
    var items = [];
    for (var i = 0; i < itemElems.length; i++) {
      var elem = itemElems[i];
      var item = new Item(elem, this);
      items.push(item);
    }
    return items;
  };

  /**
   * get item elements to be used in layout
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - item elements
   */
  proto._filterFindItemElements = function (elems) {
    return utils.filterFindElements(elems, this.options.itemSelector);
  };

  /**
   * getter method for getting item elements
   * @returns {Array} elems - collection of item elements
   */
  proto.getItemElements = function () {
    return this.items.map(function (item) {
      return item.element;
    });
  };

  // ----- init & layout ----- //

  /**
   * lays out all items
   */
  proto.layout = function () {
    this._resetLayout();
    this._manageStamps();

    // don't animate first layout
    var layoutInstant = this._getOption('layoutInstant');
    var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
    this.layoutItems(this.items, isInstant);

    // flag for initalized
    this._isLayoutInited = true;
  };

  // _init is alias for layout
  proto._init = proto.layout;

  /**
   * logic before any new layout
   */
  proto._resetLayout = function () {
    this.getSize();
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  /**
   * get measurement from option, for columnWidth, rowHeight, gutter
   * if option is String -> get element from selector string, & get size of element
   * if option is Element -> get size of element
   * else use option as a number
   *
   * @param {String} measurement
   * @param {String} size - width or height
   * @private
   */
  proto._getMeasurement = function (measurement, size) {
    var option = this.options[measurement];
    var elem;
    if (!option) {
      // default to 0
      this[measurement] = 0;
    } else {
      // use option as an element
      if (typeof option == 'string') {
        elem = this.element.querySelector(option);
      } else if (option instanceof HTMLElement) {
        elem = option;
      }
      // use size of element, if element
      this[measurement] = elem ? getSize(elem)[size] : option;
    }
  };

  /**
   * layout a collection of item elements
   * @api public
   */
  proto.layoutItems = function (items, isInstant) {
    items = this._getItemsForLayout(items);
    this._layoutItems(items, isInstant);
    this._postLayout();
  };

  /**
   * get the items to be laid out
   * you may want to skip over some items
   * @param {Array} items
   * @returns {Array} items
   */
  proto._getItemsForLayout = function (items) {
    return items.filter(function (item) {
      return !item.isIgnored;
    });
  };

  /**
   * layout items
   * @param {Array} items
   * @param {Boolean} isInstant
   */
  proto._layoutItems = function (items, isInstant) {
    this._emitCompleteOnItems('layout', items);
    if (!items || !items.length) {
      // no items, emit event with empty array
      return;
    }
    var queue = [];
    items.forEach(function (item) {
      // get x/y object from method
      var position = this._getItemLayoutPosition(item);
      // enqueue
      position.item = item;
      position.isInstant = isInstant || item.isLayoutInstant;
      queue.push(position);
    }, this);
    this._processLayoutQueue(queue);
  };

  /**
   * get item layout position
   * @param {Outlayer.Item} item
   * @returns {Object} x and y position
   */
  proto._getItemLayoutPosition = function /* item */
  () {
    return {
      x: 0,
      y: 0
    };
  };

  /**
   * iterate over array and position each item
   * Reason being - separating this logic prevents 'layout invalidation'
   * thx @paul_irish
   * @param {Array} queue
   */
  proto._processLayoutQueue = function (queue) {
    this.updateStagger();
    queue.forEach(function (obj, i) {
      this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
    }, this);
  };

  // set stagger from option in milliseconds number
  proto.updateStagger = function () {
    var stagger = this.options.stagger;
    if (stagger === null || stagger === undefined) {
      this.stagger = 0;
      return;
    }
    this.stagger = getMilliseconds(stagger);
    return this.stagger;
  };

  /**
   * Sets position of item in DOM
   * @param {Outlayer.Item} item
   * @param {Number} x - horizontal position
   * @param {Number} y - vertical position
   * @param {Boolean} isInstant - disables transitions
   */
  proto._positionItem = function (item, x, y, isInstant, i) {
    if (isInstant) {
      // if not transition, just set CSS
      item.goTo(x, y);
    } else {
      item.stagger(i * this.stagger);
      item.moveTo(x, y);
    }
  };

  /**
   * Any logic you want to do after each layout,
   * i.e. size the container
   */
  proto._postLayout = function () {
    this.resizeContainer();
  };
  proto.resizeContainer = function () {
    var isResizingContainer = this._getOption('resizeContainer');
    if (!isResizingContainer) {
      return;
    }
    var size = this._getContainerSize();
    if (size) {
      this._setContainerMeasure(size.width, true);
      this._setContainerMeasure(size.height, false);
    }
  };

  /**
   * Sets width or height of container if returned
   * @returns {Object} size
   *   @param {Number} width
   *   @param {Number} height
   */
  proto._getContainerSize = noop;

  /**
   * @param {Number} measure - size of width or height
   * @param {Boolean} isWidth
   */
  proto._setContainerMeasure = function (measure, isWidth) {
    if (measure === undefined) {
      return;
    }
    var elemSize = this.size;
    // add padding and border width if border box
    if (elemSize.isBorderBox) {
      measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
    }
    measure = Math.max(measure, 0);
    this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
  };

  /**
   * emit eventComplete on a collection of items events
   * @param {String} eventName
   * @param {Array} items - Outlayer.Items
   */
  proto._emitCompleteOnItems = function (eventName, items) {
    var _this = this;
    function onComplete() {
      _this.dispatchEvent(eventName + 'Complete', null, [items]);
    }
    var count = items.length;
    if (!items || !count) {
      onComplete();
      return;
    }
    var doneCount = 0;
    function tick() {
      doneCount++;
      if (doneCount == count) {
        onComplete();
      }
    }

    // bind callback
    items.forEach(function (item) {
      item.once(eventName, tick);
    });
  };

  /**
   * emits events via EvEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */
  proto.dispatchEvent = function (type, event, args) {
    // add original event to arguments
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);
    if (jQuery) {
      // set this.$element
      this.$element = this.$element || jQuery(this.element);
      if (event) {
        // create jQuery event
        var $event = jQuery.Event(event);
        $event.type = type;
        this.$element.trigger($event, args);
      } else {
        // just trigger with type if no event available
        this.$element.trigger(type, args);
      }
    }
  };

  // -------------------------- ignore & stamps -------------------------- //

  /**
   * keep item in collection, but do not lay it out
   * ignored items do not get skipped in layout
   * @param {Element} elem
   */
  proto.ignore = function (elem) {
    var item = this.getItem(elem);
    if (item) {
      item.isIgnored = true;
    }
  };

  /**
   * return item to layout collection
   * @param {Element} elem
   */
  proto.unignore = function (elem) {
    var item = this.getItem(elem);
    if (item) {
      delete item.isIgnored;
    }
  };

  /**
   * adds elements to stamps
   * @param {NodeList, Array, Element, or String} elems
   */
  proto.stamp = function (elems) {
    elems = this._find(elems);
    if (!elems) {
      return;
    }
    this.stamps = this.stamps.concat(elems);
    // ignore
    elems.forEach(this.ignore, this);
  };

  /**
   * removes elements to stamps
   * @param {NodeList, Array, or Element} elems
   */
  proto.unstamp = function (elems) {
    elems = this._find(elems);
    if (!elems) {
      return;
    }
    elems.forEach(function (elem) {
      // filter out removed stamp elements
      utils.removeFrom(this.stamps, elem);
      this.unignore(elem);
    }, this);
  };

  /**
   * finds child elements
   * @param {NodeList, Array, Element, or String} elems
   * @returns {Array} elems
   */
  proto._find = function (elems) {
    if (!elems) {
      return;
    }
    // if string, use argument as selector string
    if (typeof elems == 'string') {
      elems = this.element.querySelectorAll(elems);
    }
    elems = utils.makeArray(elems);
    return elems;
  };
  proto._manageStamps = function () {
    if (!this.stamps || !this.stamps.length) {
      return;
    }
    this._getBoundingRect();
    this.stamps.forEach(this._manageStamp, this);
  };

  // update boundingLeft / Top
  proto._getBoundingRect = function () {
    // get bounding rect for container element
    var boundingRect = this.element.getBoundingClientRect();
    var size = this.size;
    this._boundingRect = {
      left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
      top: boundingRect.top + size.paddingTop + size.borderTopWidth,
      right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
      bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
    };
  };

  /**
   * @param {Element} stamp
  **/
  proto._manageStamp = noop;

  /**
   * get x/y position of element relative to container element
   * @param {Element} elem
   * @returns {Object} offset - has left, top, right, bottom
   */
  proto._getElementOffset = function (elem) {
    var boundingRect = elem.getBoundingClientRect();
    var thisRect = this._boundingRect;
    var size = getSize(elem);
    var offset = {
      left: boundingRect.left - thisRect.left - size.marginLeft,
      top: boundingRect.top - thisRect.top - size.marginTop,
      right: thisRect.right - boundingRect.right - size.marginRight,
      bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
    };
    return offset;
  };

  // -------------------------- resize -------------------------- //

  // enable event handlers for listeners
  // i.e. resize -> onresize
  proto.handleEvent = utils.handleEvent;

  /**
   * Bind layout to window resizing
   */
  proto.bindResize = function () {
    window.addEventListener('resize', this);
    this.isResizeBound = true;
  };

  /**
   * Unbind layout to window resizing
   */
  proto.unbindResize = function () {
    window.removeEventListener('resize', this);
    this.isResizeBound = false;
  };
  proto.onresize = function () {
    this.resize();
  };
  utils.debounceMethod(Outlayer, 'onresize', 100);
  proto.resize = function () {
    // don't trigger if size did not change
    // or if resize was unbound. See #9
    if (!this.isResizeBound || !this.needsResizeLayout()) {
      return;
    }
    this.layout();
  };

  /**
   * check if layout is needed post layout
   * @returns Boolean
   */
  proto.needsResizeLayout = function () {
    var size = getSize(this.element);
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var hasSizes = this.size && size;
    return hasSizes && size.innerWidth !== this.size.innerWidth;
  };

  // -------------------------- methods -------------------------- //

  /**
   * add items to Outlayer instance
   * @param {Array or NodeList or Element} elems
   * @returns {Array} items - Outlayer.Items
  **/
  proto.addItems = function (elems) {
    var items = this._itemize(elems);
    // add items to collection
    if (items.length) {
      this.items = this.items.concat(items);
    }
    return items;
  };

  /**
   * Layout newly-appended item elements
   * @param {Array or NodeList or Element} elems
   */
  proto.appended = function (elems) {
    var items = this.addItems(elems);
    if (!items.length) {
      return;
    }
    // layout and reveal just the new items
    this.layoutItems(items, true);
    this.reveal(items);
  };

  /**
   * Layout prepended elements
   * @param {Array or NodeList or Element} elems
   */
  proto.prepended = function (elems) {
    var items = this._itemize(elems);
    if (!items.length) {
      return;
    }
    // add items to beginning of collection
    var previousItems = this.items.slice(0);
    this.items = items.concat(previousItems);
    // start new layout
    this._resetLayout();
    this._manageStamps();
    // layout new stuff without transition
    this.layoutItems(items, true);
    this.reveal(items);
    // layout previous items
    this.layoutItems(previousItems);
  };

  /**
   * reveal a collection of items
   * @param {Array of Outlayer.Items} items
   */
  proto.reveal = function (items) {
    this._emitCompleteOnItems('reveal', items);
    if (!items || !items.length) {
      return;
    }
    var stagger = this.updateStagger();
    items.forEach(function (item, i) {
      item.stagger(i * stagger);
      item.reveal();
    });
  };

  /**
   * hide a collection of items
   * @param {Array of Outlayer.Items} items
   */
  proto.hide = function (items) {
    this._emitCompleteOnItems('hide', items);
    if (!items || !items.length) {
      return;
    }
    var stagger = this.updateStagger();
    items.forEach(function (item, i) {
      item.stagger(i * stagger);
      item.hide();
    });
  };

  /**
   * reveal item elements
   * @param {Array}, {Element}, {NodeList} items
   */
  proto.revealItemElements = function (elems) {
    var items = this.getItems(elems);
    this.reveal(items);
  };

  /**
   * hide item elements
   * @param {Array}, {Element}, {NodeList} items
   */
  proto.hideItemElements = function (elems) {
    var items = this.getItems(elems);
    this.hide(items);
  };

  /**
   * get Outlayer.Item, given an Element
   * @param {Element} elem
   * @param {Function} callback
   * @returns {Outlayer.Item} item
   */
  proto.getItem = function (elem) {
    // loop through items to get the one that matches
    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];
      if (item.element == elem) {
        // return item
        return item;
      }
    }
  };

  /**
   * get collection of Outlayer.Items, given Elements
   * @param {Array} elems
   * @returns {Array} items - Outlayer.Items
   */
  proto.getItems = function (elems) {
    elems = utils.makeArray(elems);
    var items = [];
    elems.forEach(function (elem) {
      var item = this.getItem(elem);
      if (item) {
        items.push(item);
      }
    }, this);
    return items;
  };

  /**
   * remove element(s) from instance and DOM
   * @param {Array or NodeList or Element} elems
   */
  proto.remove = function (elems) {
    var removeItems = this.getItems(elems);
    this._emitCompleteOnItems('remove', removeItems);

    // bail if no items to remove
    if (!removeItems || !removeItems.length) {
      return;
    }
    removeItems.forEach(function (item) {
      item.remove();
      // remove item from collection
      utils.removeFrom(this.items, item);
    }, this);
  };

  // ----- destroy ----- //

  // remove and disable Outlayer instance
  proto.destroy = function () {
    // clean up dynamic styles
    var style = this.element.style;
    style.height = '';
    style.position = '';
    style.width = '';
    // destroy items
    this.items.forEach(function (item) {
      item.destroy();
    });
    this.unbindResize();
    var id = this.element.outlayerGUID;
    delete instances[id]; // remove reference to instance by id
    delete this.element.outlayerGUID;
    // remove data for jQuery
    if (jQuery) {
      jQuery.removeData(this.element, this.constructor.namespace);
    }
  };

  // -------------------------- data -------------------------- //

  /**
   * get Outlayer instance from element
   * @param {Element} elem
   * @returns {Outlayer}
   */
  Outlayer.data = function (elem) {
    elem = utils.getQueryElement(elem);
    var id = elem && elem.outlayerGUID;
    return id && instances[id];
  };

  // -------------------------- create Outlayer class -------------------------- //

  /**
   * create a layout class
   * @param {String} namespace
   */
  Outlayer.create = function (namespace, options) {
    // sub-class Outlayer
    var Layout = subclass(Outlayer);
    // apply new options and compatOptions
    Layout.defaults = utils.extend({}, Outlayer.defaults);
    utils.extend(Layout.defaults, options);
    Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
    Layout.namespace = namespace;
    Layout.data = Outlayer.data;

    // sub-class Item
    Layout.Item = subclass(Item);

    // -------------------------- declarative -------------------------- //

    utils.htmlInit(Layout, namespace);

    // -------------------------- jQuery bridge -------------------------- //

    // make into jQuery plugin
    if (jQuery && jQuery.bridget) {
      jQuery.bridget(namespace, Layout);
    }
    return Layout;
  };
  function subclass(Parent) {
    function SubClass() {
      Parent.apply(this, arguments);
    }
    SubClass.prototype = Object.create(Parent.prototype);
    SubClass.prototype.constructor = SubClass;
    return SubClass;
  }

  // ----- helpers ----- //

  // how many milliseconds are in each unit
  var msUnits = {
    ms: 1,
    s: 1000
  };

  // munge time-like parameter into millisecond number
  // '0.4s' -> 40
  function getMilliseconds(time) {
    if (typeof time == 'number') {
      return time;
    }
    var matches = time.match(/(^\d*\.?\d*)(\w*)/);
    var num = matches && matches[1];
    var unit = matches && matches[2];
    if (!num.length) {
      return 0;
    }
    num = parseFloat(num);
    var mult = msUnits[unit] || 1;
    return num * mult;
  }

  // ----- fin ----- //

  // back in global
  Outlayer.Item = Item;
  return Outlayer;
});

/***/ }),

/***/ "./node_modules/sticky-sidebar/src/sticky-sidebar.js":
/*!***********************************************************!*\
  !*** ./node_modules/sticky-sidebar/src/sticky-sidebar.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
/**
 * Sticky Sidebar JavaScript Plugin.
 * @version 3.3.1
 * @author Ahmed Bouhuolia <a.bouhuolia@gmail.com>
 * @license The MIT License (MIT)
 */
var StickySidebar = function () {
  // ---------------------------------
  // # Define Constants
  // ---------------------------------
  //
  var EVENT_KEY = '.stickySidebar';
  var VERSION = '3.3.1';
  var DEFAULTS = {
    /**
     * Additional top spacing of the element when it becomes sticky.
     * @type {Numeric|Function}
     */
    topSpacing: 0,
    /**
     * Additional bottom spacing of the element when it becomes sticky.
     * @type {Numeric|Function}
     */
    bottomSpacing: 0,
    /**
     * Container sidebar selector to know what the beginning and end of sticky element.
     * @type {String|False}
     */
    containerSelector: false,
    /**
     * Inner wrapper selector.
     * @type {String}
     */
    innerWrapperSelector: '.inner-wrapper-sticky',
    /**
     * The name of CSS class to apply to elements when they have become stuck.
     * @type {String|False}
     */
    stickyClass: 'is-affixed',
    /**
     * Detect when sidebar and its container change height so re-calculate their dimensions.
     * @type {Boolean}
     */
    resizeSensor: true,
    /**
     * The sidebar returns to its normal position if its width below this value.
     * @type {Numeric}
     */
    minWidth: false
  };

  // ---------------------------------
  // # Class Definition
  // ---------------------------------
  //
  /**
   * Sticky Sidebar Class.
   * @public
   */
  var StickySidebar = /*#__PURE__*/function () {
    /**
     * Sticky Sidebar Constructor.
     * @constructor
     * @param {HTMLElement|String} sidebar - The sidebar element or sidebar selector.
     * @param {Object} options - The options of sticky sidebar.
     */
    function StickySidebar(sidebar) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, StickySidebar);
      this.options = StickySidebar.extend(DEFAULTS, options);

      // Sidebar element query if there's no one, throw error.
      this.sidebar = 'string' === typeof sidebar ? document.querySelector(sidebar) : sidebar;
      if ('undefined' === typeof this.sidebar) throw new Error("There is no specific sidebar element.");
      this.sidebarInner = false;
      this.container = this.sidebar.parentElement;

      // Current Affix Type of sidebar element.
      this.affixedType = 'STATIC';
      this.direction = 'down';
      this.support = {
        transform: false,
        transform3d: false
      };
      this._initialized = false;
      this._reStyle = false;
      this._breakpoint = false;
      this._resizeListeners = [];

      // Dimensions of sidebar, container and screen viewport.
      this.dimensions = {
        translateY: 0,
        topSpacing: 0,
        lastTopSpacing: 0,
        bottomSpacing: 0,
        lastBottomSpacing: 0,
        sidebarHeight: 0,
        sidebarWidth: 0,
        containerTop: 0,
        containerHeight: 0,
        viewportHeight: 0,
        viewportTop: 0,
        lastViewportTop: 0
      };

      // Bind event handlers for referencability.
      ['handleEvent'].forEach(function (method) {
        _this[method] = _this[method].bind(_this);
      });

      // Initialize sticky sidebar for first time.
      this.initialize();
    }

    /**
     * Initializes the sticky sidebar by adding inner wrapper, define its container, 
     * min-width breakpoint, calculating dimensions, adding helper classes and inline style.
     * @private
     */
    _createClass(StickySidebar, [{
      key: "initialize",
      value: function initialize() {
        var _this2 = this;
        this._setSupportFeatures();

        // Get sticky sidebar inner wrapper, if not found, will create one.
        if (this.options.innerWrapperSelector) {
          this.sidebarInner = this.sidebar.querySelector(this.options.innerWrapperSelector);
          if (null === this.sidebarInner) this.sidebarInner = false;
        }
        if (!this.sidebarInner) {
          var wrapper = document.createElement('div');
          wrapper.setAttribute('class', 'inner-wrapper-sticky');
          this.sidebar.appendChild(wrapper);
          while (this.sidebar.firstChild != wrapper) {
            wrapper.appendChild(this.sidebar.firstChild);
          }
          this.sidebarInner = this.sidebar.querySelector('.inner-wrapper-sticky');
        }

        // Container wrapper of the sidebar.
        if (this.options.containerSelector) {
          var containers = document.querySelectorAll(this.options.containerSelector);
          containers = Array.prototype.slice.call(containers);
          containers.forEach(function (container, item) {
            if (!container.contains(_this2.sidebar)) return;
            _this2.container = container;
          });
          if (!containers.length) throw new Error("The container does not contains on the sidebar.");
        }

        // If top/bottom spacing is not function parse value to integer.
        if ('function' !== typeof this.options.topSpacing) this.options.topSpacing = parseInt(this.options.topSpacing) || 0;
        if ('function' !== typeof this.options.bottomSpacing) this.options.bottomSpacing = parseInt(this.options.bottomSpacing) || 0;

        // Breakdown sticky sidebar if screen width below `options.minWidth`.
        this._widthBreakpoint();

        // Calculate dimensions of sidebar, container and viewport.
        this.calcDimensions();

        // Affix sidebar in proper position.
        this.stickyPosition();

        // Bind all events.
        this.bindEvents();

        // Inform other properties the sticky sidebar is initialized.
        this._initialized = true;
      }

      /**
       * Bind all events of sticky sidebar plugin.
       * @protected
       */
    }, {
      key: "bindEvents",
      value: function bindEvents() {
        window.addEventListener('resize', this, {
          passive: true,
          capture: false
        });
        window.addEventListener('scroll', this, {
          passive: true,
          capture: false
        });
        this.sidebar.addEventListener('update' + EVENT_KEY, this);
        if (this.options.resizeSensor && 'undefined' !== typeof ResizeSensor) {
          new ResizeSensor(this.sidebarInner, this.handleEvent);
          new ResizeSensor(this.container, this.handleEvent);
        }
      }

      /**
       * Handles all events of the plugin.
       * @param {Object} event - Event object passed from listener.
       */
    }, {
      key: "handleEvent",
      value: function handleEvent(event) {
        this.updateSticky(event);
      }

      /**
       * Calculates dimensions of sidebar, container and screen viewpoint
       * @public
       */
    }, {
      key: "calcDimensions",
      value: function calcDimensions() {
        if (this._breakpoint) return;
        var dims = this.dimensions;

        // Container of sticky sidebar dimensions.
        dims.containerTop = StickySidebar.offsetRelative(this.container).top;
        dims.containerHeight = this.container.clientHeight;
        dims.containerBottom = dims.containerTop + dims.containerHeight;

        // Sidebar dimensions.
        dims.sidebarHeight = this.sidebarInner.offsetHeight;
        dims.sidebarWidth = this.sidebar.offsetWidth;

        // Screen viewport dimensions.
        dims.viewportHeight = window.innerHeight;
        this._calcDimensionsWithScroll();
      }

      /**
       * Some dimensions values need to be up-to-date when scrolling the page.
       * @private
       */
    }, {
      key: "_calcDimensionsWithScroll",
      value: function _calcDimensionsWithScroll() {
        var dims = this.dimensions;
        dims.sidebarLeft = StickySidebar.offsetRelative(this.sidebar).left;
        dims.viewportTop = document.documentElement.scrollTop || document.body.scrollTop;
        dims.viewportBottom = dims.viewportTop + dims.viewportHeight;
        dims.viewportLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
        dims.topSpacing = this.options.topSpacing;
        dims.bottomSpacing = this.options.bottomSpacing;
        if ('function' === typeof dims.topSpacing) dims.topSpacing = parseInt(dims.topSpacing(this.sidebar)) || 0;
        if ('function' === typeof dims.bottomSpacing) dims.bottomSpacing = parseInt(dims.bottomSpacing(this.sidebar)) || 0;
        if ('VIEWPORT-TOP' === this.affixedType) {
          // Adjust translate Y in the case decrease top spacing value.
          if (dims.topSpacing < dims.lastTopSpacing) {
            dims.translateY += dims.lastTopSpacing - dims.topSpacing;
            this._reStyle = true;
          }
        } else if ('VIEWPORT-BOTTOM' === this.affixedType) {
          // Adjust translate Y in the case decrease bottom spacing value.
          if (dims.bottomSpacing < dims.lastBottomSpacing) {
            dims.translateY += dims.lastBottomSpacing - dims.bottomSpacing;
            this._reStyle = true;
          }
        }
        dims.lastTopSpacing = dims.topSpacing;
        dims.lastBottomSpacing = dims.bottomSpacing;
      }

      /**
       * Determine whether the sidebar is bigger than viewport.
       * @public
       * @return {Boolean}
       */
    }, {
      key: "isSidebarFitsViewport",
      value: function isSidebarFitsViewport() {
        return this.dimensions.sidebarHeight < this.dimensions.viewportHeight;
      }

      /**
       * Observe browser scrolling direction top and down.
       */
    }, {
      key: "observeScrollDir",
      value: function observeScrollDir() {
        var dims = this.dimensions;
        if (dims.lastViewportTop === dims.viewportTop) return;
        var furthest = 'down' === this.direction ? Math.min : Math.max;

        // If the browser is scrolling not in the same direction.
        if (dims.viewportTop === furthest(dims.viewportTop, dims.lastViewportTop)) this.direction = 'down' === this.direction ? 'up' : 'down';
      }

      /**
       * Gets affix type of sidebar according to current scrollTop and scrollLeft.
       * Holds all logical affix of the sidebar when scrolling up and down and when sidebar 
       * is bigger than viewport and vice versa.
       * @public
       * @return {String|False} - Proper affix type.
       */
    }, {
      key: "getAffixType",
      value: function getAffixType() {
        var dims = this.dimensions,
          affixType = false;
        this._calcDimensionsWithScroll();
        var sidebarBottom = dims.sidebarHeight + dims.containerTop;
        var colliderTop = dims.viewportTop + dims.topSpacing;
        var colliderBottom = dims.viewportBottom - dims.bottomSpacing;

        // When browser is scrolling top.
        if ('up' === this.direction) {
          if (colliderTop <= dims.containerTop) {
            dims.translateY = 0;
            affixType = 'STATIC';
          } else if (colliderTop <= dims.translateY + dims.containerTop) {
            dims.translateY = colliderTop - dims.containerTop;
            affixType = 'VIEWPORT-TOP';
          } else if (!this.isSidebarFitsViewport() && dims.containerTop <= colliderTop) {
            affixType = 'VIEWPORT-UNBOTTOM';
          }
          // When browser is scrolling up.
        } else {
          // When sidebar element is not bigger than screen viewport.
          if (this.isSidebarFitsViewport()) {
            if (dims.sidebarHeight + colliderTop >= dims.containerBottom) {
              dims.translateY = dims.containerBottom - sidebarBottom;
              affixType = 'CONTAINER-BOTTOM';
            } else if (colliderTop >= dims.containerTop) {
              dims.translateY = colliderTop - dims.containerTop;
              affixType = 'VIEWPORT-TOP';
            }
            // When sidebar element is bigger than screen viewport.
          } else {
            if (dims.containerBottom <= colliderBottom) {
              dims.translateY = dims.containerBottom - sidebarBottom;
              affixType = 'CONTAINER-BOTTOM';
            } else if (sidebarBottom + dims.translateY <= colliderBottom) {
              dims.translateY = colliderBottom - sidebarBottom;
              affixType = 'VIEWPORT-BOTTOM';
            } else if (dims.containerTop + dims.translateY <= colliderTop) {
              affixType = 'VIEWPORT-UNBOTTOM';
            }
          }
        }

        // Make sure the translate Y is not bigger than container height.
        dims.translateY = Math.max(0, dims.translateY);
        dims.translateY = Math.min(dims.containerHeight, dims.translateY);
        dims.lastViewportTop = dims.viewportTop;
        return affixType;
      }

      /**
       * Gets inline style of sticky sidebar wrapper and inner wrapper according 
       * to its affix type.
       * @private
       * @param {String} affixType - Affix type of sticky sidebar.
       * @return {Object}
       */
    }, {
      key: "_getStyle",
      value: function _getStyle(affixType) {
        if ('undefined' === typeof affixType) return;
        var style = {
          inner: {},
          outer: {}
        };
        var dims = this.dimensions;
        switch (affixType) {
          case 'VIEWPORT-TOP':
            style.inner = {
              position: 'fixed',
              top: dims.topSpacing,
              left: dims.sidebarLeft - dims.viewportLeft,
              width: dims.sidebarWidth
            };
            break;
          case 'VIEWPORT-BOTTOM':
            style.inner = {
              position: 'fixed',
              top: 'auto',
              left: dims.sidebarLeft,
              bottom: dims.bottomSpacing,
              width: dims.sidebarWidth
            };
            break;
          case 'CONTAINER-BOTTOM':
          case 'VIEWPORT-UNBOTTOM':
            var translate = this._getTranslate(0, dims.translateY + 'px');
            if (translate) style.inner = {
              transform: translate
            };else style.inner = {
              position: 'absolute',
              top: dims.translateY,
              width: dims.sidebarWidth
            };
            break;
        }
        switch (affixType) {
          case 'VIEWPORT-TOP':
          case 'VIEWPORT-BOTTOM':
          case 'VIEWPORT-UNBOTTOM':
          case 'CONTAINER-BOTTOM':
            style.outer = {
              height: dims.sidebarHeight,
              position: 'relative'
            };
            break;
        }
        style.outer = StickySidebar.extend({
          height: '',
          position: ''
        }, style.outer);
        style.inner = StickySidebar.extend({
          position: 'relative',
          top: '',
          left: '',
          bottom: '',
          width: '',
          transform: this._getTranslate()
        }, style.inner);
        return style;
      }

      /**
       * Cause the sidebar to be sticky according to affix type by adding inline
       * style, adding helper class and trigger events.
       * @function
       * @protected
       * @param {string} force - Update sticky sidebar position by force.
       */
    }, {
      key: "stickyPosition",
      value: function stickyPosition(force) {
        if (this._breakpoint) return;
        force = this._reStyle || force || false;
        var offsetTop = this.options.topSpacing;
        var offsetBottom = this.options.bottomSpacing;
        var affixType = this.getAffixType();
        var style = this._getStyle(affixType);
        if ((this.affixedType != affixType || force) && affixType) {
          var affixEvent = 'affix.' + affixType.toLowerCase().replace('viewport-', '') + EVENT_KEY;
          StickySidebar.eventTrigger(this.sidebar, affixEvent);
          if ('STATIC' === affixType) StickySidebar.removeClass(this.sidebar, this.options.stickyClass);else StickySidebar.addClass(this.sidebar, this.options.stickyClass);
          for (var key in style.outer) {
            var _unit = 'number' === typeof style.outer[key] ? 'px' : '';
            this.sidebar.style[key] = style.outer[key];
          }
          for (var _key in style.inner) {
            var _unit2 = 'number' === typeof style.inner[_key] ? 'px' : '';
            this.sidebarInner.style[_key] = style.inner[_key] + _unit2;
          }
          var affixedEvent = 'affixed.' + affixType.toLowerCase().replace('viewport-', '') + EVENT_KEY;
          StickySidebar.eventTrigger(this.sidebar, affixedEvent);
        } else {
          if (this._initialized) this.sidebarInner.style.left = style.inner.left;
        }
        this.affixedType = affixType;
      }

      /**
       * Breakdown sticky sidebar when window width is below `options.minWidth` value.
       * @protected
       */
    }, {
      key: "_widthBreakpoint",
      value: function _widthBreakpoint() {
        if (window.innerWidth <= this.options.minWidth) {
          this._breakpoint = true;
          this.affixedType = 'STATIC';
          this.sidebar.removeAttribute('style');
          StickySidebar.removeClass(this.sidebar, this.options.stickyClass);
          this.sidebarInner.removeAttribute('style');
        } else {
          this._breakpoint = false;
        }
      }

      /**
       * Switches between functions stack for each event type, if there's no 
       * event, it will re-initialize sticky sidebar.
       * @public
       */
    }, {
      key: "updateSticky",
      value: function updateSticky() {
        var _this3 = this;
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this._running) return;
        this._running = true;
        (function (eventType) {
          requestAnimationFrame(function () {
            switch (eventType) {
              // When browser is scrolling and re-calculate just dimensions
              // within scroll. 
              case 'scroll':
                _this3._calcDimensionsWithScroll();
                _this3.observeScrollDir();
                _this3.stickyPosition();
                break;

              // When browser is resizing or there's no event, observe width
              // breakpoint and re-calculate dimensions.
              case 'resize':
              default:
                _this3._widthBreakpoint();
                _this3.calcDimensions();
                _this3.stickyPosition(true);
                break;
            }
            _this3._running = false;
          });
        })(event.type);
      }

      /**
       * Set browser support features to the public property.
       * @private
       */
    }, {
      key: "_setSupportFeatures",
      value: function _setSupportFeatures() {
        var support = this.support;
        support.transform = StickySidebar.supportTransform();
        support.transform3d = StickySidebar.supportTransform(true);
      }

      /**
       * Get translate value, if the browser supports transfrom3d, it will adopt it.
       * and the same with translate. if browser doesn't support both return false.
       * @param {Number} y - Value of Y-axis.
       * @param {Number} x - Value of X-axis.
       * @param {Number} z - Value of Z-axis.
       * @return {String|False}
       */
    }, {
      key: "_getTranslate",
      value: function _getTranslate() {
        var y = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var x = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var z = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        if (this.support.transform3d) return 'translate3d(' + y + ', ' + x + ', ' + z + ')';else if (this.support.translate) return 'translate(' + y + ', ' + x + ')';else return false;
      }

      /**
       * Destroy sticky sidebar plugin.
       * @public
       */
    }, {
      key: "destroy",
      value: function destroy() {
        window.removeEventListener('resize', this, {
          caption: false
        });
        window.removeEventListener('scroll', this, {
          caption: false
        });
        this.sidebar.classList.remove(this.options.stickyClass);
        this.sidebar.style.minHeight = '';
        this.sidebar.removeEventListener('update' + EVENT_KEY, this);
        var styleReset = {
          inner: {},
          outer: {}
        };
        styleReset.inner = {
          position: '',
          top: '',
          left: '',
          bottom: '',
          width: '',
          transform: ''
        };
        styleReset.outer = {
          height: '',
          position: ''
        };
        for (var key in styleReset.outer) {
          this.sidebar.style[key] = styleReset.outer[key];
        }
        for (var _key2 in styleReset.inner) {
          this.sidebarInner.style[_key2] = styleReset.inner[_key2];
        }
        if (this.options.resizeSensor && 'undefined' !== typeof ResizeSensor) {
          ResizeSensor.detach(this.sidebarInner, this.handleEvent);
          ResizeSensor.detach(this.container, this.handleEvent);
        }
      }

      /**
       * Determine if the browser supports CSS transform feature.
       * @function
       * @static
       * @param {Boolean} transform3d - Detect transform with translate3d.
       * @return {String}
       */
    }], [{
      key: "supportTransform",
      value: function supportTransform(transform3d) {
        var result = false,
          property = transform3d ? 'perspective' : 'transform',
          upper = property.charAt(0).toUpperCase() + property.slice(1),
          prefixes = ['Webkit', 'Moz', 'O', 'ms'],
          support = document.createElement('support'),
          style = support.style;
        (property + ' ' + prefixes.join(upper + ' ') + upper).split(' ').forEach(function (property, i) {
          if (style[property] !== undefined) {
            result = property;
            return false;
          }
        });
        return result;
      }

      /**
       * Trigger custom event.
       * @static
       * @param {DOMObject} element - Target element on the DOM.
       * @param {String} eventName - Event name.
       * @param {Object} data - 
       */
    }, {
      key: "eventTrigger",
      value: function eventTrigger(element, eventName, data) {
        try {
          var event = new CustomEvent(eventName, {
            detail: data
          });
        } catch (e) {
          var event = document.createEvent('CustomEvent');
          event.initCustomEvent(eventName, true, true, data);
        }
        element.dispatchEvent(event);
      }

      /**
       * Extend options object with defaults.
       * @function
       * @static
       */
    }, {
      key: "extend",
      value: function extend(defaults, options) {
        var results = {};
        for (var key in defaults) {
          if ('undefined' !== typeof options[key]) results[key] = options[key];else results[key] = defaults[key];
        }
        return results;
      }

      /**
       * Get current coordinates left and top of specific element.
       * @static
       */
    }, {
      key: "offsetRelative",
      value: function offsetRelative(element) {
        var result = {
          left: 0,
          top: 0
        };
        do {
          var offsetTop = element.offsetTop;
          var offsetLeft = element.offsetLeft;
          if (!isNaN(offsetTop)) result.top += offsetTop;
          if (!isNaN(offsetLeft)) result.left += offsetLeft;
          element = 'BODY' === element.tagName ? element.parentElement : element.offsetParent;
        } while (element);
        return result;
      }

      /**
       * Add specific class name to specific element.
       * @static 
       * @param {ObjectDOM} element 
       * @param {String} className 
       */
    }, {
      key: "addClass",
      value: function addClass(element, className) {
        if (!StickySidebar.hasClass(element, className)) {
          if (element.classList) element.classList.add(className);else element.className += ' ' + className;
        }
      }

      /**
       * Remove specific class name to specific element
       * @static
       * @param {ObjectDOM} element 
       * @param {String} className 
       */
    }, {
      key: "removeClass",
      value: function removeClass(element, className) {
        if (StickySidebar.hasClass(element, className)) {
          if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
      }

      /**
       * Determine weather the element has specific class name.
       * @static
       * @param {ObjectDOM} element 
       * @param {String} className 
       */
    }, {
      key: "hasClass",
      value: function hasClass(element, className) {
        if (element.classList) return element.classList.contains(className);else return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
      }
    }]);
    return StickySidebar;
  }();
  return StickySidebar;
}();
/* harmony default export */ __webpack_exports__["default"] = (StickySidebar);

// Global
// -------------------------
window.StickySidebar = StickySidebar;

/***/ }),

/***/ "./node_modules/unidragger/unidragger.js":
/*!***********************************************!*\
  !*** ./node_modules/unidragger/unidragger.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Unidragger v2.4.0
 * Draggable base class
 * MIT license
 */

/*jshint browser: true, unused: true, undef: true, strict: true */

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! unipointer/unipointer */ "./node_modules/unipointer/unipointer.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (Unipointer) {
      return factory(window, Unipointer);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, Unipointer) {
  'use strict';

  // -------------------------- Unidragger -------------------------- //
  function Unidragger() {}

  // inherit Unipointer & EvEmitter
  var proto = Unidragger.prototype = Object.create(Unipointer.prototype);

  // ----- bind start ----- //

  proto.bindHandles = function () {
    this._bindHandles(true);
  };
  proto.unbindHandles = function () {
    this._bindHandles(false);
  };

  /**
   * Add or remove start event
   * @param {Boolean} isAdd
   */
  proto._bindHandles = function (isAdd) {
    // munge isAdd, default to true
    isAdd = isAdd === undefined ? true : isAdd;
    // bind each handle
    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';
    var touchAction = isAdd ? this._touchActionValue : '';
    for (var i = 0; i < this.handles.length; i++) {
      var handle = this.handles[i];
      this._bindStartEvent(handle, isAdd);
      handle[bindMethod]('click', this);
      // touch-action: none to override browser touch gestures. metafizzy/flickity#540
      if (window.PointerEvent) {
        handle.style.touchAction = touchAction;
      }
    }
  };

  // prototype so it can be overwriteable by Flickity
  proto._touchActionValue = 'none';

  // ----- start event ----- //

  /**
   * pointer start
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto.pointerDown = function (event, pointer) {
    var isOkay = this.okayPointerDown(event);
    if (!isOkay) {
      return;
    }
    // track start event position
    // Safari 9 overrides pageX and pageY. These values needs to be copied. flickity#842
    this.pointerDownPointer = {
      pageX: pointer.pageX,
      pageY: pointer.pageY
    };
    event.preventDefault();
    this.pointerDownBlur();
    // bind move and end events
    this._bindPostStartEvents(event);
    this.emitEvent('pointerDown', [event, pointer]);
  };

  // nodes that have text fields
  var cursorNodes = {
    TEXTAREA: true,
    INPUT: true,
    SELECT: true,
    OPTION: true
  };

  // input types that do not have text fields
  var clickTypes = {
    radio: true,
    checkbox: true,
    button: true,
    submit: true,
    image: true,
    file: true
  };

  // dismiss inputs with text fields. flickity#403, flickity#404
  proto.okayPointerDown = function (event) {
    var isCursorNode = cursorNodes[event.target.nodeName];
    var isClickType = clickTypes[event.target.type];
    var isOkay = !isCursorNode || isClickType;
    if (!isOkay) {
      this._pointerReset();
    }
    return isOkay;
  };

  // kludge to blur previously focused input
  proto.pointerDownBlur = function () {
    var focused = document.activeElement;
    // do not blur body for IE10, metafizzy/flickity#117
    var canBlur = focused && focused.blur && focused != document.body;
    if (canBlur) {
      focused.blur();
    }
  };

  // ----- move event ----- //

  /**
   * drag move
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto.pointerMove = function (event, pointer) {
    var moveVector = this._dragPointerMove(event, pointer);
    this.emitEvent('pointerMove', [event, pointer, moveVector]);
    this._dragMove(event, pointer, moveVector);
  };

  // base pointer move logic
  proto._dragPointerMove = function (event, pointer) {
    var moveVector = {
      x: pointer.pageX - this.pointerDownPointer.pageX,
      y: pointer.pageY - this.pointerDownPointer.pageY
    };
    // start drag if pointer has moved far enough to start drag
    if (!this.isDragging && this.hasDragStarted(moveVector)) {
      this._dragStart(event, pointer);
    }
    return moveVector;
  };

  // condition if pointer has moved far enough to start drag
  proto.hasDragStarted = function (moveVector) {
    return Math.abs(moveVector.x) > 3 || Math.abs(moveVector.y) > 3;
  };

  // ----- end event ----- //

  /**
   * pointer up
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto.pointerUp = function (event, pointer) {
    this.emitEvent('pointerUp', [event, pointer]);
    this._dragPointerUp(event, pointer);
  };
  proto._dragPointerUp = function (event, pointer) {
    if (this.isDragging) {
      this._dragEnd(event, pointer);
    } else {
      // pointer didn't move enough for drag to start
      this._staticClick(event, pointer);
    }
  };

  // -------------------------- drag -------------------------- //

  // dragStart
  proto._dragStart = function (event, pointer) {
    this.isDragging = true;
    // prevent clicks
    this.isPreventingClicks = true;
    this.dragStart(event, pointer);
  };
  proto.dragStart = function (event, pointer) {
    this.emitEvent('dragStart', [event, pointer]);
  };

  // dragMove
  proto._dragMove = function (event, pointer, moveVector) {
    // do not drag if not dragging yet
    if (!this.isDragging) {
      return;
    }
    this.dragMove(event, pointer, moveVector);
  };
  proto.dragMove = function (event, pointer, moveVector) {
    event.preventDefault();
    this.emitEvent('dragMove', [event, pointer, moveVector]);
  };

  // dragEnd
  proto._dragEnd = function (event, pointer) {
    // set flags
    this.isDragging = false;
    // re-enable clicking async
    setTimeout(function () {
      delete this.isPreventingClicks;
    }.bind(this));
    this.dragEnd(event, pointer);
  };
  proto.dragEnd = function (event, pointer) {
    this.emitEvent('dragEnd', [event, pointer]);
  };

  // ----- onclick ----- //

  // handle all clicks and prevent clicks when dragging
  proto.onclick = function (event) {
    if (this.isPreventingClicks) {
      event.preventDefault();
    }
  };

  // ----- staticClick ----- //

  // triggered after pointer down & up with no/tiny movement
  proto._staticClick = function (event, pointer) {
    // ignore emulated mouse up clicks
    if (this.isIgnoringMouseUp && event.type == 'mouseup') {
      return;
    }
    this.staticClick(event, pointer);

    // set flag for emulated clicks 300ms after touchend
    if (event.type != 'mouseup') {
      this.isIgnoringMouseUp = true;
      // reset flag after 300ms
      setTimeout(function () {
        delete this.isIgnoringMouseUp;
      }.bind(this), 400);
    }
  };
  proto.staticClick = function (event, pointer) {
    this.emitEvent('staticClick', [event, pointer]);
  };

  // ----- utils ----- //

  Unidragger.getPointerPoint = Unipointer.getPointerPoint;

  // -----  ----- //

  return Unidragger;
});

/***/ }),

/***/ "./node_modules/unipointer/unipointer.js":
/*!***********************************************!*\
  !*** ./node_modules/unipointer/unipointer.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
/*!
 * Unipointer v2.4.0
 * base class for doing one thing with pointer event
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */ /*global define, module, require */
  if (true) {
    // AMD
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(/*! ev-emitter/ev-emitter */ "./node_modules/ev-emitter/ev-emitter.js")], __WEBPACK_AMD_DEFINE_RESULT__ = (function (EvEmitter) {
      return factory(window, EvEmitter);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
})(window, function factory(window, EvEmitter) {
  'use strict';

  function noop() {}
  function Unipointer() {}

  // inherit EvEmitter
  var proto = Unipointer.prototype = Object.create(EvEmitter.prototype);
  proto.bindStartEvent = function (elem) {
    this._bindStartEvent(elem, true);
  };
  proto.unbindStartEvent = function (elem) {
    this._bindStartEvent(elem, false);
  };

  /**
   * Add or remove start event
   * @param {Boolean} isAdd - remove if falsey
   */
  proto._bindStartEvent = function (elem, isAdd) {
    // munge isAdd, default to true
    isAdd = isAdd === undefined ? true : isAdd;
    var bindMethod = isAdd ? 'addEventListener' : 'removeEventListener';

    // default to mouse events
    var startEvent = 'mousedown';
    if ('ontouchstart' in window) {
      // HACK prefer Touch Events as you can preventDefault on touchstart to
      // disable scroll in iOS & mobile Chrome metafizzy/flickity#1177
      startEvent = 'touchstart';
    } else if (window.PointerEvent) {
      // Pointer Events
      startEvent = 'pointerdown';
    }
    elem[bindMethod](startEvent, this);
  };

  // trigger handler methods for events
  proto.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };

  // returns the touch that we're keeping track of
  proto.getTouch = function (touches) {
    for (var i = 0; i < touches.length; i++) {
      var touch = touches[i];
      if (touch.identifier == this.pointerIdentifier) {
        return touch;
      }
    }
  };

  // ----- start event ----- //

  proto.onmousedown = function (event) {
    // dismiss clicks from right or middle buttons
    var button = event.button;
    if (button && button !== 0 && button !== 1) {
      return;
    }
    this._pointerDown(event, event);
  };
  proto.ontouchstart = function (event) {
    this._pointerDown(event, event.changedTouches[0]);
  };
  proto.onpointerdown = function (event) {
    this._pointerDown(event, event);
  };

  /**
   * pointer start
   * @param {Event} event
   * @param {Event or Touch} pointer
   */
  proto._pointerDown = function (event, pointer) {
    // dismiss right click and other pointers
    // button = 0 is okay, 1-4 not
    if (event.button || this.isPointerDown) {
      return;
    }
    this.isPointerDown = true;
    // save pointer identifier to match up touch events
    this.pointerIdentifier = pointer.pointerId !== undefined ?
    // pointerId for pointer events, touch.indentifier for touch events
    pointer.pointerId : pointer.identifier;
    this.pointerDown(event, pointer);
  };
  proto.pointerDown = function (event, pointer) {
    this._bindPostStartEvents(event);
    this.emitEvent('pointerDown', [event, pointer]);
  };

  // hash of events to be bound after start event
  var postStartEvents = {
    mousedown: ['mousemove', 'mouseup'],
    touchstart: ['touchmove', 'touchend', 'touchcancel'],
    pointerdown: ['pointermove', 'pointerup', 'pointercancel']
  };
  proto._bindPostStartEvents = function (event) {
    if (!event) {
      return;
    }
    // get proper events to match start event
    var events = postStartEvents[event.type];
    // bind events to node
    events.forEach(function (eventName) {
      window.addEventListener(eventName, this);
    }, this);
    // save these arguments
    this._boundPointerEvents = events;
  };
  proto._unbindPostStartEvents = function () {
    // check for _boundEvents, in case dragEnd triggered twice (old IE8 bug)
    if (!this._boundPointerEvents) {
      return;
    }
    this._boundPointerEvents.forEach(function (eventName) {
      window.removeEventListener(eventName, this);
    }, this);
    delete this._boundPointerEvents;
  };

  // ----- move event ----- //

  proto.onmousemove = function (event) {
    this._pointerMove(event, event);
  };
  proto.onpointermove = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerMove(event, event);
    }
  };
  proto.ontouchmove = function (event) {
    var touch = this.getTouch(event.changedTouches);
    if (touch) {
      this._pointerMove(event, touch);
    }
  };

  /**
   * pointer move
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */
  proto._pointerMove = function (event, pointer) {
    this.pointerMove(event, pointer);
  };

  // public
  proto.pointerMove = function (event, pointer) {
    this.emitEvent('pointerMove', [event, pointer]);
  };

  // ----- end event ----- //

  proto.onmouseup = function (event) {
    this._pointerUp(event, event);
  };
  proto.onpointerup = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerUp(event, event);
    }
  };
  proto.ontouchend = function (event) {
    var touch = this.getTouch(event.changedTouches);
    if (touch) {
      this._pointerUp(event, touch);
    }
  };

  /**
   * pointer up
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */
  proto._pointerUp = function (event, pointer) {
    this._pointerDone();
    this.pointerUp(event, pointer);
  };

  // public
  proto.pointerUp = function (event, pointer) {
    this.emitEvent('pointerUp', [event, pointer]);
  };

  // ----- pointer done ----- //

  // triggered on pointer up & pointer cancel
  proto._pointerDone = function () {
    this._pointerReset();
    this._unbindPostStartEvents();
    this.pointerDone();
  };
  proto._pointerReset = function () {
    // reset properties
    this.isPointerDown = false;
    delete this.pointerIdentifier;
  };
  proto.pointerDone = noop;

  // ----- pointer cancel ----- //

  proto.onpointercancel = function (event) {
    if (event.pointerId == this.pointerIdentifier) {
      this._pointerCancel(event, event);
    }
  };
  proto.ontouchcancel = function (event) {
    var touch = this.getTouch(event.changedTouches);
    if (touch) {
      this._pointerCancel(event, touch);
    }
  };

  /**
   * pointer cancel
   * @param {Event} event
   * @param {Event or Touch} pointer
   * @private
   */
  proto._pointerCancel = function (event, pointer) {
    this._pointerDone();
    this.pointerCancel(event, pointer);
  };

  // public
  proto.pointerCancel = function (event, pointer) {
    this.emitEvent('pointerCancel', [event, pointer]);
  };

  // -----  ----- //

  // utility function for getting x/y coords from event
  Unipointer.getPointerPoint = function (pointer) {
    return {
      x: pointer.pageX,
      y: pointer.pageY
    };
  };

  // -----  ----- //

  return Unipointer;
});

/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (module) {
  if (!module.webpackPolyfill) {
    module.deprecate = function () {};
    module.paths = [];
    // module.parent = undefined by default
    if (!module.children) module.children = [];
    Object.defineProperty(module, "loaded", {
      enumerable: true,
      get: function get() {
        return module.l;
      }
    });
    Object.defineProperty(module, "id", {
      enumerable: true,
      get: function get() {
        return module.i;
      }
    });
    module.webpackPolyfill = 1;
  }
  return module;
};

/***/ })

/******/ });